import { jsx as s, jsxs as O, Fragment as Ue } from "react/jsx-runtime";
import { Button as Ca, Modal as Vn, Label as qt, TextInput as Ym, Spinner as Ea, Checkbox as Ml, Select as $m, Radio as qm, ToggleSwitch as Km, Textarea as Qm, Sidebar as cr, Badge as Xm, Alert as Jm, Flowbite as jm } from "flowbite-react";
import me, { useState as Y, useEffect as ee, createContext as dt, useContext as Ot, Children as kn, cloneElement as Ll, useRef as Re, isValidElement as Zm, useMemo as Ol, createRef as eg, useCallback as an, forwardRef as Dl } from "react";
import { motion as ye, AnimatePresence as et } from "framer-motion";
import { LiaTimesSolid as Pl } from "react-icons/lia";
import { FaRegWindowMinimize as tg, FaRegWindowMaximize as ng } from "react-icons/fa";
import { BsFillExclamationCircleFill as rg, BsFillInfoCircleFill as ig } from "react-icons/bs";
import { MdOutlineDoneOutline as og, MdAdminPanelSettings as ag } from "react-icons/md";
import { PiWarningFill as sg } from "react-icons/pi";
import { twMerge as sn } from "tailwind-merge";
import { useField as ot, Field as Dt, Formik as Ta, Form as Ia, useFormikContext as Wl } from "formik";
import { RiEyeFill as lg, RiEyeCloseFill as cg } from "react-icons/ri";
import { HiOutlineLightBulb as zl, HiLightBulb as Fa, HiChevronDown as ug, HiOutlineChevronDoubleLeft as dg, HiViewGrid as fg, HiBeaker as hg, HiChartPie as pg, HiClipboard as mg, HiClipboardList as gg, HiQuestionMarkCircle as xg, HiHome as yg, HiChevronRight as vg, HiOutlineChevronDoubleRight as bg, HiInformationCircle as wg } from "react-icons/hi";
import Ze from "lodash.debounce";
import { Sketch as kg } from "@uiw/react-color";
import { IoIosArrowDown as _g, IoIosArrowUp as Ag } from "react-icons/io";
import pr from "dayjs";
import { huHU as Hl, deDE as Sg, enUS as Cg, LocalizationProvider as Eg, DateTimePicker as ll } from "@mui/x-date-pickers";
import { AdapterDayjs as Ul } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider as Tg } from "@mui/x-date-pickers/LocalizationProvider";
import { unstable_useDateField as Ig } from "@mui/x-date-pickers/DateField";
import Fg from "@mui/joy/FormControl";
import Bg from "@mui/joy/FormLabel";
import Ng from "@mui/joy/Input";
import "dayjs/locale/en";
import "dayjs/locale/hu";
import "dayjs/locale/de";
import { DatePicker as Rg } from "@mui/x-date-pickers/DatePicker";
import Mg from "swr";
import _n from "axios";
import { FormControl as Lg, Typography as Hr, Select as Og, MenuItem as $i, FormHelperText as Dg, Chip as Hi, Tooltip as Qi, IconButton as Gl, Button as Vl, Menu as Yl, Stepper as Pg, Step as Wg, StepLabel as zg, styled as Ba, TabScrollButton as cl, Tabs as Hg, Tab as Ug } from "@mui/material";
import Gg from "@mui/material/Slider";
import { styled as Vg, experimental_extendTheme as Yg, Experimental_CssVarsProvider as $g, THEME_ID as qg } from "@mui/material/styles";
import Kg from "@mui/material/Input";
import Na, { isMobile as $l } from "is-mobile";
import { useNavigate as Qg } from "react-router-dom";
import { MaterialReactTable as ql } from "material-react-table";
import Xg from "@mui/icons-material/Close";
import { ArrowTopRightOnSquareIcon as Jg, ChatBubbleBottomCenterTextIcon as jg, ArrowDownTrayIcon as ul, ExclamationTriangleIcon as Zg, CheckIcon as ex, XMarkIcon as Kl, TrashIcon as tx, EllipsisHorizontalIcon as nx, PlusIcon as rx } from "@heroicons/react/24/outline";
import { Modal as ix, ModalDialog as ox, ModalClose as ax, tabClasses as sx, Tabs as lx, TabList as cx, Tab as ux, ListItemDecorator as dx, TabPanel as fx } from "@mui/joy";
import hx from "@mui/icons-material/KeyboardArrowRightOutlined";
import px from "@mui/icons-material/Download";
import * as qi from "yup";
import { MRT_Localization_HU as mx } from "material-react-table/locales/hu";
import * as hr from "xlsx";
import { saveAs as gx } from "file-saver";
import { useStateWithCallbackLazy as xx } from "use-state-with-callback";
import { Tooltip as yx } from "react-tooltip";
import wa from "lottie-react";
import { GrClose as vx } from "react-icons/gr";
import { extendTheme as bx, CssVarsProvider as wx, THEME_ID as kx } from "@mui/joy/styles";
import _x, { tooltipClasses as dl } from "@mui/material/Tooltip";
const $t = ({ children: a, color: o = "primary", ...r }) => /* @__PURE__ */ s(Ca, { color: o, ...r, children: a }), Yi = ({ children: a, endIcon: o, startIcon: r, size: l, ...u }) => {
  const [d, m] = Y("h-4 w-4"), [p, g] = Y(["mr-2", "ml-2"]), x = (k) => {
    g([
      ["mr-0", "ml-0"],
      ["mr-1", "ml-1"],
      ["mr-2", "ml-2"],
      ["mr-3", "ml-3"],
      ["mr-4", "ml-4"],
      ["mr-5", "ml-5"],
      ["mr-6", "ml-6"]
    ][k]);
  };
  return ee(() => {
    switch (l) {
      case "xs":
        x(2), m("h-4 w-4");
        break;
      case "sm":
        x(2), m("h-5 w-5");
        break;
      case "lg":
        x(3), m("h-6 w-6");
        break;
      case "xl":
        x(4), m("h-6 w-6");
        break;
      default:
        x(2), m("h-5 w-5");
        break;
    }
  }, [l]), /* @__PURE__ */ O($t, { size: l, ...u, children: [
    r && /* @__PURE__ */ s("div", { className: `${d} ${p[0]}`, children: r }),
    /* @__PURE__ */ s("p", { className: "whitespace-nowrap", children: a }),
    o && /* @__PURE__ */ s("div", { className: `${d} ${p[1]}`, children: o })
  ] });
}, Ql = ({ openModal: a, setOpenModal: o, header: r, children: l, footer: u }) => /* @__PURE__ */ O(Vn, { show: a === "default", onClose: () => o(void 0), "data-testid": "modal", children: [
  /* @__PURE__ */ s(Vn.Header, { children: r }),
  /* @__PURE__ */ s(Vn.Body, { children: l }),
  u && /* @__PURE__ */ s(Vn.Footer, { children: u })
] }), Ax = {}, Sx = {
  color: "gray"
}, Xl = ({ onConfirm: a, onCancel: o, confirmTitle: r = "Megerősítés", cancelTitle: l = "Mégse", confirmButtonProps: u = Ax, cancelButtonProps: d = Sx, ...m }) => /* @__PURE__ */ s(Jl, {
  ...m,
  footer: /* @__PURE__ */ O(Ue, { children: [
    /* @__PURE__ */ s($t, {
      "data-testid": "confirm-modal-confirm-button",
      onClick: () => {
        m.setOpenModal(void 0), a();
      },
      ...u,
      children: r
    }),
    /* @__PURE__ */ s($t, {
      "data-testid": "confirm-modal-cancel-button",
      onClick: () => {
        m.setOpenModal(void 0), o == null || o();
      },
      ...d,
      children: l
    })
  ] })
}), Jl = ({ text: a, children: o, ...r }) => /* @__PURE__ */ s(Ql, { ...r, children: /* @__PURE__ */ O("div", { className: "space-y-6", children: [
  a && /* @__PURE__ */ s("div", { className: "text-base leading-relaxed text-gray-500 dark:text-gray-400", children: Array.isArray(a) ? a.map((l, u) => typeof l == "string" ? /* @__PURE__ */ s("span", { children: l }, u) : /* @__PURE__ */ s("span", { children: l }, u)) : /* @__PURE__ */ s("span", { children: a }) }),
  o
] }) }), Cx = ({ onClose: a, toastContainerPosition: o }) => {
  const [r, l] = Y(!1), [u, d] = Y({}), [m, p] = Y(!1), g = () => {
    d({}), l(!1), a();
  }, x = 3, [k, v] = Y([]), [A, C] = Y(o), T = (I) => {
    v((z) => z.filter((R) => R.id !== I));
  };
  return {
    isMinimized: r,
    setIsMinimized: l,
    close: g,
    lastPos: u,
    setLastPos: d,
    disableAllControls: m,
    setDisableAllControls: p,
    toastMessages: k,
    setToastMessages: v,
    showToast: (I, z) => {
      const R = {
        id: Date.now(),
        message: I,
        type: z
      };
      v((P) => [...P, R]), setTimeout(() => {
        T(R.id);
      }, x * 1e3);
    },
    removeToast: T,
    clearAllToasts: () => {
      v([]);
    },
    toastPosition: A
  };
}, Ex = {
  isMinimized: !1,
  lastPos: { left: "", top: "" },
  disableAllControls: !1,
  setDisableAllControls: () => {
  },
  close: () => {
  },
  setIsMinimized: () => {
  },
  setLastPos: () => {
  },
  toastMessages: [],
  setToastMessages: () => {
  },
  showToast: () => {
  },
  removeToast: () => {
  },
  clearAllToasts: () => {
  },
  toastPosition: "top"
}, jl = dt(Ex), Tx = ({ children: a, onClose: o, toastContainerPosition: r }) => /* @__PURE__ */ s(jl.Provider, { value: Cx({ onClose: o, toastContainerPosition: r }), children: a }), Zl = () => Ot(jl), Ix = ({ numberOfModalsProp: a }) => {
  const [o, r] = Y(a), [l, u] = Y(0);
  return {
    numberOfModals: o,
    activeModalIndex: l,
    setActiveModalIndex: u
  };
}, Fx = {
  numberOfModals: 0,
  activeModalIndex: 0,
  setActiveModalIndex: () => {
  }
}, ec = dt(Fx), Bx = ({ children: a, numberOfModalsProp: o }) => /* @__PURE__ */ s(ec.Provider, { value: Ix({ numberOfModalsProp: o }), children: a }), Nx = () => Ot(ec), ma = ({ children: a, onClickFunc: o, ariaLabel: r, title: l, ...u }) => /* @__PURE__ */ s(ye.button, {
  whileHover: {
    scale: 1.1,
    transition: {
      duration: 0.1
    }
  },
  whileTap: { scale: 0.8 },
  className: "text-white disabled:opacity-50",
  type: "button",
  title: l,
  "aria-label": r,
  onClick: () => {
    o();
  },
  ...u,
  children: a
}), Rx = () => /* @__PURE__ */ s(Pl, {}), Mx = () => /* @__PURE__ */ s(og, { className: "text-green-600" }), Lx = () => /* @__PURE__ */ s(rg, { className: "text-red-600" }), Ox = () => /* @__PURE__ */ s(sg, { className: "text-yellow-300" }), Dx = () => /* @__PURE__ */ s(ig, { className: "text-blue-600" }), Px = ({ message: a = "Add a meaningful toast message here.", type: o = "success", onClose: r }) => {
  const u = {
    success: /* @__PURE__ */ s(Mx, {}),
    failure: /* @__PURE__ */ s(Lx, {}),
    warning: /* @__PURE__ */ s(Ox, {}),
    info: /* @__PURE__ */ s(Dx, {})
  }[o] || null;
  return /* @__PURE__ */ O(ye.div, {
    initial: { opacity: 0, x: 50 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: 50 },
    transition: { duration: 0.2 },
    whileHover: { scale: 1.05 },
    className: `${o}-toast-nofitication relative cursor-pointer rounded-lg bg-white p-4 shadow-lg ring-1 ${o === "failure" && "ring-red-500"} ${o === "success" && "ring-green-500"} ${o === "warning" && "ring-yellow-500"} ${o === "info" && "ring-blue-700"}`,
    role: "alert",
    "data-testid": "draggable-modal-toast",
    onClick: r,
    children: [
      /* @__PURE__ */ O("div", { className: "flex items-center gap-4 text-center", children: [
        u && /* @__PURE__ */ s("div", { className: "self-center align-middle text-xl", children: u }),
        /* @__PURE__ */ s("p", { children: a })
      ] }),
      /* @__PURE__ */ s(ye.button, {
        whileHover: { scale: 1.1 },
        whileTap: { scale: 0.9 },
        className: "absolute right-2 top-2 h-4 w-4 cursor-pointer p-0 text-inherit",
        onClick: r,
        "data-testid": "draggable-modal-toast-close-button",
        children: /* @__PURE__ */ s("span", { children: /* @__PURE__ */ s(Rx, {}) })
      })
    ]
  });
};
const Wx = () => {
  const { toastMessages: a, removeToast: o, toastPosition: r } = Zl(), l = r.includes("bottom") ? [...a].reverse() : [...a];
  return /* @__PURE__ */ s("div", {
    className: `absolute z-10 grid h-auto w-[300px] gap-2 overflow-hidden bg-transparent p-3 pt-1 toast-container-${r}`,
    children: /* @__PURE__ */ s(et, { children: l.map((u) => /* @__PURE__ */ s(Px, {
      message: u.message,
      type: u.type,
      onClose: () => o(u.id)
    }, u.id)) })
  });
}, zx = ({ children: a, title: o, show: r, width: l = 500, height: u, currentModalIndex: d = 0, className: m, required: p = !1, isMinimizable: g = !0 }) => {
  const x = me.useRef(null), k = me.useRef(null), [v, A] = me.useState(!1), [C, T] = me.useState(!1), F = 40, { close: E, isMinimized: I, setIsMinimized: z, setLastPos: R, lastPos: P, disableAllControls: U } = Zl(), { setActiveModalIndex: q, activeModalIndex: B } = Nx();
  function M($) {
    let j = 0, le = 0, ve = 0, se = 0;
    x.current ? x.current.onmousedown = _e : $.onmousedown = _e;
    function _e(he) {
      he = he || window.event, he.preventDefault(), ve = he.clientX, se = he.clientY, document.onmouseup = ft, document.onmousemove = at, q(d);
    }
    function at(he) {
      he = he || window.event, he.preventDefault(), j = ve - he.clientX, le = se - he.clientY, ve = he.clientX, se = he.clientY, !(ve < 0 || se < 0 || ve > window.innerWidth || se > window.innerHeight) && ($.style.top = $.offsetTop >= window.innerHeight - F && se > window.innerHeight - F ? window.innerHeight - F + "px" : $.offsetTop <= 0 && se <= F ? "0px" : $.offsetTop - le + "px", $.style.left = $.offsetLeft >= window.innerWidth - $.getBoundingClientRect().width / 4 && ve >= window.innerWidth - $.getBoundingClientRect().width / 4 ? window.innerWidth - $.getBoundingClientRect().width / 4 + "px" : $.offsetLeft <= (0 - $.getBoundingClientRect().width / 4) * 3 && ve <= $.getBoundingClientRect().width / 4 ? (0 - $.getBoundingClientRect().width / 4) * 3 + "px" : $.offsetLeft - j + "px");
    }
    function ft() {
      document.onmouseup = null, document.onmousemove = null;
    }
  }
  function V() {
    k.current && (z(!0), R({
      left: k.current.style.left,
      top: k.current.style.top
    }), k.current.style.width = "250px", k.current.style.height = "250px", k.current.style.position = "relative", k.current.style.left = "0px", k.current.style.top = `-${F}px`);
  }
  function X() {
    k.current && (z(!1), k.current.style.position = "fixed", k.current.style.width = `${l}px`, k.current.style.height = `${u !== void 0 ? u + F + "px" : "auto"}`, k.current.style.top = `${P.top}`, k.current.style.left = `${P.left}`);
  }
  function te($, j) {
    return $.length > j ? $.slice(0, j - 1) + "..." : $;
  }
  ee(() => {
    const $ = k.current, j = x.current;
    return $ && (I ? (j && (j.onmousedown = null), document.onmouseup = null, document.onmousemove = null, document.onmousemove = null) : (r && P.left === void 0 && ($.style.top = window.innerHeight / 2 - $.getBoundingClientRect().height / 2 + d * 15 + "px", window.innerWidth > 768 ? $.style.left = window.innerWidth / 2 - $.getBoundingClientRect().width / 2 + d * 15 + "px" : $.style.left = window.innerWidth * 0.05 / 2 + "px"), window.innerWidth > 768 ? (M($), T(!1)) : T(!0))), () => {
      j && (j.onmousedown = null), document.onmouseup = null, document.onmousemove = null, document.onmousemove = null;
    };
  }, [I, r]), ee(() => {
    const $ = k.current;
    $ && (d === B ? $.style.zIndex = "1052" : $.style.zIndex = "1050");
  }, [B]);
  const ne = {
    intitial: { scale: 1, opacity: 0 },
    animate: {
      scale: [1, 1.02, 1, 1.02, 1],
      transition: {
        duration: 1
      }
    },
    fade: { opacity: 1, transition: { duration: 0.3 } },
    exit: { opacity: 0, transition: { duration: 0.3 } }
  };
  return /* @__PURE__ */ s(et, { children: r ? /* @__PURE__ */ O(Ue, { children: [
    p || C ? /* @__PURE__ */ s("button", {
      type: "button",
      "aria-label": "draggable-modal-background",
      "data-testid": "draggable-modal-background",
      onClick: () => A(!0),
      className: `fixed left-0 top-0 h-screen w-screen ${C ? "bg-black opacity-20" : ""}`
    }) : null,
    /* @__PURE__ */ O(ye.div, {
      "data-testid": "draggable-modal",
      initial: "initial",
      animate: `${v ? "animate" : ""}`,
      variants: ne,
      exit: "exit",
      onAnimationComplete: () => A(!1),
      onClick: () => q(d),
      onFocus: () => q(d),
      ref: k,
      className: "fixed rounded-2xl bg-white shadow-lg ring-2 ring-black ring-opacity-5 will-change-auto",
      style: {
        width: `${C ? "95%" : l + "px"}`
      },
      children: [
        /* @__PURE__ */ s(Wx, {}),
        /* @__PURE__ */ O(ye.header, {
          "data-testid": "draggable-modal-header",
          initial: "initial",
          animate: `${v ? "animate" : ""}`,
          ref: x,
          className: sn(`relative flex items-center justify-between rounded-tl-2xl rounded-tr-2xl bg-main px-4 text-white h-[${F}px] ${I || C ? "cursor-default" : "cursor-move"}`, m),
          children: [
            /* @__PURE__ */ s("h1", { className: "font-semibold", "data-testid": "draggable-modal-title", children: I ? te(o, 15) : o }),
            /* @__PURE__ */ O("div", { className: "flex gap-2", children: [
              C ? null : /* @__PURE__ */ O(Ue, { children: [
                /* @__PURE__ */ s(ma, {
                  "data-testid": "draggable-modal-minimize-button",
                  onClickFunc: V,
                  title: "Minimize",
                  ariaLabel: "minimize-draggable-modal",
                  disabled: I || !g || U,
                  children: /* @__PURE__ */ s(tg, {})
                }),
                /* @__PURE__ */ s(ma, {
                  "data-testid": "draggable-modal-maximize-button",
                  onClickFunc: X,
                  title: "Maximize",
                  ariaLabel: "maximize-draggable-modal",
                  disabled: !I || U,
                  children: /* @__PURE__ */ s(ng, {})
                })
              ] }),
              /* @__PURE__ */ s(ma, {
                "data-testid": "draggable-modal-close-button",
                onClickFunc: E,
                title: "Close",
                ariaLabel: "close-draggable-modal",
                disabled: U,
                children: /* @__PURE__ */ s(Pl, { className: "fill-white text-2xl" })
              })
            ] })
          ]
        }),
        /* @__PURE__ */ s("div", {
          style: {
            height: `${u !== void 0 ? u + "px" : "auto"}`
          },
          children: a
        })
      ]
    })
  ] }) : null });
}, fv = ({ children: a, title: o, show: r, width: l = 500, height: u, currentModalIndex: d = 0, className: m, onClose: p, required: g = !1, isMinimizable: x = !1, toastPosition: k = "top" }) => /* @__PURE__ */ s(Tx, { onClose: p, toastContainerPosition: k, children: /* @__PURE__ */ s(zx, {
  title: o,
  show: r,
  width: l,
  height: u,
  currentModalIndex: d,
  className: m,
  required: g,
  isMinimizable: x,
  children: a
}) }), hv = ({ children: a }) => /* @__PURE__ */ s(Bx, { numberOfModalsProp: kn.toArray(a).length, children: /* @__PURE__ */ s("div", {
  className: "fixed -bottom-[40px] left-0 flex h-[40px] w-screen justify-start gap-2 px-2",
  style: { zIndex: "50" },
  "data-testid": "draggable-modal-container",
  children: kn.map(a, (o, r) => Ll(o, {
    currentModalIndex: r
  }))
}) }), pv = ({ children: a, onClick: o, buttonProps: r, ...l }) => {
  const [u, d] = me.useState();
  return /* @__PURE__ */ O(Ue, { children: [
    /* @__PURE__ */ s($t, {
      ...r,
      onClick: () => {
        o == null || o(), d("default");
      },
      children: a
    }),
    /* @__PURE__ */ s(Xl, { openModal: u, setOpenModal: d, ...l })
  ] });
}, mv = ({ children: a, onClick: o, buttonProps: r, ...l }) => {
  const [u, d] = me.useState(void 0);
  return /* @__PURE__ */ O(Ue, { children: [
    /* @__PURE__ */ s($t, {
      ...r,
      onClick: () => {
        o == null || o(), d("default");
      },
      children: a
    }),
    /* @__PURE__ */ s(Jl, { openModal: u, setOpenModal: d, ...l })
  ] });
}, Hx = {
  initial: { opacity: 0, display: "none", height: 0 },
  in: {
    display: "flex",
    opacity: 1,
    height: "auto",
    transition: { duration: 0.3 }
  },
  out: {
    opacity: 0,
    height: 0,
    transition: { duration: 0.3 },
    transitionEnd: { display: "none" }
  }
}, Ux = ({ errorMessage: a, renderErrorMessageDiv: o = !1 }) => /* @__PURE__ */ O(Ue, { children: [
  o && /* @__PURE__ */ s("div", { className: "absolute", "data-error": "formik-error" }),
  /* @__PURE__ */ s("div", { className: "mt-0 text-sm text-red-600 dark:text-red-500", children: /* @__PURE__ */ s(et, { initial: !1, children: a && // Apply the fadeInOut animation variants to the error message
  /* @__PURE__ */ s(ye.div, {
    initial: "initial",
    animate: "in",
    variants: Hx,
    exit: "out",
    "data-testid": "error-message",
    children: a
  }) }) })
] }), Gx = ({ title: a, content: o }) => /* @__PURE__ */ O("div", { className: "relative flex flex-col items-start", "data-testid": "hint-content", children: [
  /* @__PURE__ */ s("div", { className: "font-semibold", "data-testid": "hint-content-label", children: a }),
  /* @__PURE__ */ s("div", {
    className: "mt-1 w-full border-t-2 border-t-other-gray pb-1 lg:pb-3",
    "data-testid": "hint-content-divider"
  }),
  /* @__PURE__ */ s("div", { className: "pb-1 text-[13px] lg:pb-3 lg:text-[15px]", "data-testid": "hint-content-content", children: o })
] });
const Vx = ({ children: a, title: o, textContent: r, sideToRenderPointer: l = "top", width: u = "auto", height: d = "auto", sideToRenderHint: m = "bottom", pointerOffset: p = "15px" }) => {
  const g = me.useRef(null), x = me.useRef(null);
  return me.useEffect(() => {
    x.current && (u === "auto" ? x.current.style.setProperty("--width", `${x.current.getBoundingClientRect().width}px`) : x.current.style.setProperty("--width", u), d === "auto" ? x.current.style.setProperty("--height", `${x.current.getBoundingClientRect().height}px`) : x.current.style.setProperty("--height", d));
  }, []), /* @__PURE__ */ s("div", {
    className: `input-hint-container absolute input-hint-container-${m}`,
    ref: x,
    style: { "--pointer-offset": p },
    "data-testid": "hint-bubble",
    children: /* @__PURE__ */ O(ye.div, {
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      exit: { opacity: 0 },
      className: "relative z-[100]",
      children: [
        /* @__PURE__ */ O("div", { className: "input-hint", children: [
          /* @__PURE__ */ s(Gx, { title: o, content: r }),
          /* @__PURE__ */ s("div", { children: a })
        ] }),
        /* @__PURE__ */ s("div", {
          className: `input-hint-pointer rotate-45 bg-white ${l}-input-hint-pointer`,
          ref: g,
          "data-testid": "hint-bubble-pointer"
        })
      ]
    })
  });
}, Yx = ({ showHint: a, setShowHint: o, hintHoverEvent: r = !0, hintClickEvent: l = !0, absoluteHintPositioning: u = !0, hintButtonColor: d = "#0872AB", hintButtonSize: m = "1.125rem", showHintButtonIcon: p = /* @__PURE__ */ s(zl, { style: { fontSize: "1.125rem", lineHeight: "1.75rem" } }), hideHintButtonIcon: g = /* @__PURE__ */ s(Fa, { style: { fontSize: "1.125rem", lineHeight: "1.75rem" } }) }) => {
  const [x, k] = me.useState(!1), [v, A] = me.useState(!1);
  return ee(() => {
    o(r && x === !1 && v === !0 ? !1 : x);
  }, [x]), ee(() => {
    l && !x ? o(v) : l || o(v);
  }, [v]), /* @__PURE__ */ s(ye.div, {
    whileHover: {
      scale: 1.1
    },
    whileFocus: { scale: 1.1 },
    whileTap: l ? { scale: 0.9 } : {},
    onClick: () => {
      l && k((C) => !C);
    },
    onMouseEnter: () => {
      r && A(!0);
    },
    onMouseLeave: () => {
      r && A(!1);
    },
    transition: {
      type: "spring",
      stiffness: 400,
      damping: 17
    },
    "data-testid": "toggle-input-hint",
    className: `${u && "absolute"} right-0 top-0 z-10 rounded-full`,
    style: { color: d, fontSize: m },
    children: a ? g : p
  });
}, Pt = ({ children: a, errorMessage: o, labelComponent: r, showErrorMessage: l = !0, name: u, hintProperties: d, style: m }) => {
  const [p, g] = me.useState(!1);
  return /* @__PURE__ */ O("div", { className: "relative flex w-full flex-col gap-1", id: `${u}-basic-input-field-container`, style: m, children: [
    o ? /* @__PURE__ */ s("div", { className: "absolute", "data-error": "formik-error" }) : null,
    /* @__PURE__ */ O("div", {
      className: `flex ${d != null && d.positionHintBulbAfterLabel ? "gap-1" : "justify-between"} items-center`,
      children: [
        r,
        d ? /* @__PURE__ */ s(Yx, {
          showHint: p,
          setShowHint: g,
          hintHoverEvent: d == null ? void 0 : d.hintHoverEvent,
          hintClickEvent: d == null ? void 0 : d.hintClickEvent,
          absoluteHintPositioning: d.absoluteHintPositioning,
          hintButtonColor: d.hintButtonColor,
          hintButtonSize: d.hintButtonSize,
          showHintButtonIcon: d.showHintButtonIcon,
          hideHintButtonIcon: d.hideHintButtonIcon
        }) : null
      ]
    }),
    /* @__PURE__ */ s("div", { className: "relative", children: a }),
    d ? /* @__PURE__ */ s(et, { children: p ? /* @__PURE__ */ s(Vx, {
      title: d.title,
      textContent: d.textContent,
      sideToRenderHint: d.sideToRenderHint,
      sideToRenderPointer: d.sideToRenderPointer,
      width: d.width,
      height: d.height,
      pointerOffset: d.pointerOffset,
      children: d.children
    }) : null }) : null,
    l ? /* @__PURE__ */ s(Ux, { errorMessage: o }) : null
  ] });
}, tc = ({ label: a, placeholder: o, name: r, type: l = "text", disabled: u, svgIcon: d, rightIcon: m, required: p = !1, min: g = 0, max: x = 100, step: k = 1, inputProps: v = {
  sizing: "md"
}, isProcessing: A = !1, hideErrorMessage: C = !1, onBlurFunc: T, onChangeFunc: F, onFocusFunc: E, onChangeIntervalInMs: I = 300, onBlurIntervalInMs: z = 300, onFocusIntervalInMs: R = 300, hintProperties: P }) => {
  const [U, q] = Y(!1), [B, M, { setTouched: V, setValue: X }] = ot(r), { onChange: te, onBlur: ne } = B, { error: $, value: j, touched: le } = M, ve = Re(Ze((he) => {
    F && F(he);
  }, I)).current, se = Re(Ze((he) => {
    T && T(he);
  }, z)).current, _e = Re(Ze((he) => {
    E && E(he);
  }, R)).current;
  ee(() => () => {
    _e.cancel();
  }, [_e]), ee(() => () => {
    ve.cancel();
  }, [ve]), ee(() => () => {
    se.cancel();
  }, [se]);
  const at = {
    initial: { opacity: 0 },
    in: {
      opacity: 1,
      display: "block",
      transition: { duration: 0.5 }
    },
    out: {
      opacity: 0,
      transition: { duration: 0.6 },
      transitionEnd: {
        display: "none"
      }
    }
  }, ft = (he) => {
    const Ye = he.target.value;
    parseInt(Ye) < g ? X(g) : parseInt(Ye) > x && X(x);
  };
  return /* @__PURE__ */ O(Pt, {
    showErrorMessage: !C,
    name: r,
    labelComponent: a && // Render the label with color indicating error state if touched and has an error
    /* @__PURE__ */ s(qt, {
      color: $ && le ? "failure" : "",
      htmlFor: `${r}-input`,
      value: `${p ? a + "*" : a}`
    }),
    errorMessage: $ && le ? $ : "",
    hintProperties: P,
    children: [
      /* @__PURE__ */ s(Dt, { children: ({ field: he }) => /* @__PURE__ */ s(Ym, {
        ...he,
        id: `${r}-input`,
        "data-testid": "text-input-field",
        type: l === "password" ? U ? "text" : "password" : l,
        color: $ && le ? "failure" : "",
        placeholder: o,
        disabled: u,
        icon: d,
        rightIcon: m,
        required: p,
        onClick: () => V(!0),
        onFocus: () => V(!0),
        onChange: (Ye) => {
          te(Ye), ve(Ye);
        },
        onBlur: (Ye) => {
          ne(Ye), l === "number" && ft(Ye), se(Ye);
        },
        onFocusCapture: (Ye) => {
          _e(Ye);
        },
        min: g,
        max: x,
        step: k,
        value: j,
        ...v,
        name: r
      }) }),
      /* @__PURE__ */ s(ye.div, {
        initial: "initial",
        animate: A ? "in" : "out",
        variants: at,
        className: "absolute right-2 top-[50%] translate-y-[-50%]",
        children: /* @__PURE__ */ s(Ea, { size: v.sizing })
      }),
      l === "password" && // Password visibility toggle button for password input
      /* @__PURE__ */ s("div", { className: "absolute right-2 ", style: { top: "55%", transform: "translate(-50%, -50%)" }, children: /* @__PURE__ */ s("button", {
        "data-testid": "password-visibility-button",
        className: "text-other-gray-dark",
        type: "button",
        onClick: () => q(!U),
        children: U ? /* @__PURE__ */ s(lg, { "data-testid": "opened-eye" }) : /* @__PURE__ */ s(cg, { "data-testid": "closed-eye" })
      }) })
    ]
  });
}, $x = ({ field: a, form: o, ...r }) => {
  const { required: l, disabled: u, label: d } = r, { name: m } = a;
  return (
    // Render the Checkbox component with props from the field
    /* @__PURE__ */ s(Ml, {
      ...a,
      "data-testid": "checkbox-input-field",
      name: m,
      id: `${d.trim().toLowerCase()}-checkbox`,
      required: l,
      disabled: u,
      value: r.value
    })
  );
}, gv = ({ name: a, label: o, disabled: r = !1, required: l = !1, groupValue: u }) => {
  const [d, m, p] = ot(a), { error: g, value: x, touched: k } = m, { onChange: v } = d;
  return /* @__PURE__ */ O("div", { className: "flex items-center gap-2", children: [
    /* @__PURE__ */ s(Dt, {
      component: $x,
      name: a,
      label: o,
      disabled: r,
      required: l,
      checked: x,
      value: u,
      onChange: v
    }),
    /* @__PURE__ */ s(qt, {
      color: g && k ? "failure" : "",
      htmlFor: `${o.trim().toLowerCase()}-checkbox`,
      children: `${l ? o + "*" : o}`
    })
  ] });
}, xv = ({ title: a, name: o, onChangeFunc: r, onChangeIntervalInMs: l = 300, children: u, required: d, hintProperties: m, ...p }) => {
  const [g, { error: x, touched: k }, { setTouched: v }] = ot(o), A = Re(Ze((T) => {
    r && r(T);
  }, l)).current;
  ee(() => () => {
    A.cancel();
  }, [A]);
  const C = (T) => me.Children.map(T, (F) => me.isValidElement(F) ? me.cloneElement(F, {
    ...F.props,
    name: o,
    // Set the name prop to the radio group name
    children: C(F.props.children)
    // Recurse into the children
  }) : F);
  return /* @__PURE__ */ s(Pt, {
    name: o,
    errorMessage: x && k ? x : "",
    labelComponent: a && // Render the label with color indicating error state if touched and has an error
    /* @__PURE__ */ s("label", {
      className: `${x && k ? "text-red-600 dark:text-red-500" : ""}`,
      htmlFor: `${o}-input`,
      children: `${d ? a + "*" : a}`
    }),
    hintProperties: m,
    children: /* @__PURE__ */ s("div", { className: "flex flex-col gap-3", children: /* @__PURE__ */ s("fieldset", {
      onChange: (T) => {
        v(!0), A(T);
      },
      id: `${o}-checkbox-group`,
      "data-testid": "checkbox-group",
      ...p,
      children: C(u)
    }) })
  });
}, qx = ({ field: a, form: o, ...r }) => {
  const { onChangeFunc: l, required: u, disabled: d, checked: m, setTouched: p, setValue: g } = r, { name: x } = a, [k, v] = Y(o.values[x]);
  return ee(() => {
    v(m);
  }, [m]), /* @__PURE__ */ s(Ml, {
    ...a,
    "data-testid": "checkbox-input-field",
    onChange: (A) => {
      l && l(A), p(!0), g(!k), v(!k);
    },
    name: x,
    id: `${x}-checkbox`,
    checked: k,
    required: u,
    disabled: d
  });
}, yv = ({ name: a, label: o, disabled: r = !1, required: l = !1, onChangeFunc: u, hintProperties: d }) => {
  const [m, p, g] = ot(a), { error: x, value: k, touched: v } = p, { onChange: A } = m, { setValue: C, setTouched: T } = g;
  return /* @__PURE__ */ s(Pt, { name: a, errorMessage: x && v ? x : "", hintProperties: d, children: /* @__PURE__ */ O("div", { className: "flex items-center gap-2", children: [
    /* @__PURE__ */ s(Dt, {
      component: qx,
      name: a,
      disabled: r,
      required: l,
      checked: k,
      setValue: C,
      setTouched: T,
      onChange: A,
      onChangeFunc: u
    }),
    /* @__PURE__ */ s(qt, { color: x && v ? "failure" : "", htmlFor: `${a}-checkbox`, children: `${l ? o + "*" : o}` })
  ] }) });
}, Kx = {
  initial: {
    rotate: 0
  },
  up: {
    rotate: 180,
    transition: {
      duration: 0.3
    }
  },
  down: {
    rotate: 0,
    transition: {
      duration: 0.3
    }
  }
}, vv = ({ name: a, label: o, required: r = !1, sizing: l = "md", disabled: u = !1, disableAlpha: d = !0, disableEditableInputs: m = !1, presetColors: p = [], mouseEvents: g = !0, popOverPosition: x = "bottom", hintProperties: k }) => {
  const [v, A] = Y(!1), [C, { error: T, value: F, touched: E }, { setValue: I }] = ot(a), z = {
    bottom: "top-[45px] left-0",
    left: "top-0 -left-[222px]",
    right: "top-0 left-[102%]"
  }, R = Re(null), P = Re(null), [U, q] = Y(!1), [B, M] = Y({
    top: !1,
    left: !1,
    right: !1,
    bottom: !1
  });
  return ee(() => {
    const V = new IntersectionObserver((X) => {
      X[0].intersectionRatio === 0 && A(!1);
    }, { threshold: [0, 0.25, 0.5, 0.75, 1] });
    return P.current && V.observe(P.current), () => V.disconnect();
  }, []), ee(() => {
    function V(te) {
      const ne = te[0].intersectionRatio, $ = R.current, j = P.current;
      $ && j && (ne <= 0.8 ? B.top === !1 ? (M((le) => ({
        ...le,
        top: !0
      })), $.style.top = `-${$.getBoundingClientRect().height + 2}px`, $.style.left = "0px", q((le) => !le)) : B.top === !0 && B.left === !1 ? (M((le) => ({
        ...le,
        left: !0
      })), $.style.top = "0px", $.style.left = `-${$.getBoundingClientRect().width + 2}px`, q((le) => !le)) : B.top === !0 && B.left === !0 && (M((le) => ({
        ...le,
        right: !0
      })), $.style.top = "0px", $.style.left = `${j.getBoundingClientRect().width + 2}px`, q((le) => !le)) : ne > 0.8 && ne <= 1 && M({
        top: !1,
        left: !1,
        right: !1,
        bottom: !1
      }));
    }
    const X = new IntersectionObserver(V, {
      threshold: [0, 0.25, 0.5, 0.75, 1]
    });
    return R.current && X.observe(R.current), () => X.disconnect();
  }, [v, R.current, U]), /* @__PURE__ */ s(Pt, {
    name: a,
    labelComponent: o && // Render the label with color indicating error state if touched and has an error
    /* @__PURE__ */ s(qt, {
      color: T && E ? "failure" : "",
      htmlFor: `${a}-input`,
      value: `${r ? o + "*" : o}`
    }),
    errorMessage: T && E ? T : "",
    hintProperties: k,
    children: /* @__PURE__ */ O("fieldset", {
      ref: P,
      onFocus: () => A(!0),
      onBlur: () => A(!1),
      onChange: () => console.log("CHANGE"),
      onMouseOver: () => g && A(!0),
      onMouseOut: () => g && A(!1),
      children: [
        /* @__PURE__ */ s(et, { children: v ? (
          // Animate the color picker popover appearance
          /* @__PURE__ */ s(ye.div, {
            initial: { opacity: 0 },
            animate: { opacity: 1 },
            exit: { opacity: 0 },
            className: `absolute z-10 ${z[x]}`,
            ref: R,
            children: /* @__PURE__ */ s(kg, {
              "data-testid": "color-picker-popover",
              presetColors: p || void 0,
              disableAlpha: d,
              editableDisable: !m,
              color: F,
              onChange: (V) => {
                I(V.hex);
              }
            })
          })
        ) : null }),
        /* @__PURE__ */ O("div", { className: "relative flex cursor-pointer items-center", children: [
          /* @__PURE__ */ s(Dt, {
            ...C,
            className: "absolute flex h-full w-[50px] items-center justify-between gap-2 rounded-lg border border-gray-500 p-[13px] text-sm outline-none",
            name: a,
            disabled: u,
            value: F,
            id: `${a}-input`,
            "data-testid": "color-picker-input-field"
          }),
          /* @__PURE__ */ O("label", {
            "data-testid": "color-picker",
            htmlFor: `${a}-input`,
            className: `relative w-full min-w-[${l === "md" ? "100px" : l === "sm" ? "90px" : "120px"}] flex h-full items-center justify-between gap-2 border bg-white p-[${l === "md" ? "13px" : l === "sm" ? "9px" : "14px"}] rounded-lg text-sm ${u ? "cursor-not-allowed" : "cursor-pointer"} ${v ? "border-blue-500 ring-1 ring-blue-500" : u ? "border-gray-300" : "border-gray-500"}`,
            children: [
              /* @__PURE__ */ s("div", {
                className: `w-[${l === "sm" ? "30" : l === "md" ? "45" : "50"}px] h-[${l === "sm" ? "12" : l === "md" ? "15" : "18"}px] rounded-full ring-1 ring-gray-300`,
                style: { background: F }
              }),
              /* @__PURE__ */ s(ye.div, {
                initial: "initial",
                animate: v ? "up" : "down",
                variants: Kx,
                className: `${u ? "text-gray-400" : ""}`,
                children: /* @__PURE__ */ s(_g, {})
              })
            ]
          })
        ] })
      ]
    })
  });
}, Qx = me.forwardRef((a, o) => {
  const { disabled: r, id: l, label: u, ownerState: d, InputProps: { ref: m, startAdornment: p, endAdornment: g } = {}, formControlSx: x, ...k } = a;
  return /* @__PURE__ */ O(Fg, {
    disabled: r,
    id: l,
    sx: [
      {
        flexGrow: 1
      },
      ...Array.isArray(x) ? x : [x]
    ],
    ref: m,
    children: [
      /* @__PURE__ */ s(Bg, { children: u }),
      /* @__PURE__ */ s(Ng, {
        color: d == null ? void 0 : d.color,
        disabled: r,
        slotProps: { input: { ref: o } },
        startDecorator: p,
        endDecorator: g,
        ...k
      })
    ]
  });
});
function Xx(a) {
  const { inputRef: o, slots: r, slotProps: l, ...u } = a, d = Ig({
    props: u,
    inputRef: o
  });
  return /* @__PURE__ */ s(Qx, { ...d });
}
function Jx(a) {
  var o, r;
  return /* @__PURE__ */ s(Rg, {
    ...a,
    slots: { field: Xx, ...a.slots },
    slotProps: {
      field: {
        formControlSx: {
          flexDirection: "row"
        }
      },
      actionBar: {
        actions: (o = a == null ? void 0 : a.slotProps) != null && o.actionBar ? (r = a == null ? void 0 : a.slotProps) == null ? void 0 : r.actionBar.actions : null
      }
    }
  });
}
const bv = ({ name: a, title: o, local: r, disableOpenPicker: l, disablePastOrFuture: u, weekendsShouldBeDisabled: d, displayWeekNumber: m, customActions: p, required: g = !1, onChangeFunc: x, onChangeIntervalInMs: k = 300, hintProperties: v, style: A }) => {
  const [C, T, F] = ot(a), { setValue: E, setTouched: I } = F, { error: z, value: R, touched: P } = T, U = (B) => {
    const M = B.day();
    return M === 0 || M === 6;
  }, q = Re(Ze((B) => {
    x && x(B);
  }, k)).current;
  return ee(() => () => {
    q.cancel();
  }, [q]), /* @__PURE__ */ s(Pt, {
    name: a,
    errorMessage: z && P ? z : "",
    labelComponent: o && // Render the label with color indicating error state if touched and has an error
    /* @__PURE__ */ s(qt, {
      color: z && P ? "failure" : "",
      htmlFor: `${a}-input`,
      value: `${g ? o + "*" : o}`
    }),
    hintProperties: v,
    style: A,
    children: /* @__PURE__ */ s(Dt, { name: a, id: `${a}-date-picker`, children: ({ field: B }) => (
      // LocalizationProvider is used to set the date adapter and locale
      /* @__PURE__ */ s(Tg, {
        dateAdapter: Ul,
        adapterLocale: r,
        localeText: r === "hu" ? Hl.components.MuiLocalizationProvider.defaultProps.localeText : r === "de" ? Sg.components.MuiLocalizationProvider.defaultProps.localeText : Cg.components.MuiLocalizationProvider.defaultProps.localeText,
        children: /* @__PURE__ */ s(Jx, {
          ...B,
          color: `${z && P ? "danger" : "neutral"}`,
          format: "YYYY.MM.DD",
          views: ["year", "month", "day"],
          disableOpenPicker: l,
          disableFuture: u === "future",
          disablePast: u === "past",
          shouldDisableDate: d ? U : void 0,
          slotProps: {
            actionBar: {
              actions: p
            }
          },
          displayWeekNumber: m,
          value: R !== null || R === void 0 ? pr(R) : null,
          onChange: (M) => {
            I(!0), E(M ? M.toDate() : ""), q(M ? M.toDate() : "");
          },
          onViewChange: () => I(!0),
          onSelectedSectionsChange: () => I(!0),
          onOpen: () => I(!0)
        })
      })
    ) })
  });
}, fl = ({ name: a, fileTypes: o, multiple: r, classes: l }) => {
  const [u, d] = ot(a), { onChange: m } = u;
  return /* @__PURE__ */ s(Dt, { name: a, children: ({ field: p }) => /* @__PURE__ */ s("input", {
    ...p,
    "data-testid": "file-input-field",
    id: `${a}-file`,
    type: "file",
    multiple: r,
    className: l,
    value: "",
    onChange: m,
    accept: o.map((g) => `${g}`)
  }) });
}, wv = ({ label: a = "", name: o, displayTypes: r, fileTypes: l, multiple: u = !1, required: d = !1, buttonTextForBasicStyle: m = "", style: p = "basic", hintProperties: g }) => {
  const [x, k, v] = ot(o), { error: A, value: C, touched: T } = k, { setTouched: F } = v;
  return /* @__PURE__ */ s(Pt, {
    name: o,
    errorMessage: A && T ? A : "",
    labelComponent: /* @__PURE__ */ s(qt, {
      color: A && T ? "failure" : "",
      className: p === "basic" ? "text-sm" : "text-lg",
      value: `${d && a ? a + "*" : a}`
    }),
    hintProperties: g,
    children: /* @__PURE__ */ s("div", { className: "grid gap-3", children: p === "basic" ? /* @__PURE__ */ O("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ s(fl, {
        classes: "custom-file-input h-0 overflow-hidden w-0 text-sm bg-main  rounded-md hidden",
        fileTypes: l,
        multiple: u,
        ...x
      }),
      /* @__PURE__ */ s("label", {
        onClick: () => F(!0),
        htmlFor: `${o}-file`,
        "data-testid": "file-input-button",
        className: `file-input relative inline-block cursor-pointer rounded-md border-none px-8 py-2 align-middle font-semibold text-white shadow-[0px_6px_#064669] outline-none transition-none hover:top-[2px] hover:shadow-[0px_4px_#0872ab] ${A && T ? "bg-red-600 shadow-[0px_6px_#8a1e1e] hover:bg-red-600 hover:shadow-red-600" : "bg-main hover:bg-main"}`,
        children: m || "Choose a file"
      }),
      /* @__PURE__ */ s("p", {
        "data-testid": "file-input-url",
        className: `mt-1 text-base ${A && T ? "text-red-600" : ""}`,
        children: C || "No file choosen"
      })
    ] }) : /* @__PURE__ */ s("div", { className: "flex w-full items-center justify-center", children: /* @__PURE__ */ O("label", {
      "data-testid": "file-input-button",
      onClick: () => F(!0),
      htmlFor: `${o}-file`,
      className: `flex h-64 w-full flex-col items-center justify-center border-2 ${A && T ? "border-red-600" : "border-gray-300"} dark:hover:bg-bray-800 cursor-pointer rounded-lg border-dashed bg-gray-50 hover:bg-gray-100 dark:border-gray-600 dark:bg-gray-700 dark:hover:border-gray-500 dark:hover:bg-gray-600`,
      children: [
        /* @__PURE__ */ O("div", { className: "flex flex-col items-center justify-center pb-6 pt-5", children: [
          /* @__PURE__ */ s("svg", {
            className: `mb-4 h-8 w-8 ${A && T ? "text-red-600 dark:text-red-500" : "text-gray-500 dark:text-gray-400"}`,
            "aria-hidden": "true",
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 20 16",
            children: /* @__PURE__ */ s("path", {
              stroke: "currentColor",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: "2",
              d: "M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
            })
          }),
          /* @__PURE__ */ O("p", {
            className: `mb-2 text-sm ${A && T ? "text-red-600 dark:text-red-500" : "text-gray-500 dark:text-gray-400"}`,
            children: [
              /* @__PURE__ */ s("span", { className: "font-semibold", children: "Click to upload" }),
              " or drag and drop"
            ]
          }),
          /* @__PURE__ */ s("p", {
            className: `text-xs ${A && T ? "text-red-600 dark:text-red-500" : "text-gray-500 dark:text-gray-400"}`,
            "data-testid": "file-input-types",
            children: r.map((E, I) => I === r.length - 1 ? `${E}` : I === r.length - 2 ? `${E} or ` : `${E}, `)
          }),
          /* @__PURE__ */ s("p", { className: "mt-1 text-base", "data-testid": "file-input-url", children: C && C })
        ] }),
        /* @__PURE__ */ s(fl, { classes: "hidden", fileTypes: l, multiple: u, ...x })
      ]
    }) }) })
  });
}, ga = {
  initial: { opacity: 0 },
  animate: {
    opacity: 1,
    transition: { duration: 0.5 }
  }
}, nc = ({ label: a, name: o, disabled: r, required: l = !1, options: u, defaultOptionText: d, sizing: m = "md", onBlurFunc: p, onChangeFunc: g, onChangeIntervalInMs: x = 300, onBlurIntervalInMs: k = 300, isLoading: v = !1, hintProperties: A }) => {
  const [C, T, { setTouched: F }] = ot(o), { error: E, touched: I } = T, { onChange: z, onBlur: R } = C;
  function P(B) {
    return "value" in B;
  }
  const U = Re(Ze((B) => {
    g && g(B);
  }, x)).current, q = Re(Ze((B) => {
    p && p(B);
  }, k)).current;
  return ee(() => () => {
    U.cancel();
  }, [U]), ee(() => () => {
    q.cancel();
  }, [q]), /* @__PURE__ */ s(Pt, {
    name: o,
    labelComponent: /* @__PURE__ */ s(Ue, { children: /* @__PURE__ */ s(et, { children: v ? /* @__PURE__ */ O(ye.div, {
      "data-testid": "select-input-field-skeleton",
      initial: "initial",
      animate: "animate",
      variants: ga,
      role: "status",
      className: "w-full animate-pulse",
      children: [
        /* @__PURE__ */ s("div", { className: "h-[20px] w-[200px] rounded-lg bg-gray-200 dark:bg-gray-700" }),
        /* @__PURE__ */ s("span", { className: "sr-only", children: "Loading..." })
      ]
    }) : /* @__PURE__ */ s(qt, {
      color: E && I ? "failure" : "",
      htmlFor: `${o}-input`,
      value: `${l ? a + "*" : a}`
    }) }) }),
    errorMessage: E && I ? E : "",
    hintProperties: A,
    children: /* @__PURE__ */ s(et, { initial: !1, children: v ? /* @__PURE__ */ O(ye.div, {
      initial: "initial",
      animate: "animate",
      variants: ga,
      role: "status",
      className: "w-full animate-pulse",
      children: [
        /* @__PURE__ */ s("div", {
          className: `w-full rounded-lg bg-gray-200 dark:bg-gray-700 ${m === "sm" ? "h-[33.6px]" : m === "md" ? "h-[41.6px]" : "h-[57.6px]"}`
        }),
        /* @__PURE__ */ s("span", { className: "sr-only", children: "Loading..." })
      ]
    }) : /* @__PURE__ */ s(ye.div, { initial: "initial", animate: "animate", variants: ga, children: /* @__PURE__ */ s(Dt, { ...C, children: ({ field: B }) => /* @__PURE__ */ O($m, {
      ...B,
      "data-testid": "select-input-field",
      id: `${o}-input`,
      sizing: m,
      color: E && I ? "failure" : "",
      disabled: r,
      onClick: () => F(!0),
      onFocus: () => F(!0),
      onChange: (M) => {
        z(M), U(M);
      },
      onBlur: (M) => {
        R(M), q(M);
      },
      required: l,
      children: [
        d && /* @__PURE__ */ s("option", { hidden: !0, value: "null", children: d }),
        u.map((M, V) => typeof M == "object" && P(M) ? /* @__PURE__ */ s("option", { value: M.value, children: M.label }, V) : /* @__PURE__ */ s("option", { value: M, children: M }, V))
      ]
    }) }) }) })
  });
}, jx = ({ isFormFullScreen: a, formName: o, hintsParam: r }) => {
  const [l, u] = Y(!1), [d, m] = Y(a), [p, g] = Y(o), [x, k] = Y(r);
  return {
    name: p,
    setName: g,
    isFormElementLoading: l,
    setIsFormElementLoading: u,
    isFullScreen: d,
    setIsFullScreen: m,
    hints: x
  };
}, Zx = {
  isFormElementLoading: !1,
  isFullScreen: !1,
  name: "",
  hints: [],
  setName: () => {
  },
  setIsFullScreen: () => {
  },
  setIsFormElementLoading: () => {
  }
}, rc = dt(Zx), e3 = ({ children: a, isFormFullScreen: o, formName: r, hintsParam: l }) => /* @__PURE__ */ s(rc.Provider, {
  value: jx({
    isFormFullScreen: o,
    formName: r,
    hintsParam: l
  }),
  children: a
}), Ur = () => Ot(rc), kv = ({ name: a, url: o, label: r, defaultOptionText: l, required: u = !1, disabled: d = !1, sizing: m = "md", loadingFormElement: p = !1, labelProp: g, valueProp: x, responseProp: k, hintProperties: v }) => {
  const A = (I) => _n.get(I).then((z) => k ? z.data[k] : z.data), { isFormElementLoading: C, setIsFormElementLoading: T } = Ur(), { data: F, isLoading: E } = Mg(o, A, {
    // Retry configuration
    onErrorRetry: (I, z, R, P, { retryCount: U }) => {
      p && T(!0), I.status !== 404 && (U >= 3 || setTimeout(() => P({ retryCount: U }), 3e3));
    },
    // Success handler
    onSuccess() {
      p && T(!1);
    },
    // Loading slow handler
    onLoadingSlow() {
      p && T(!0);
    },
    onError(I) {
      p && T(!1), console.log(`%c ${I}`, "color: red");
    }
  });
  return ee(() => {
    p && T(!0);
  }, []), /* @__PURE__ */ s(nc, {
    label: r,
    required: u,
    defaultOptionText: l,
    isLoading: E || C,
    name: a,
    sizing: m,
    disabled: d,
    hintProperties: v,
    options: !E && F ? F.map((I) => ({
      label: I[g],
      value: I[x]
    })) : []
  });
}, t3 = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1
  }
}, ic = ({ children: a, show: o, ...r }) => o ? /* @__PURE__ */ s(ye.div, { variants: t3, initial: "hidden", animate: "visible", exit: "hidden", ...r, children: a }) : void 0, _v = ({ name: a, options: o, label: r, required: l = !1, disabled: u = !1, defaultOption: d, size: m = "small", inputProps: p }) => {
  const [g, x] = ot(a), { error: k, touched: v } = x;
  return /* @__PURE__ */ O(Lg, { error: !!k && v, fullWidth: !0, size: m, disabled: u, required: l, children: [
    r && /* @__PURE__ */ O("div", { className: "flex", children: [
      /* @__PURE__ */ s(Hr, { variant: "body2", children: r }),
      l && /* @__PURE__ */ s(Hr, { variant: "body2", color: "error.main", children: "*" })
    ] }),
    /* @__PURE__ */ O(Og, {
      ...g,
      inputProps: p,
      "data-testid": "mui-select-input",
      sx: {
        "& .MuiInputBase-root": {
          borderRadius: "50px"
        }
      },
      children: [
        d && /* @__PURE__ */ s($i, { disabled: !0, value: "", children: /* @__PURE__ */ s("em", { children: d }) }),
        o.map((A) => /* @__PURE__ */ s($i, { value: A.value, children: A.label }, A.value))
      ]
    }),
    /* @__PURE__ */ s(ic, { show: !!k && v, children: /* @__PURE__ */ s(Dg, { children: k }) })
  ] });
}, xa = ({ name: a, value: o, label: r }) => {
  const [l, u, d] = ot(a), { onChange: m } = l, { error: p, touched: g } = u, { setValue: x, setTouched: k } = d;
  return /* @__PURE__ */ O("div", { className: "flex items-center gap-2", children: [
    /* @__PURE__ */ s(Dt, { ...l, value: o, children: ({ field: v }) => (
      // Render a Radio input element
      /* @__PURE__ */ s(qm, {
        ...v,
        "data-testid": "radio-button-input",
        "data-value": o,
        defaultChecked: u.value === o,
        id: `${o}-radio-button`,
        onChange: (A) => {
          m(A), x(A.target.dataset.value), k(!0);
        }
      })
    ) }),
    /* @__PURE__ */ s(qt, { color: p && g ? "failure" : "", htmlFor: `${o}-radio-button`, children: r })
  ] });
}, n3 = ({ name: a, label: o, children: r, required: l, className: u, onChangeFunc: d, onChangeIntervalInMs: m = 300, hintProperties: p }) => {
  const [g, { value: x, error: k, touched: v }, { setValue: A }] = ot(a);
  ee(() => {
    A(x);
  }, [x]);
  const C = Re(Ze((F) => {
    d && d(F);
  }, m)).current;
  ee(() => () => {
    C.cancel();
  }, [C]);
  const T = (F) => me.Children.map(F, (E) => me.isValidElement(E) ? me.cloneElement(E, {
    ...E.props,
    name: a,
    // Set the name prop to the radio group name
    children: T(E.props.children)
    // Recurse into the children
  }) : E);
  return (
    // Render the radio button group inside a fieldset element
    /* @__PURE__ */ s(Pt, {
      name: a,
      errorMessage: k && v ? k : "",
      labelComponent: o && // Render the label with color indicating error state if touched and has an error
      /* @__PURE__ */ s("label", {
        className: `${k && v ? "text-red-600 dark:text-red-500" : ""}`,
        htmlFor: `${a}-input`,
        children: `${l ? o + "*" : o}`
      }),
      hintProperties: p,
      children: /* @__PURE__ */ s("section", { className: "flex flex-col gap-2", children: /* @__PURE__ */ s("fieldset", {
        className: `${sn(u, "")}`,
        id: `${a}-radio-group`,
        onChange: (F) => {
          C(F);
        },
        "data-testid": "radio-button-group",
        children: T(r)
      }) })
    })
  );
}, r3 = ({ field: a, form: o, ...r }) => {
  const { label: l, description: u, checkedByDefault: d, disabled: m, setValue: p, setTouched: g, required: x, error: k, touched: v, debouncedOnChange: A } = r, { name: C } = a, [T, F] = Y(d);
  return /* @__PURE__ */ O("div", { children: [
    /* @__PURE__ */ O("div", { className: "flex items-center", children: [
      /* @__PURE__ */ s(Km, {
        ...a,
        id: `${C}-switch`,
        name: C,
        checked: T,
        "aria-label": `${C}-switch-button`,
        color: k && v ? "failure" : "info",
        onChange: (E) => {
          g(!0), p(!T), F(!T), A(E);
        },
        disabled: m
      }),
      /* @__PURE__ */ s("span", {
        className: `text-center align-middle text-sm font-medium ${k && v ? "text-red-700 dark:text-red-500" : "text-gray-900 dark:text-gray-300"} disabled:opacity-50`,
        "data-testid": "switch-input-field-label",
        children: typeof l == "string" ? `${x ? l + "*" : l}` : Zm(l) ? l : null
      })
    ] }),
    /* @__PURE__ */ s("p", {
      "data-testid": "switch-input-field-description",
      className: `ml-14 text-xs ${k && v ? "text-red-700 dark:text-red-500" : "text-[#6B7280]"}`,
      children: u
    })
  ] });
}, Av = ({ label: a, name: o, description: r = "", disabled: l = !1, required: u = !1, onChangeFunc: d, onChangeIntervalInMs: m = 300, hintProperties: p }) => {
  const [g, x, k] = ot(o), { error: v, touched: A } = x, { onChange: C } = g, { setValue: T, setTouched: F } = k, E = Re(Ze((I) => {
    d && d(I);
  }, m)).current;
  return ee(() => () => {
    E.cancel();
  }, [E]), /* @__PURE__ */ s(Pt, { name: o, errorMessage: v && A ? v : "", hintProperties: p, children: /* @__PURE__ */ s(Dt, {
    component: r3,
    name: o,
    label: a,
    error: v,
    touched: A,
    description: r,
    setValue: T,
    setTouched: F,
    onChange: C,
    debouncedOnChange: E,
    disabled: l,
    required: u,
    checkedByDefault: g.value
  }) });
}, Sv = ({ label: a, placeholder: o, name: r, disabled: l, rows: u = 4, maxCharacters: d = 100, hideCharacterCounter: m = !1, required: p = !1, sizing: g = "md", onBlurFunc: x, onChangeFunc: k, onChangeIntervalInMs: v = 300, onBlurIntervalInMs: A = 300, hintProperties: C }) => {
  const [T, F, { setTouched: E }] = ot(r), { error: I, value: z, touched: R } = F, { onChange: P, onBlur: U } = T, q = Re(Ze((M) => {
    k && k(M);
  }, v)).current, B = Re(Ze((M) => {
    x && x(M);
  }, A)).current;
  return ee(() => () => {
    q.cancel();
  }, [q]), ee(() => () => {
    B.cancel();
  }, [B]), /* @__PURE__ */ s(Pt, {
    name: r,
    labelComponent: (
      // Render the label with color indicating error state if touched and has an error
      /* @__PURE__ */ s(qt, {
        color: I && R ? "failure" : "",
        htmlFor: `${r}-input`,
        value: `${p ? a + "*" : a}`
      })
    ),
    errorMessage: I && R ? I : "",
    hintProperties: C,
    children: /* @__PURE__ */ O("div", { className: "relative", children: [
      /* @__PURE__ */ s(Dt, { ...T, children: ({ field: M }) => /* @__PURE__ */ s(Qm, {
        ...M,
        id: `${r}-input`,
        "data-testid": "text-area-input-field",
        sizing: g,
        color: I && R ? "failure" : "",
        placeholder: o,
        disabled: l,
        rows: u,
        value: z,
        required: p,
        onClick: () => E(!0),
        onFocus: () => E(!0),
        onChange: (V) => {
          P(V), q(V);
        },
        onBlur: (V) => {
          U(V), B(V);
        }
      }) }),
      !m && /* @__PURE__ */ O("p", {
        className: `absolute right-0 self-end text-base ${I ? "text-red-600" : ""} ${l ? "text-gray-500" : ""}`,
        "data-testid": "character-counter",
        children: [
          z ? z.length : 0,
          " / ",
          d
        ]
      })
    ] })
  });
}, i3 = Vg(Gg)(({ iserror: a, istouched: o, orientation: r, height: l, width: u }) => ({
  // Customize the color of the slider based on error and touched state
  color: a && o ? "#dc2626" : "#0872AB",
  height: l,
  width: u,
  // Customize the appearance of slider marks
  "& .MuiSlider-mark": {
    backgroundColor: "#bfbfbf",
    height: r === "horizontal" ? l * 2 : 1,
    width: r === "vertical" ? u * 2 : 1,
    "&.MuiSlider-markActive": {
      opacity: 1,
      backgroundColor: "currentColor"
    }
  },
  // Customize the appearance of the slider rail
  "& .MuiSlider-rail": {
    border: "2px solid currentColor",
    opacity: 0.1,
    background: "#bfbfbf",
    borderRadiues: "none"
  },
  // Customize the appearance of the slider thumb
  "& .MuiSlider-thumb": {
    height: 24,
    width: 24,
    backgroundColor: "#fff",
    border: "2px solid currentColor",
    boxShadow: hl,
    "&:focus, &:hover, &.Mui-active": {
      boxShadow: "0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.3),0 0 0 1px rgba(0,0,0,0.02)",
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        boxShadow: hl
      }
    },
    "&:before": {
      display: "none"
    }
  },
  // Customize the appearance of the slider value label
  "& .MuiSlider-valueLabel": {
    lineHeight: 1.2,
    fontSize: 12,
    background: "unset",
    padding: 0,
    width: 32,
    height: 32,
    borderRadius: r === "horizontal" ? "50% 50% 50% 0" : "50% 50% 0% 50%",
    backgroundColor: a && o ? "#dc2626" : "#0872AB",
    transformOrigin: "bottom left",
    transform: "translate(50%, -100%) rotate(-45deg) scale(0)",
    "&:before": { display: "none" },
    "&.MuiSlider-valueLabelOpen": {
      transform: r === "horizontal" ? "translate(50%, -100%) rotate(-45deg) scale(1)" : "translate(45%, -30%) rotate(-45deg) scale(1)"
    },
    "& > *": {
      transform: "rotate(45deg)"
    }
  }
})), hl = "0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)", Cv = ({ name: a, label: o = "", inputSize: r = "45", hideInput: l = !0, step: u = 1, marks: d, trackDirection: m = "normal", required: p = !1, displayValueLabel: g = "auto", orientation: x = "horizontal", height: k = 8, disabled: v = !1, width: A = x === "vertical" ? 5 : void 0, min: C = 0, max: T = 100, onBlurFunc: F, onChangeFunc: E, onChangeIntervalInMs: I = 300, onBlurIntervalInMs: z = 300, hintProperties: R }) => {
  const [P, { error: U, value: q, touched: B }, { setValue: M, setTouched: V }] = ot(a), [X, te] = Y(q), ne = (se, _e) => {
    le(se), te(_e), M(_e), V(!0);
  }, $ = (se) => {
    le(se), te(se.target.value === "" ? 0 : Number(se.target.value)), M(se.target.value === "" ? "" : Number(se.target.value)), V(!0);
  }, j = (se) => {
    X < C ? te(C) : X > T && te(T), ve(se), M(X);
  }, le = Re(Ze((se) => {
    E && E(se);
  }, I)).current, ve = Re(Ze((se) => {
    F && F(se);
  }, z)).current;
  return ee(() => () => {
    le.cancel();
  }, [le]), ee(() => () => {
    ve.cancel();
  }, [ve]), /* @__PURE__ */ s(Pt, {
    labelComponent: /* @__PURE__ */ s(qt, {
      color: U && B ? "failure" : "",
      htmlFor: `${a}-range`,
      value: `${p ? o + "*" : o}`
    }),
    errorMessage: U && B ? U : "",
    name: a,
    hintProperties: R,
    children: /* @__PURE__ */ O("div", { className: "flex justify-center gap-7", children: [
      /* @__PURE__ */ s(Dt, { ...P, children: ({ field: se }) => /* @__PURE__ */ s("div", { className: "relative h-full w-full min-w-[70px]", children: /* @__PURE__ */ s(i3, {
        ...se,
        defaultValue: q,
        value: X,
        valueLabelDisplay: g,
        "aria-label": "pretto slider",
        onChange: ne,
        orientation: x,
        iserror: U,
        istouched: B ? `${B}` : void 0,
        disabled: v,
        height: k,
        width: A,
        track: m,
        marks: d,
        min: C,
        max: T,
        step: u
      }) }) }),
      !l && // Render the input element for slider value
      /* @__PURE__ */ s(Kg, {
        id: `${a}-range`,
        className: "self-center",
        style: { width: `${r}px` },
        value: X,
        size: "small",
        onChange: $,
        onBlur: j,
        inputProps: {
          step: { step: u },
          min: { min: C },
          max: { max: T },
          type: "number",
          "aria-labelledby": "input-slider"
        }
      })
    ] })
  });
}, pl = ({ isSidebarOpen: a, dropdown: o, isDropdownOpen: r, children: l }) => {
  const u = {
    visible: {
      width: "auto",
      opacity: 1,
      transition: {
        duration: 0.2
      }
    },
    hidden: {
      width: 0,
      opacity: 0,
      transition: {
        duration: 0.2
      }
    }
  }, d = {
    closed: {
      rotate: 0,
      transition: {
        duration: 0.2
      }
    },
    open: {
      rotate: 180,
      transition: {
        duration: 0.2
      }
    }
  };
  return /* @__PURE__ */ s(et, { initial: !1, children: a && /* @__PURE__ */ O(ye.div, {
    "data-testid": "animated-label",
    initial: "hidden",
    animate: "visible",
    exit: "hidden",
    variants: u,
    className: "flex flex-row items-center overflow-hidden",
    children: [
      l,
      /* @__PURE__ */ s("p", { className: "flex-grow" }),
      o && /* @__PURE__ */ s(ye.div, {
        "data-testid": "animated-label-dropdown",
        initial: "closed",
        animate: r ? "open" : "closed",
        variants: d,
        children: /* @__PURE__ */ s(ug, { className: "w-5 h-5" })
      })
    ]
  }) });
}, Ra = dt(null), o3 = ({ children: a }) => {
  const [o, r] = Y(!0);
  return /* @__PURE__ */ s(Ra.Provider, { value: { isOpen: o, setIsOpen: r }, children: a });
}, a3 = ({ structure: a }) => {
  const o = $l(), r = {
    root: {
      inner: "h-full overflow-y-auto overflow-x-hidden bg-gray-50 py-4 px-3 dark:bg-gray-800"
    }
  }, l = Qg(), u = {
    visible: {
      height: "auto",
      opacity: 1,
      transition: {
        duration: 0.2
      }
    },
    hidden: {
      height: 0,
      opacity: 0,
      transition: {
        duration: 0.2
      }
    }
  }, d = {
    visible: {
      width: "15rem",
      opacity: 1,
      transition: {
        duration: 0.2
      }
    },
    compact: {
      width: "4rem",
      opacity: 1,
      transition: {
        duration: 0.2
      }
    },
    hidden: {
      width: 0,
      opacity: 0,
      transition: {
        duration: 0.2
      }
    }
  };
  function m(C) {
    p && (g(!1), v((T) => T.map(() => !1)), C == null || C.stopPropagation());
  }
  const { isOpen: p, setIsOpen: g } = me.useContext(Ra), x = [];
  a.items.forEach(() => {
    x.push(!1);
  });
  const [k, v] = Y(x);
  function A(C) {
    a.items[C].dropdown && v((T) => Object.assign([], {
      ...T,
      [C]: !k[C]
    }));
  }
  return /* @__PURE__ */ s("div", { className: "h-screen block", children: /* @__PURE__ */ s(et, { children: /* @__PURE__ */ s(ye.div, {
    className: "h-screen overflow-hidden",
    id: "sidenav",
    animate: p ? "visible" : o ? "hidden" : "compact",
    variants: d,
    layout: !0,
    children: /* @__PURE__ */ O(cr, {
      "data-testid": "sidenav",
      theme: r,
      className: "h-full w-60",
      onClick: () => {
        p || g(!0);
      },
      children: [
        a.logoImg && /* @__PURE__ */ s(cr.Logo, {
          href: "#",
          img: a.logoImg,
          imgAlt: "SampleTrack logo",
          className: "h-[32px] pl-1",
          children: /* @__PURE__ */ O(pl, { isSidebarOpen: p, children: [
            a.logo,
            !o && /* @__PURE__ */ O(Ca, {
              "data-testid": "sidenav-close-button",
              color: "light",
              className: "w-8 h-8 border-none focus:ring-0",
              onClick: m,
              children: [
                /* @__PURE__ */ s("div", { className: " hidden" }),
                /* @__PURE__ */ s(dg, { className: "w-6 h-6 text-main" })
              ]
            })
          ] })
        }),
        /* @__PURE__ */ s(cr.Items, { children: /* @__PURE__ */ s(cr.ItemGroup, { children: a.items.map((C, T) => {
          var F;
          return /* @__PURE__ */ O("div", { children: [
            /* @__PURE__ */ s(cr.Item, {
              icon: C.icon,
              onClick: () => {
                C.dropdown ? A(T) : l("/" + C.link);
              },
              children: /* @__PURE__ */ s(pl, {
                isSidebarOpen: p,
                dropdown: C.dropdown,
                isDropdownOpen: k[T],
                children: C.label
              })
            }),
            C.dropdown && /* @__PURE__ */ s(et, { children: k[T] && /* @__PURE__ */ s(ye.div, {
              initial: "hidden",
              animate: "visible",
              exit: "hidden",
              className: "overflow-hidden pl-6",
              variants: u,
              children: (F = C.items) == null ? void 0 : F.map((E) => /* @__PURE__ */ s(cr.Item, {
                className: "block",
                onClick: () => {
                  l("/" + E.link);
                },
                children: /* @__PURE__ */ s("div", { className: "whitespace-normal -my-6", children: E.label })
              }, E.label + E.link))
            }, "dropList") })
          ] }, C.label + C.link);
        }) }) })
      ]
    })
  }, "sidenavbar") }) });
}, ka = ({ disableText: a = !1, disableImg: o = !1, className: r = "", imageSize: l }) => /* @__PURE__ */ O("div", { "data-testid": "sampletrack-logo", className: `flex flex-row ${r} items-center p-2`, children: [
  !o && /* @__PURE__ */ s("img", {
    "data-testid": "logo-image",
    src: "\\src\\assets\\sample_track_logo_blue.png",
    alt: "SampleTrack logo",
    style: { height: l || "2rem" },
    className: "pr-2"
  }),
  !a && /* @__PURE__ */ O("div", { "data-testid": "logo-text", className: "flex cursor-default flex-row items-center", children: [
    /* @__PURE__ */ s("p", { children: "Sample" }),
    /* @__PURE__ */ s("p", { className: "pr-1 text-main", children: "Track" })
  ] })
] }), s3 = {
  logo: /* @__PURE__ */ s(ka, { disableImg: !0 }),
  logoImg: "\\src\\assets\\sample_track_logo_blue.png",
  items: [
    {
      label: "Dashboard",
      dropdown: !1,
      icon: fg,
      link: "home"
    },
    {
      label: "Minták",
      dropdown: !0,
      icon: hg,
      link: "#",
      items: [
        {
          label: "Minta csoportok",
          dropdown: !1,
          link: "mintacsoportok"
        },
        {
          label: "Minta csoport hozzáadása",
          dropdown: !1,
          link: "sample-group"
        },
        {
          label: "Minta letöltése",
          dropdown: !1,
          link: "sample-download"
        },
        {
          label: "Minta általános információk",
          dropdown: !1,
          link: "#"
        },
        {
          label: "Minta elhelyezés információk",
          dropdown: !1,
          link: "#"
        },
        {
          label: "Minta tárolók",
          dropdown: !1,
          link: "mintatarolok"
        },
        {
          label: "Tároló információk",
          dropdown: !1,
          link: "#"
        },
        {
          label: "Tároló hozzáadása",
          dropdown: !1,
          link: "plate-addition"
        }
      ]
    },
    {
      label: "Diagnosztikumok",
      dropdown: !0,
      icon: pg,
      link: "#",
      items: [
        {
          label: "Diagnosztikum gyártó",
          dropdown: !1,
          link: "#"
        },
        {
          label: "Diagnosztikum típusok",
          dropdown: !1,
          link: "#"
        },
        {
          label: "Diagnosztikum dobozok",
          dropdown: !1,
          link: "#"
        }
      ]
    },
    {
      label: "Vizsgálat végzése",
      dropdown: !1,
      icon: mg,
      link: "layout-test-2"
    },
    {
      label: "Vizsgálat típusok",
      dropdown: !0,
      icon: gg,
      link: "#",
      items: [
        {
          label: "Metódusok",
          dropdown: !1,
          link: "methods"
        }
      ]
    },
    {
      label: "Adminisztráció",
      dropdown: !0,
      icon: ag,
      link: "#",
      items: [
        {
          label: "Felhasználók",
          dropdown: !1,
          link: "admin/user-list"
        }
      ]
    },
    {
      label: "Segítség",
      dropdown: !1,
      icon: xg,
      link: "#"
    }
  ]
}, Ev = ({ children: a, sidenavConfig: o = s3 }) => (
  //Page container
  /* @__PURE__ */ s("div", { "data-testid": "sidenav-container", className: "flex w-screen h-screen flex-row overflow-hidden", children: /* @__PURE__ */ O(o3, { children: [
    /* @__PURE__ */ s(a3, { structure: o }),
    /* @__PURE__ */ s("div", { "data-testid": "page-content", className: "flex-[0_0_100%] sm:flex-auto overflow-y-auto custom-scrollbar mr-0.5", children: a })
  ] }) })
), oc = ({ children: a, className: o, ...r }) => /* @__PURE__ */ s("div", {
  "data-testid": "background",
  className: sn("bg-sub min-h-screen font-sans", o),
  ...r,
  children: a
}), l3 = ({ path: a }) => /* @__PURE__ */ O("div", {
  "data-testid": "breadcrumbs-container",
  className: "flex flex-row items-start py-2 text-sm font-medium text-other-black",
  children: [
    /* @__PURE__ */ s(yg, { className: "mr-2.5 h-5 w-5 " }),
    /* @__PURE__ */ s("div", { children: "Home" }),
    a == null ? void 0 : a.map((o, r) => /* @__PURE__ */ O("div", { className: "flex flex-row", children: [
      /* @__PURE__ */ s(vg, { className: "mx-1 h-5 w-5" }),
      /* @__PURE__ */ s("div", { children: o })
    ] }, r))
  ]
}), c3 = ({ mobile: a, pfp: o, logout: r }) => {
  const l = {
    visible: {
      height: "auto",
      opacity: 1,
      transition: {
        duration: 0.2
      }
    },
    hidden: {
      height: 0,
      opacity: 0,
      transition: {
        duration: 0.2
      }
    }
  }, [u, d] = Y(!1);
  return /* @__PURE__ */ s(Ue, { children: a ? /* @__PURE__ */ O("div", { "data-testid": "mobile-extras", className: "relative flex-[0_0_auto] flex-row py-5 sm:px-6 lg:px-8", children: [
    /* @__PURE__ */ s("img", {
      className: "mx-2 h-8 w-8 rounded-full object-cover",
      src: o,
      alt: "",
      onClick: () => d(!u)
    }),
    /* @__PURE__ */ s(et, { children: u && /* @__PURE__ */ O(ye.div, {
      initial: "hidden",
      animate: "visible",
      exit: "hidden",
      variants: l,
      className: "top-18 absolute right-0 z-50 flex-col rounded-sm border border-other-gray bg-white px-1 text-base font-normal shadow",
      children: [
        /* @__PURE__ */ s("div", { className: "my-1 px-4 py-1 hover:bg-other-gray-light", children: "Profil" }),
        /* @__PURE__ */ s("div", { className: "border-t border-t-other-gray-dark" }),
        /* @__PURE__ */ s("div", { className: "my-1 px-4 py-1 hover:bg-other-gray-light", onClick: r, children: "Kijelentkezés" })
      ]
    }, "profiledropdown") })
  ] }) : /* @__PURE__ */ O("div", { "data-testid": "desktop-extras", className: "flex flex-[0_0_auto] flex-row sm:mt-12", children: [
    /* @__PURE__ */ s("img", { className: "mx-2 h-10 w-10 rounded-full object-cover", src: o, alt: "" }),
    /* @__PURE__ */ s("div", { className: "my-2 h-6 border-l-2 border-l-other-gray-dark" }),
    /* @__PURE__ */ s("div", { className: "mx-2 cursor-pointer py-2 text-sm font-medium text-other-gray-dark", onClick: r, children: "Kijelentkezés" })
  ] }) });
}, u3 = () => {
  const a = {
    open: {
      rotate: 180,
      transition: {
        duration: 0.2
      }
    },
    closed: {
      rotate: 0,
      transition: {
        duration: 0.2
      }
    }
  }, { isOpen: o, setIsOpen: r } = me.useContext(Ra);
  return /* @__PURE__ */ s(Ca, {
    "data-testid": "navbar-button",
    color: "light",
    className: "mx-2 h-8 w-8 border-none focus:ring-0",
    onClick: () => {
      r(!o);
    },
    children: /* @__PURE__ */ s(ye.div, { animate: o ? "open" : "closed", variants: a, children: /* @__PURE__ */ s(bg, { className: "h-6 w-6 text-main" }) })
  });
}, Ma = ({ children: a, path: o, pfp: r, noSidenav: l = !1, label: u, headerProps: d, logout: m }) => {
  const p = $l();
  return /* @__PURE__ */ O("div", {
    "data-testid": "Header",
    className: sn("z-10 flex flex-row items-center bg-other-white px-3 text-xl font-extrabold text-other-gray-dark sm:bg-transparent sm:text-3xl md:px-6", d == null ? void 0 : d.className),
    children: [
      /* @__PURE__ */ O("div", { className: "flex w-full  min-w-0 max-w-7xl flex-col sm:pt-12", children: [
        /* @__PURE__ */ O("div", { className: "flex w-full flex-row items-center justify-between", children: [
          p && !l && /* @__PURE__ */ s(u3, {}),
          /* @__PURE__ */ s("div", { className: "overflow-hidden text-ellipsis whitespace-nowrap font-bold tracking-wide sm:min-h-[40px]", children: u }),
          /* @__PURE__ */ s("div", { className: "flex flex-[0_0_auto] flex-row items-center", children: a })
        ] }),
        !p && /* @__PURE__ */ s(l3, { path: o })
      ] }),
      r && /* @__PURE__ */ s("div", { className: "flex-[1_5_100%]" }),
      r && /* @__PURE__ */ s(c3, { pfp: r, mobile: p, logout: m })
    ]
  });
}, La = ({ children: a, className: o = "", ...r }) => /* @__PURE__ */ s("div", {
  className: sn("px-3 md:px-6 xl:px-16 2xl:px-24 py-3 sm:py-8", o),
  ...r,
  children: a
}), Tv = ({ children: a, headerChildren: o, bodyProps: r, ...l }) => /* @__PURE__ */ O(oc, { children: [
  /* @__PURE__ */ s(Ma, {
    headerProps: {
      className: "xl:px-16 2xl:px-24"
    },
    pfp: "https://i.natgeofe.com/k/8fa25ea4-6409-47fb-b3cc-4af8e0dc9616/red-eyed-tree-frog-on-leaves-3-2_3x2.jpg",
    ...l,
    children: o
  }),
  /* @__PURE__ */ s(La, { ...r, children: a })
] }), Iv = ({ children: a, headerChildren: o, headerProps: r, ...l }) => /* @__PURE__ */ s(oc, { children: /* @__PURE__ */ O(La, { className: "w-full h-screen max-h-screen overflow-hidden grid grid-cols-1 grid-rows-[min-content_1fr] py-0 sm:py-0 px-0", children: [
  /* @__PURE__ */ s(Ma, {
    pfp: "https://i.natgeofe.com/k/8fa25ea4-6409-47fb-b3cc-4af8e0dc9616/red-eyed-tree-frog-on-leaves-3-2_3x2.jpg",
    headerProps: {
      ...r,
      className: sn(r == null ? void 0 : r.className, "px-0 sm:px-0 md:px-0 lg:px-0 xl:px-0 2xl:px-0")
    },
    ...l,
    children: o
  }),
  /* @__PURE__ */ s("div", { className: "w-full h-full max-h-full p-3 sm:p-0 sm:pt-8 sm:pb-16", children: a })
] }) }), d3 = (a) => {
  switch (a) {
    case "equals":
      return "__iexact";
    case "contains":
      return "__icontains";
    case "greaterThan":
      return "__gt";
    case "lessThan":
      return "__lt";
    case "greaterThanOrEqual":
      return "__gte";
    case "lessThanOrEqual":
      return "__lte";
    case "between":
      return "__range";
    default:
      return "__contains";
  }
};
async function ac(a, o, r, l, u, d) {
  const m = (p) => u && u[p] ? `${d3(u[p])}` : "__contains";
  return new Promise((p, g) => {
    const x = new URL(a, d ?? "https://sample-track.up.railway.app/");
    x.searchParams.set("page_size", `${o.pageSize}`), x.searchParams.set("page", `${o.pageIndex + 1}`), l.forEach((v) => {
      if (m(v.id) === "__iexact" && Array.isArray(v.value)) {
        const [A, C] = v.value;
        A && x.searchParams.set(`${v.id}__gte`, A), C && x.searchParams.set(`${v.id}__lte`, C);
      } else if (m(v.id) === "__range") {
        const [A, C] = v.value;
        A && x.searchParams.set(`${v.id}__gte`, A), C && x.searchParams.set(`${v.id}__lte`, C);
      } else
        m(v.id) === "__icontains" && Array.isArray(v.value) ? v.value.forEach((A) => {
          x.searchParams.append(`${v.id}${m(v.id)}`, `${A}`);
        }) : x.searchParams.set(`${v.id}${m(v.id)}`, `${v.value}`);
    });
    const k = [];
    r.forEach((v) => {
      k.push(`${v.desc ? "-" : ""}${v.id}`);
    }), k.length > 0 && x.searchParams.set("__ordering__", k.join(",")), console.log("fetching url:", x.href), _n.get(x.href).then((v) => {
      p({
        response: v.data,
        url: x.href
      });
    }).catch((v) => {
      g(v);
    });
  });
}
const Oa = ({ status: a, variant: o }) => {
  const r = {
    variant: o ?? "outlined",
    size: "small"
  };
  return [
    /* @__PURE__ */ s(Hi, { label: "Létrehozva", ...r }, 0),
    /* @__PURE__ */ s(Hi, { label: "Letöltendő", color: "warning", ...r }, 1),
    /* @__PURE__ */ s(Hi, { label: "Kész", color: "success", ...r }, 2),
    /* @__PURE__ */ s(Hi, { label: "Elutasítva", color: "error", ...r }, 3)
  ][a - 1];
};
function sc(a) {
  return a.map((o) => (Object.keys(o).forEach((r) => {
    Array.isArray(o[r]) && (o[r] = o[r].join(", "));
  }), o));
}
function f3(a, o) {
  const r = {};
  return a.forEach((l) => {
    const u = o.original[l.accessorKey];
    let d = u ? /* @__PURE__ */ s("div", { children: u }) : /* @__PURE__ */ s("i", { className: "opacity-30", children: "empty" });
    l.quickFilterType === "status-select" ? d = /* @__PURE__ */ s(Oa, { status: u }) : l.quickFilterType === "date-range" && (d = /* @__PURE__ */ s("div", { children: pr(u).format("YYYY-MM-DD HH:mm") })), r[l.header] = d;
  }), r;
}
const ml = ({ disabled: a, onClick: o }) => /* @__PURE__ */ s(Qi, { title: "Szűrő törlése", placement: "right", arrow: !0, children: /* @__PURE__ */ s("span", { children: /* @__PURE__ */ s(Gl, {
  sx: {
    marginBottom: "8px"
  },
  "data-testid": "clearfilterbutton",
  size: "small",
  disabled: a,
  onClick: o,
  children: /* @__PURE__ */ s(Xg, {})
}) }) }), gl = {
  sx: {
    marginTop: "0px",
    marginBottom: "10px",
    "& .MuiInputBase-input::placeholder": {
      textTransform: "none"
    },
    "& .MuiInputBase-input": {
      textTransform: "lowercase"
    }
  },
  ampm: !1,
  disableFuture: !0,
  format: "YYYY/MM/DD HH:mm",
  localeText: Hl.components.MuiLocalizationProvider.defaultProps.localeText
}, Ui = {
  textField: {
    hiddenLabel: !0,
    label: void 0,
    variant: "standard",
    inputProps: {
      className: "focus:ring-0"
      // disabled: true,
    }
  },
  inputAdornment: {
    position: "start",
    sx: {
      marginRight: "4px",
      paddingBottom: "4px"
    }
  },
  openPickerButton: {
    size: "small"
  }
};
function h3({
  // column,
  getFilterValue: a,
  setFilterValue: o,
  setDateFilter: r,
  value: l,
  columnKey: u
}) {
  const d = (p) => {
    const g = p ? pr(p).toISOString() : void 0, x = p || null;
    if (Array.isArray(a())) {
      const [k, v] = a();
      o([g, v]);
    } else
      o([g, void 0]);
    r(u, { ...l, from: x });
  }, m = (p) => {
    const g = p ? pr(p).toISOString() : void 0, x = p || null;
    if (Array.isArray(a())) {
      const [k, v] = a();
      o([k, g]);
    } else
      o([void 0, g]);
    r(u, { ...l, to: x });
  };
  return /* @__PURE__ */ O(Eg, { dateAdapter: Ul, children: [
    /* @__PURE__ */ O("div", { className: "flex flex-row items-center justify-between gap-1", children: [
      /* @__PURE__ */ s(ll, {
        label: "Szűrés Dátumtól",
        onChange: d,
        slotProps: {
          ...Ui,
          textField: {
            ...Ui.textField,
            placeholder: "Szűrés Dátumtól"
          }
        },
        value: l.from,
        ...gl
      }),
      /* @__PURE__ */ s(ml, {
        disabled: l.from === null,
        onClick: () => {
          d(null);
        }
      })
    ] }),
    /* @__PURE__ */ O("div", { className: "flex flex-row items-center justify-between gap-1", children: [
      /* @__PURE__ */ s(ll, {
        label: "Szűrés Dátumig",
        onChange: m,
        value: l.to,
        slotProps: {
          ...Ui,
          textField: {
            ...Ui.textField,
            placeholder: "Szűrés Dátumig"
          }
        },
        ...gl
      }),
      /* @__PURE__ */ s(ml, {
        disabled: l.to === null,
        onClick: () => {
          m(null);
        }
      })
    ] })
  ] });
}
const lc = ({ showModal: a, toggleShowModal: o, children: r, title: l }) => /* @__PURE__ */ s(ix, {
  "data-testid": "table-modal",
  open: a,
  onClose: o,
  "aria-labelledby": "modal-modal-title",
  "aria-describedby": "modal-modal-description",
  children: /* @__PURE__ */ O(ox, { children: [
    /* @__PURE__ */ s(ax, {
      sx: {
        marginTop: "6px",
        marginRight: "12px"
      },
      size: "lg",
      "data-testid": "export-modal-close"
    }),
    /* @__PURE__ */ s("p", { className: "font-semibold text-lg", children: l }),
    /* @__PURE__ */ s("hr", {}),
    /* @__PURE__ */ s("div", { className: "mt-2 space-y-6 text-sm leading-relaxed text-gray-500", children: r })
  ] })
}), cc = ({ message: a, title: o, messageIcon: r }) => {
  const [l, u] = Y();
  return /* @__PURE__ */ O(Ue, { children: [
    /* @__PURE__ */ O("button", {
      className: "flex max-w-[200px] cursor-pointer items-center gap-2 opacity-60 hover:opacity-100",
      onClick: () => u("default"),
      children: [
        /* @__PURE__ */ s("div", { className: "h-5 w-5 flex-shrink-0 cursor-pointer", children: r ? /* @__PURE__ */ s(Jg, { "data-tesid": "message-icon" }) : /* @__PURE__ */ s(jg, { "data-testid": "not-message-icon" }) }),
        /* @__PURE__ */ s("p", { className: "max-w-full overflow-hidden text-ellipsis text-xs text-other-gray-dark", children: a })
      ]
    }),
    /* @__PURE__ */ s(lc, {
      showModal: l === "default",
      toggleShowModal: () => u(void 0),
      title: o,
      children: a
    })
  ] });
};
function p3({ label: a, tooltip: o, onClick: r }) {
  return /* @__PURE__ */ s(Qi, { title: o, arrow: !0, placement: "left", children: /* @__PURE__ */ s(Vl, {
    size: "small",
    style: { textTransform: "lowercase" },
    endIcon: /* @__PURE__ */ s(hx, {}),
    onClick: r,
    children: a
  }) });
}
function m3(a, o, r, l, u) {
  const d = [];
  return a.forEach((m) => {
    const p = m;
    p.enableFilterMatchHighlighting = !1, m.quickFilterType && (m.quickFilterType === "date-range" && o[m.accessorKey] ? (p.enableColumnFilterModes = !1, p.Filter = ({ column: g }) => /* @__PURE__ */ s(h3, {
      getFilterValue: g.getFilterValue,
      setFilterValue: g.setFilterValue,
      setDateFilter: r,
      value: o[p.accessorKey],
      columnKey: p.accessorKey
    }), p.Cell = ({ cell: g }) => /* @__PURE__ */ s("div", { children: pr(g.getValue()).format("YYYY-MM-DD HH:mm") }), p.size = 260, l(p.accessorKey, "equals")) : m.quickFilterType === "status-select" ? (p.enableColumnFilterModes = !1, p.Cell = ({ cell: g }) => /* @__PURE__ */ s(Oa, { status: g.getValue() }), p.filterVariant = "select", p.filterSelectOptions = [
      {
        text: "Létrehozva",
        value: "1"
      },
      {
        text: "Letöltendő",
        value: "2"
      },
      {
        text: "Kész",
        value: "3"
      },
      {
        text: "Elutasítva",
        value: "4"
      }
    ]) : m.quickFilterType === "comment" ? (p.columnFilterModeOptions = ["contains", "equals"], p.Cell = ({ cell: g }) => g.getValue() !== "" && g.getValue() != null && /* @__PURE__ */ s(cc, { title: "Megjegyzes", message: g.getValue() })) : m.quickFilterType === "number" ? p.columnFilterModeOptions = [
      "equals",
      "greaterThan",
      "greaterThanOrEqualTo",
      "lessThan",
      "lessThanOrEqualTo",
      "between"
    ] : m.quickFilterType === "text" ? p.columnFilterModeOptions = ["contains", "equals"] : (p.size = 260, m.quickFilterType in u ? (p.enableColumnFilterModes = !1, p.filterVariant = "select", p.filterSelectOptions = u[m.quickFilterType], "Filter" in p && delete p.Filter) : p.Filter = () => /* @__PURE__ */ s("p", { className: "animate-pulse border-b border-other-gray pt-[7px] font-extralight italic text-other-gray", children: "töltés..." }))), m.onCellClick && (p.Cell = ({ cell: g, row: x }) => /* @__PURE__ */ s(p3, {
      label: g.getValue(),
      tooltip: m.clickableCellToolTip ?? "Kattints ide!",
      onClick: () => {
        var k;
        (k = m.onCellClick) == null || k.call(m, x.original);
      }
    })), d.push(p);
  }), d;
}
function g3(a) {
  const o = [];
  return a.forEach((r) => {
    const l = r;
    r.quickCellType ? r.quickCellType === "date" ? l.Cell = ({ cell: u }) => /* @__PURE__ */ s("p", { children: pr(u.getValue()).format("YYYY-MM-DD HH:mm") }) : r.quickCellType === "status" ? l.Cell = ({ cell: u }) => /* @__PURE__ */ s(Oa, { status: u.getValue() }) : (r.quickCellType === "comment" || r.quickCellType === "long") && (l.Cell = ({ cell: u }) => u.getValue() !== "" && u.getValue() != null && /* @__PURE__ */ s(cc, {
      title: r.quickCellType === "comment" ? "Megjegyzes" : r.header,
      message: u.getValue(),
      messageIcon: r.quickCellType === "long"
    })) : l.Cell = ({ cell: u }) => /* @__PURE__ */ s("p", { className: "max-w-[300px] overflow-hidden text-ellipsis", children: u.getValue() }), o.push(l);
  }), o;
}
function Fv({ columnsData: a, dataURL: o, mainURL: r = "" }) {
  const [l, u] = Y([]), [d, m] = Y(!1);
  ee(() => {
    l.length || m(!0), ac(o, {
      pageIndex: 0,
      pageSize: 10
    }, [], [], {}, r).then(({ response: g }) => {
      u(sc(g.results)), m(!1);
    }).catch((g) => {
      console.error("Error fetching data:", g), m(!1);
    });
  }, []);
  const p = Ol(() => g3(a), [a]);
  return /* @__PURE__ */ s("div", { className: "overflow-hidden rounded-small border border-other-gray", children: d ? /* @__PURE__ */ s("div", { className: "flex h-full w-full items-center justify-center p-4", children: /* @__PURE__ */ s(Ea, { size: "lg" }) }) : /* @__PURE__ */ s(ql, {
    data: l,
    columns: p,
    initialState: {
      density: "compact"
    },
    enableColumnActions: !1,
    enableColumnFilters: !1,
    enablePagination: !0,
    enableSorting: !1,
    enableBottomToolbar: !1,
    enableTopToolbar: !1,
    muiTableBodyRowProps: { hover: !1 },
    muiTableProps: {
      sx: {
        border: 0
      }
    },
    muiTableHeadCellProps: {
      sx: {
        border: 0,
        backgroundColor: "rgba(0, 0, 0, 0.05)"
      }
    },
    muiTableBodyCellProps: {
      sx: {
        border: 0,
        borderTop: "1px solid rgba(0, 0, 0, 0.2)"
      }
    },
    muiTablePaperProps: {
      elevation: 0,
      sx: {
        borderRadius: "6px",
        overflow: "hidden"
      }
    }
  }) });
}
const x3 = () => {
  const { columnsData: a } = Gr(), [o, r] = Y({});
  return ee(() => {
    const u = {};
    a.forEach((d) => {
      d.defaultFilterFn ? u[d.accessorKey] = d.defaultFilterFn : u[d.accessorKey] = "contains";
    }), r(u);
  }, [a]), {
    columnFilterFns: o,
    setColumnFilterFns: r,
    changeColumnFilterFn: (u, d) => {
      const m = { ...o };
      m[u] = d, r(m);
    }
  };
}, y3 = () => {
  const { columnsData: a } = Gr(), [o, r] = Y({}), l = (p, g) => {
    const x = { ...o };
    x[p] = g, r(x);
  }, u = (p) => {
    const g = { ...o };
    g[p] = {
      from: null,
      to: null
    }, r(g);
  }, d = () => {
    const p = {};
    return a.forEach((g) => {
      g.quickFilterType && g.quickFilterType === "date-range" && (p[g.accessorKey] = {
        from: null,
        to: null
      });
    }), p;
  }, m = (p) => {
    Object.keys(o).forEach((g) => {
      p.find((x) => x.id === g) || u(g);
    });
  };
  return ee(() => {
    r(d());
  }, [a]), {
    dateFilter: o,
    changeDateFilterAtKey: l,
    resetDateFilterAtKey: u,
    refreshAllDateFilterValues: m
  };
}, uc = async (a) => new Promise((o, r) => {
  _n.get(a).then((l) => {
    o(l.data);
  }).catch((l) => {
    r(l);
  });
});
function v3(a) {
  return a.replace(/"/g, "").replace(/,/g, ";").replace(/[A-Z]+/g, (o) => "-" + o.toLowerCase());
}
function Gn(a, o, r) {
  for (let l = 0; l < a.cssRules.length; l++) {
    const u = a.cssRules[l];
    if (u instanceof CSSStyleRule && u.selectorText === o) {
      a.deleteRule(l);
      break;
    }
  }
  return a.insertRule(`${o} ${v3(JSON.stringify(r))}`);
}
function _a(a) {
  let o = document.getElementById(a);
  return o || (o = document.createElement("style"), o.type = "text/css", o.id = a, document.head.appendChild(o)), o.sheet;
}
const dc = ({ selectorName: a, whenTriggered: o = !0, whenRerender: r, scrollVerticalAlignment: l = "center", scrollHorizontalAlignment: u = "nearest", focusedElementIndex: d = 0, onlyScroll: m = !1, focusOnParent: p = !1, whenFinished: g = () => () => {
} }) => {
  let x;
  const k = Ze(() => {
    const v = document.querySelectorAll(a)[d];
    v && (m || (p ? v.parentElement && (v.parentElement.classList.remove("animate-scale"), v.parentElement.classList.add("animate-scale")) : v && (v.classList.remove("animate-scale"), v.classList.add("animate-scale")), x = setTimeout(() => {
      try {
        p ? v.parentElement && v.parentElement.classList.remove("animate-scale") : v && v.classList.remove("animate-scale"), g();
      } catch (A) {
        console.warn(A);
      }
    }, 2e3)), v.scrollIntoView && v.scrollIntoView({
      behavior: "smooth",
      block: l,
      inline: u
    }));
  }, 500);
  return ee(() => {
    if (!(!r && !o))
      return k.cancel(), k(), () => {
        g(), clearTimeout(x), k.cancel();
        const v = document.querySelectorAll(a)[d];
        try {
          p ? v != null && v.parentElement && (v == null || v.parentElement.classList.remove("animate-scale")) : v && v.classList.remove("animate-scale");
        } catch {
        }
      };
  }, [r]), null;
}, Aa = {
  animalspecies: "https://sample-track.up.railway.app/samples/animalspecies",
  testmain: "https://sample-track.up.railway.app/measeval/testmain"
}, b3 = () => {
  const { selectableColumns: a } = Gr(), [o, r] = me.useState({}), [l, u] = me.useState("loading");
  return ee(() => {
    async function d() {
      const p = Object.keys(Aa).map(async (g) => {
        try {
          if (a != null && a.includes(g)) {
            const x = (await uc(Aa[g])).results.map((k) => k.name);
            r((k) => ({ ...k, [g]: x }));
          }
        } catch (x) {
          console.log(x), r((k) => ({ ...k, [g]: [] })), u("error");
        }
      });
      await Promise.all(p);
    }
    async function m() {
      try {
        u("loading"), await d(), u("ready");
      } catch (p) {
        console.log(p), u("error");
      }
    }
    a && m();
  }, [a]), {
    selectables: o,
    selectablesStatus: l
  };
}, Gr = () => Ot(mc), w3 = () => Ot(yc), k3 = () => {
  const [a, o] = Y("idle"), [r, l] = Y(/* @__PURE__ */ s(ul, {}));
  return ee(() => {
    switch (a) {
      case "idle":
        l(/* @__PURE__ */ s(ul, {}));
        break;
      case "loading":
        l(/* @__PURE__ */ s(Ea, { size: "sm", className: "mb-2" }));
        break;
      case "success":
        l(/* @__PURE__ */ s(ex, {}));
        break;
      case "error":
        l(/* @__PURE__ */ s(Zg, {}));
        break;
    }
  }, [a]), { exportStatus: a, setExportStatus: o, exportStatusIcon: r };
}, _3 = {
  fileName: "exportalt_adatok",
  fileType: "csv",
  options: "all"
}, A3 = ({ toggleShowModal: a }) => {
  const { data: o, fetchingURL: r, tableRef: l, exportData: u } = w3(), { exportStatus: d, setExportStatus: m, exportStatusIcon: p } = k3(), { columnsData: g } = Gr(), x = g.reduce((F, E) => (E.accessorKey && (F[E.accessorKey] = E.header), F), {}), k = async (F) => {
    if (l && l.current) {
      let E = null;
      F.options === "selected" ? E = l.current.getSelectedRowModel().rows.map((z) => z.original) : F.options === "page" && (E = o), m("loading"), u(F.fileName, F.fileType, x, E ?? void 0, r).then(() => {
        m("success"), a();
      }).catch(() => {
        m("error");
      });
    }
  }, [v, A] = Y(0), [C, T] = Y(0);
  return ee(() => {
    l && l.current && (A(l.current.getSelectedRowModel().rows.length), T(l.current.getRowModel().rows.length));
  }), /* @__PURE__ */ s(Ta, {
    initialValues: _3,
    validationSchema: qi.object().shape({
      fileName: qi.string().required("Adjon meg egy fajl nevet!").test("fileName", "Nem tartalmazhat speciális karaktereket!", (F) => !F.match(/[^A-Za-z0-9_]/g))
    }),
    onSubmit: k,
    children: /* @__PURE__ */ O(Ia, { children: [
      /* @__PURE__ */ O("div", { className: "flex justify-between gap-2", children: [
        /* @__PURE__ */ s("div", { className: "sm:w-[300px]", children: /* @__PURE__ */ s(tc, { name: "fileName", placeholder: "...", label: "Fájl neve", required: !0 }) }),
        /* @__PURE__ */ s("div", { className: "w-[120px] sm:w-[150px]", children: /* @__PURE__ */ s(nc, {
          name: "fileType",
          label: "Fájl típusa",
          defaultOptionText: ".csv",
          options: [
            { value: "csv", label: ".csv" },
            { value: "xlsx", label: ".xlsx" }
          ]
        }) })
      ] }),
      /* @__PURE__ */ O(n3, { label: "", name: "options", className: "mt-2 space-y-2", children: [
        /* @__PURE__ */ s(xa, { value: "all", label: "Összes adat exportálása" }),
        /* @__PURE__ */ s(xa, { value: "page", label: "Jelenlegi oldal exportálása" }),
        /* @__PURE__ */ O("div", { className: v === 0 ? "hidden" : "", children: [
          /* @__PURE__ */ s(xa, { value: "selected", label: "Kiválasztott elemek exportálása" }),
          /* @__PURE__ */ s(Xm, { color: "main", className: "mt-4 rounded-small px-4 py-2", children: `Kiválasztott elemek száma: ${v}/${C}` })
        ] })
      ] }),
      /* @__PURE__ */ O("div", { className: "mt-6 flex items-center gap-2", children: [
        /* @__PURE__ */ s(Yi, { type: "submit", size: "sm", endIcon: p, children: "Exportálás" }),
        /* @__PURE__ */ s($t, { size: "sm", color: "gray", onClick: a, children: "Vissza" })
      ] }),
      d === "error" && /* @__PURE__ */ s(Jm, { className: "mt-4", color: "failure", icon: wg, children: "Exportálás sikertelen!" })
    ] })
  });
}, fc = () => {
  const [a, o] = Y(!1), r = () => {
    o(!a);
  };
  return /* @__PURE__ */ O(Ue, { children: [
    /* @__PURE__ */ s(Qi, { title: "Adatok exportálása...", arrow: !0, children: /* @__PURE__ */ s(Gl, { onClick: r, "data-testid": "table-export-button", children: /* @__PURE__ */ s(px, {}) }) }),
    /* @__PURE__ */ s(lc, { showModal: a, toggleShowModal: r, title: "Adatok exportálása", children: /* @__PURE__ */ s(A3, { toggleShowModal: r }) })
  ] });
};
function hc({ table: a }) {
  return /* @__PURE__ */ O("div", { className: "mb-2 flex flex-wrap items-center gap-2", children: [
    /* @__PURE__ */ s(fc, {}),
    /* @__PURE__ */ s(Yi, {
      size: "xs",
      color: "gray",
      onClick: () => {
        a.resetGlobalFilter(), a.resetColumnFilters();
      },
      endIcon: /* @__PURE__ */ s(Kl, {}),
      children: "Szűrők törlése"
    }),
    /* @__PURE__ */ O(ic, {
      show: a.getIsSomeRowsSelected() || a.getIsAllRowsSelected(),
      className: "flex flex-row flex-wrap items-center gap-2",
      children: [
        /* @__PURE__ */ s(Yi, {
          size: "xs",
          color: "gray-error",
          onClick: () => {
            console.log(a.getSelectedRowModel());
          },
          endIcon: /* @__PURE__ */ s(tx, {}),
          "data-testid": "table-delete-selected-button",
          children: "Kiválasztottak törlése"
        }),
        /* @__PURE__ */ s(Yi, {
          size: "xs",
          color: "gray-warning",
          onClick: () => {
            console.log(a.getSelectedRowModel());
          },
          endIcon: /* @__PURE__ */ s(nx, {}),
          "data-testid": "table-action-selected-button",
          children: "Kiválasztott akciók"
        })
      ]
    })
  ] });
}
function S3({ columnNames: a }) {
  return /* @__PURE__ */ s("div", { className: "flex flex-col space-y-2 text-gray-500", children: Object.entries(a).map(([o, r]) => /* @__PURE__ */ O("div", { "data-testid": "detailpanel-item", className: "flex items-center", children: [
    /* @__PURE__ */ s("p", { className: "mr-2 font-bold text-other-gray-dark", children: `${o}: ` }),
    r
  ] }, o)) });
}
function C3() {
  const a = Na(), { columnsData: o, mainURL: r, dataURL: l, onRowClick: u, renderToptoolbar: d, enableRowSelection: m, showFiltersInitially: p, enablePinnning: g } = Gr(), [x, k] = Y([]), [v, A] = Y(""), [C, T] = Y(!1), [F, E] = Y(!0), [I, z] = Y(!1), [R, P] = Y(!1), [U, q] = Y(0), [B, M] = Y([]), { columnFilterFns: V, setColumnFilterFns: X, changeColumnFilterFn: te } = x3(), [ne, $] = Y(""), [j, le] = Y([]), [ve, se] = Y({
    pageIndex: 0,
    pageSize: 10
  }), _e = Re(null), { dateFilter: at, changeDateFilterAtKey: ft, refreshAllDateFilterValues: he } = y3(), { selectables: Ye, selectablesStatus: Yn } = b3();
  ee(() => {
    x.length ? P(!0) : E(!0), he(B), ac(l, ve, j, B, V, r).then(({ response: Me, url: Wt }) => {
      A(Wt), console.log("Data fetched:", Me), k(sc(Me.results)), E(!1), P(!1), q(Me.count);
    }).catch((Me) => {
      console.error("Error fetching data:", Me), T(!0), E(!1), P(!1);
    });
  }, [B, ne, ve.pageIndex, ve.pageSize, j]);
  const gr = Ol(() => m3(o, at, ft, te, Ye), [B, o, Yn]);
  return /* @__PURE__ */ s("div", { className: "ropunded-small h-full overflow-hidden", children: /* @__PURE__ */ s(F3, {
    data: x,
    tableRef: _e,
    fetchingURL: v,
    columnFilters: B,
    columnFilterFns: V,
    globalFilter: ne,
    sorting: j,
    pagination: ve,
    isLoading: F,
    isRefetching: R,
    rowCount: U,
    isError: C,
    isFullscreen: I,
    children: /* @__PURE__ */ s(ql, {
      data: x,
      columns: gr,
      enableRowSelection: m,
      enableGlobalFilter: !1,
      enableDensityToggle: !1,
      manualFiltering: !0,
      manualPagination: !0,
      manualSorting: !0,
      enableColumnFilterModes: !0,
      positionToolbarAlertBanner: "bottom",
      tableInstanceRef: _e,
      initialState: {
        showColumnFilters: p && !a,
        density: "compact"
      },
      muiTableHeadCellFilterTextFieldProps: {
        inputProps: {
          className: "focus:ring-0"
        }
      },
      muiSearchTextFieldProps: {
        inputProps: {
          className: "focus:ring-0"
        }
      },
      muiToolbarAlertBannerProps: C ? {
        color: "error",
        children: "Error loading data"
      } : void 0,
      muiTablePaperProps: {
        elevation: 0,
        sx: {
          borderRadius: "6px",
          overflow: "hidden",
          height: "100%"
        }
      },
      muiLinearProgressProps: ({ isTopToolbar: Me }) => ({
        sx: { display: Me ? "block" : "none" }
      }),
      muiTableBodyRowProps: u ? ({ row: Me }) => ({
        onClick: () => {
          u(Me.original);
        },
        sx: {
          cursor: "pointer"
        }
      }) : {
        hover: !1
      },
      onColumnFiltersChange: M,
      onColumnFilterFnsChange: X,
      onGlobalFilterChange: $,
      onPaginationChange: se,
      onSortingChange: le,
      onIsFullScreenChange: z,
      rowCount: U,
      state: {
        columnFilters: B,
        columnFilterFns: V,
        globalFilter: ne,
        isLoading: F,
        pagination: ve,
        showAlertBanner: C,
        showProgressBars: R,
        sorting: j,
        isFullScreen: I
      },
      renderTopToolbarCustomActions: ({ table: Me }) => d ? d(Me) : /* @__PURE__ */ s(hc, { table: Me }),
      renderDetailPanel: a ? ({ row: Me }) => /* @__PURE__ */ s(S3, { columnNames: f3(o, Me) }) : void 0,
      enableStickyHeader: !0,
      localization: {
        ...mx,
        rowsPerPage: a ? "Sorok" : "Sorok Száma",
        of: a ? "/" : "össz."
      },
      enablePinning: g
    })
  }) });
}
const pc = {
  columnsData: [],
  dataURL: "",
  mainURL: "",
  onRowClick: void 0,
  renderToptoolbar: void 0,
  selectableColumns: void 0,
  enableRowSelection: !0,
  showFiltersInitially: !0,
  enablePinnning: !0
}, mc = dt(pc), E3 = ({ children: a, ...o }) => {
  const [r, l] = me.useState(void 0);
  return ee(() => {
    const u = [];
    o.columnsData.forEach((d) => {
      const m = d.quickFilterType;
      m && m in Aa && u.push(m);
    }), l(u);
  }, [o.columnsData]), /* @__PURE__ */ s(mc.Provider, {
    value: {
      ...pc,
      selectableColumns: r,
      ...o
    },
    children: a
  });
}, gc = (a, o, r, l, u) => {
  const d = (m) => {
    o === "csv" ? T3(m, a) : o === "xlsx" && I3(m, a);
  };
  return new Promise((m, p) => {
    if (l) {
      const g = xl(l, r);
      d(g), m();
    } else if (u && u !== "") {
      const g = new URL(u);
      g.searchParams.set("page_size", "100"), u = g.href, xc(u, []).then((x) => {
        const k = xl(x, r);
        d(k), m();
      }).catch(() => {
        p();
      });
    }
  });
}, T3 = (a, o) => {
  const r = hr.utils.json_to_sheet(a), l = hr.utils.sheet_to_csv(r), u = new Blob([l], { type: "text/csv" });
  gx(u, `${o}.csv`);
}, I3 = (a, o) => {
  const r = hr.utils.json_to_sheet(a), l = hr.utils.book_new();
  hr.utils.book_append_sheet(l, r, "sheet"), hr.writeFile(l, `${o}.xlsx`);
}, xc = (a, o) => new Promise((r, l) => {
  uc(a).then((u) => {
    u.next ? xc(u.next, [...o, ...u.results]).then((d) => {
      r(d);
    }).catch(() => {
      l();
    }) : r([...o, ...u.results]);
  }).catch(() => {
    l();
  });
}), xl = (a, o) => {
  const r = [];
  return a.forEach((l) => {
    const u = {};
    Object.keys(o).forEach((d) => {
      u[o[d]] = l[d];
    }), r.push(u);
  }), r;
}, yc = dt({
  data: [],
  fetchingURL: "",
  tableRef: null,
  exportData: gc,
  columnFilters: [],
  columnFilterFns: {},
  globalFilter: "",
  sorting: [],
  pagination: {
    pageIndex: 0,
    pageSize: 10
  },
  isLoading: !0,
  isRefetching: !1,
  rowCount: 0,
  isError: !1,
  isFullscreen: !1,
  renderComponent: {
    ExportTableButton: () => /* @__PURE__ */ s("div", {}),
    Toptoolbar: /* @__PURE__ */ s("div", {})
  }
}), F3 = ({ children: a, data: o, fetchingURL: r, tableRef: l, columnFilters: u, columnFilterFns: d, globalFilter: m, sorting: p, pagination: g, isLoading: x, isRefetching: k, rowCount: v, isError: A, isFullscreen: C }) => /* @__PURE__ */ s(yc.Provider, {
  value: {
    data: o,
    fetchingURL: r,
    tableRef: l,
    exportData: gc,
    columnFilters: u,
    columnFilterFns: d,
    globalFilter: m,
    sorting: p,
    pagination: g,
    isLoading: x,
    isRefetching: k,
    rowCount: v,
    isError: A,
    isFullscreen: C,
    renderComponent: {
      ExportTableButton: fc,
      Toptoolbar: /* @__PURE__ */ s(hc, { table: l == null ? void 0 : l.current })
    }
  },
  children: a
}), Bv = (a) => /* @__PURE__ */ s(E3, { ...a, children: /* @__PURE__ */ s(C3, {}) });
/*! @viselect/vanilla v3.4.0 MIT | https://github.com/Simonwep/selection/tree/master/packages/vanilla */
var B3 = Object.defineProperty, N3 = (a, o, r) => o in a ? B3(a, o, { enumerable: !0, configurable: !0, writable: !0, value: r }) : a[o] = r, De = (a, o, r) => (N3(a, typeof o != "symbol" ? o + "" : o, r), r);
class R3 {
  constructor() {
    De(this, "_listeners", /* @__PURE__ */ new Map()), De(this, "on", this.addEventListener), De(this, "off", this.removeEventListener), De(this, "emit", this.dispatchEvent);
  }
  addEventListener(o, r) {
    const l = this._listeners.get(o) ?? /* @__PURE__ */ new Set();
    return this._listeners.set(o, l), l.add(r), this;
  }
  removeEventListener(o, r) {
    var l;
    return (l = this._listeners.get(o)) == null || l.delete(r), this;
  }
  dispatchEvent(o, ...r) {
    let l = !0;
    for (const u of this._listeners.get(o) ?? [])
      l = u(...r) !== !1 && l;
    return l;
  }
  unbindAllListeners() {
    this._listeners.clear();
  }
}
const yl = (a, o = "px") => typeof a == "number" ? a + o : a;
function bn({ style: a }, o, r) {
  if (typeof o == "object")
    for (const [l, u] of Object.entries(o))
      u !== void 0 && (a[l] = yl(u));
  else
    r !== void 0 && (a[o] = yl(r));
}
const vc = (a) => (o, r, l, u = {}) => {
  o instanceof HTMLCollection || o instanceof NodeList ? o = Array.from(o) : Array.isArray(o) || (o = [o]), Array.isArray(r) || (r = [r]);
  for (const d of o)
    if (d)
      for (const m of r)
        d[a](m, l, { capture: !1, ...u });
  return [o, r, l, u];
}, ur = vc("addEventListener"), wn = vc("removeEventListener"), Gi = (a) => {
  var o;
  const { clientX: r, clientY: l, target: u } = ((o = a.touches) == null ? void 0 : o[0]) ?? a;
  return { x: r, y: l, target: u };
};
function vl(a, o, r = "touch") {
  switch (r) {
    case "center": {
      const l = o.left + o.width / 2, u = o.top + o.height / 2;
      return l >= a.left && l <= a.right && u >= a.top && u <= a.bottom;
    }
    case "cover":
      return o.left >= a.left && o.top >= a.top && o.right <= a.right && o.bottom <= a.bottom;
    case "touch":
      return a.right >= o.left && a.left <= o.right && a.bottom >= o.top && a.top <= o.bottom;
  }
}
function dr(a, o = document) {
  const r = Array.isArray(a) ? a : [a];
  let l = [];
  for (let u = 0, d = r.length; u < d; u++) {
    const m = r[u];
    typeof m == "string" ? l = l.concat(Array.from(o.querySelectorAll(m))) : m instanceof Element && l.push(m);
  }
  return l;
}
const M3 = () => matchMedia("(hover: none), (pointer: coarse)").matches, L3 = () => "safari" in window, O3 = (a) => {
  let o, r = -1, l = !1;
  return {
    next(...u) {
      o = u, l || (l = !0, r = requestAnimationFrame(() => {
        a(...o), l = !1;
      }));
    },
    cancel() {
      cancelAnimationFrame(r), l = !1;
    }
  };
}, { abs: Un, max: bl, min: wl, ceil: kl } = Math;
class bc extends R3 {
  constructor(o) {
    var r, l, u, d, m;
    super(), De(this, "_options"), De(this, "_selection", {
      stored: [],
      selected: [],
      touched: [],
      changed: {
        added: [],
        // Added elements since last selection
        removed: []
        // Removed elements since last selection
      }
    }), De(this, "_area"), De(this, "_clippingElement"), De(this, "_targetElement"), De(this, "_targetRect"), De(this, "_selectables", []), De(this, "_latestElement"), De(this, "_areaRect", new DOMRect()), De(this, "_areaLocation", { y1: 0, x2: 0, y2: 0, x1: 0 }), De(this, "_singleClick", !0), De(this, "_frame"), De(this, "_scrollAvailable", !0), De(this, "_scrollingActive", !1), De(this, "_scrollSpeed", { x: 0, y: 0 }), De(this, "_scrollDelta", { x: 0, y: 0 }), De(this, "disable", this._bindStartEvents.bind(this, !1)), De(this, "enable", this._bindStartEvents), this._options = {
      selectionAreaClass: "selection-area",
      selectionContainerClass: void 0,
      selectables: [],
      document: window.document,
      startAreas: ["html"],
      boundaries: ["html"],
      container: "body",
      ...o,
      behaviour: {
        overlap: "invert",
        intersect: "touch",
        ...o.behaviour,
        startThreshold: (r = o.behaviour) != null && r.startThreshold ? typeof o.behaviour.startThreshold == "number" ? o.behaviour.startThreshold : { x: 10, y: 10, ...o.behaviour.startThreshold } : { x: 10, y: 10 },
        scrolling: {
          speedDivider: 10,
          manualSpeed: 750,
          ...(l = o.behaviour) == null ? void 0 : l.scrolling,
          startScrollMargins: {
            x: 0,
            y: 0,
            ...(d = (u = o.behaviour) == null ? void 0 : u.scrolling) == null ? void 0 : d.startScrollMargins
          }
        }
      },
      features: {
        range: !0,
        touch: !0,
        ...o.features,
        singleTap: {
          allow: !0,
          intersect: "native",
          ...(m = o.features) == null ? void 0 : m.singleTap
        }
      }
    };
    for (const k of Object.getOwnPropertyNames(Object.getPrototypeOf(this)))
      typeof this[k] == "function" && (this[k] = this[k].bind(this));
    const { document: p, selectionAreaClass: g, selectionContainerClass: x } = this._options;
    this._area = p.createElement("div"), this._clippingElement = p.createElement("div"), this._clippingElement.appendChild(this._area), this._area.classList.add(g), x && this._clippingElement.classList.add(x), bn(this._area, {
      willChange: "top, left, bottom, right, width, height",
      top: 0,
      left: 0,
      position: "fixed"
    }), bn(this._clippingElement, {
      overflow: "hidden",
      position: "fixed",
      transform: "translate3d(0, 0, 0)",
      // https://stackoverflow.com/a/38268846
      pointerEvents: "none",
      zIndex: "1"
    }), this._frame = O3((k) => {
      this._recalculateSelectionAreaRect(), this._updateElementSelection(), this._emitEvent("move", k), this._redrawSelectionArea();
    }), this.enable();
  }
  _bindStartEvents(o = !0) {
    const { document: r, features: l } = this._options, u = o ? ur : wn;
    u(r, "mousedown", this._onTapStart), l.touch && u(r, "touchstart", this._onTapStart, {
      passive: !1
    });
  }
  _onTapStart(o, r = !1) {
    const { x: l, y: u, target: d } = Gi(o), { _options: m } = this, { document: p } = this._options, g = d.getBoundingClientRect(), x = dr(m.startAreas, m.document), k = dr(m.boundaries, m.document);
    this._targetElement = k.find(
      (C) => vl(C.getBoundingClientRect(), g)
    );
    const v = o.composedPath();
    if (!this._targetElement || !x.find((C) => v.includes(C)) || !k.find((C) => v.includes(C)) || !r && this._emitEvent("beforestart", o) === !1)
      return;
    this._areaLocation = { x1: l, y1: u, x2: 0, y2: 0 };
    const A = p.scrollingElement ?? p.body;
    this._scrollDelta = { x: A.scrollLeft, y: A.scrollTop }, this._singleClick = !0, this.clearSelection(!1, !0), ur(p, ["touchmove", "mousemove"], this._delayedTapMove, { passive: !1 }), ur(p, ["mouseup", "touchcancel", "touchend"], this._onTapStop), ur(p, "scroll", this._onScroll);
  }
  _onSingleTap(o) {
    const { singleTap: { intersect: r }, range: l } = this._options.features, u = Gi(o);
    let d;
    if (r === "native")
      d = u.target;
    else if (r === "touch") {
      this.resolveSelectables();
      const { x: p, y: g } = u;
      d = this._selectables.find((x) => {
        const { right: k, left: v, top: A, bottom: C } = x.getBoundingClientRect();
        return p < k && p > v && g < C && g > A;
      });
    }
    if (!d)
      return;
    for (this.resolveSelectables(); !this._selectables.includes(d); ) {
      if (!d.parentElement)
        return;
      d = d.parentElement;
    }
    const { stored: m } = this._selection;
    if (this._emitEvent("start", o), o.shiftKey && l && this._latestElement) {
      const p = this._latestElement, [g, x] = p.compareDocumentPosition(d) & 4 ? [d, p] : [p, d], k = [...this._selectables.filter(
        (v) => v.compareDocumentPosition(g) & 4 && v.compareDocumentPosition(x) & 2
      ), g, x];
      this.select(k), this._latestElement = p;
    } else
      m.includes(d) && (m.length === 1 || o.ctrlKey || m.every((p) => this._selection.stored.includes(p))) ? this.deselect(d) : (this.select(d), this._latestElement = d);
    this._emitEvent("stop", o);
  }
  _delayedTapMove(o) {
    const { container: r, document: l, behaviour: { startThreshold: u } } = this._options, { x1: d, y1: m } = this._areaLocation, { x: p, y: g } = Gi(o);
    if (
      // Single number for both coordinates
      typeof u == "number" && Un(p + g - (d + m)) >= u || // Different x and y threshold
      typeof u == "object" && Un(p - d) >= u.x || Un(g - m) >= u.y
    ) {
      if (wn(l, ["mousemove", "touchmove"], this._delayedTapMove, { passive: !1 }), this._emitEvent("beforedrag", o) === !1) {
        wn(l, ["mouseup", "touchcancel", "touchend"], this._onTapStop);
        return;
      }
      ur(l, ["mousemove", "touchmove"], this._onTapMove, { passive: !1 }), bn(this._area, "display", "block"), dr(r, l)[0].appendChild(this._clippingElement), this.resolveSelectables(), this._singleClick = !1, this._targetRect = this._targetElement.getBoundingClientRect(), this._scrollAvailable = this._targetElement.scrollHeight !== this._targetElement.clientHeight || this._targetElement.scrollWidth !== this._targetElement.clientWidth, this._scrollAvailable && (ur(this._targetElement, "wheel", this._manualScroll, { passive: !1 }), this._selectables = this._selectables.filter((x) => this._targetElement.contains(x))), this._setupSelectionArea(), this._emitEvent("start", o), this._onTapMove(o);
    }
    this._handleMoveEvent(o);
  }
  _setupSelectionArea() {
    const { _clippingElement: o, _targetElement: r, _area: l } = this, u = this._targetRect = r.getBoundingClientRect();
    this._scrollAvailable ? (bn(o, {
      top: u.top,
      left: u.left,
      width: u.width,
      height: u.height
    }), bn(l, {
      marginTop: -u.top,
      marginLeft: -u.left
    })) : (bn(o, {
      top: 0,
      left: 0,
      width: "100%",
      height: "100%"
    }), bn(l, {
      marginTop: 0,
      marginLeft: 0
    }));
  }
  _onTapMove(o) {
    const { x: r, y: l } = Gi(o), { _scrollSpeed: u, _areaLocation: d, _options: m, _frame: p } = this, { speedDivider: g } = m.behaviour.scrolling, x = this._targetElement;
    if (d.x2 = r, d.y2 = l, this._scrollAvailable && !this._scrollingActive && (u.y || u.x)) {
      this._scrollingActive = !0;
      const k = () => {
        if (!u.x && !u.y) {
          this._scrollingActive = !1;
          return;
        }
        const { scrollTop: v, scrollLeft: A } = x;
        u.y && (x.scrollTop += kl(u.y / g), d.y1 -= x.scrollTop - v), u.x && (x.scrollLeft += kl(u.x / g), d.x1 -= x.scrollLeft - A), p.next(o), requestAnimationFrame(k);
      };
      requestAnimationFrame(k);
    } else
      p.next(o);
    this._handleMoveEvent(o);
  }
  _handleMoveEvent(o) {
    const { features: r } = this._options;
    (r.touch && M3() || this._scrollAvailable && L3()) && o.preventDefault();
  }
  _onScroll() {
    const { _scrollDelta: o, _options: { document: r } } = this, { scrollTop: l, scrollLeft: u } = r.scrollingElement ?? r.body;
    this._areaLocation.x1 += o.x - u, this._areaLocation.y1 += o.y - l, o.x = u, o.y = l, this._setupSelectionArea(), this._frame.next(null);
  }
  _manualScroll(o) {
    const { manualSpeed: r } = this._options.behaviour.scrolling, l = o.deltaY ? o.deltaY > 0 ? 1 : -1 : 0, u = o.deltaX ? o.deltaX > 0 ? 1 : -1 : 0;
    this._scrollSpeed.y += l * r, this._scrollSpeed.x += u * r, this._onTapMove(o), o.preventDefault();
  }
  _recalculateSelectionAreaRect() {
    const { _scrollSpeed: o, _areaLocation: r, _areaRect: l, _targetElement: u, _options: d } = this, { scrollTop: m, scrollHeight: p, clientHeight: g, scrollLeft: x, scrollWidth: k, clientWidth: v } = u, A = this._targetRect, { x1: C, y1: T } = r;
    let { x2: F, y2: E } = r;
    const { behaviour: { scrolling: { startScrollMargins: I } } } = d;
    F < A.left + I.x ? (o.x = x ? -Un(A.left - F + I.x) : 0, F = F < A.left ? A.left : F) : F > A.right - I.x ? (o.x = k - x - v ? Un(A.left + A.width - F - I.x) : 0, F = F > A.right ? A.right : F) : o.x = 0, E < A.top + I.y ? (o.y = m ? -Un(A.top - E + I.y) : 0, E = E < A.top ? A.top : E) : E > A.bottom - I.y ? (o.y = p - m - g ? Un(A.top + A.height - E - I.y) : 0, E = E > A.bottom ? A.bottom : E) : o.y = 0;
    const z = wl(C, F), R = wl(T, E), P = bl(C, F), U = bl(T, E);
    l.x = z, l.y = R, l.width = P - z, l.height = U - R;
  }
  _redrawSelectionArea() {
    const { x: o, y: r, width: l, height: u } = this._areaRect, { style: d } = this._area;
    d.left = `${o}px`, d.top = `${r}px`, d.width = `${l}px`, d.height = `${u}px`;
  }
  _onTapStop(o, r) {
    var l;
    const { document: u, features: d } = this._options, { _singleClick: m } = this;
    wn(u, ["mousemove", "touchmove"], this._delayedTapMove), wn(u, ["touchmove", "mousemove"], this._onTapMove), wn(u, ["mouseup", "touchcancel", "touchend"], this._onTapStop), wn(u, "scroll", this._onScroll), this._keepSelection(), o && m && d.singleTap.allow ? this._onSingleTap(o) : !m && !r && (this._updateElementSelection(), this._emitEvent("stop", o)), this._scrollSpeed.x = 0, this._scrollSpeed.y = 0, wn(this._targetElement, "wheel", this._manualScroll, { passive: !0 }), this._clippingElement.remove(), (l = this._frame) == null || l.cancel(), bn(this._area, "display", "none");
  }
  _updateElementSelection() {
    const { _selectables: o, _options: r, _selection: l, _areaRect: u } = this, { stored: d, selected: m, touched: p } = l, { intersect: g, overlap: x } = r.behaviour, k = x === "invert", v = [], A = [], C = [];
    for (let F = 0; F < o.length; F++) {
      const E = o[F];
      if (vl(u, E.getBoundingClientRect(), g)) {
        if (m.includes(E))
          d.includes(E) && !p.includes(E) && p.push(E);
        else if (k && d.includes(E)) {
          C.push(E);
          continue;
        } else
          A.push(E);
        v.push(E);
      }
    }
    k && A.push(...d.filter((F) => !m.includes(F)));
    const T = x === "keep";
    for (let F = 0; F < m.length; F++) {
      const E = m[F];
      !v.includes(E) && !// Check if user wants to keep previously selected elements, e.g.
      // not make them part of the current selection as soon as they're touched.
      (T && d.includes(E)) && C.push(E);
    }
    l.selected = v, l.changed = { added: A, removed: C }, this._latestElement = void 0;
  }
  _emitEvent(o, r) {
    return this.emit(o, {
      event: r,
      store: this._selection,
      selection: this
    });
  }
  _keepSelection() {
    const { _options: o, _selection: r } = this, { selected: l, changed: u, touched: d, stored: m } = r, p = l.filter((g) => !m.includes(g));
    switch (o.behaviour.overlap) {
      case "drop": {
        r.stored = [
          ...p,
          ...m.filter((g) => !d.includes(g))
          // Elements not touched
        ];
        break;
      }
      case "invert": {
        r.stored = [
          ...p,
          ...m.filter((g) => !u.removed.includes(g))
          // Elements not removed from selection
        ];
        break;
      }
      case "keep": {
        r.stored = [
          ...m,
          ...l.filter((g) => !m.includes(g))
          // Newly added
        ];
        break;
      }
    }
  }
  /**
   * Manually triggers the start of a selection
   * @param evt A MouseEvent / TouchEvent -like object
   * @param silent If beforestart should be fired,
   */
  trigger(o, r = !0) {
    this._onTapStart(o, r);
  }
  /**
   * Can be used if during a selection elements have been added.
   * Will update everything which can be selected.
   */
  resolveSelectables() {
    this._selectables = dr(this._options.selectables, this._options.document);
  }
  /**
   * Same as deselect, but for all elements currently selected.
   * @param includeStored If the store should also get cleared
   * @param quiet If move / stop events should be fired
   */
  clearSelection(o = !0, r = !1) {
    const { selected: l, stored: u, changed: d } = this._selection;
    d.added = [], d.removed.push(
      ...l,
      ...o ? u : []
    ), r || (this._emitEvent("move", null), this._emitEvent("stop", null)), this._selection = {
      stored: o ? [] : u,
      selected: [],
      touched: [],
      changed: { added: [], removed: [] }
    };
  }
  /**
   * @returns {Array} Selected elements
   */
  getSelection() {
    return this._selection.stored;
  }
  /**
   * @returns {HTMLElement} The selection area element
   */
  getSelectionArea() {
    return this._area;
  }
  /**
   * Cancel the current selection process.
   * @param keepEvent {boolean} true to fire a stop event after cancel.
   */
  cancel(o = !1) {
    this._onTapStop(null, !o);
  }
  /**
   * Unbinds all events and removes the area-element.
   */
  destroy() {
    this.cancel(), this.disable(), this._clippingElement.remove(), super.unbindAllListeners();
  }
  /**
   * Adds elements to the selection
   * @param query - CSS Query, can be an array of queries
   * @param quiet - If this should not trigger the move event
   */
  select(o, r = !1) {
    const { changed: l, selected: u, stored: d } = this._selection, m = dr(o, this._options.document).filter(
      (p) => !u.includes(p) && !d.includes(p)
    );
    return d.push(...m), u.push(...m), l.added.push(...m), l.removed = [], this._latestElement = void 0, r || (this._emitEvent("move", null), this._emitEvent("stop", null)), m;
  }
  /**
   * Removes a particular element from the selection.
   * @param query - CSS Query, can be an array of queries
   * @param quiet - If this should not trigger the move event
   */
  deselect(o, r = !1) {
    const { selected: l, stored: u, changed: d } = this._selection, m = dr(o, this._options.document).filter(
      (p) => l.includes(p) || u.includes(p)
    );
    m.length && (this._selection.stored = u.filter((p) => !m.includes(p)), this._selection.selected = l.filter((p) => !m.includes(p)), this._selection.changed.added = [], this._selection.changed.removed.push(
      ...m.filter((p) => !d.removed.includes(p))
    ), this._latestElement = void 0, r || (this._emitEvent("move", null), this._emitEvent("stop", null)));
  }
}
De(bc, "version", "3.4.0");
/*! @viselect/react v3.4.0 MIT | https://github.com/Simonwep/selection/tree/master/packages/react */
var Sa = { exports: {} }, fr = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var ya, _l;
function wc() {
  if (_l)
    return ya;
  _l = 1;
  var a = Object.getOwnPropertySymbols, o = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function l(d) {
    if (d == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(d);
  }
  function u() {
    try {
      if (!Object.assign)
        return !1;
      var d = new String("abc");
      if (d[5] = "de", Object.getOwnPropertyNames(d)[0] === "5")
        return !1;
      for (var m = {}, p = 0; p < 10; p++)
        m["_" + String.fromCharCode(p)] = p;
      var g = Object.getOwnPropertyNames(m).map(function(k) {
        return m[k];
      });
      if (g.join("") !== "0123456789")
        return !1;
      var x = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(k) {
        x[k] = k;
      }), Object.keys(Object.assign({}, x)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return ya = u() ? Object.assign : function(d, m) {
    for (var p, g = l(d), x, k = 1; k < arguments.length; k++) {
      p = Object(arguments[k]);
      for (var v in p)
        o.call(p, v) && (g[v] = p[v]);
      if (a) {
        x = a(p);
        for (var A = 0; A < x.length; A++)
          r.call(p, x[A]) && (g[x[A]] = p[x[A]]);
      }
    }
    return g;
  }, ya;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Al;
function D3() {
  if (Al)
    return fr;
  Al = 1, wc();
  var a = me, o = 60103;
  if (fr.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var r = Symbol.for;
    o = r("react.element"), fr.Fragment = r("react.fragment");
  }
  var l = a.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, u = Object.prototype.hasOwnProperty, d = { key: !0, ref: !0, __self: !0, __source: !0 };
  function m(p, g, x) {
    var k, v = {}, A = null, C = null;
    x !== void 0 && (A = "" + x), g.key !== void 0 && (A = "" + g.key), g.ref !== void 0 && (C = g.ref);
    for (k in g)
      u.call(g, k) && !d.hasOwnProperty(k) && (v[k] = g[k]);
    if (p && p.defaultProps)
      for (k in g = p.defaultProps, g)
        v[k] === void 0 && (v[k] = g[k]);
    return { $$typeof: o, type: p, key: A, ref: C, props: v, _owner: l.current };
  }
  return fr.jsx = m, fr.jsxs = m, fr;
}
var Sl = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Cl;
function P3() {
  return Cl || (Cl = 1, function(a) {
    process.env.NODE_ENV !== "production" && function() {
      var o = me, r = wc(), l = 60103, u = 60106;
      a.Fragment = 60107;
      var d = 60108, m = 60114, p = 60109, g = 60110, x = 60112, k = 60113, v = 60120, A = 60115, C = 60116, T = 60121, F = 60122, E = 60117, I = 60129, z = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var R = Symbol.for;
        l = R("react.element"), u = R("react.portal"), a.Fragment = R("react.fragment"), d = R("react.strict_mode"), m = R("react.profiler"), p = R("react.provider"), g = R("react.context"), x = R("react.forward_ref"), k = R("react.suspense"), v = R("react.suspense_list"), A = R("react.memo"), C = R("react.lazy"), T = R("react.block"), F = R("react.server.block"), E = R("react.fundamental"), R("react.scope"), R("react.opaque.id"), I = R("react.debug_trace_mode"), R("react.offscreen"), z = R("react.legacy_hidden");
      }
      var P = typeof Symbol == "function" && Symbol.iterator, U = "@@iterator";
      function q(b) {
        if (b === null || typeof b != "object")
          return null;
        var G = P && b[P] || b[U];
        return typeof G == "function" ? G : null;
      }
      var B = o.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function M(b) {
        {
          for (var G = arguments.length, Q = new Array(G > 1 ? G - 1 : 0), ae = 1; ae < G; ae++)
            Q[ae - 1] = arguments[ae];
          V("error", b, Q);
        }
      }
      function V(b, G, Q) {
        {
          var ae = B.ReactDebugCurrentFrame, Ce = ae.getStackAddendum();
          Ce !== "" && (G += "%s", Q = Q.concat([Ce]));
          var Ee = Q.map(function(ke) {
            return "" + ke;
          });
          Ee.unshift("Warning: " + G), Function.prototype.apply.call(console[b], console, Ee);
        }
      }
      var X = !1;
      function te(b) {
        return !!(typeof b == "string" || typeof b == "function" || b === a.Fragment || b === m || b === I || b === d || b === k || b === v || b === z || X || typeof b == "object" && b !== null && (b.$$typeof === C || b.$$typeof === A || b.$$typeof === p || b.$$typeof === g || b.$$typeof === x || b.$$typeof === E || b.$$typeof === T || b[0] === F));
      }
      function ne(b, G, Q) {
        var ae = G.displayName || G.name || "";
        return b.displayName || (ae !== "" ? Q + "(" + ae + ")" : Q);
      }
      function $(b) {
        return b.displayName || "Context";
      }
      function j(b) {
        if (b == null)
          return null;
        if (typeof b.tag == "number" && M("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof b == "function")
          return b.displayName || b.name || null;
        if (typeof b == "string")
          return b;
        switch (b) {
          case a.Fragment:
            return "Fragment";
          case u:
            return "Portal";
          case m:
            return "Profiler";
          case d:
            return "StrictMode";
          case k:
            return "Suspense";
          case v:
            return "SuspenseList";
        }
        if (typeof b == "object")
          switch (b.$$typeof) {
            case g:
              var G = b;
              return $(G) + ".Consumer";
            case p:
              var Q = b;
              return $(Q._context) + ".Provider";
            case x:
              return ne(b, b.render, "ForwardRef");
            case A:
              return j(b.type);
            case T:
              return j(b._render);
            case C: {
              var ae = b, Ce = ae._payload, Ee = ae._init;
              try {
                return j(Ee(Ce));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var le = 0, ve, se, _e, at, ft, he, Ye;
      function Yn() {
      }
      Yn.__reactDisabledLog = !0;
      function gr() {
        {
          if (le === 0) {
            ve = console.log, se = console.info, _e = console.warn, at = console.error, ft = console.group, he = console.groupCollapsed, Ye = console.groupEnd;
            var b = {
              configurable: !0,
              enumerable: !0,
              value: Yn,
              writable: !0
            };
            Object.defineProperties(console, {
              info: b,
              log: b,
              warn: b,
              error: b,
              group: b,
              groupCollapsed: b,
              groupEnd: b
            });
          }
          le++;
        }
      }
      function Me() {
        {
          if (le--, le === 0) {
            var b = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: r({}, b, {
                value: ve
              }),
              info: r({}, b, {
                value: se
              }),
              warn: r({}, b, {
                value: _e
              }),
              error: r({}, b, {
                value: at
              }),
              group: r({}, b, {
                value: ft
              }),
              groupCollapsed: r({}, b, {
                value: he
              }),
              groupEnd: r({}, b, {
                value: Ye
              })
            });
          }
          le < 0 && M("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var Wt = B.ReactCurrentDispatcher, xr;
      function zt(b, G, Q) {
        {
          if (xr === void 0)
            try {
              throw Error();
            } catch (Ce) {
              var ae = Ce.stack.trim().match(/\n( *(at )?)/);
              xr = ae && ae[1] || "";
            }
          return `
` + xr + b;
        }
      }
      var Kt = !1, $n;
      {
        var qn = typeof WeakMap == "function" ? WeakMap : Map;
        $n = new qn();
      }
      function Sn(b, G) {
        if (!b || Kt)
          return "";
        {
          var Q = $n.get(b);
          if (Q !== void 0)
            return Q;
        }
        var ae;
        Kt = !0;
        var Ce = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var Ee;
        Ee = Wt.current, Wt.current = null, gr();
        try {
          if (G) {
            var ke = function() {
              throw Error();
            };
            if (Object.defineProperty(ke.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(ke, []);
              } catch (Bt) {
                ae = Bt;
              }
              Reflect.construct(b, [], ke);
            } else {
              try {
                ke.call();
              } catch (Bt) {
                ae = Bt;
              }
              b.call(ke.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (Bt) {
              ae = Bt;
            }
            b();
          }
        } catch (Bt) {
          if (Bt && ae && typeof Bt.stack == "string") {
            for (var ge = Bt.stack.split(`
`), qe = ae.stack.split(`
`), Le = ge.length - 1, Pe = qe.length - 1; Le >= 1 && Pe >= 0 && ge[Le] !== qe[Pe]; )
              Pe--;
            for (; Le >= 1 && Pe >= 0; Le--, Pe--)
              if (ge[Le] !== qe[Pe]) {
                if (Le !== 1 || Pe !== 1)
                  do
                    if (Le--, Pe--, Pe < 0 || ge[Le] !== qe[Pe]) {
                      var wt = `
` + ge[Le].replace(" at new ", " at ");
                      return typeof b == "function" && $n.set(b, wt), wt;
                    }
                  while (Le >= 1 && Pe >= 0);
                break;
              }
          }
        } finally {
          Kt = !1, Wt.current = Ee, Me(), Error.prepareStackTrace = Ce;
        }
        var un = b ? b.displayName || b.name : "", jr = un ? zt(un) : "";
        return typeof b == "function" && $n.set(b, jr), jr;
      }
      function yr(b, G, Q) {
        return Sn(b, !1);
      }
      function ht(b) {
        var G = b.prototype;
        return !!(G && G.isReactComponent);
      }
      function Ht(b, G, Q) {
        if (b == null)
          return "";
        if (typeof b == "function")
          return Sn(b, ht(b));
        if (typeof b == "string")
          return zt(b);
        switch (b) {
          case k:
            return zt("Suspense");
          case v:
            return zt("SuspenseList");
        }
        if (typeof b == "object")
          switch (b.$$typeof) {
            case x:
              return yr(b.render);
            case A:
              return Ht(b.type, G, Q);
            case T:
              return yr(b._render);
            case C: {
              var ae = b, Ce = ae._payload, Ee = ae._init;
              try {
                return Ht(Ee(Ce), G, Q);
              } catch {
              }
            }
          }
        return "";
      }
      var Vr = {}, bt = B.ReactDebugCurrentFrame;
      function Cn(b) {
        if (b) {
          var G = b._owner, Q = Ht(b.type, b._source, G ? G.type : null);
          bt.setExtraStackFrame(Q);
        } else
          bt.setExtraStackFrame(null);
      }
      function Xi(b, G, Q, ae, Ce) {
        {
          var Ee = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var ke in b)
            if (Ee(b, ke)) {
              var ge = void 0;
              try {
                if (typeof b[ke] != "function") {
                  var qe = Error((ae || "React class") + ": " + Q + " type `" + ke + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof b[ke] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw qe.name = "Invariant Violation", qe;
                }
                ge = b[ke](G, ke, ae, Q, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (Le) {
                ge = Le;
              }
              ge && !(ge instanceof Error) && (Cn(Ce), M("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", ae || "React class", Q, ke, typeof ge), Cn(null)), ge instanceof Error && !(ge.message in Vr) && (Vr[ge.message] = !0, Cn(Ce), M("Failed %s type: %s", Q, ge.message), Cn(null));
            }
        }
      }
      var Ft = B.ReactCurrentOwner, tt = Object.prototype.hasOwnProperty, En = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Tn, Yr, Qt;
      Qt = {};
      function Ji(b) {
        if (tt.call(b, "ref")) {
          var G = Object.getOwnPropertyDescriptor(b, "ref").get;
          if (G && G.isReactWarning)
            return !1;
        }
        return b.ref !== void 0;
      }
      function In(b) {
        if (tt.call(b, "key")) {
          var G = Object.getOwnPropertyDescriptor(b, "key").get;
          if (G && G.isReactWarning)
            return !1;
        }
        return b.key !== void 0;
      }
      function cn(b, G) {
        if (typeof b.ref == "string" && Ft.current && G && Ft.current.stateNode !== G) {
          var Q = j(Ft.current.type);
          Qt[Q] || (M('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', j(Ft.current.type), b.ref), Qt[Q] = !0);
        }
      }
      function vr(b, G) {
        {
          var Q = function() {
            Tn || (Tn = !0, M("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", G));
          };
          Q.isReactWarning = !0, Object.defineProperty(b, "key", {
            get: Q,
            configurable: !0
          });
        }
      }
      function br(b, G) {
        {
          var Q = function() {
            Yr || (Yr = !0, M("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", G));
          };
          Q.isReactWarning = !0, Object.defineProperty(b, "ref", {
            get: Q,
            configurable: !0
          });
        }
      }
      var wr = function(b, G, Q, ae, Ce, Ee, ke) {
        var ge = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: l,
          // Built-in properties that belong on the element
          type: b,
          key: G,
          ref: Q,
          props: ke,
          // Record the component responsible for creating this element.
          _owner: Ee
        };
        return ge._store = {}, Object.defineProperty(ge._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(ge, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: ae
        }), Object.defineProperty(ge, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: Ce
        }), Object.freeze && (Object.freeze(ge.props), Object.freeze(ge)), ge;
      };
      function kr(b, G, Q, ae, Ce) {
        {
          var Ee, ke = {}, ge = null, qe = null;
          Q !== void 0 && (ge = "" + Q), In(G) && (ge = "" + G.key), Ji(G) && (qe = G.ref, cn(G, Ce));
          for (Ee in G)
            tt.call(G, Ee) && !En.hasOwnProperty(Ee) && (ke[Ee] = G[Ee]);
          if (b && b.defaultProps) {
            var Le = b.defaultProps;
            for (Ee in Le)
              ke[Ee] === void 0 && (ke[Ee] = Le[Ee]);
          }
          if (ge || qe) {
            var Pe = typeof b == "function" ? b.displayName || b.name || "Unknown" : b;
            ge && vr(ke, Pe), qe && br(ke, Pe);
          }
          return wr(b, ge, qe, Ce, ae, Ft.current, ke);
        }
      }
      var Fn = B.ReactCurrentOwner, Kn = B.ReactDebugCurrentFrame;
      function Ut(b) {
        if (b) {
          var G = b._owner, Q = Ht(b.type, b._source, G ? G.type : null);
          Kn.setExtraStackFrame(Q);
        } else
          Kn.setExtraStackFrame(null);
      }
      var Bn;
      Bn = !1;
      function Nn(b) {
        return typeof b == "object" && b !== null && b.$$typeof === l;
      }
      function $r() {
        {
          if (Fn.current) {
            var b = j(Fn.current.type);
            if (b)
              return `

Check the render method of \`` + b + "`.";
          }
          return "";
        }
      }
      function ji(b) {
        {
          if (b !== void 0) {
            var G = b.fileName.replace(/^.*[\\\/]/, ""), Q = b.lineNumber;
            return `

Check your code at ` + G + ":" + Q + ".";
          }
          return "";
        }
      }
      var qr = {};
      function Kr(b) {
        {
          var G = $r();
          if (!G) {
            var Q = typeof b == "string" ? b : b.displayName || b.name;
            Q && (G = `

Check the top-level render call using <` + Q + ">.");
          }
          return G;
        }
      }
      function _r(b, G) {
        {
          if (!b._store || b._store.validated || b.key != null)
            return;
          b._store.validated = !0;
          var Q = Kr(G);
          if (qr[Q])
            return;
          qr[Q] = !0;
          var ae = "";
          b && b._owner && b._owner !== Fn.current && (ae = " It was passed a child from " + j(b._owner.type) + "."), Ut(b), M('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Q, ae), Ut(null);
        }
      }
      function Qr(b, G) {
        {
          if (typeof b != "object")
            return;
          if (Array.isArray(b))
            for (var Q = 0; Q < b.length; Q++) {
              var ae = b[Q];
              Nn(ae) && _r(ae, G);
            }
          else if (Nn(b))
            b._store && (b._store.validated = !0);
          else if (b) {
            var Ce = q(b);
            if (typeof Ce == "function" && Ce !== b.entries)
              for (var Ee = Ce.call(b), ke; !(ke = Ee.next()).done; )
                Nn(ke.value) && _r(ke.value, G);
          }
        }
      }
      function Zi(b) {
        {
          var G = b.type;
          if (G == null || typeof G == "string")
            return;
          var Q;
          if (typeof G == "function")
            Q = G.propTypes;
          else if (typeof G == "object" && (G.$$typeof === x || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          G.$$typeof === A))
            Q = G.propTypes;
          else
            return;
          if (Q) {
            var ae = j(G);
            Xi(Q, b.props, "prop", ae, b);
          } else if (G.PropTypes !== void 0 && !Bn) {
            Bn = !0;
            var Ce = j(G);
            M("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Ce || "Unknown");
          }
          typeof G.getDefaultProps == "function" && !G.getDefaultProps.isReactClassApproved && M("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function eo(b) {
        {
          for (var G = Object.keys(b.props), Q = 0; Q < G.length; Q++) {
            var ae = G[Q];
            if (ae !== "children" && ae !== "key") {
              Ut(b), M("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", ae), Ut(null);
              break;
            }
          }
          b.ref !== null && (Ut(b), M("Invalid attribute `ref` supplied to `React.Fragment`."), Ut(null));
        }
      }
      function Xr(b, G, Q, ae, Ce, Ee) {
        {
          var ke = te(b);
          if (!ke) {
            var ge = "";
            (b === void 0 || typeof b == "object" && b !== null && Object.keys(b).length === 0) && (ge += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var qe = ji(Ce);
            qe ? ge += qe : ge += $r();
            var Le;
            b === null ? Le = "null" : Array.isArray(b) ? Le = "array" : b !== void 0 && b.$$typeof === l ? (Le = "<" + (j(b.type) || "Unknown") + " />", ge = " Did you accidentally export a JSX literal instead of a component?") : Le = typeof b, M("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Le, ge);
          }
          var Pe = kr(b, G, Q, Ce, Ee);
          if (Pe == null)
            return Pe;
          if (ke) {
            var wt = G.children;
            if (wt !== void 0)
              if (ae)
                if (Array.isArray(wt)) {
                  for (var un = 0; un < wt.length; un++)
                    Qr(wt[un], b);
                  Object.freeze && Object.freeze(wt);
                } else
                  M("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                Qr(wt, b);
          }
          return b === a.Fragment ? eo(Pe) : Zi(Pe), Pe;
        }
      }
      function Jr(b, G, Q) {
        return Xr(b, G, Q, !0);
      }
      function to(b, G, Q) {
        return Xr(b, G, Q, !1);
      }
      var no = to, ro = Jr;
      a.jsx = no, a.jsxs = ro;
    }();
  }(Sl)), Sl;
}
process.env.NODE_ENV === "production" ? Sa.exports = D3() : Sa.exports = P3();
var El = Sa.exports;
const W3 = dt(void 0), z3 = (a) => {
  const [o, r] = Y(void 0), l = eg();
  return ee(() => {
    const { onBeforeStart: u, onBeforeDrag: d, onStart: m, onMove: p, onStop: g, ...x } = a, k = l.current, v = new bc({
      boundaries: k,
      ...x
    });
    return v.on("beforestart", (A) => {
      var C;
      return (C = a.onBeforeStart) == null ? void 0 : C.call(a, A);
    }), v.on("beforedrag", (A) => {
      var C;
      return (C = a.onBeforeDrag) == null ? void 0 : C.call(a, A);
    }), v.on("start", (A) => {
      var C;
      return (C = a.onStart) == null ? void 0 : C.call(a, A);
    }), v.on("move", (A) => {
      var C;
      return (C = a.onMove) == null ? void 0 : C.call(a, A);
    }), v.on("stop", (A) => {
      var C;
      return (C = a.onStop) == null ? void 0 : C.call(a, A);
    }), r(v), () => {
      v.destroy(), r(void 0);
    };
  }, []), /* @__PURE__ */ El.jsx(W3.Provider, { value: o, children: /* @__PURE__ */ El.jsx("div", { ref: l, className: a.className, id: a.id, children: a.children }) });
}, H3 = ({
  rows: a,
  cols: o,
  selected: r,
  setSelected: l,
  wells: u,
  // setWells,
  setWellsWithReorder: d,
  defaultWellData: m,
  vertical: p,
  setVertical: g
}) => {
  const x = (T) => ({
    index: T,
    title: "",
    desc: "",
    colors: [],
    data: m,
    notification: void 0
  });
  return {
    recalculateWellOrderNums: (T) => {
      const F = [];
      if (p)
        T.forEach((E, I) => {
          if (E != null && E.title) {
            const z = F.find((R) => R.title === (E == null ? void 0 : E.title));
            z ? (z.count++, T.set(I, { ...E, desc: "#" + z.count.toString() })) : (F.push({ title: E == null ? void 0 : E.title, count: 1 }), T.set(I, { ...E, desc: "#1" }));
          } else
            T.set(I, { ...E, desc: "" });
        });
      else
        for (let E = 0; E < a; E++)
          for (let I = 0; I < o; I++) {
            const z = T.get(I * a + E);
            if (z != null && z.title) {
              const R = F.find((P) => P.title === (z == null ? void 0 : z.title));
              R ? (R.count++, T.set(I * a + E, { ...z, desc: "#" + R.count.toString() })) : (F.push({ title: z == null ? void 0 : z.title, count: 1 }), T.set(I * a + E, { ...z, desc: "#1" }));
            } else
              z && T.set(I * a + E, { ...z, desc: "" });
          }
      return T;
    },
    getDefaultWell: x,
    deleteWells: (T) => {
      d((F) => {
        let { ranges: E } = T ?? {};
        const { attributes: I } = T ?? {};
        let z = new Map(F);
        const R = x(0);
        return E ? (Array.isArray(E) || (E = [E]), E.forEach((P) => {
          for (let U = P.start; U <= P.end; U++)
            if (F.has(U)) {
              const q = F.get(U);
              I ? (I.forEach((B) => {
                q[B] = R[B];
              }), z.set(U, q)) : z.set(U, {
                ...R,
                index: U
              });
            }
        })) : (z = new Map(F), r.forEach((P, U) => {
          I ? (I.forEach((q) => {
            P[q] = R[q];
          }), z.set(U, P)) : z.set(U, {
            ...R,
            index: U
          });
        })), console.log("new wells", z), z;
      });
    },
    selectRange: (T) => {
      l(() => {
        const F = /* @__PURE__ */ new Map();
        return Array.isArray(T) || (T = [T]), T.forEach((E) => {
          for (let I = E.start; I <= E.end; I++)
            u.has(I) && F.set(I, u.get(I));
        }), F;
      });
    },
    toggleOrientation: () => {
      g((T) => !T);
    }
  };
}, U3 = ({ sessionId: a, setWells: o }) => {
  const r = (m) => Array.from(m.values()), l = (m) => {
    const p = /* @__PURE__ */ new Map();
    return m.forEach((g) => {
      p.set(g.index, g);
    }), p;
  }, u = {
    current: -1,
    history: []
  }, d = () => JSON.parse(window.sessionStorage.getItem(a ?? "")) ?? u;
  return a ? {
    log: () => {
      const m = d();
      console.log(m);
    },
    reset: () => {
      const m = u;
      window.sessionStorage.setItem(a ?? "", JSON.stringify(m));
    },
    add: (m) => {
      const p = d();
      p.current < p.history.length - 1 ? p.history.splice(p.current + 1) : p.history.length >= 10 && p.history.shift();
      const g = r(m);
      p.history.push(g), p.current = p.history.length - 1, window.sessionStorage.setItem(a ?? "", JSON.stringify(p));
    },
    get: () => d().history.map((g) => l(g)),
    // go to previous history if it exists and return the wells map
    prev: () => {
      const m = d();
      if (m.current <= 0)
        return /* @__PURE__ */ new Map();
      m.current -= 1, window.sessionStorage.setItem(a ?? "", JSON.stringify(m));
      const p = l(m.history[m.current]);
      return o(() => p, () => {
      }), p;
    },
    // go to next history if it exists and return the wells map
    next: () => {
      const m = d();
      if (m.current >= m.history.length - 1)
        return /* @__PURE__ */ new Map();
      m.current += 1, window.sessionStorage.setItem(a ?? "", JSON.stringify(m));
      const p = l(m.history[m.current]);
      return o(() => p, () => {
      }), p;
    },
    set: (m) => {
      const p = d();
      p.history = m.map((g) => r(g)), p.current = p.history.length - 1, window.sessionStorage.setItem(a ?? "", JSON.stringify(p));
    },
    current: {
      index: {
        get: () => d().current,
        set: (m) => {
          const p = d();
          p.current = Math.max(0, Math.min(m, p.history.length - 1)), window.sessionStorage.setItem(a ?? "", JSON.stringify(p));
        }
      },
      get: () => {
        const m = d();
        return m.current < 0 || m.history.length <= 0 ? /* @__PURE__ */ new Map() : l(m.history[m.current]);
      },
      set: (m) => {
        const p = d();
        p.current < 0 || p.history.length <= 0 || (p.history[p.current] = r(m), window.sessionStorage.setItem(a ?? "", JSON.stringify(p)));
      }
    }
  } : void 0;
}, G3 = {
  rows: 8,
  cols: 12,
  isCopy: { current: !1 },
  disableCopy: !1,
  disableReCalculation: !1,
  defaultWellBackground: { current: "repeating-conic-gradient( from 0deg, #9D9D9D 0deg 360deg )" },
  vertical: !0,
  selected: {
    value: /* @__PURE__ */ new Map(),
    set: () => {
    }
  },
  wells: {
    value: /* @__PURE__ */ new Map(),
    set: () => {
    }
  },
  actions: {
    getDefaultWell: () => ({ index: 0, title: "", desc: "", colors: [], data: {}, notification: void 0 }),
    selectRange: () => {
    },
    deleteWells: () => {
    },
    recalculateWellOrderNums: () => /* @__PURE__ */ new Map(),
    toggleOrientation: () => {
    }
  },
  history: {
    reset: () => {
    },
    get: () => [],
    log: () => {
    },
    set: () => {
    },
    add: () => {
    },
    prev: () => /* @__PURE__ */ new Map(),
    next: () => /* @__PURE__ */ new Map(),
    current: {
      index: {
        get: () => 0,
        set: () => {
        }
      },
      get: () => /* @__PURE__ */ new Map(),
      set: () => {
      }
    }
  }
}, kc = dt(G3), ln = () => Ot(kc), Nv = ({ children: a, wells: o, setWells: r, rows: l = 8, cols: u = 12, isVertical: d = !0, disableCopy: m = !1, disableReCalculation: p = !1, sessionId: g, defaultWellData: x = {} }) => {
  const [k, v] = Y(() => /* @__PURE__ */ new Map()), A = me.useRef(!1), C = me.useRef("repeating-conic-gradient( from 0deg, #9D9D9D 0deg 360deg )"), [T, F] = Y(d), E = (R) => {
    r(R, () => {
      r((P) => {
        if (p)
          return P;
        const U = z.recalculateWellOrderNums(P);
        return I == null || I.add(U), U;
      }, () => {
      });
    });
  }, I = U3({ sessionId: g, setWells: r }), z = H3({
    rows: l,
    cols: u,
    selected: k,
    setSelected: v,
    wells: o,
    setWells: r,
    setWellsWithReorder: E,
    defaultWellData: x,
    vertical: T,
    setVertical: F
  });
  return ee(() => {
    if (o.size > 0 && o.size === l * u) {
      I == null || I.reset(), I == null || I.add(o), console.log("reset history");
      return;
    }
    r((R) => {
      if (R.size > 0)
        return R;
      if (I && (I == null ? void 0 : I.current.index.get()) !== -1)
        return console.log("history"), (I == null ? void 0 : I.current.get()) ?? R;
      {
        console.log("no history");
        const P = new Map(R);
        return new Array(u * l).fill(0).map((U, q) => {
          P.set(q, z.getDefaultWell(q));
        }), I == null || I.add(P), P;
      }
    }, () => {
    });
  }, []), ee(() => {
    v((R) => {
      const P = new Map(R);
      return R.forEach((U, q) => {
        o.has(q) && P.set(q, o.get(q));
      }), P;
    });
  }, [o]), ee(() => {
    r((R) => p ? R : z.recalculateWellOrderNums(R), () => {
    }), v(/* @__PURE__ */ new Map());
  }, [T]), /* @__PURE__ */ s(kc.Provider, {
    value: {
      rows: l,
      cols: u,
      isCopy: A,
      disableCopy: m,
      disableReCalculation: p,
      defaultWellBackground: C,
      vertical: T,
      selected: {
        value: k,
        set: v
      },
      wells: {
        value: o,
        set: E
      },
      actions: z,
      history: I
    },
    children: a
  });
};
dt({
  wells1: /* @__PURE__ */ new Map(),
  setWells1: () => {
  }
});
const Rv = (a) => xx(a ?? /* @__PURE__ */ new Map()), _c = dt(void 0), V3 = ({ children: a, menuItems: o, menuProps: r }) => {
  const [l, u] = Y(null), [d, m] = Y(/* @__PURE__ */ new Map()), [p, g] = Y(null), [x, k] = Y(""), { selected: v } = ln(), A = () => {
    u(null);
  }, C = (T, F) => {
    if (T.preventDefault(), u(l === null ? {
      mouseX: T.clientX + 2,
      mouseY: T.clientY - 6
    } : (
      // repeated contextmenu when it is already open closes it with Chrome 84 on Ubuntu
      // Other native context menus might behave different.
      // With this behavior we prevent contextmenu from the backdrop to re-locale existing context menus.
      null
    )), v.value.size > 0 && v.value.has(F.index))
      m(v.value);
    else {
      const E = /* @__PURE__ */ new Map();
      E.set(F.index, F), m(E);
    }
  };
  return /* @__PURE__ */ O(Ue, { children: [
    d && o ? /* @__PURE__ */ s(Yl, {
      "data-testid": "context-menu",
      open: l !== null,
      onClose: A,
      anchorReference: "anchorPosition",
      anchorPosition: l !== null ? { top: l.mouseY, left: l.mouseX } : void 0,
      MenuListProps: {
        dense: !0
      },
      sx: {
        "& .MuiMenu-paper": {
          borderRadius: "8px"
        }
      },
      disableAutoFocusItem: !0,
      variant: "menu",
      ...r,
      children: o(d).map((T, F) => /* @__PURE__ */ O($i, {
        "data-testid": "context-menu-item",
        onClick: () => {
          A(), T.renderModal && (g(T.renderModal(() => {
            g(null);
          })), k(T.modalTitle ? T.modalTitle : T.label)), T.onClick();
        },
        ...T.menuItemProps,
        children: [
          T.icon && /* @__PURE__ */ s("div", { className: "mb-1 mr-2 h-5 w-5", children: T.icon }),
          /* @__PURE__ */ s(Hr, { variant: "inherit", paddingRight: 2, noWrap: !0, children: T.label })
        ]
      }, F))
    }) : void 0,
    /* @__PURE__ */ s(Ql, {
      openModal: p ? "default" : void 0,
      setOpenModal: () => {
        g(null);
      },
      header: x,
      children: p
    }),
    /* @__PURE__ */ s(_c.Provider, { value: { handleContextMenu: C, contextMenuData: d }, children: a })
  ] });
}, Y3 = () => Ot(_c), Tl = (a) => {
  const o = a == null ? void 0 : a.substring(1, 3), r = a == null ? void 0 : a.substring(3, 5), l = a == null ? void 0 : a.substring(5, 7), u = parseInt(o, 16), d = parseInt(r, 16), m = parseInt(l, 16);
  return u * 0.299 + d * 0.587 + m * 0.114;
}, $3 = (a) => {
  const { defaultWellBackground: o } = ln();
  if (a != null && a.length) {
    let r = "repeating-conic-gradient( from 0deg";
    return a.forEach((l, u) => {
      r += `, ${l} ${u * 360 / a.length}deg ${(u + 1) * 360 / a.length}deg`;
    }), r += " )", r;
  } else
    return o.current;
}, q3 = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z"
];
function K3(a) {
  const r = Ac(a, "well-container");
  return JSON.parse(r.children[0].getAttribute("data-wellinfo") ?? "{}") ?? null;
}
function Ac(a, o) {
  return a.classList.contains(o) ? (a.classList.contains("plate-column"), a) : Ac(a.parentElement, o);
}
const Q3 = ({ isSelected: a, index: o, colors: r, title: l, desc: u, data: d, notification: m }) => {
  const { handleContextMenu: p } = Y3() ?? {}, [g, x] = me.useState(!1), { isCopy: k, disableCopy: v } = ln();
  return /* @__PURE__ */ O("div", {
    "data-testid": `well-${o}`,
    className: "well-container relative z-[1]",
    onMouseEnter: () => x(!0),
    onMouseLeave: () => x(!1),
    children: [
      /* @__PURE__ */ O("article", {
        style: Object.assign({
          background: $3(r),
          color: Tl(r == null ? void 0 : r[0]) < 150 ? "#ffffff" : "#000000"
        }),
        className: `well-size WellStyle relative z-[10] flex flex-col items-center justify-center text-center text-base transition-all duration-150 ease-in-out ${a ? "selected selectable" : "selectable"}`,
        "data-wellinfo": JSON.stringify({
          index: o,
          title: l,
          desc: u,
          colors: r,
          data: d,
          notification: m
        }),
        "data-tooltip-id": "microplate-tooltip",
        "data-tooltip-content": JSON.stringify(d),
        onContextMenu: (A) => {
          p == null || p(A, {
            index: o,
            title: l,
            desc: u,
            colors: r,
            data: d,
            notification: m
          });
        },
        children: [
          l && /* @__PURE__ */ s("div", { className: "", children: l }),
          u ? /* @__PURE__ */ s("div", { className: "-mt-2 h-4 text-sm font-normal", children: u }) : null,
          m ? /* @__PURE__ */ s("div", {
            "data-testid": `well-${o}-notification`,
            className: "absolute right-[-2px] top-[-2px] h-4 w-4 rounded-full text-center text-xs ring-2 ring-white",
            style: {
              background: m.color,
              color: Tl(m.color) < 150 ? "#ffffff" : "#000000"
            },
            children: m.text
          }) : null
        ]
      }, o),
      v ? null : /* @__PURE__ */ s(et, { children: g && !k.current ? /* @__PURE__ */ s(ye.button, {
        onMouseDown: () => {
          k.current = !0;
        },
        onMouseUp: () => {
          k.current = !1;
        },
        "data-testid": `well-${o}-copy`,
        type: "button",
        initial: { opacity: 0, scale: 0.5 },
        animate: { opacity: 1, scale: 1 },
        exit: { opacity: 0, scale: 0.5 },
        className: "WellCopyButton absolute -bottom-[4px] -right-[4px] z-[1] cursor-pointer overflow-hidden rounded-bl-full rounded-br-[3000px] rounded-tl-full rounded-tr-full outline-none",
        children: /* @__PURE__ */ s(Ag, {
          className: "absolute -bottom-[2px] -right-[2px] h-4",
          style: { rotate: "135deg" }
        })
      }) : null })
    ]
  });
};
const X3 = ({ renderTooltip: a }) => /* @__PURE__ */ s(yx, {
  id: "microplate-tooltip",
  className: "z-20 hidden bg-white sm:block",
  opacity: 1,
  place: "bottom",
  delayShow: 300,
  render: ({ content: r }) => {
    const l = JSON.parse(r || "{}");
    return /* @__PURE__ */ s("div", { className: "whitespace-nowrap text-xs", "data-testid": "well-tooltip", children: a(l) });
  }
}), J3 = () => {
  const { cols: a } = ln();
  return /* @__PURE__ */ s("section", { className: "top-heading HeadingStyle  flex gap-2", children: new Array(a).fill(0).map((o, r) => /* @__PURE__ */ s("div", { className: "mx-2 flex items-center justify-center text-xl font-semibold", children: r + 1 }, r)) });
}, j3 = () => {
  const { rows: a } = ln();
  return /* @__PURE__ */ O("section", { className: "left-heading HeadingStyle flex flex-col gap-5", children: [
    /* @__PURE__ */ s("span", { className: "flex items-center justify-center text-xl font-semibold" }),
    new Array(a).fill(0).map((o, r) => /* @__PURE__ */ s("div", { className: "flex items-center justify-center text-xl font-semibold", children: q3[r] }, r))
  ] });
}, Z3 = ({ children: a }) => {
  const { cols: o, rows: r } = ln();
  return /* @__PURE__ */ s("main", {
    className: "PlateLayout",
    style: { "--cols": o, "--rows": r },
    onContextMenu: (l) => l.preventDefault(),
    children: a
  });
}, e2 = ({ children: a }) => {
  const { vertical: o } = ln();
  return /* @__PURE__ */ s("div", {
    className: `PlateColumn flex items-center ${o ? "flex-col gap-y-5 p-2" : "flex-row gap-x-6 px-2 py-2"} rounded-full bg-white  shadow-lg`,
    children: a
  });
}, t2 = ({ children: a }) => {
  const { vertical: o } = ln();
  return /* @__PURE__ */ s("div", {
    className: `left-0 top-0 grid ${o ? "plate-container gap-x-2 gap-y-2" : "grid-cols-1 gap-y-1"} w-full  bg-transparent`,
    children: a
  });
}, Wr = {
  ".SelectedWell": { boxShadow: " 0 0 0 4px #0872ab" },
  ".SelectedWellWhenCopying": { boxShadow: "0 0 0 4px black" },
  ".AreaSelection": { border: "1px solid #0872ab", background: "#4f90f22d", zIndex: "9999" },
  ".AreaSelectionWhenCopying": { border: "2px solid black", background: "#0505055b" },
  ".WellCopyButton": { color: "white", background: "#06b7d2 !important" },
  ".WellStyle": {
    borderRadius: "9999px",
    background: "repeating-conic-gradient( from 0deg, #9D9D9D 0deg 360deg )"
  },
  ".HeadingStyle": {
    fontSize: "1.25rem",
    lineHeight: "1.75rem",
    fontWeight: "600",
    color: "black",
    background: "rgb(232 238 243)"
  },
  ".PlateColumn": { background: "white", borderRadius: "9999px" },
  ".PlateLayout": {
    background: "rgb(232 238 243)",
    borderRadius: "0.5rem",
    border: "dashed 1px gray",
    padding: "0.7rem 1.4rem"
  }
};
function Mv({ mouseActions: a = {
  disableMouseLeftButton: !1,
  disableMouseRightButton: !0,
  disableMouseMiddleButton: !0
}, renderTooltip: o, renderContextMenu: r, styleSheet: l = {} }) {
  const { wells: u, selected: d, rows: m, cols: p, isCopy: g, vertical: x, defaultWellBackground: k } = ln(), v = Re([1, 2, 4]), A = me.useRef(null), [C, T] = me.useState("auto"), F = "plate-style", E = ".selection-area", I = ".selected", z = (B) => B.map((M) => JSON.parse(M.getAttribute("data-wellinfo") ?? "{}")), R = ({ event: B, selection: M }) => {
    !(B != null && B.ctrlKey) && !(B != null && B.metaKey) && (M.clearSelection(), d.set(() => /* @__PURE__ */ new Map())), g.current === !0 && T("grabbing");
  }, P = ({ store: { changed: { added: B, removed: M } } }) => {
    d.set((V) => {
      const X = new Map(V);
      return z(B).forEach((te) => {
        X.set(te.index, te);
      }), z(M).forEach((te) => {
        X.delete(te.index);
      }), X;
    });
  }, U = ({ event: B }) => {
    if (g.current === !0 && (A.current = K3(B.target)), B instanceof MouseEvent)
      return v.current.includes(B.buttons);
    if (B instanceof TouchEvent)
      return !0;
  }, q = ({ event: B, selection: M }) => {
    T("auto"), B && g.current === !0 && (g.current = !1, u.set((V) => {
      const X = new Map(V);
      return z(M.getSelection()).forEach((te) => {
        var ne, $, j, le, ve;
        X.set(te.index, {
          index: te.index,
          colors: ((ne = A.current) == null ? void 0 : ne.colors) ?? te.colors,
          title: (($ = A.current) == null ? void 0 : $.title) ?? te.title,
          desc: ((j = A.current) == null ? void 0 : j.desc) ?? te.desc,
          data: (le = A.current) != null && le.data ? A.current.data : te.data,
          notification: (ve = A.current) == null ? void 0 : ve.notification
        });
      }), X;
    }));
  };
  return ee(() => (document.body.style.cursor = C, () => {
    document.body.style.cursor = "auto";
  }), [C]), ee(() => {
    var te;
    const { disableMouseLeftButton: B, disableMouseRightButton: M, disableMouseMiddleButton: V } = a;
    B && (v.current = v.current.filter((ne) => ne !== 1)), M && (v.current = v.current.filter((ne) => ne !== 2)), V && (v.current = v.current.filter((ne) => ne !== 4));
    const X = _a(F);
    return (te = l[".WellStyle"]) != null && te.background && (k.current = l[".WellStyle"].background), Object.entries(Wr).forEach(([ne, $]) => {
      const j = { ...$, ...l[ne] };
      Gn(X, ne, j);
    }), () => {
      const ne = document.getElementById(F);
      ne && document.head.removeChild(ne);
    };
  }, []), ee(() => {
    const B = _a(F);
    g.current === !1 ? (Gn(B, E, l[".AreaSelection"] ? l[".AreaSelection"] : Wr[".AreaSelection"]), Gn(B, I, l[".SelectedWell"] ? l[".SelectedWell"] : Wr[".SelectedWell"])) : (Gn(B, E, l[".AreaSelectionWhenCopying"] ? l[".AreaSelectionWhenCopying"] : Wr[".AreaSelectionWhenCopying"]), Gn(B, I, l[".SelectedWellWhenCopying"] ? l[".SelectedWellWhenCopying"] : Wr[".SelectedWellWhenCopying"]));
  }, [g.current]), /* @__PURE__ */ s(Z3, { children: /* @__PURE__ */ O(z3, {
    className: "container",
    selectionAreaClass: E.replace(".", ""),
    onStart: R,
    onMove: P,
    onStop: q,
    onBeforeStart: U,
    container: "body",
    selectables: ".selectable",
    document: window.document,
    behaviour: {
      overlap: "invert",
      intersect: "touch",
      startThreshold: 10,
      scrolling: {
        speedDivider: 10,
        manualSpeed: 750,
        startScrollMargins: { x: 0, y: 0 }
      }
    },
    features: {
      touch: !0,
      range: !0,
      singleTap: {
        allow: !0,
        intersect: "native"
      }
    },
    children: [
      /* @__PURE__ */ s(J3, {}),
      /* @__PURE__ */ s(j3, {}),
      /* @__PURE__ */ s(V3, { menuItems: r, children: /* @__PURE__ */ s(t2, { children: u.value.size === p * m && new Array(x ? p : m).fill(0).map((B, M) => {
        const V = x ? M * m : M;
        return /* @__PURE__ */ s(e2, { children: new Array(x ? m : p).fill(0).map((X, te) => {
          var j, le, ve, se, _e;
          const ne = x ? te : te * m, $ = V + ne;
          return /* @__PURE__ */ s(Q3, {
            isSelected: d.value.has($),
            index: $,
            colors: ((j = u.value.get($)) == null ? void 0 : j.colors) ?? [],
            title: ((le = u.value.get($)) == null ? void 0 : le.title) ?? "",
            desc: ((ve = u.value.get($)) == null ? void 0 : ve.desc) ?? "",
            notification: (se = u.value.get($)) == null ? void 0 : se.notification,
            data: ((_e = u.value.get($)) == null ? void 0 : _e.data) ?? {}
          }, $);
        }) }, M);
      }) }) }),
      o && /* @__PURE__ */ s(X3, { renderTooltip: o })
    ]
  }) });
}
const n2 = "5.5.7", r2 = {
  g: "LottieFiles AE 0.1.20",
  a: "",
  k: "",
  d: "",
  tc: ""
}, i2 = 30, o2 = 0, a2 = 286, s2 = 1920, l2 = 1283, c2 = "Animation (Lab)", u2 = 0, d2 = [
  {
    id: "image_0",
    w: 7,
    h: 7,
    u: "",
    p: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAAeklEQVQYV3WO0RHBUBREzyL/6SAFYIYOaESiAx1IB3RAVEIFzEghNJA19434kvu1c87s3BXA6e58nFHZ5BKvzUzH4AoxyngARYB04lZOtdKl9c5w+Ilv6MxazdM1Yv9XDjbFUtFoWp+BMr0Tb0wdo5LsFzNhsZ3r2rMPW+YpDReknx4AAAAASUVORK5CYII=",
    e: 1
  },
  {
    id: "image_1",
    w: 24,
    h: 159,
    u: "",
    p: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAACfCAYAAADjwhmYAAACTElEQVRoQ+2ZzW7TQBSFzx0L2PGzRA1SeQLMzmFDngDmDWifoH0BpDxC4QnyBoQKsSUggSyxwGWDWoGSKmnYdEF/FLLyRUNSVEWKr+3Q3cnW4zkzX+65c2wLav6+Hxz3rFsFyMQatOz6j4Njte5V4D0FCikREauo2EY0mtVmQERE9JcAuym7KbspfcBsah0IPDItQkwVJiEiIqIZAQYvBi8GL/qAwcs6ERi8LEJMFSahUojk/PTjlbx9l8kE0Zu3J1H6ef+/CYRJ3bd9RL0PQ7f39d4sVWj97wfD5y8HGPSdnJ7ncnZ2E5PfdxbBriRwlDwtceivsAMKmEYgIiKaP4DQaEYpsNmxXReXCLspuym7KUAf0Af0AX1guoCIiGhOgOma6ZrpesV3dgxeZj8lIiJiNmXwMl1ARETEbBoIXOmROXrkY8n1i1VstZ8Pxk3vVfWVKSDyotbX2FHT74jqlikA2awlcJQ8yQB5YAk4yP3KAmX5A7q3lu7GlQXGie8o9Jm1eoVsNtJup5LAz8Sv59C+NTmAw7X09XoYV0mg6uorCQwT33LQd9bqQ+030t3WxbhSO+i3/O0bUx0ocKtIQIATgcR30+6gtECY/Po075UpS3XysPGpm11eROEOKk0+r5rFHS4VmNV73rFWHrDkTlqLKy9ENG76bai2LebhD43gNi4zL9xBqBRB3hbIY6NaDhXSDkayqkoC52tTeEG+beEI9le4nTIT/0M0SvwGBDE0j2fGuFh9mAy/IC6DIouAXhGKZTsp5QMLQ9H1P/RkiGCYmYJ9AAAAAElFTkSuQmCC",
    e: 1
  },
  {
    id: "image_2",
    w: 38,
    h: 98,
    u: "",
    p: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAABiCAYAAAA89KHUAAACmklEQVRoQ+2bz24SURjFz1eHpDs1ERJX4hOITyBvIEnbxJ0sRzfFJxDfADc6S9yZdIz4BMIb0DeoK5O2SXVHwrSf+aBDpvxpOAOjLr67A86998zvnhk2cwT/6ZCsr4tG6964NGpAURegCqAG4O6c94ECJwIZJoH2Hn6OToq4tomxs/2wDqAF4HmOTQYq6FaOom6OuSunyPle2FHB4RYWHajstCpHH4abrmWg5Gw/7AN4tuli6XwFPl0GaOc54tODsCmKNiwq2zY2u0DBMRQ9AP1yHNnFL4yfL8JqaSy1K9GGAI1MngfFGVvmZGr214qbKjvjLxtbPy9ubH1WU6UTc2IsAVbvGXNiLAFW7xlzYiwBVu8Zc2IsAVbvGXNiLAFW7xlzYiwBVu8Zc2IsAVbvGXNiLAFW7xlzYiwBVu8Zc2IsAVbvGXNiLAFW7xlzYiwBVu8Zc2IsAVbvGXNiLAFW7xlzYiwBVu8Zc2IsAVbvGXNiLAFW7xlzYiwBSi+K9/autb0N/paaWbhY3sj53quGin4tfC9iA5Wdp2J1jCQYXRDzipb+KMdRNa1m2Hv3eWoZWzdp+XrwJWplOyPft75LjgWTAI+tPTFr2RTWhCDMWa2jEkdNm5I1Zk2bf0otpXXDmH3YYuOG4DSTvivHkT26JmOhMJWURn0onuRZeYM5g3Ic2YnNxg1j9u3148PaWfMNrg32vWWq4DgY79bv9zpWclltzH45PXhdE72yR8ijYtzMzmupqYWjzJqYkCv2WL8FyW5zntTSjC2jU8B/6W9A2uX4Y+e201jI2DKxNa7uJGgL8HKTo2XqZ2sZS81MK2FoqUzqYOvl77pqlgToMn04yliWVtpbU1HrYNpIb/dJz01UhuOSDhkz2fX/AERnuXyQnh/LAAAAAElFTkSuQmCC",
    e: 1
  },
  {
    id: "image_3",
    w: 56,
    h: 89,
    u: "",
    p: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAABZCAYAAABrLufhAAAEmUlEQVR4Xu1cTWhcVRT+zpuf5M2kOmmp0KqYRSWgUEe0uvAnEysItUpwpVVwFl35QwfqHwj6Cm5ciG7ahSKTVLG4UaGKdmVaXLiRRpK0IGgTbWtrmtqEMfPjzDtyJ84wGZved1/uS17G+3bJ++6957vnfueecx9zCW1P/iSnIjFkmTDU/m61/i4Vucd1ES1XuGdhgTfJxo3HMRqLRt7Zdz99146l1n98dIqHmDHMjOtlna7W+2qVMXvZxcICS4dMJun4y4PRTCuwSfDwJGeZkZf2skaAQsHFzCVXOrpt08+v7oxuawDrBPPjnLEI30pbrzFAeHJ+Xk6y1ZN1giMTPAXgljW239Pwv52tolqVQ3tT0QeEJknoznXxubxJOBBel2oiYY298lDkThqZ4GEAz4bDfLkVrgtM/yp3YSxGxdcfiSZoZJJHwRiQdx0ehNdl6uyOkfDgutFfY4p/v1BDqSTfNhYJrkMPdjzBM1NyDVoW+I1dMYsOT3COgXfDo7BrW1KpMM6dr0nN7e6mC689HN1C+dPcZ9VwRtoiJICZSzUUCnL9bUhaH+4fjOxtbPTvAdgXEg7LmuHVe40tQnS0mKqd5JQVwyiAO8JKUux/587LsxihveuS9FRuIPppk2DYSQrPXfyjJk3R2sktIdjw3Mg4O2QhF4aSSRCbm3elmhPEurrol2R3ZOcL99F06ypcUg+2vshPchouUv29bvrmRG1Vo+zsX0BFshNcLtGxyRnrG2Hz/gcjIoZc9VmWYANdLBYzFiiEpRQf6LJtRxYzDEHjQdkaCey9WaL1qTUaNBoMTGOyjo0GjQbrM9DxGvzs2Iknz16cPSJTRPv7LZs34vHMvarNFPCaNPjWoY9zR74+4SvZ3rMrg5eyTygYrQINAUFh7pcHHWzdvFHFco/YkBB8/80Xcfftt3o0WgUWEoLH829jQ9JWsdwjNgQEneeeDjDQaCL4w/hPu0vl8lGP09qEbb1hU0DaawyhiWDH74OGoOra1YY3S9Qk2/+PZNsEGW1BQ7UjTUHGb7mU2bEd/X03qlqtgNdEcCXl0rpI1VZCULijo5NtQbDjy6WOLnjXxZGF3yh6123bAqrkTbm0ZKsxH19MqqaQe+iFaspkjAf1ukWhN+NBU9HXZ8DvuWh/300BnWhr3uj9VhM9Cbv+ZSm4T2iaNOiXoJhnQfKrg05AngwBQVMuKWwK/4WGwIOPDdyDA88/syIayzfWRPDQJ0f3fv/j6Q9UrRzcsR17Hl3yUz7VLiR4TQRNqqbZL967Mx40qZr5+OJdL0EgjQaNBo0Gg1CW9z6NBo0GjQa96yUIpNGg0eC1NDgNxhiIxwiYqgHiNoXFGWNKW0CfS0gTgrxCQv8SnSPGMFxrON4TH/OiKv6TU393l4ZcUFY/WU0EK4VKGpabjZW7HOqlK16IXQ3z78mAuPlE0701mgj6JbRcu3Kx6ACUA3zfGzVNYCdu22KypI/0C6+0Bx+AxtJlpiEQxMmU7JKsOTBGifgLr8SaMcGHfdqbCBnUIrWUCFBEnBIDMNMVJhZan7JtuxnEVAdfEw+qGrkS/D/uSPd4YihK8wAAAABJRU5ErkJggg==",
    e: 1
  },
  {
    id: "image_4",
    w: 24,
    h: 24,
    u: "",
    p: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABq0lEQVRIS7VV0VXCQBCcCc9vsQLxU4EnVCBWYCxAQioQKxArECuIwQK0BKxAeIJ+Ch3gr5Jb3wWCBALvonCfdzM7t7t3O8Sa5b1LLhPAFqACIhuDCjqWhfbFEZ/WxWDSoQ5sBWgAcNaRp2dDEo1qnvdJ2CWBVl9qAJoi2DUI/gshntUXbLfM0TwvJuC/SgPEdarAc2ASnwFQcfPsRNszAX1zEXh/DT7H66pvVKJMQoGwmQqd1GVZfZs7p8C6Pg4F/J7oBpk01DhBlcGBe8gBpy/mw5hpDvSdAmts9aQuwK05zwypG17NM0u/J/qjnJnR0qEUUabflzYEJ+moZmglON2qAIGrrQpYFs63KjApUU+aAC7NqpoOpb6xx4c3sZXCYzqqEbrrFFiKfvIAwL4RzRBEwtUjPBTY4KCL5IdOgbnZLArn0Qb/g26uW2Q7JuC9SNbagZ7j/yuV4MYpUrthuGKGMx18enQcG5Y6DlsIviQQesMkE32DNE93qAS1qCzzqommHwpNjZ+EvcaIuiSaqww/MYOk0nh9KUEhmyFKtDAYBxhhjM6iwSdxfwACZapIHTwhTAAAAABJRU5ErkJggg==",
    e: 1
  },
  {
    id: "image_5",
    w: 7,
    h: 7,
    u: "",
    p: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAAeklEQVQYV3WO0RHBUBREzyL/6SAFYIYOaESiAx1IB3RAVEIFzEghNJA19434kvu1c87s3BXA6e58nFHZ5BKvzUzH4AoxyngARYB04lZOtdKl9c5w+Ilv6MxazdM1Yv9XDjbFUtFoWp+BMr0Tb0wdo5LsFzNhsZ3r2rMPW+YpDReknx4AAAAASUVORK5CYII=",
    e: 1
  },
  {
    id: "image_6",
    w: 60,
    h: 172,
    u: "",
    p: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAACsCAYAAAAnms8xAAAG7UlEQVR4Xu2dS29bRRTHz9xHBChtEtWtWFAa5+HQLqhhj3AlJJakEgt2pBKVkIoh+QSknyBuDUtEumWD+wlI+QIkqypOg2uxo67SSCAS38egub5x7fgxD7/O2JPtjNv7m/858zrn3EsOi5UcBUiD4J8N4XoydWVXsDu6buRZsbJDAD4WfbKQ0FvLy5d3RPtj62eAeYoYhXkjhKzdmDRPEGPSvBFC1m5MmieIMWneCCFrNybNE8SYNG+EkLUbk+YJYkyaN0LI2o1J8wQxJs0bIWTtxqR5ghiT5o0QsnZj0jxBjEnzRghZuzFpniDGpHkjhKzdmDRPEGPSvBFC1m5MmieIMWneCCFrNybNE8SYNG+EkLUbk+YJYkyaN0LI2o1J8wQxJs0bIWTtxqR5ghiT5o0QsnZj0lxBKL2/uHJ5k9sPaQdphUF34D+LlW0K8KWwILoDH+6/2ARCvhcFJgCPFlKJNdH+2PqRw4OX60DpluiDUYAnS6lERrQ/tn7k4OBFxqLkN4kHO15MJWYl+qPqSkqlo9nQC45knsoK7GTy+txzmd9g6UvYgxzuV54DgWuiD0Up3F5aSRRE+2PqFwFLz9QADxZTiXVMIKLPEgE/K1bWCMDPoj8CIHuLqUvCxV3i/+7ge0bApadH86EdlGT+O8u155LJuVcyv8HQNwJW8mOAO0upxDYGCJlneA1crOQA4DvRH+u6AakDl4p/p0Ow/hAFBoBjy7XndTPrOvCkmPU5YLl9tY7bzCZgpdlas11XE/AkbEJagFUOEzpNXi3A8c5Lqmpcp1uQtsDjrHJb4HFWuSPwuM7YHYFrG5HxW5e7AkfQxZe7APSm8JYT+a0mFzg2bfaikhlRaMzxJy5wNIHtV1YJgV9FgTEfLISAa6Ytd3zEus8WBh4Xf5YCHgd/lgIeB3+WBtbdn5WAlbaeSO6ylYHjEA0LtwivzxgiFsrATGWlU1Vgp0cZl+oJWGW/PeqoRc/AuvlzX4B18ue+ACv7M4SZYb9BsW/AkT9Lpk8wf7ZcKzPM6EVfgaNr3v1KgRL4TPRkNewYVd+BI3+uBrtSGQVDjET2HZgpqxSYG5I/DwQYsz8PDBirPw8UuLY+hzsyl4B0wP48UOAGf2Yv7xU+ZFgQfjCo9XngwPHWUy5LiELZmrLTg1ifhwKsEoYlFB4vrCRWRddz0X5DA1bxZyBkY3H5Eku26dvf0ICx+PNQgTH489CBR+3PIwEe5aX+yIBzv//z/k8l95f3poPphenwrY8S3tz1C0HXyakfQbqRATOyqby/SuF1kM614L8bF/zK5+9UE5++7b150aHnB6Dn7L+RAjMaN+/lAEjbHM+bM/5fdxdOr35yxauD9xqkGzlwDTroGnS/6NLjr5Kn4RdXT+ci1XsIuqMAfmOLzgcOg+6+32Ymv3bttHp34WRm2g2VPrCBApip7OS9DAGx6hoGnl06Ofn6Xe9D2Ut9NMC1SczbpCBeNDZl0af/3nNvyOw7UQGL+HMrHH3gZV3hghN8wD9W0xBKJaoDAbhdzTpCZUXogGsq+6yWQrwAFODY9u30yQbhFo+hBI5nbakqG3ap72VtbmkRSmBFldnPHnlZp2vlK1pgNZUBgMId71unY3kRWuBobX7oF4hE2CaewY/BCjPevam2nzlDDXz+cCG+3pI9z7cysEFaKudQA8e+zB5a+Iq3YVDa+rMOwLJLVJ253fqMHljdrAEI0PvVrNv0Cg70wL2YtbbAirO1xgo/9NeAyBR019xYW4VVNyHaAqv6sdbAKn6sNbDsbYjWPix753W289BaYZWJS2vgeOJqCUV0O1CMAzDLFRH+OLT2wLIztfbAsjO1AY62mxr9yYRjtF+HVdZi7U164hR2JcMw2issu/kwwLrN0kZhzpJqTFo3k5Y9Imqv8MStwwZ43Cctczwcd4Un7saDl4R6XnDtlyU370/OraXskqT9jYf7QyD18v7YvFvyPLS505KdsGLgJ17WafpigTbAbt5XyOZpTUfUAriXxBYv6zQxagGskF1bX6Eo0Ft+1mUhmjgNQoN7aTVzPgNrTiBHr7CrmNDSoGPZyzrz2ijs5n2W9C380Y22BtuQYYta4T6oe8ZfVxk3cD/Urdsy2fC+sXNogWXPvgJzb1QXgRJYNqQiAMvuK6McanzAW3TWdQKpd+0JANerXnABR7ByLzrhw5I927dWz0p80ADX7pzDgsxbXXiwlMJjP7DXGksBUADHe2WW+a6S6t+Ou0wA1ttVq40UOJ6c2Hs6hFOROKqWgZCc51nb7Qo8apcCQ/6LTNcOMkCAFVT1A7QMQAsUoNB4SOiENXBgpiINSfQVPUKsNKFhz1/Uo8R6RWm46/vObiclOwH/D1Jrxj0R0FZ4AAAAAElFTkSuQmCC",
    e: 1
  },
  {
    id: "image_7",
    w: 150,
    h: 76,
    u: "",
    p: "data:image/png;base64,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",
    e: 1
  },
  {
    id: "image_8",
    w: 74,
    h: 44,
    u: "",
    p: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAAAsCAYAAADCfS42AAAC+UlEQVRoQ+2aUZLSQBCG/w7qq9zAfdXdLfEEcgO5gEs4gXiC5Qh4Ash6ATiB2RMItaCPwgnEVyHT1kwRaheBdMIACUmqUlDQ6cx86f4z0zOE4hARIJFVYYQClDAIClAFKCEBoVkRUVkG1fnOZTxDRffBAaqrvhAuoM/1gzEDYxD+rABff29ck/m0cZw0okIgBkYIgfHeRsce+ZiCMIGCrwEmhXdUUJ2ffFFSqDKbKNER89YyFKm7PgF+UEKv8ZomkosODqrzwFWHUAPM+UrSqCPb9B0H3Y9vqLfrvgcB9fUH15RCjQg1Zrw8cseT3m5KhNbNJXU3ObAGSqeVs4ALgpvSyJECnDoOmusRtjeoZWo1AXyQtiQTdoR75cANNSwxKAPIQQv231Kp4UiEPwCaOh1jgzIpptA9Z0DrT4qAz7FA6XFP6QUmGRJoG9Hp1a/IjQXKG7Ofp0gCYCBp2mJQ3gO3QLi18Ygy4mMFSQxq+Wb7lpEO7t1MrUk3V9R+7CgyovKmS0RobBp0RoLKiy7poUAAVBuXtKpCiCMqR7o0VCXUdk2Qt0ZUjnTJU3M0G+9oFntSrHXJeW4KYWmc7e8t1qGDTaK9zfnGiMpByg0Vwd2mR6LqgZmiBPhl7bGlz9EXNUcrKtU2TGOe/uSNWNdj6unr394tmiqGa6UUfMYCniiKtg4Pzi6adE0JaMbRokgxPzNt2lnWTZLEq7eeN2I9t/mUxElartGja1Zo16+pZbtNK1B3Y55luM40JaAdzNGN+zaTAjWg7sbsMqMjvShFdkMitLetnNhspwHljVivaWViccCkF6OnCG0bIi2FScvpym/pBSe06xOhF/xF71DptXOul9a0CyOHCP6p4DwZR6Vl7LQE45s9AQT/mGklyRIywwJC5aiLBoR7LLfqOCUMFoSBdLOEpFOHsPmvetAZcwUKZX2ztb1JZQNUcui9ShqEXr0gzIJw79ICg1Poi6TJUTaRpeAoB3n5vwAlfNIFqAKUkIDQrIgoIah/HV0WITQ3S+4AAAAASUVORK5CYII=",
    e: 1
  },
  {
    id: "image_9",
    w: 113,
    h: 140,
    u: "",
    p: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHEAAACMCAYAAABLckYXAAAJ7klEQVR4Xu2dTYwcxRXHX/XsznSPd2FB4RA4eCKRIAWRLOLrQJIdwwklKIuiHBIh2RwQByJYKwk+IRblBggmZ6R4l1yIFCnjE0cmSiIlUiTGik24RPZCwEgGzFj2TM9kpl9U8+VlveN5VVNdVT37WtrTvqqp/v/6vVdd9bpbgAfH79/H9SSBdRBQcjWcbhcWOm1cShJcuNrEr3W7UKCMJQggXliAv4eLuY1fPCx2KG1M2wjTHar0d/IsrgYIWwDwXZV2NmzjGOHiZz3odmm/FgSAxaI49avywhO0FuasnEF86yweA4AKItxs7nTM9pQk0AfZbCK54ygS/znx6MKd5AYGDJ1AlB6YA6j5DHC3th9/0oNOhw6yWAzqLzySu9cAH1IXTiBun8G6jyF0kmLdLoIEKT2TeizfFBz/5Q9yFar9LHbWIQ4nMX+aZdAu2n7+RQKXL9Mp2gyr1iFun0E5kTnqAsQsvynDqfRGlWPzR4tW9LXyI7tPfPss1gBhTUUMX2zPnSdOVYcDthVS7UM8g/QZgi/0huNQneDMM8TzAHDYMz6k4ex82PVycmPfEzMaTuXMVEJUOW5ZWfj+898Tf1Vpo2NrHeJbZ3ADAd7QGazLNleuJHDxM/rsNJeD7ouPLS7aGLN1iCf/jaWgB+dsnJzJ37jwaQ/kUhz1WFoSVVtLcNYhShG2/4WbIOAlqiCu7eT9obxPpB42vVCOyQnEPsiM5EbV+0O5EH7TIfGzjbWFP1Chz2rnDOLJ93AlWAS5LOXtjb+OBy4XxZM2ATr1xNHV11+GQ9jwZQFAzkKbzQQal5G86C3DZxiKv0X53FEXe4rOPHFvCJETHuhe2xReu/1/lUVhb5+x0wX4/CotsP3lo9zxkWUO8YJtz9s7Sm8g7h1Y3IprAvxcnitEoVe6eTWY3SAZIi0qeJETJw2VITJEugIalhxOiaKxJxKFcnmzP22IDHGaQtf+zxMbulZjSw6nRNHYE4lCcTilC7Xbkj2RqBt7IlEo9kS6UOyJGlr97o/vfHClGd+l2vTx8kNw+223qjZTsudwSpTrJ8/95tIH5z5aIZqPzZaKEby5+RzcVbpDtSnZniESpdKFKLt/fO1BePnZJ4m/pG7GEImazQLxvm/f2ffGtA6GSFR2FojsiUSR0zbThfitw3f0vXD5UJTaENkTidL+o/7+P7vd3n1E87HZ/Xd/U7WJsj1DJErGN/tEofhmny4U3+xraMWeSBeNt6LoWo0tOScSRWNPJArFOZEuFOdEDa3YE+micU6ka8U5UVUrna2or992Kxx54DuprtbI8+CJDZGm7rKbBPn2KydSBckQU4You+cFcKLIaZvpeqIcF29FpU2H2P8sENkTiSKnbaYLUZZnvP3qiVTrbDgnEunrzE6XixHIQqk09xLl8EUvuDe/lJdvivTi4PtEDQwJ4JEoimoaTVNpwhA1ZGWIRNF8XnZjiAyRqADdjMMpXauxJXsiUTQOp0SheD+RLtRuS/ZEom7siUShfPZEnbrT5UPFVB+kGcnKnki8wHSX3eTi9+u/fjrVVRuGmDJE2f0zP32s/5fWwRCJyup6ouw+7a0ohmgBYvmBe/ohNa2DIRKV1fVEG08KM0QixBOvvfnfCxcvKT2zLZ/V//kPj6Q+Q2WIRIjtVuztR1AYIh0i/fsFxD5NmTFEopLtlsJHKIh9mjPDlwtRtGmuv9l68nIXo9VqlQMQ7852amm2ZohT1W1fba9DgN5+KBMB/hxGYXnqiVgy8NIT263WJoDw+Qs2jUIUKr8oKS2mXkL0eQdj1yL4N6IokjNo54eXEP2e1AyZJeKJwqFC1TlBH7eiOlc6q5hL3vNBnBuNQSD8Nl8MN3wYp3eemIF8OOK2U4jCEkPcR4F2M66Dxc8LzQIhAfQiL3rlia1WqxSAyMwHMhHheFgM5ZfnnB5eQYyb8YYQGfpULcLpQjFcdUrQt4lNlkKpT7ca3nhi1kLpCKIPs1RvIHaacQUFPO86NGn8vvPVGy8g4iVc6YRtufpxs4aIzpsIwKfyUbTlaiBeQMzchGYvLccTHC8g+ryLT/UulxvFziFm3guHlF1uTzmFmPVcuNdLXeVGpxAzPCOdFGV38nFhVdwivqSGYRN2ziBmZbdCVWQX941OIA7DqHyFyGFVkbJgb3uS4wRiu9XeAsCjWQCiOcZGPi6UbIVV6xA7rdYxBHFSU5zMNLM5W7UKcV7z4KQry1Z+tAZx3vPgxBBhoRbHGsR2M66CgB9nJh6aG2gjAVxNszLOCsR5WZXR5pry2mrqEA9aHnSRH1OFeGDz4CSSKeXHVCFmoZJbO0TqNWyIXlA2/a7U1CBmqH5UD4duK4TT+XahbHIhIBWI/j+apkvAVDuxXYgKx4z1ZqqjUT/ztr1kWp9Rfya3rYx7IudBMnZj+dEoRM6DZIADQ0P50RhEzoOKAMfms+dHIxCHhb9yfzCTJYe68ptqN2t+NAIxi+X3pgCY6meWb23MDHEO62RMcVHtR7s+ZyaIvr/lQlVF5/YIpwrFcF11HNoQOQ+qSk2z13nmURsi50EaFB0r1fyoBfEAFDrpaG+yjVJ+VIZ4UAqdTBLR6Uul0EoJ4nCDV36tjO8Hdcgot6G9Q44Msb+wXWjXsvJmC2W9PG1AKUQmQ+Q86Izy1EJkEkTOg84ADtfJb/xWx6kQOQ+6BXjt1yfnxxtC5EInXwAOxjEpP94Q4gEu+PWL3rXR7FuIPBHigS/49RXjPoXI+0Lkgl9fCQ7GtfdBnesgch70G+B4dLsKka+DyHkwIxABxvnxKxC50CkzAAcDHebHMURiodMOAvRfXh4g1FHgvm+JEChWEgH9V0gKhBVeqlO+OBoIIGuWrtNZAJzvDRnI/4dxWO9D3LfgF+G0AKiBwDr0cnUTzw/0L5QkWIEgWQUUEnLpQANGOA1C1AGS8wlALdfLfamjcx/iqOBXbn8EgFuLcVg1+azAtOtwEAWg3AcrQH40ZB53SRqAA6eQwKIokrtBRg4xyINBKYFkM82nWVVGO7jF6a0DivUse6p0CkCoBklQ0/EwqmZC1sr4Am+/Qcvx5QDKOADq++PiDQBRhQSq+U6+ZiuaTV0Ap14NNuwkUIFiXQiQ36Pw5UVGY3CuPnaSKYi7L5RBHg2OOXupEcIpIbDq8mW1Iz0yC3F0Av1wi2IDBcjn/dKeEO0gQgUFVn1KQZmHOII5uE2KNwCEDLVmYSKcAhRbrsLltFQ1NxC/CrNTMRBmGwJhqyew4pPX7Qd07iCOTlLepiS5pCIA1qZdyXv+vwOAW/k4rNiaXSqO7zrzuYU4OtPhvqj8/u+0ELsjADd9mKioQp17iFKQ/q0JiK0JXplZeHMzO1W5avdUK2Qe3oGEOPTKcg6glMWwOemC/T97143G9mwrvwAAAABJRU5ErkJggg==",
    e: 1
  }
], f2 = [
  {
    ddd: 0,
    ind: 1,
    ty: 3,
    nm: "Null 3",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 0,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          930.163,
          731.012,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          0,
          0,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          300,
          300,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 0,
    op: 5400,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 2,
    ty: 2,
    nm: "Bulat 16",
    parent: 1,
    refId: "image_0",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 255,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 260,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 280,
            s: [
              100
            ]
          },
          {
            t: 285,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 255,
            s: [
              61.359,
              59.625,
              0
            ],
            to: [
              12,
              -34.167,
              0
            ],
            ti: [
              -22,
              50.167,
              0
            ]
          },
          {
            t: 285,
            s: [
              61.359,
              -28.375,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          3.386,
          3.246,
          0
        ],
        ix: 1
      },
      s: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833,
                0.833,
                0.833
              ],
              y: [
                0.833,
                0.833,
                0.833
              ]
            },
            o: {
              x: [
                0.167,
                0.167,
                0.167
              ],
              y: [
                0.167,
                0.167,
                0.167
              ]
            },
            t: 255,
            s: [
              100,
              100,
              100
            ]
          },
          {
            t: 285,
            s: [
              250,
              250,
              100
            ]
          }
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 255,
    op: 286,
    st: 255,
    bm: 0
  },
  {
    ddd: 0,
    ind: 3,
    ty: 2,
    nm: "Bulat 15",
    parent: 1,
    refId: "image_0",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 240,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 245,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 265,
            s: [
              100
            ]
          },
          {
            t: 270,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 240,
            s: [
              61.359,
              59.625,
              0
            ],
            to: [
              12,
              -34.167,
              0
            ],
            ti: [
              -22,
              50.167,
              0
            ]
          },
          {
            t: 270,
            s: [
              61.359,
              -28.375,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          3.386,
          3.246,
          0
        ],
        ix: 1
      },
      s: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833,
                0.833,
                0.833
              ],
              y: [
                0.833,
                0.833,
                0.833
              ]
            },
            o: {
              x: [
                0.167,
                0.167,
                0.167
              ],
              y: [
                0.167,
                0.167,
                0.167
              ]
            },
            t: 240,
            s: [
              100,
              100,
              100
            ]
          },
          {
            t: 270,
            s: [
              250,
              250,
              100
            ]
          }
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 240,
    op: 271,
    st: 240,
    bm: 0
  },
  {
    ddd: 0,
    ind: 4,
    ty: 2,
    nm: "Bulat 14",
    parent: 1,
    refId: "image_0",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 225,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 230,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 250,
            s: [
              100
            ]
          },
          {
            t: 255,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 225,
            s: [
              61.359,
              59.625,
              0
            ],
            to: [
              12,
              -34.167,
              0
            ],
            ti: [
              -22,
              50.167,
              0
            ]
          },
          {
            t: 255,
            s: [
              61.359,
              -28.375,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          3.386,
          3.246,
          0
        ],
        ix: 1
      },
      s: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833,
                0.833,
                0.833
              ],
              y: [
                0.833,
                0.833,
                0.833
              ]
            },
            o: {
              x: [
                0.167,
                0.167,
                0.167
              ],
              y: [
                0.167,
                0.167,
                0.167
              ]
            },
            t: 225,
            s: [
              100,
              100,
              100
            ]
          },
          {
            t: 255,
            s: [
              250,
              250,
              100
            ]
          }
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 225,
    op: 256,
    st: 225,
    bm: 0
  },
  {
    ddd: 0,
    ind: 5,
    ty: 2,
    nm: "Bulat 13",
    parent: 1,
    refId: "image_0",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 210,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 215,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 235,
            s: [
              100
            ]
          },
          {
            t: 240,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 210,
            s: [
              61.359,
              59.625,
              0
            ],
            to: [
              12,
              -34.167,
              0
            ],
            ti: [
              -22,
              50.167,
              0
            ]
          },
          {
            t: 240,
            s: [
              61.359,
              -28.375,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          3.386,
          3.246,
          0
        ],
        ix: 1
      },
      s: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833,
                0.833,
                0.833
              ],
              y: [
                0.833,
                0.833,
                0.833
              ]
            },
            o: {
              x: [
                0.167,
                0.167,
                0.167
              ],
              y: [
                0.167,
                0.167,
                0.167
              ]
            },
            t: 210,
            s: [
              100,
              100,
              100
            ]
          },
          {
            t: 240,
            s: [
              250,
              250,
              100
            ]
          }
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 210,
    op: 241,
    st: 210,
    bm: 0
  },
  {
    ddd: 0,
    ind: 6,
    ty: 2,
    nm: "Bulat 12",
    parent: 1,
    refId: "image_0",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 195,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 200,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 220,
            s: [
              100
            ]
          },
          {
            t: 225,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 195,
            s: [
              61.359,
              59.625,
              0
            ],
            to: [
              12,
              -34.167,
              0
            ],
            ti: [
              -22,
              50.167,
              0
            ]
          },
          {
            t: 225,
            s: [
              61.359,
              -28.375,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          3.386,
          3.246,
          0
        ],
        ix: 1
      },
      s: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833,
                0.833,
                0.833
              ],
              y: [
                0.833,
                0.833,
                0.833
              ]
            },
            o: {
              x: [
                0.167,
                0.167,
                0.167
              ],
              y: [
                0.167,
                0.167,
                0.167
              ]
            },
            t: 195,
            s: [
              100,
              100,
              100
            ]
          },
          {
            t: 225,
            s: [
              250,
              250,
              100
            ]
          }
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 195,
    op: 226,
    st: 195,
    bm: 0
  },
  {
    ddd: 0,
    ind: 7,
    ty: 2,
    nm: "Bulat 11",
    parent: 1,
    refId: "image_0",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 180,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 185,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 205,
            s: [
              100
            ]
          },
          {
            t: 210,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 180,
            s: [
              61.359,
              59.625,
              0
            ],
            to: [
              12,
              -34.167,
              0
            ],
            ti: [
              -22,
              50.167,
              0
            ]
          },
          {
            t: 210,
            s: [
              61.359,
              -28.375,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          3.386,
          3.246,
          0
        ],
        ix: 1
      },
      s: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833,
                0.833,
                0.833
              ],
              y: [
                0.833,
                0.833,
                0.833
              ]
            },
            o: {
              x: [
                0.167,
                0.167,
                0.167
              ],
              y: [
                0.167,
                0.167,
                0.167
              ]
            },
            t: 180,
            s: [
              100,
              100,
              100
            ]
          },
          {
            t: 210,
            s: [
              250,
              250,
              100
            ]
          }
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 180,
    op: 211,
    st: 180,
    bm: 0
  },
  {
    ddd: 0,
    ind: 8,
    ty: 2,
    nm: "Bulat 10",
    parent: 1,
    refId: "image_0",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 165,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 170,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 190,
            s: [
              100
            ]
          },
          {
            t: 195,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 165,
            s: [
              61.359,
              59.625,
              0
            ],
            to: [
              12,
              -34.167,
              0
            ],
            ti: [
              -22,
              50.167,
              0
            ]
          },
          {
            t: 195,
            s: [
              61.359,
              -28.375,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          3.386,
          3.246,
          0
        ],
        ix: 1
      },
      s: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833,
                0.833,
                0.833
              ],
              y: [
                0.833,
                0.833,
                0.833
              ]
            },
            o: {
              x: [
                0.167,
                0.167,
                0.167
              ],
              y: [
                0.167,
                0.167,
                0.167
              ]
            },
            t: 165,
            s: [
              100,
              100,
              100
            ]
          },
          {
            t: 195,
            s: [
              250,
              250,
              100
            ]
          }
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 165,
    op: 196,
    st: 165,
    bm: 0
  },
  {
    ddd: 0,
    ind: 9,
    ty: 2,
    nm: "Bulat 9",
    parent: 1,
    refId: "image_0",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 150,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 155,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 175,
            s: [
              100
            ]
          },
          {
            t: 180,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 150,
            s: [
              61.359,
              59.625,
              0
            ],
            to: [
              12,
              -34.167,
              0
            ],
            ti: [
              -22,
              50.167,
              0
            ]
          },
          {
            t: 180,
            s: [
              61.359,
              -28.375,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          3.386,
          3.246,
          0
        ],
        ix: 1
      },
      s: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833,
                0.833,
                0.833
              ],
              y: [
                0.833,
                0.833,
                0.833
              ]
            },
            o: {
              x: [
                0.167,
                0.167,
                0.167
              ],
              y: [
                0.167,
                0.167,
                0.167
              ]
            },
            t: 150,
            s: [
              100,
              100,
              100
            ]
          },
          {
            t: 180,
            s: [
              250,
              250,
              100
            ]
          }
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 150,
    op: 181,
    st: 150,
    bm: 0
  },
  {
    ddd: 0,
    ind: 10,
    ty: 2,
    nm: "Bulat 8",
    parent: 1,
    refId: "image_0",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 135,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 140,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 160,
            s: [
              100
            ]
          },
          {
            t: 165,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 135,
            s: [
              61.359,
              59.625,
              0
            ],
            to: [
              12,
              -34.167,
              0
            ],
            ti: [
              -22,
              50.167,
              0
            ]
          },
          {
            t: 165,
            s: [
              61.359,
              -28.375,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          3.386,
          3.246,
          0
        ],
        ix: 1
      },
      s: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833,
                0.833,
                0.833
              ],
              y: [
                0.833,
                0.833,
                0.833
              ]
            },
            o: {
              x: [
                0.167,
                0.167,
                0.167
              ],
              y: [
                0.167,
                0.167,
                0.167
              ]
            },
            t: 135,
            s: [
              100,
              100,
              100
            ]
          },
          {
            t: 165,
            s: [
              250,
              250,
              100
            ]
          }
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 135,
    op: 166,
    st: 135,
    bm: 0
  },
  {
    ddd: 0,
    ind: 11,
    ty: 2,
    nm: "Bulat 7",
    parent: 1,
    refId: "image_0",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 120,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 125,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 145,
            s: [
              100
            ]
          },
          {
            t: 150,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 120,
            s: [
              61.359,
              59.625,
              0
            ],
            to: [
              12,
              -34.167,
              0
            ],
            ti: [
              -22,
              50.167,
              0
            ]
          },
          {
            t: 150,
            s: [
              61.359,
              -28.375,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          3.386,
          3.246,
          0
        ],
        ix: 1
      },
      s: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833,
                0.833,
                0.833
              ],
              y: [
                0.833,
                0.833,
                0.833
              ]
            },
            o: {
              x: [
                0.167,
                0.167,
                0.167
              ],
              y: [
                0.167,
                0.167,
                0.167
              ]
            },
            t: 120,
            s: [
              100,
              100,
              100
            ]
          },
          {
            t: 150,
            s: [
              250,
              250,
              100
            ]
          }
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 120,
    op: 151,
    st: 120,
    bm: 0
  },
  {
    ddd: 0,
    ind: 12,
    ty: 2,
    nm: "Bulat 6",
    parent: 1,
    refId: "image_0",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 105,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 110,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 130,
            s: [
              100
            ]
          },
          {
            t: 135,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 105,
            s: [
              61.359,
              59.625,
              0
            ],
            to: [
              12,
              -34.167,
              0
            ],
            ti: [
              -22,
              50.167,
              0
            ]
          },
          {
            t: 135,
            s: [
              61.359,
              -28.375,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          3.386,
          3.246,
          0
        ],
        ix: 1
      },
      s: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833,
                0.833,
                0.833
              ],
              y: [
                0.833,
                0.833,
                0.833
              ]
            },
            o: {
              x: [
                0.167,
                0.167,
                0.167
              ],
              y: [
                0.167,
                0.167,
                0.167
              ]
            },
            t: 105,
            s: [
              100,
              100,
              100
            ]
          },
          {
            t: 135,
            s: [
              250,
              250,
              100
            ]
          }
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 105,
    op: 136,
    st: 105,
    bm: 0
  },
  {
    ddd: 0,
    ind: 13,
    ty: 2,
    nm: "Bulat 5",
    parent: 1,
    refId: "image_0",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 90,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 95,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 115,
            s: [
              100
            ]
          },
          {
            t: 120,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 90,
            s: [
              61.359,
              59.625,
              0
            ],
            to: [
              12,
              -34.167,
              0
            ],
            ti: [
              -22,
              50.167,
              0
            ]
          },
          {
            t: 120,
            s: [
              61.359,
              -28.375,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          3.386,
          3.246,
          0
        ],
        ix: 1
      },
      s: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833,
                0.833,
                0.833
              ],
              y: [
                0.833,
                0.833,
                0.833
              ]
            },
            o: {
              x: [
                0.167,
                0.167,
                0.167
              ],
              y: [
                0.167,
                0.167,
                0.167
              ]
            },
            t: 90,
            s: [
              100,
              100,
              100
            ]
          },
          {
            t: 120,
            s: [
              250,
              250,
              100
            ]
          }
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 90,
    op: 121,
    st: 90,
    bm: 0
  },
  {
    ddd: 0,
    ind: 14,
    ty: 2,
    nm: "Bulat 4",
    parent: 1,
    refId: "image_0",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 75,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 80,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 100,
            s: [
              100
            ]
          },
          {
            t: 105,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 75,
            s: [
              61.359,
              59.625,
              0
            ],
            to: [
              12,
              -34.167,
              0
            ],
            ti: [
              -22,
              50.167,
              0
            ]
          },
          {
            t: 105,
            s: [
              61.359,
              -28.375,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          3.386,
          3.246,
          0
        ],
        ix: 1
      },
      s: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833,
                0.833,
                0.833
              ],
              y: [
                0.833,
                0.833,
                0.833
              ]
            },
            o: {
              x: [
                0.167,
                0.167,
                0.167
              ],
              y: [
                0.167,
                0.167,
                0.167
              ]
            },
            t: 75,
            s: [
              100,
              100,
              100
            ]
          },
          {
            t: 105,
            s: [
              250,
              250,
              100
            ]
          }
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 75,
    op: 106,
    st: 75,
    bm: 0
  },
  {
    ddd: 0,
    ind: 15,
    ty: 2,
    nm: "Bulat 3",
    parent: 1,
    refId: "image_0",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 60,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 65,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 85,
            s: [
              100
            ]
          },
          {
            t: 90,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 60,
            s: [
              61.359,
              59.625,
              0
            ],
            to: [
              12,
              -34.167,
              0
            ],
            ti: [
              -22,
              50.167,
              0
            ]
          },
          {
            t: 90,
            s: [
              61.359,
              -28.375,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          3.386,
          3.246,
          0
        ],
        ix: 1
      },
      s: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833,
                0.833,
                0.833
              ],
              y: [
                0.833,
                0.833,
                0.833
              ]
            },
            o: {
              x: [
                0.167,
                0.167,
                0.167
              ],
              y: [
                0.167,
                0.167,
                0.167
              ]
            },
            t: 60,
            s: [
              100,
              100,
              100
            ]
          },
          {
            t: 90,
            s: [
              250,
              250,
              100
            ]
          }
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 60,
    op: 91,
    st: 60,
    bm: 0
  },
  {
    ddd: 0,
    ind: 16,
    ty: 2,
    nm: "Bulat 2",
    parent: 1,
    refId: "image_0",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 45,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 50,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 70,
            s: [
              100
            ]
          },
          {
            t: 75,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 45,
            s: [
              61.359,
              59.625,
              0
            ],
            to: [
              12,
              -34.167,
              0
            ],
            ti: [
              -22,
              50.167,
              0
            ]
          },
          {
            t: 75,
            s: [
              61.359,
              -28.375,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          3.386,
          3.246,
          0
        ],
        ix: 1
      },
      s: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833,
                0.833,
                0.833
              ],
              y: [
                0.833,
                0.833,
                0.833
              ]
            },
            o: {
              x: [
                0.167,
                0.167,
                0.167
              ],
              y: [
                0.167,
                0.167,
                0.167
              ]
            },
            t: 45,
            s: [
              100,
              100,
              100
            ]
          },
          {
            t: 75,
            s: [
              250,
              250,
              100
            ]
          }
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 45,
    op: 76,
    st: 45,
    bm: 0
  },
  {
    ddd: 0,
    ind: 17,
    ty: 2,
    nm: "Bulat",
    parent: 1,
    refId: "image_0",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 30,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 35,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 55,
            s: [
              100
            ]
          },
          {
            t: 60,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 30,
            s: [
              61.359,
              59.625,
              0
            ],
            to: [
              12,
              -34.167,
              0
            ],
            ti: [
              -22,
              50.167,
              0
            ]
          },
          {
            t: 60,
            s: [
              61.359,
              -28.375,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          3.386,
          3.246,
          0
        ],
        ix: 1
      },
      s: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833,
                0.833,
                0.833
              ],
              y: [
                0.833,
                0.833,
                0.833
              ]
            },
            o: {
              x: [
                0.167,
                0.167,
                0.167
              ],
              y: [
                0.167,
                0.167,
                0.167
              ]
            },
            t: 30,
            s: [
              100,
              100,
              100
            ]
          },
          {
            t: 60,
            s: [
              250,
              250,
              100
            ]
          }
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 30,
    op: 61,
    st: 30,
    bm: 0
  },
  {
    ddd: 0,
    ind: 18,
    ty: 2,
    nm: "Shadow",
    parent: 1,
    refId: "image_1",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          66.876,
          -7.791,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          11.995,
          79.011,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 0,
    op: 5550,
    st: 150,
    bm: 0
  },
  {
    ddd: 0,
    ind: 19,
    ty: 2,
    nm: "Air",
    parent: 1,
    refId: "image_2",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          59.93,
          22.335,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          18.942,
          48.885,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 0,
    op: 5550,
    st: 150,
    bm: 0
  },
  {
    ddd: 0,
    ind: 20,
    ty: 2,
    nm: "Lab mini",
    parent: 1,
    refId: "image_3",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          59.93,
          -59.581,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          27.605,
          44.216,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 0,
    op: 5550,
    st: 150,
    bm: 0
  },
  {
    ddd: 0,
    ind: 21,
    ty: 2,
    nm: "Bulat 30",
    parent: 1,
    refId: "image_4",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 240,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 245,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 265,
            s: [
              100
            ]
          },
          {
            t: 270,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 240,
            s: [
              8.112,
              56.168,
              0
            ],
            to: [
              12.667,
              -21.5,
              0
            ],
            ti: [
              -10.167,
              31.5,
              0
            ]
          },
          {
            t: 270,
            s: [
              3.112,
              -0.832,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          11.754,
          11.754,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 240,
    op: 271,
    st: 240,
    bm: 0
  },
  {
    ddd: 0,
    ind: 22,
    ty: 2,
    nm: "Bulat 28",
    parent: 1,
    refId: "image_4",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 210,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 215,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 235,
            s: [
              100
            ]
          },
          {
            t: 240,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 210,
            s: [
              8.112,
              56.168,
              0
            ],
            to: [
              12.667,
              -21.5,
              0
            ],
            ti: [
              -10.167,
              31.5,
              0
            ]
          },
          {
            t: 240,
            s: [
              3.112,
              -0.832,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          11.754,
          11.754,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 210,
    op: 241,
    st: 210,
    bm: 0
  },
  {
    ddd: 0,
    ind: 23,
    ty: 2,
    nm: "Bulat 26",
    parent: 1,
    refId: "image_4",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 180,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 185,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 205,
            s: [
              100
            ]
          },
          {
            t: 210,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 180,
            s: [
              8.112,
              56.168,
              0
            ],
            to: [
              12.667,
              -21.5,
              0
            ],
            ti: [
              -10.167,
              31.5,
              0
            ]
          },
          {
            t: 210,
            s: [
              3.112,
              -0.832,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          11.754,
          11.754,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 180,
    op: 211,
    st: 180,
    bm: 0
  },
  {
    ddd: 0,
    ind: 24,
    ty: 2,
    nm: "Bulat 24",
    parent: 1,
    refId: "image_4",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 150,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 155,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 175,
            s: [
              100
            ]
          },
          {
            t: 180,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 150,
            s: [
              8.112,
              56.168,
              0
            ],
            to: [
              12.667,
              -21.5,
              0
            ],
            ti: [
              -10.167,
              31.5,
              0
            ]
          },
          {
            t: 180,
            s: [
              3.112,
              -0.832,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          11.754,
          11.754,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 150,
    op: 181,
    st: 150,
    bm: 0
  },
  {
    ddd: 0,
    ind: 25,
    ty: 2,
    nm: "Bulat 22",
    parent: 1,
    refId: "image_4",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 120,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 125,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 145,
            s: [
              100
            ]
          },
          {
            t: 150,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 120,
            s: [
              8.112,
              56.168,
              0
            ],
            to: [
              12.667,
              -21.5,
              0
            ],
            ti: [
              -10.167,
              31.5,
              0
            ]
          },
          {
            t: 150,
            s: [
              3.112,
              -0.832,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          11.754,
          11.754,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 120,
    op: 151,
    st: 120,
    bm: 0
  },
  {
    ddd: 0,
    ind: 26,
    ty: 2,
    nm: "Bulat 20",
    parent: 1,
    refId: "image_4",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 90,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 95,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 115,
            s: [
              100
            ]
          },
          {
            t: 120,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 90,
            s: [
              8.112,
              56.168,
              0
            ],
            to: [
              12.667,
              -21.5,
              0
            ],
            ti: [
              -10.167,
              31.5,
              0
            ]
          },
          {
            t: 120,
            s: [
              3.112,
              -0.832,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          11.754,
          11.754,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 90,
    op: 121,
    st: 90,
    bm: 0
  },
  {
    ddd: 0,
    ind: 27,
    ty: 2,
    nm: "Bulat 18",
    parent: 1,
    refId: "image_4",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 60,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 65,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 85,
            s: [
              100
            ]
          },
          {
            t: 90,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 60,
            s: [
              8.112,
              56.168,
              0
            ],
            to: [
              12.667,
              -21.5,
              0
            ],
            ti: [
              -10.167,
              31.5,
              0
            ]
          },
          {
            t: 90,
            s: [
              3.112,
              -0.832,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          11.754,
          11.754,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 60,
    op: 91,
    st: 60,
    bm: 0
  },
  {
    ddd: 0,
    ind: 28,
    ty: 2,
    nm: "Bulat",
    parent: 1,
    refId: "image_4",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 30,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 35,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 55,
            s: [
              100
            ]
          },
          {
            t: 60,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 30,
            s: [
              8.112,
              56.168,
              0
            ],
            to: [
              12.667,
              -21.5,
              0
            ],
            ti: [
              -10.167,
              31.5,
              0
            ]
          },
          {
            t: 60,
            s: [
              3.112,
              -0.832,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          11.754,
          11.754,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 30,
    op: 61,
    st: 30,
    bm: 0
  },
  {
    ddd: 0,
    ind: 29,
    ty: 2,
    nm: "Bulat 45",
    parent: 1,
    refId: "image_5",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 255,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 260,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 280,
            s: [
              100
            ]
          },
          {
            t: 285,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 255,
            s: [
              -11.304,
              61.394,
              0
            ],
            to: [
              -16.75,
              -16.208,
              0
            ],
            ti: [
              16,
              23.208,
              0
            ]
          },
          {
            t: 285,
            s: [
              -20.304,
              -13.356,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          3.384,
          3.245,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 255,
    op: 286,
    st: 255,
    bm: 0
  },
  {
    ddd: 0,
    ind: 30,
    ty: 2,
    nm: "Bulat 44",
    parent: 1,
    refId: "image_5",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 240,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 245,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 265,
            s: [
              100
            ]
          },
          {
            t: 270,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 240,
            s: [
              -11.304,
              61.394,
              0
            ],
            to: [
              -16.75,
              -16.208,
              0
            ],
            ti: [
              16,
              23.208,
              0
            ]
          },
          {
            t: 270,
            s: [
              -20.304,
              -13.356,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          3.384,
          3.245,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 240,
    op: 271,
    st: 240,
    bm: 0
  },
  {
    ddd: 0,
    ind: 31,
    ty: 2,
    nm: "Bulat 43",
    parent: 1,
    refId: "image_5",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 225,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 230,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 250,
            s: [
              100
            ]
          },
          {
            t: 255,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 225,
            s: [
              -11.304,
              61.394,
              0
            ],
            to: [
              -16.75,
              -16.208,
              0
            ],
            ti: [
              16,
              23.208,
              0
            ]
          },
          {
            t: 255,
            s: [
              -20.304,
              -13.356,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          3.384,
          3.245,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 225,
    op: 256,
    st: 225,
    bm: 0
  },
  {
    ddd: 0,
    ind: 32,
    ty: 2,
    nm: "Bulat 42",
    parent: 1,
    refId: "image_5",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 210,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 215,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 235,
            s: [
              100
            ]
          },
          {
            t: 240,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 210,
            s: [
              -11.304,
              61.394,
              0
            ],
            to: [
              -16.75,
              -16.208,
              0
            ],
            ti: [
              16,
              23.208,
              0
            ]
          },
          {
            t: 240,
            s: [
              -20.304,
              -13.356,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          3.384,
          3.245,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 210,
    op: 241,
    st: 210,
    bm: 0
  },
  {
    ddd: 0,
    ind: 33,
    ty: 2,
    nm: "Bulat 41",
    parent: 1,
    refId: "image_5",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 195,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 200,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 220,
            s: [
              100
            ]
          },
          {
            t: 225,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 195,
            s: [
              -11.304,
              61.394,
              0
            ],
            to: [
              -16.75,
              -16.208,
              0
            ],
            ti: [
              16,
              23.208,
              0
            ]
          },
          {
            t: 225,
            s: [
              -20.304,
              -13.356,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          3.384,
          3.245,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 195,
    op: 226,
    st: 195,
    bm: 0
  },
  {
    ddd: 0,
    ind: 34,
    ty: 2,
    nm: "Bulat 40",
    parent: 1,
    refId: "image_5",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 180,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 185,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 205,
            s: [
              100
            ]
          },
          {
            t: 210,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 180,
            s: [
              -11.304,
              61.394,
              0
            ],
            to: [
              -16.75,
              -16.208,
              0
            ],
            ti: [
              16,
              23.208,
              0
            ]
          },
          {
            t: 210,
            s: [
              -20.304,
              -13.356,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          3.384,
          3.245,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 180,
    op: 211,
    st: 180,
    bm: 0
  },
  {
    ddd: 0,
    ind: 35,
    ty: 2,
    nm: "Bulat 39",
    parent: 1,
    refId: "image_5",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 165,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 170,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 190,
            s: [
              100
            ]
          },
          {
            t: 195,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 165,
            s: [
              -11.304,
              61.394,
              0
            ],
            to: [
              -16.75,
              -16.208,
              0
            ],
            ti: [
              16,
              23.208,
              0
            ]
          },
          {
            t: 195,
            s: [
              -20.304,
              -13.356,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          3.384,
          3.245,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 165,
    op: 196,
    st: 165,
    bm: 0
  },
  {
    ddd: 0,
    ind: 36,
    ty: 2,
    nm: "Bulat 38",
    parent: 1,
    refId: "image_5",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 150,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 155,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 175,
            s: [
              100
            ]
          },
          {
            t: 180,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 150,
            s: [
              -11.304,
              61.394,
              0
            ],
            to: [
              -16.75,
              -16.208,
              0
            ],
            ti: [
              16,
              23.208,
              0
            ]
          },
          {
            t: 180,
            s: [
              -20.304,
              -13.356,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          3.384,
          3.245,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 150,
    op: 181,
    st: 150,
    bm: 0
  },
  {
    ddd: 0,
    ind: 37,
    ty: 2,
    nm: "Bulat 37",
    parent: 1,
    refId: "image_5",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 135,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 140,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 160,
            s: [
              100
            ]
          },
          {
            t: 165,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 135,
            s: [
              -11.304,
              61.394,
              0
            ],
            to: [
              -16.75,
              -16.208,
              0
            ],
            ti: [
              16,
              23.208,
              0
            ]
          },
          {
            t: 165,
            s: [
              -20.304,
              -13.356,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          3.384,
          3.245,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 135,
    op: 166,
    st: 135,
    bm: 0
  },
  {
    ddd: 0,
    ind: 38,
    ty: 2,
    nm: "Bulat 36",
    parent: 1,
    refId: "image_5",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 120,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 125,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 145,
            s: [
              100
            ]
          },
          {
            t: 150,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 120,
            s: [
              -11.304,
              61.394,
              0
            ],
            to: [
              -16.75,
              -16.208,
              0
            ],
            ti: [
              16,
              23.208,
              0
            ]
          },
          {
            t: 150,
            s: [
              -20.304,
              -13.356,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          3.384,
          3.245,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 120,
    op: 151,
    st: 120,
    bm: 0
  },
  {
    ddd: 0,
    ind: 39,
    ty: 2,
    nm: "Bulat 35",
    parent: 1,
    refId: "image_5",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 105,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 110,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 130,
            s: [
              100
            ]
          },
          {
            t: 135,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 105,
            s: [
              -11.304,
              61.394,
              0
            ],
            to: [
              -16.75,
              -16.208,
              0
            ],
            ti: [
              16,
              23.208,
              0
            ]
          },
          {
            t: 135,
            s: [
              -20.304,
              -13.356,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          3.384,
          3.245,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 105,
    op: 136,
    st: 105,
    bm: 0
  },
  {
    ddd: 0,
    ind: 40,
    ty: 2,
    nm: "Bulat 34",
    parent: 1,
    refId: "image_5",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 90,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 95,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 115,
            s: [
              100
            ]
          },
          {
            t: 120,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 90,
            s: [
              -11.304,
              61.394,
              0
            ],
            to: [
              -16.75,
              -16.208,
              0
            ],
            ti: [
              16,
              23.208,
              0
            ]
          },
          {
            t: 120,
            s: [
              -20.304,
              -13.356,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          3.384,
          3.245,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 90,
    op: 121,
    st: 90,
    bm: 0
  },
  {
    ddd: 0,
    ind: 41,
    ty: 2,
    nm: "Bulat 33",
    parent: 1,
    refId: "image_5",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 75,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 80,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 100,
            s: [
              100
            ]
          },
          {
            t: 105,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 75,
            s: [
              -11.304,
              61.394,
              0
            ],
            to: [
              -16.75,
              -16.208,
              0
            ],
            ti: [
              16,
              23.208,
              0
            ]
          },
          {
            t: 105,
            s: [
              -20.304,
              -13.356,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          3.384,
          3.245,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 75,
    op: 106,
    st: 75,
    bm: 0
  },
  {
    ddd: 0,
    ind: 42,
    ty: 2,
    nm: "Bulat 32",
    parent: 1,
    refId: "image_5",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 60,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 65,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 85,
            s: [
              100
            ]
          },
          {
            t: 90,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 60,
            s: [
              -11.304,
              61.394,
              0
            ],
            to: [
              -16.75,
              -16.208,
              0
            ],
            ti: [
              16,
              23.208,
              0
            ]
          },
          {
            t: 90,
            s: [
              -20.304,
              -13.356,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          3.384,
          3.245,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 60,
    op: 91,
    st: 60,
    bm: 0
  },
  {
    ddd: 0,
    ind: 43,
    ty: 2,
    nm: "Bulat 31",
    parent: 1,
    refId: "image_5",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 45,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 50,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 70,
            s: [
              100
            ]
          },
          {
            t: 75,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 45,
            s: [
              -11.304,
              61.394,
              0
            ],
            to: [
              -16.75,
              -16.208,
              0
            ],
            ti: [
              16,
              23.208,
              0
            ]
          },
          {
            t: 75,
            s: [
              -20.304,
              -13.356,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          3.384,
          3.245,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 45,
    op: 76,
    st: 45,
    bm: 0
  },
  {
    ddd: 0,
    ind: 44,
    ty: 2,
    nm: "Bulat",
    parent: 1,
    refId: "image_5",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 30,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 35,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 55,
            s: [
              100
            ]
          },
          {
            t: 60,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 30,
            s: [
              -11.304,
              61.394,
              0
            ],
            to: [
              -16.75,
              -16.208,
              0
            ],
            ti: [
              16,
              23.208,
              0
            ]
          },
          {
            t: 60,
            s: [
              -20.304,
              -13.356,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          3.384,
          3.245,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 30,
    op: 61,
    st: 30,
    bm: 0
  },
  {
    ddd: 0,
    ind: 45,
    ty: 2,
    nm: "Shadow",
    parent: 1,
    refId: "image_6",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          15.462,
          -14.652,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          29.71,
          85.872,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 0,
    op: 5550,
    st: 150,
    bm: 0
  },
  {
    ddd: 0,
    ind: 46,
    ty: 2,
    nm: "Air",
    parent: 1,
    refId: "image_7",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          -21.229,
          33.672,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          74.677,
          37.548,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 0,
    op: 5550,
    st: 150,
    bm: 0
  },
  {
    ddd: 0,
    ind: 47,
    ty: 2,
    nm: "Air",
    parent: 1,
    refId: "image_8",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          -54.591,
          18.174,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          36.849,
          21.555,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 0,
    op: 5550,
    st: 150,
    bm: 0
  },
  {
    ddd: 0,
    ind: 48,
    ty: 2,
    nm: "Lab big",
    parent: 1,
    refId: "image_9",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          -22.829,
          -47.671,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          56.213,
          69.847,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 0,
    op: 5550,
    st: 150,
    bm: 0
  }
], h2 = [], Il = {
  v: n2,
  meta: r2,
  fr: i2,
  ip: o2,
  op: a2,
  w: s2,
  h: l2,
  nm: c2,
  ddd: u2,
  assets: d2,
  layers: f2,
  markers: h2
}, Fl = {
  initial: {
    height: "100vh",
    bottom: 0
  },
  animate: {
    height: 0,
    transition: {
      when: "afterChildren",
      duration: 1.5,
      ease: [0.87, 0, 0.13, 1]
    }
  }
}, Bl = {
  initial: {
    opacity: 1,
    display: "block",
    transition: {
      duration: 0.3
    }
  },
  animate: {
    opacity: 0,
    transition: {
      duration: 0.25,
      when: "afterChildren"
    },
    transitionEnd: {
      display: "none"
    }
  }
}, Nl = {
  initial: {
    opacity: 0
  },
  animate: {
    opacity: 1,
    transition: {
      duration: 0.5,
      ease: [0.87, 0, 0.13, 1]
    }
  }
}, Rl = {
  initial: {
    opacity: 1
  },
  animate: {
    opacity: 1,
    transition: {
      duration: 2
    }
  }
}, p2 = ({ isLoading: a = !1 }) => (ee(() => () => {
  document.body.classList.remove("overflow-hidden");
}, []), a ? /* @__PURE__ */ s(ye.div, {
  "data-testid": "page-transition-animation-with-logo",
  className: "fixed z-50 flex w-full items-center justify-center bg-[#DEEDED]",
  initial: "initial",
  animate: !a && "animate",
  variants: Fl,
  onAnimationStart: () => document.body.classList.add("overflow-hidden"),
  onAnimationComplete: () => {
    document.body.classList.remove("overflow-hidden");
  },
  exit: { display: "none" },
  children: /* @__PURE__ */ s(ye.div, { variants: Bl, children: /* @__PURE__ */ O(ye.div, {
    animate: "animate",
    variants: Rl,
    onAnimationStart: () => document.body.classList.add("overflow-hidden"),
    className: "flex h-[500px] flex-col items-center justify-center",
    children: [
      /* @__PURE__ */ s(ye.div, {
        animate: !a && "animate",
        variants: Nl,
        className: "h-[167px] w-[250px] self-center sm:h-[200px] sm:w-[300px]",
        children: /* @__PURE__ */ s(wa, { animationData: Il })
      }),
      /* @__PURE__ */ s(ka, { disableImg: !0, className: "relative -top-10 text-3xl font-bold sm:text-5xl" })
    ]
  }) })
}) : /* @__PURE__ */ s(ye.div, {
  "data-testid": "page-transition-animation-with-logo",
  className: "fixed z-50 flex w-full items-center justify-center bg-[#DEEDED]",
  initial: "initial",
  animate: "animate",
  variants: Fl,
  onAnimationStart: () => document.body.classList.add("overflow-hidden"),
  onAnimationComplete: () => {
    document.body.classList.remove("overflow-hidden");
  },
  exit: { display: "none" },
  children: /* @__PURE__ */ s(ye.div, { variants: Bl, children: /* @__PURE__ */ O(ye.div, {
    variants: Rl,
    onAnimationStart: () => document.body.classList.add("overflow-hidden"),
    className: "flex h-[500px] flex-col items-center justify-center",
    children: [
      /* @__PURE__ */ s(ye.div, {
        variants: Nl,
        className: "h-[167px] w-[250px] self-center sm:h-[200px] sm:w-[300px]",
        children: /* @__PURE__ */ s(wa, { animationData: Il })
      }),
      /* @__PURE__ */ s(ka, { disableImg: !0, className: "relative -top-10 text-3xl font-bold sm:text-5xl" })
    ]
  }) })
}));
var zr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Ki = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
Ki.exports;
(function(a, o) {
  (function() {
    var r, l = "4.17.21", u = 200, d = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", m = "Expected a function", p = "Invalid `variable` option passed into `_.template`", g = "__lodash_hash_undefined__", x = 500, k = "__lodash_placeholder__", v = 1, A = 2, C = 4, T = 1, F = 2, E = 1, I = 2, z = 4, R = 8, P = 16, U = 32, q = 64, B = 128, M = 256, V = 512, X = 30, te = "...", ne = 800, $ = 16, j = 1, le = 2, ve = 3, se = 1 / 0, _e = 9007199254740991, at = 17976931348623157e292, ft = 0 / 0, he = 4294967295, Ye = he - 1, Yn = he >>> 1, gr = [
      ["ary", B],
      ["bind", E],
      ["bindKey", I],
      ["curry", R],
      ["curryRight", P],
      ["flip", V],
      ["partial", U],
      ["partialRight", q],
      ["rearg", M]
    ], Me = "[object Arguments]", Wt = "[object Array]", xr = "[object AsyncFunction]", zt = "[object Boolean]", Kt = "[object Date]", $n = "[object DOMException]", qn = "[object Error]", Sn = "[object Function]", yr = "[object GeneratorFunction]", ht = "[object Map]", Ht = "[object Number]", Vr = "[object Null]", bt = "[object Object]", Cn = "[object Promise]", Xi = "[object Proxy]", Ft = "[object RegExp]", tt = "[object Set]", En = "[object String]", Tn = "[object Symbol]", Yr = "[object Undefined]", Qt = "[object WeakMap]", Ji = "[object WeakSet]", In = "[object ArrayBuffer]", cn = "[object DataView]", vr = "[object Float32Array]", br = "[object Float64Array]", wr = "[object Int8Array]", kr = "[object Int16Array]", Fn = "[object Int32Array]", Kn = "[object Uint8Array]", Ut = "[object Uint8ClampedArray]", Bn = "[object Uint16Array]", Nn = "[object Uint32Array]", $r = /\b__p \+= '';/g, ji = /\b(__p \+=) '' \+/g, qr = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Kr = /&(?:amp|lt|gt|quot|#39);/g, _r = /[&<>"']/g, Qr = RegExp(Kr.source), Zi = RegExp(_r.source), eo = /<%-([\s\S]+?)%>/g, Xr = /<%([\s\S]+?)%>/g, Jr = /<%=([\s\S]+?)%>/g, to = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, no = /^\w*$/, ro = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, b = /[\\^$.*+?()[\]{}|]/g, G = RegExp(b.source), Q = /^\s+/, ae = /\s/, Ce = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Ee = /\{\n\/\* \[wrapped with (.+)\] \*/, ke = /,? & /, ge = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, qe = /[()=,{}\[\]\/\s]/, Le = /\\(\\)?/g, Pe = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, wt = /\w*$/, un = /^[-+]0x[0-9a-f]+$/i, jr = /^0b[01]+$/i, Bt = /^\[object .+?Constructor\]$/, Rc = /^0o[0-7]+$/i, Mc = /^(?:0|[1-9]\d*)$/, Lc = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Zr = /($^)/, Oc = /['\n\r\u2028\u2029\\]/g, ei = "\\ud800-\\udfff", Dc = "\\u0300-\\u036f", Pc = "\\ufe20-\\ufe2f", Wc = "\\u20d0-\\u20ff", Da = Dc + Pc + Wc, Pa = "\\u2700-\\u27bf", Wa = "a-z\\xdf-\\xf6\\xf8-\\xff", zc = "\\xac\\xb1\\xd7\\xf7", Hc = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Uc = "\\u2000-\\u206f", Gc = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", za = "A-Z\\xc0-\\xd6\\xd8-\\xde", Ha = "\\ufe0e\\ufe0f", Ua = zc + Hc + Uc + Gc, io = "['’]", Vc = "[" + ei + "]", Ga = "[" + Ua + "]", ti = "[" + Da + "]", Va = "\\d+", Yc = "[" + Pa + "]", Ya = "[" + Wa + "]", $a = "[^" + ei + Ua + Va + Pa + Wa + za + "]", oo = "\\ud83c[\\udffb-\\udfff]", $c = "(?:" + ti + "|" + oo + ")", qa = "[^" + ei + "]", ao = "(?:\\ud83c[\\udde6-\\uddff]){2}", so = "[\\ud800-\\udbff][\\udc00-\\udfff]", Qn = "[" + za + "]", Ka = "\\u200d", Qa = "(?:" + Ya + "|" + $a + ")", qc = "(?:" + Qn + "|" + $a + ")", Xa = "(?:" + io + "(?:d|ll|m|re|s|t|ve))?", Ja = "(?:" + io + "(?:D|LL|M|RE|S|T|VE))?", ja = $c + "?", Za = "[" + Ha + "]?", Kc = "(?:" + Ka + "(?:" + [qa, ao, so].join("|") + ")" + Za + ja + ")*", Qc = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Xc = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", es = Za + ja + Kc, Jc = "(?:" + [Yc, ao, so].join("|") + ")" + es, jc = "(?:" + [qa + ti + "?", ti, ao, so, Vc].join("|") + ")", Zc = RegExp(io, "g"), eu = RegExp(ti, "g"), lo = RegExp(oo + "(?=" + oo + ")|" + jc + es, "g"), tu = RegExp([
      Qn + "?" + Ya + "+" + Xa + "(?=" + [Ga, Qn, "$"].join("|") + ")",
      qc + "+" + Ja + "(?=" + [Ga, Qn + Qa, "$"].join("|") + ")",
      Qn + "?" + Qa + "+" + Xa,
      Qn + "+" + Ja,
      Xc,
      Qc,
      Va,
      Jc
    ].join("|"), "g"), nu = RegExp("[" + Ka + ei + Da + Ha + "]"), ru = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, iu = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], ou = -1, Be = {};
    Be[vr] = Be[br] = Be[wr] = Be[kr] = Be[Fn] = Be[Kn] = Be[Ut] = Be[Bn] = Be[Nn] = !0, Be[Me] = Be[Wt] = Be[In] = Be[zt] = Be[cn] = Be[Kt] = Be[qn] = Be[Sn] = Be[ht] = Be[Ht] = Be[bt] = Be[Ft] = Be[tt] = Be[En] = Be[Qt] = !1;
    var Fe = {};
    Fe[Me] = Fe[Wt] = Fe[In] = Fe[cn] = Fe[zt] = Fe[Kt] = Fe[vr] = Fe[br] = Fe[wr] = Fe[kr] = Fe[Fn] = Fe[ht] = Fe[Ht] = Fe[bt] = Fe[Ft] = Fe[tt] = Fe[En] = Fe[Tn] = Fe[Kn] = Fe[Ut] = Fe[Bn] = Fe[Nn] = !0, Fe[qn] = Fe[Sn] = Fe[Qt] = !1;
    var au = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, su = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, lu = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, cu = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, uu = parseFloat, du = parseInt, ts = typeof zr == "object" && zr && zr.Object === Object && zr, fu = typeof self == "object" && self && self.Object === Object && self, Ke = ts || fu || Function("return this")(), co = o && !o.nodeType && o, Rn = co && !0 && a && !a.nodeType && a, ns = Rn && Rn.exports === co, uo = ns && ts.process, kt = function() {
      try {
        var _ = Rn && Rn.require && Rn.require("util").types;
        return _ || uo && uo.binding && uo.binding("util");
      } catch {
      }
    }(), rs = kt && kt.isArrayBuffer, is = kt && kt.isDate, os = kt && kt.isMap, as = kt && kt.isRegExp, ss = kt && kt.isSet, ls = kt && kt.isTypedArray;
    function pt(_, L, N) {
      switch (N.length) {
        case 0:
          return _.call(L);
        case 1:
          return _.call(L, N[0]);
        case 2:
          return _.call(L, N[0], N[1]);
        case 3:
          return _.call(L, N[0], N[1], N[2]);
      }
      return _.apply(L, N);
    }
    function hu(_, L, N, J) {
      for (var ce = -1, Ae = _ == null ? 0 : _.length; ++ce < Ae; ) {
        var Ge = _[ce];
        L(J, Ge, N(Ge), _);
      }
      return J;
    }
    function _t(_, L) {
      for (var N = -1, J = _ == null ? 0 : _.length; ++N < J && L(_[N], N, _) !== !1; )
        ;
      return _;
    }
    function pu(_, L) {
      for (var N = _ == null ? 0 : _.length; N-- && L(_[N], N, _) !== !1; )
        ;
      return _;
    }
    function cs(_, L) {
      for (var N = -1, J = _ == null ? 0 : _.length; ++N < J; )
        if (!L(_[N], N, _))
          return !1;
      return !0;
    }
    function dn(_, L) {
      for (var N = -1, J = _ == null ? 0 : _.length, ce = 0, Ae = []; ++N < J; ) {
        var Ge = _[N];
        L(Ge, N, _) && (Ae[ce++] = Ge);
      }
      return Ae;
    }
    function ni(_, L) {
      var N = _ == null ? 0 : _.length;
      return !!N && Xn(_, L, 0) > -1;
    }
    function fo(_, L, N) {
      for (var J = -1, ce = _ == null ? 0 : _.length; ++J < ce; )
        if (N(L, _[J]))
          return !0;
      return !1;
    }
    function Ne(_, L) {
      for (var N = -1, J = _ == null ? 0 : _.length, ce = Array(J); ++N < J; )
        ce[N] = L(_[N], N, _);
      return ce;
    }
    function fn(_, L) {
      for (var N = -1, J = L.length, ce = _.length; ++N < J; )
        _[ce + N] = L[N];
      return _;
    }
    function ho(_, L, N, J) {
      var ce = -1, Ae = _ == null ? 0 : _.length;
      for (J && Ae && (N = _[++ce]); ++ce < Ae; )
        N = L(N, _[ce], ce, _);
      return N;
    }
    function mu(_, L, N, J) {
      var ce = _ == null ? 0 : _.length;
      for (J && ce && (N = _[--ce]); ce--; )
        N = L(N, _[ce], ce, _);
      return N;
    }
    function po(_, L) {
      for (var N = -1, J = _ == null ? 0 : _.length; ++N < J; )
        if (L(_[N], N, _))
          return !0;
      return !1;
    }
    var gu = mo("length");
    function xu(_) {
      return _.split("");
    }
    function yu(_) {
      return _.match(ge) || [];
    }
    function us(_, L, N) {
      var J;
      return N(_, function(ce, Ae, Ge) {
        if (L(ce, Ae, Ge))
          return J = Ae, !1;
      }), J;
    }
    function ri(_, L, N, J) {
      for (var ce = _.length, Ae = N + (J ? 1 : -1); J ? Ae-- : ++Ae < ce; )
        if (L(_[Ae], Ae, _))
          return Ae;
      return -1;
    }
    function Xn(_, L, N) {
      return L === L ? Fu(_, L, N) : ri(_, ds, N);
    }
    function vu(_, L, N, J) {
      for (var ce = N - 1, Ae = _.length; ++ce < Ae; )
        if (J(_[ce], L))
          return ce;
      return -1;
    }
    function ds(_) {
      return _ !== _;
    }
    function fs(_, L) {
      var N = _ == null ? 0 : _.length;
      return N ? xo(_, L) / N : ft;
    }
    function mo(_) {
      return function(L) {
        return L == null ? r : L[_];
      };
    }
    function go(_) {
      return function(L) {
        return _ == null ? r : _[L];
      };
    }
    function hs(_, L, N, J, ce) {
      return ce(_, function(Ae, Ge, Ie) {
        N = J ? (J = !1, Ae) : L(N, Ae, Ge, Ie);
      }), N;
    }
    function bu(_, L) {
      var N = _.length;
      for (_.sort(L); N--; )
        _[N] = _[N].value;
      return _;
    }
    function xo(_, L) {
      for (var N, J = -1, ce = _.length; ++J < ce; ) {
        var Ae = L(_[J]);
        Ae !== r && (N = N === r ? Ae : N + Ae);
      }
      return N;
    }
    function yo(_, L) {
      for (var N = -1, J = Array(_); ++N < _; )
        J[N] = L(N);
      return J;
    }
    function wu(_, L) {
      return Ne(L, function(N) {
        return [N, _[N]];
      });
    }
    function ps(_) {
      return _ && _.slice(0, ys(_) + 1).replace(Q, "");
    }
    function mt(_) {
      return function(L) {
        return _(L);
      };
    }
    function vo(_, L) {
      return Ne(L, function(N) {
        return _[N];
      });
    }
    function Ar(_, L) {
      return _.has(L);
    }
    function ms(_, L) {
      for (var N = -1, J = _.length; ++N < J && Xn(L, _[N], 0) > -1; )
        ;
      return N;
    }
    function gs(_, L) {
      for (var N = _.length; N-- && Xn(L, _[N], 0) > -1; )
        ;
      return N;
    }
    function ku(_, L) {
      for (var N = _.length, J = 0; N--; )
        _[N] === L && ++J;
      return J;
    }
    var _u = go(au), Au = go(su);
    function Su(_) {
      return "\\" + cu[_];
    }
    function Cu(_, L) {
      return _ == null ? r : _[L];
    }
    function Jn(_) {
      return nu.test(_);
    }
    function Eu(_) {
      return ru.test(_);
    }
    function Tu(_) {
      for (var L, N = []; !(L = _.next()).done; )
        N.push(L.value);
      return N;
    }
    function bo(_) {
      var L = -1, N = Array(_.size);
      return _.forEach(function(J, ce) {
        N[++L] = [ce, J];
      }), N;
    }
    function xs(_, L) {
      return function(N) {
        return _(L(N));
      };
    }
    function hn(_, L) {
      for (var N = -1, J = _.length, ce = 0, Ae = []; ++N < J; ) {
        var Ge = _[N];
        (Ge === L || Ge === k) && (_[N] = k, Ae[ce++] = N);
      }
      return Ae;
    }
    function ii(_) {
      var L = -1, N = Array(_.size);
      return _.forEach(function(J) {
        N[++L] = J;
      }), N;
    }
    function Iu(_) {
      var L = -1, N = Array(_.size);
      return _.forEach(function(J) {
        N[++L] = [J, J];
      }), N;
    }
    function Fu(_, L, N) {
      for (var J = N - 1, ce = _.length; ++J < ce; )
        if (_[J] === L)
          return J;
      return -1;
    }
    function Bu(_, L, N) {
      for (var J = N + 1; J--; )
        if (_[J] === L)
          return J;
      return J;
    }
    function jn(_) {
      return Jn(_) ? Ru(_) : gu(_);
    }
    function Nt(_) {
      return Jn(_) ? Mu(_) : xu(_);
    }
    function ys(_) {
      for (var L = _.length; L-- && ae.test(_.charAt(L)); )
        ;
      return L;
    }
    var Nu = go(lu);
    function Ru(_) {
      for (var L = lo.lastIndex = 0; lo.test(_); )
        ++L;
      return L;
    }
    function Mu(_) {
      return _.match(lo) || [];
    }
    function Lu(_) {
      return _.match(tu) || [];
    }
    var Ou = function _(L) {
      L = L == null ? Ke : Zn.defaults(Ke.Object(), L, Zn.pick(Ke, iu));
      var N = L.Array, J = L.Date, ce = L.Error, Ae = L.Function, Ge = L.Math, Ie = L.Object, wo = L.RegExp, Du = L.String, At = L.TypeError, oi = N.prototype, Pu = Ae.prototype, er = Ie.prototype, ai = L["__core-js_shared__"], si = Pu.toString, Te = er.hasOwnProperty, Wu = 0, vs = function() {
        var e = /[^.]+$/.exec(ai && ai.keys && ai.keys.IE_PROTO || "");
        return e ? "Symbol(src)_1." + e : "";
      }(), li = er.toString, zu = si.call(Ie), Hu = Ke._, Uu = wo(
        "^" + si.call(Te).replace(b, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), ci = ns ? L.Buffer : r, pn = L.Symbol, ui = L.Uint8Array, bs = ci ? ci.allocUnsafe : r, di = xs(Ie.getPrototypeOf, Ie), ws = Ie.create, ks = er.propertyIsEnumerable, fi = oi.splice, _s = pn ? pn.isConcatSpreadable : r, Sr = pn ? pn.iterator : r, Mn = pn ? pn.toStringTag : r, hi = function() {
        try {
          var e = Wn(Ie, "defineProperty");
          return e({}, "", {}), e;
        } catch {
        }
      }(), Gu = L.clearTimeout !== Ke.clearTimeout && L.clearTimeout, Vu = J && J.now !== Ke.Date.now && J.now, Yu = L.setTimeout !== Ke.setTimeout && L.setTimeout, pi = Ge.ceil, mi = Ge.floor, ko = Ie.getOwnPropertySymbols, $u = ci ? ci.isBuffer : r, As = L.isFinite, qu = oi.join, Ku = xs(Ie.keys, Ie), Ve = Ge.max, Je = Ge.min, Qu = J.now, Xu = L.parseInt, Ss = Ge.random, Ju = oi.reverse, _o = Wn(L, "DataView"), Cr = Wn(L, "Map"), Ao = Wn(L, "Promise"), tr = Wn(L, "Set"), Er = Wn(L, "WeakMap"), Tr = Wn(Ie, "create"), gi = Er && new Er(), nr = {}, ju = zn(_o), Zu = zn(Cr), ed = zn(Ao), td = zn(tr), nd = zn(Er), xi = pn ? pn.prototype : r, Ir = xi ? xi.valueOf : r, Cs = xi ? xi.toString : r;
      function f(e) {
        if (We(e) && !ue(e) && !(e instanceof be)) {
          if (e instanceof St)
            return e;
          if (Te.call(e, "__wrapped__"))
            return E0(e);
        }
        return new St(e);
      }
      var rr = function() {
        function e() {
        }
        return function(t) {
          if (!Oe(t))
            return {};
          if (ws)
            return ws(t);
          e.prototype = t;
          var n = new e();
          return e.prototype = r, n;
        };
      }();
      function yi() {
      }
      function St(e, t) {
        this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = r;
      }
      f.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: eo,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: Xr,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: Jr,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: f
        }
      }, f.prototype = yi.prototype, f.prototype.constructor = f, St.prototype = rr(yi.prototype), St.prototype.constructor = St;
      function be(e) {
        this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = he, this.__views__ = [];
      }
      function rd() {
        var e = new be(this.__wrapped__);
        return e.__actions__ = st(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = st(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = st(this.__views__), e;
      }
      function id() {
        if (this.__filtered__) {
          var e = new be(this);
          e.__dir__ = -1, e.__filtered__ = !0;
        } else
          e = this.clone(), e.__dir__ *= -1;
        return e;
      }
      function od() {
        var e = this.__wrapped__.value(), t = this.__dir__, n = ue(e), i = t < 0, c = n ? e.length : 0, h = yf(0, c, this.__views__), y = h.start, w = h.end, S = w - y, D = i ? w : y - 1, W = this.__iteratees__, H = W.length, K = 0, Z = Je(S, this.__takeCount__);
        if (!n || !i && c == S && Z == S)
          return Xs(e, this.__actions__);
        var ie = [];
        e:
          for (; S-- && K < Z; ) {
            D += t;
            for (var fe = -1, oe = e[D]; ++fe < H; ) {
              var xe = W[fe], we = xe.iteratee, yt = xe.type, it = we(oe);
              if (yt == le)
                oe = it;
              else if (!it) {
                if (yt == j)
                  continue e;
                break e;
              }
            }
            ie[K++] = oe;
          }
        return ie;
      }
      be.prototype = rr(yi.prototype), be.prototype.constructor = be;
      function Ln(e) {
        var t = -1, n = e == null ? 0 : e.length;
        for (this.clear(); ++t < n; ) {
          var i = e[t];
          this.set(i[0], i[1]);
        }
      }
      function ad() {
        this.__data__ = Tr ? Tr(null) : {}, this.size = 0;
      }
      function sd(e) {
        var t = this.has(e) && delete this.__data__[e];
        return this.size -= t ? 1 : 0, t;
      }
      function ld(e) {
        var t = this.__data__;
        if (Tr) {
          var n = t[e];
          return n === g ? r : n;
        }
        return Te.call(t, e) ? t[e] : r;
      }
      function cd(e) {
        var t = this.__data__;
        return Tr ? t[e] !== r : Te.call(t, e);
      }
      function ud(e, t) {
        var n = this.__data__;
        return this.size += this.has(e) ? 0 : 1, n[e] = Tr && t === r ? g : t, this;
      }
      Ln.prototype.clear = ad, Ln.prototype.delete = sd, Ln.prototype.get = ld, Ln.prototype.has = cd, Ln.prototype.set = ud;
      function Xt(e) {
        var t = -1, n = e == null ? 0 : e.length;
        for (this.clear(); ++t < n; ) {
          var i = e[t];
          this.set(i[0], i[1]);
        }
      }
      function dd() {
        this.__data__ = [], this.size = 0;
      }
      function fd(e) {
        var t = this.__data__, n = vi(t, e);
        if (n < 0)
          return !1;
        var i = t.length - 1;
        return n == i ? t.pop() : fi.call(t, n, 1), --this.size, !0;
      }
      function hd(e) {
        var t = this.__data__, n = vi(t, e);
        return n < 0 ? r : t[n][1];
      }
      function pd(e) {
        return vi(this.__data__, e) > -1;
      }
      function md(e, t) {
        var n = this.__data__, i = vi(n, e);
        return i < 0 ? (++this.size, n.push([e, t])) : n[i][1] = t, this;
      }
      Xt.prototype.clear = dd, Xt.prototype.delete = fd, Xt.prototype.get = hd, Xt.prototype.has = pd, Xt.prototype.set = md;
      function Jt(e) {
        var t = -1, n = e == null ? 0 : e.length;
        for (this.clear(); ++t < n; ) {
          var i = e[t];
          this.set(i[0], i[1]);
        }
      }
      function gd() {
        this.size = 0, this.__data__ = {
          hash: new Ln(),
          map: new (Cr || Xt)(),
          string: new Ln()
        };
      }
      function xd(e) {
        var t = Bi(this, e).delete(e);
        return this.size -= t ? 1 : 0, t;
      }
      function yd(e) {
        return Bi(this, e).get(e);
      }
      function vd(e) {
        return Bi(this, e).has(e);
      }
      function bd(e, t) {
        var n = Bi(this, e), i = n.size;
        return n.set(e, t), this.size += n.size == i ? 0 : 1, this;
      }
      Jt.prototype.clear = gd, Jt.prototype.delete = xd, Jt.prototype.get = yd, Jt.prototype.has = vd, Jt.prototype.set = bd;
      function On(e) {
        var t = -1, n = e == null ? 0 : e.length;
        for (this.__data__ = new Jt(); ++t < n; )
          this.add(e[t]);
      }
      function wd(e) {
        return this.__data__.set(e, g), this;
      }
      function kd(e) {
        return this.__data__.has(e);
      }
      On.prototype.add = On.prototype.push = wd, On.prototype.has = kd;
      function Rt(e) {
        var t = this.__data__ = new Xt(e);
        this.size = t.size;
      }
      function _d() {
        this.__data__ = new Xt(), this.size = 0;
      }
      function Ad(e) {
        var t = this.__data__, n = t.delete(e);
        return this.size = t.size, n;
      }
      function Sd(e) {
        return this.__data__.get(e);
      }
      function Cd(e) {
        return this.__data__.has(e);
      }
      function Ed(e, t) {
        var n = this.__data__;
        if (n instanceof Xt) {
          var i = n.__data__;
          if (!Cr || i.length < u - 1)
            return i.push([e, t]), this.size = ++n.size, this;
          n = this.__data__ = new Jt(i);
        }
        return n.set(e, t), this.size = n.size, this;
      }
      Rt.prototype.clear = _d, Rt.prototype.delete = Ad, Rt.prototype.get = Sd, Rt.prototype.has = Cd, Rt.prototype.set = Ed;
      function Es(e, t) {
        var n = ue(e), i = !n && Hn(e), c = !n && !i && vn(e), h = !n && !i && !c && sr(e), y = n || i || c || h, w = y ? yo(e.length, Du) : [], S = w.length;
        for (var D in e)
          (t || Te.call(e, D)) && !(y && // Safari 9 has enumerable `arguments.length` in strict mode.
          (D == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          c && (D == "offset" || D == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          h && (D == "buffer" || D == "byteLength" || D == "byteOffset") || // Skip index properties.
          tn(D, S))) && w.push(D);
        return w;
      }
      function Ts(e) {
        var t = e.length;
        return t ? e[Lo(0, t - 1)] : r;
      }
      function Td(e, t) {
        return Ni(st(e), Dn(t, 0, e.length));
      }
      function Id(e) {
        return Ni(st(e));
      }
      function So(e, t, n) {
        (n !== r && !Mt(e[t], n) || n === r && !(t in e)) && jt(e, t, n);
      }
      function Fr(e, t, n) {
        var i = e[t];
        (!(Te.call(e, t) && Mt(i, n)) || n === r && !(t in e)) && jt(e, t, n);
      }
      function vi(e, t) {
        for (var n = e.length; n--; )
          if (Mt(e[n][0], t))
            return n;
        return -1;
      }
      function Fd(e, t, n, i) {
        return mn(e, function(c, h, y) {
          t(i, c, n(c), y);
        }), i;
      }
      function Is(e, t) {
        return e && Vt(t, $e(t), e);
      }
      function Bd(e, t) {
        return e && Vt(t, ct(t), e);
      }
      function jt(e, t, n) {
        t == "__proto__" && hi ? hi(e, t, {
          configurable: !0,
          enumerable: !0,
          value: n,
          writable: !0
        }) : e[t] = n;
      }
      function Co(e, t) {
        for (var n = -1, i = t.length, c = N(i), h = e == null; ++n < i; )
          c[n] = h ? r : aa(e, t[n]);
        return c;
      }
      function Dn(e, t, n) {
        return e === e && (n !== r && (e = e <= n ? e : n), t !== r && (e = e >= t ? e : t)), e;
      }
      function Ct(e, t, n, i, c, h) {
        var y, w = t & v, S = t & A, D = t & C;
        if (n && (y = c ? n(e, i, c, h) : n(e)), y !== r)
          return y;
        if (!Oe(e))
          return e;
        var W = ue(e);
        if (W) {
          if (y = bf(e), !w)
            return st(e, y);
        } else {
          var H = je(e), K = H == Sn || H == yr;
          if (vn(e))
            return Zs(e, w);
          if (H == bt || H == Me || K && !c) {
            if (y = S || K ? {} : y0(e), !w)
              return S ? cf(e, Bd(y, e)) : lf(e, Is(y, e));
          } else {
            if (!Fe[H])
              return c ? e : {};
            y = wf(e, H, w);
          }
        }
        h || (h = new Rt());
        var Z = h.get(e);
        if (Z)
          return Z;
        h.set(e, y), q0(e) ? e.forEach(function(oe) {
          y.add(Ct(oe, t, n, oe, e, h));
        }) : Y0(e) && e.forEach(function(oe, xe) {
          y.set(xe, Ct(oe, t, n, xe, e, h));
        });
        var ie = D ? S ? $o : Yo : S ? ct : $e, fe = W ? r : ie(e);
        return _t(fe || e, function(oe, xe) {
          fe && (xe = oe, oe = e[xe]), Fr(y, xe, Ct(oe, t, n, xe, e, h));
        }), y;
      }
      function Nd(e) {
        var t = $e(e);
        return function(n) {
          return Fs(n, e, t);
        };
      }
      function Fs(e, t, n) {
        var i = n.length;
        if (e == null)
          return !i;
        for (e = Ie(e); i--; ) {
          var c = n[i], h = t[c], y = e[c];
          if (y === r && !(c in e) || !h(y))
            return !1;
        }
        return !0;
      }
      function Bs(e, t, n) {
        if (typeof e != "function")
          throw new At(m);
        return Dr(function() {
          e.apply(r, n);
        }, t);
      }
      function Br(e, t, n, i) {
        var c = -1, h = ni, y = !0, w = e.length, S = [], D = t.length;
        if (!w)
          return S;
        n && (t = Ne(t, mt(n))), i ? (h = fo, y = !1) : t.length >= u && (h = Ar, y = !1, t = new On(t));
        e:
          for (; ++c < w; ) {
            var W = e[c], H = n == null ? W : n(W);
            if (W = i || W !== 0 ? W : 0, y && H === H) {
              for (var K = D; K--; )
                if (t[K] === H)
                  continue e;
              S.push(W);
            } else
              h(t, H, i) || S.push(W);
          }
        return S;
      }
      var mn = i0(Gt), Ns = i0(To, !0);
      function Rd(e, t) {
        var n = !0;
        return mn(e, function(i, c, h) {
          return n = !!t(i, c, h), n;
        }), n;
      }
      function bi(e, t, n) {
        for (var i = -1, c = e.length; ++i < c; ) {
          var h = e[i], y = t(h);
          if (y != null && (w === r ? y === y && !xt(y) : n(y, w)))
            var w = y, S = h;
        }
        return S;
      }
      function Md(e, t, n, i) {
        var c = e.length;
        for (n = de(n), n < 0 && (n = -n > c ? 0 : c + n), i = i === r || i > c ? c : de(i), i < 0 && (i += c), i = n > i ? 0 : Q0(i); n < i; )
          e[n++] = t;
        return e;
      }
      function Rs(e, t) {
        var n = [];
        return mn(e, function(i, c, h) {
          t(i, c, h) && n.push(i);
        }), n;
      }
      function Qe(e, t, n, i, c) {
        var h = -1, y = e.length;
        for (n || (n = _f), c || (c = []); ++h < y; ) {
          var w = e[h];
          t > 0 && n(w) ? t > 1 ? Qe(w, t - 1, n, i, c) : fn(c, w) : i || (c[c.length] = w);
        }
        return c;
      }
      var Eo = o0(), Ms = o0(!0);
      function Gt(e, t) {
        return e && Eo(e, t, $e);
      }
      function To(e, t) {
        return e && Ms(e, t, $e);
      }
      function wi(e, t) {
        return dn(t, function(n) {
          return nn(e[n]);
        });
      }
      function Pn(e, t) {
        t = xn(t, e);
        for (var n = 0, i = t.length; e != null && n < i; )
          e = e[Yt(t[n++])];
        return n && n == i ? e : r;
      }
      function Ls(e, t, n) {
        var i = t(e);
        return ue(e) ? i : fn(i, n(e));
      }
      function nt(e) {
        return e == null ? e === r ? Yr : Vr : Mn && Mn in Ie(e) ? xf(e) : Ff(e);
      }
      function Io(e, t) {
        return e > t;
      }
      function Ld(e, t) {
        return e != null && Te.call(e, t);
      }
      function Od(e, t) {
        return e != null && t in Ie(e);
      }
      function Dd(e, t, n) {
        return e >= Je(t, n) && e < Ve(t, n);
      }
      function Fo(e, t, n) {
        for (var i = n ? fo : ni, c = e[0].length, h = e.length, y = h, w = N(h), S = 1 / 0, D = []; y--; ) {
          var W = e[y];
          y && t && (W = Ne(W, mt(t))), S = Je(W.length, S), w[y] = !n && (t || c >= 120 && W.length >= 120) ? new On(y && W) : r;
        }
        W = e[0];
        var H = -1, K = w[0];
        e:
          for (; ++H < c && D.length < S; ) {
            var Z = W[H], ie = t ? t(Z) : Z;
            if (Z = n || Z !== 0 ? Z : 0, !(K ? Ar(K, ie) : i(D, ie, n))) {
              for (y = h; --y; ) {
                var fe = w[y];
                if (!(fe ? Ar(fe, ie) : i(e[y], ie, n)))
                  continue e;
              }
              K && K.push(ie), D.push(Z);
            }
          }
        return D;
      }
      function Pd(e, t, n, i) {
        return Gt(e, function(c, h, y) {
          t(i, n(c), h, y);
        }), i;
      }
      function Nr(e, t, n) {
        t = xn(t, e), e = k0(e, t);
        var i = e == null ? e : e[Yt(Tt(t))];
        return i == null ? r : pt(i, e, n);
      }
      function Os(e) {
        return We(e) && nt(e) == Me;
      }
      function Wd(e) {
        return We(e) && nt(e) == In;
      }
      function zd(e) {
        return We(e) && nt(e) == Kt;
      }
      function Rr(e, t, n, i, c) {
        return e === t ? !0 : e == null || t == null || !We(e) && !We(t) ? e !== e && t !== t : Hd(e, t, n, i, Rr, c);
      }
      function Hd(e, t, n, i, c, h) {
        var y = ue(e), w = ue(t), S = y ? Wt : je(e), D = w ? Wt : je(t);
        S = S == Me ? bt : S, D = D == Me ? bt : D;
        var W = S == bt, H = D == bt, K = S == D;
        if (K && vn(e)) {
          if (!vn(t))
            return !1;
          y = !0, W = !1;
        }
        if (K && !W)
          return h || (h = new Rt()), y || sr(e) ? m0(e, t, n, i, c, h) : mf(e, t, S, n, i, c, h);
        if (!(n & T)) {
          var Z = W && Te.call(e, "__wrapped__"), ie = H && Te.call(t, "__wrapped__");
          if (Z || ie) {
            var fe = Z ? e.value() : e, oe = ie ? t.value() : t;
            return h || (h = new Rt()), c(fe, oe, n, i, h);
          }
        }
        return K ? (h || (h = new Rt()), gf(e, t, n, i, c, h)) : !1;
      }
      function Ud(e) {
        return We(e) && je(e) == ht;
      }
      function Bo(e, t, n, i) {
        var c = n.length, h = c, y = !i;
        if (e == null)
          return !h;
        for (e = Ie(e); c--; ) {
          var w = n[c];
          if (y && w[2] ? w[1] !== e[w[0]] : !(w[0] in e))
            return !1;
        }
        for (; ++c < h; ) {
          w = n[c];
          var S = w[0], D = e[S], W = w[1];
          if (y && w[2]) {
            if (D === r && !(S in e))
              return !1;
          } else {
            var H = new Rt();
            if (i)
              var K = i(D, W, S, e, t, H);
            if (!(K === r ? Rr(W, D, T | F, i, H) : K))
              return !1;
          }
        }
        return !0;
      }
      function Ds(e) {
        if (!Oe(e) || Sf(e))
          return !1;
        var t = nn(e) ? Uu : Bt;
        return t.test(zn(e));
      }
      function Gd(e) {
        return We(e) && nt(e) == Ft;
      }
      function Vd(e) {
        return We(e) && je(e) == tt;
      }
      function Yd(e) {
        return We(e) && Pi(e.length) && !!Be[nt(e)];
      }
      function Ps(e) {
        return typeof e == "function" ? e : e == null ? ut : typeof e == "object" ? ue(e) ? Hs(e[0], e[1]) : zs(e) : al(e);
      }
      function No(e) {
        if (!Or(e))
          return Ku(e);
        var t = [];
        for (var n in Ie(e))
          Te.call(e, n) && n != "constructor" && t.push(n);
        return t;
      }
      function $d(e) {
        if (!Oe(e))
          return If(e);
        var t = Or(e), n = [];
        for (var i in e)
          i == "constructor" && (t || !Te.call(e, i)) || n.push(i);
        return n;
      }
      function Ro(e, t) {
        return e < t;
      }
      function Ws(e, t) {
        var n = -1, i = lt(e) ? N(e.length) : [];
        return mn(e, function(c, h, y) {
          i[++n] = t(c, h, y);
        }), i;
      }
      function zs(e) {
        var t = Ko(e);
        return t.length == 1 && t[0][2] ? b0(t[0][0], t[0][1]) : function(n) {
          return n === e || Bo(n, e, t);
        };
      }
      function Hs(e, t) {
        return Xo(e) && v0(t) ? b0(Yt(e), t) : function(n) {
          var i = aa(n, e);
          return i === r && i === t ? sa(n, e) : Rr(t, i, T | F);
        };
      }
      function ki(e, t, n, i, c) {
        e !== t && Eo(t, function(h, y) {
          if (c || (c = new Rt()), Oe(h))
            qd(e, t, y, n, ki, i, c);
          else {
            var w = i ? i(jo(e, y), h, y + "", e, t, c) : r;
            w === r && (w = h), So(e, y, w);
          }
        }, ct);
      }
      function qd(e, t, n, i, c, h, y) {
        var w = jo(e, n), S = jo(t, n), D = y.get(S);
        if (D) {
          So(e, n, D);
          return;
        }
        var W = h ? h(w, S, n + "", e, t, y) : r, H = W === r;
        if (H) {
          var K = ue(S), Z = !K && vn(S), ie = !K && !Z && sr(S);
          W = S, K || Z || ie ? ue(w) ? W = w : ze(w) ? W = st(w) : Z ? (H = !1, W = Zs(S, !0)) : ie ? (H = !1, W = e0(S, !0)) : W = [] : Pr(S) || Hn(S) ? (W = w, Hn(w) ? W = X0(w) : (!Oe(w) || nn(w)) && (W = y0(S))) : H = !1;
        }
        H && (y.set(S, W), c(W, S, i, h, y), y.delete(S)), So(e, n, W);
      }
      function Us(e, t) {
        var n = e.length;
        if (n)
          return t += t < 0 ? n : 0, tn(t, n) ? e[t] : r;
      }
      function Gs(e, t, n) {
        t.length ? t = Ne(t, function(h) {
          return ue(h) ? function(y) {
            return Pn(y, h.length === 1 ? h[0] : h);
          } : h;
        }) : t = [ut];
        var i = -1;
        t = Ne(t, mt(re()));
        var c = Ws(e, function(h, y, w) {
          var S = Ne(t, function(D) {
            return D(h);
          });
          return { criteria: S, index: ++i, value: h };
        });
        return bu(c, function(h, y) {
          return sf(h, y, n);
        });
      }
      function Kd(e, t) {
        return Vs(e, t, function(n, i) {
          return sa(e, i);
        });
      }
      function Vs(e, t, n) {
        for (var i = -1, c = t.length, h = {}; ++i < c; ) {
          var y = t[i], w = Pn(e, y);
          n(w, y) && Mr(h, xn(y, e), w);
        }
        return h;
      }
      function Qd(e) {
        return function(t) {
          return Pn(t, e);
        };
      }
      function Mo(e, t, n, i) {
        var c = i ? vu : Xn, h = -1, y = t.length, w = e;
        for (e === t && (t = st(t)), n && (w = Ne(e, mt(n))); ++h < y; )
          for (var S = 0, D = t[h], W = n ? n(D) : D; (S = c(w, W, S, i)) > -1; )
            w !== e && fi.call(w, S, 1), fi.call(e, S, 1);
        return e;
      }
      function Ys(e, t) {
        for (var n = e ? t.length : 0, i = n - 1; n--; ) {
          var c = t[n];
          if (n == i || c !== h) {
            var h = c;
            tn(c) ? fi.call(e, c, 1) : Po(e, c);
          }
        }
        return e;
      }
      function Lo(e, t) {
        return e + mi(Ss() * (t - e + 1));
      }
      function Xd(e, t, n, i) {
        for (var c = -1, h = Ve(pi((t - e) / (n || 1)), 0), y = N(h); h--; )
          y[i ? h : ++c] = e, e += n;
        return y;
      }
      function Oo(e, t) {
        var n = "";
        if (!e || t < 1 || t > _e)
          return n;
        do
          t % 2 && (n += e), t = mi(t / 2), t && (e += e);
        while (t);
        return n;
      }
      function pe(e, t) {
        return Zo(w0(e, t, ut), e + "");
      }
      function Jd(e) {
        return Ts(lr(e));
      }
      function jd(e, t) {
        var n = lr(e);
        return Ni(n, Dn(t, 0, n.length));
      }
      function Mr(e, t, n, i) {
        if (!Oe(e))
          return e;
        t = xn(t, e);
        for (var c = -1, h = t.length, y = h - 1, w = e; w != null && ++c < h; ) {
          var S = Yt(t[c]), D = n;
          if (S === "__proto__" || S === "constructor" || S === "prototype")
            return e;
          if (c != y) {
            var W = w[S];
            D = i ? i(W, S, w) : r, D === r && (D = Oe(W) ? W : tn(t[c + 1]) ? [] : {});
          }
          Fr(w, S, D), w = w[S];
        }
        return e;
      }
      var $s = gi ? function(e, t) {
        return gi.set(e, t), e;
      } : ut, Zd = hi ? function(e, t) {
        return hi(e, "toString", {
          configurable: !0,
          enumerable: !1,
          value: ca(t),
          writable: !0
        });
      } : ut;
      function ef(e) {
        return Ni(lr(e));
      }
      function Et(e, t, n) {
        var i = -1, c = e.length;
        t < 0 && (t = -t > c ? 0 : c + t), n = n > c ? c : n, n < 0 && (n += c), c = t > n ? 0 : n - t >>> 0, t >>>= 0;
        for (var h = N(c); ++i < c; )
          h[i] = e[i + t];
        return h;
      }
      function tf(e, t) {
        var n;
        return mn(e, function(i, c, h) {
          return n = t(i, c, h), !n;
        }), !!n;
      }
      function _i(e, t, n) {
        var i = 0, c = e == null ? i : e.length;
        if (typeof t == "number" && t === t && c <= Yn) {
          for (; i < c; ) {
            var h = i + c >>> 1, y = e[h];
            y !== null && !xt(y) && (n ? y <= t : y < t) ? i = h + 1 : c = h;
          }
          return c;
        }
        return Do(e, t, ut, n);
      }
      function Do(e, t, n, i) {
        var c = 0, h = e == null ? 0 : e.length;
        if (h === 0)
          return 0;
        t = n(t);
        for (var y = t !== t, w = t === null, S = xt(t), D = t === r; c < h; ) {
          var W = mi((c + h) / 2), H = n(e[W]), K = H !== r, Z = H === null, ie = H === H, fe = xt(H);
          if (y)
            var oe = i || ie;
          else
            D ? oe = ie && (i || K) : w ? oe = ie && K && (i || !Z) : S ? oe = ie && K && !Z && (i || !fe) : Z || fe ? oe = !1 : oe = i ? H <= t : H < t;
          oe ? c = W + 1 : h = W;
        }
        return Je(h, Ye);
      }
      function qs(e, t) {
        for (var n = -1, i = e.length, c = 0, h = []; ++n < i; ) {
          var y = e[n], w = t ? t(y) : y;
          if (!n || !Mt(w, S)) {
            var S = w;
            h[c++] = y === 0 ? 0 : y;
          }
        }
        return h;
      }
      function Ks(e) {
        return typeof e == "number" ? e : xt(e) ? ft : +e;
      }
      function gt(e) {
        if (typeof e == "string")
          return e;
        if (ue(e))
          return Ne(e, gt) + "";
        if (xt(e))
          return Cs ? Cs.call(e) : "";
        var t = e + "";
        return t == "0" && 1 / e == -se ? "-0" : t;
      }
      function gn(e, t, n) {
        var i = -1, c = ni, h = e.length, y = !0, w = [], S = w;
        if (n)
          y = !1, c = fo;
        else if (h >= u) {
          var D = t ? null : hf(e);
          if (D)
            return ii(D);
          y = !1, c = Ar, S = new On();
        } else
          S = t ? [] : w;
        e:
          for (; ++i < h; ) {
            var W = e[i], H = t ? t(W) : W;
            if (W = n || W !== 0 ? W : 0, y && H === H) {
              for (var K = S.length; K--; )
                if (S[K] === H)
                  continue e;
              t && S.push(H), w.push(W);
            } else
              c(S, H, n) || (S !== w && S.push(H), w.push(W));
          }
        return w;
      }
      function Po(e, t) {
        return t = xn(t, e), e = k0(e, t), e == null || delete e[Yt(Tt(t))];
      }
      function Qs(e, t, n, i) {
        return Mr(e, t, n(Pn(e, t)), i);
      }
      function Ai(e, t, n, i) {
        for (var c = e.length, h = i ? c : -1; (i ? h-- : ++h < c) && t(e[h], h, e); )
          ;
        return n ? Et(e, i ? 0 : h, i ? h + 1 : c) : Et(e, i ? h + 1 : 0, i ? c : h);
      }
      function Xs(e, t) {
        var n = e;
        return n instanceof be && (n = n.value()), ho(t, function(i, c) {
          return c.func.apply(c.thisArg, fn([i], c.args));
        }, n);
      }
      function Wo(e, t, n) {
        var i = e.length;
        if (i < 2)
          return i ? gn(e[0]) : [];
        for (var c = -1, h = N(i); ++c < i; )
          for (var y = e[c], w = -1; ++w < i; )
            w != c && (h[c] = Br(h[c] || y, e[w], t, n));
        return gn(Qe(h, 1), t, n);
      }
      function Js(e, t, n) {
        for (var i = -1, c = e.length, h = t.length, y = {}; ++i < c; ) {
          var w = i < h ? t[i] : r;
          n(y, e[i], w);
        }
        return y;
      }
      function zo(e) {
        return ze(e) ? e : [];
      }
      function Ho(e) {
        return typeof e == "function" ? e : ut;
      }
      function xn(e, t) {
        return ue(e) ? e : Xo(e, t) ? [e] : C0(Se(e));
      }
      var nf = pe;
      function yn(e, t, n) {
        var i = e.length;
        return n = n === r ? i : n, !t && n >= i ? e : Et(e, t, n);
      }
      var js = Gu || function(e) {
        return Ke.clearTimeout(e);
      };
      function Zs(e, t) {
        if (t)
          return e.slice();
        var n = e.length, i = bs ? bs(n) : new e.constructor(n);
        return e.copy(i), i;
      }
      function Uo(e) {
        var t = new e.constructor(e.byteLength);
        return new ui(t).set(new ui(e)), t;
      }
      function rf(e, t) {
        var n = t ? Uo(e.buffer) : e.buffer;
        return new e.constructor(n, e.byteOffset, e.byteLength);
      }
      function of(e) {
        var t = new e.constructor(e.source, wt.exec(e));
        return t.lastIndex = e.lastIndex, t;
      }
      function af(e) {
        return Ir ? Ie(Ir.call(e)) : {};
      }
      function e0(e, t) {
        var n = t ? Uo(e.buffer) : e.buffer;
        return new e.constructor(n, e.byteOffset, e.length);
      }
      function t0(e, t) {
        if (e !== t) {
          var n = e !== r, i = e === null, c = e === e, h = xt(e), y = t !== r, w = t === null, S = t === t, D = xt(t);
          if (!w && !D && !h && e > t || h && y && S && !w && !D || i && y && S || !n && S || !c)
            return 1;
          if (!i && !h && !D && e < t || D && n && c && !i && !h || w && n && c || !y && c || !S)
            return -1;
        }
        return 0;
      }
      function sf(e, t, n) {
        for (var i = -1, c = e.criteria, h = t.criteria, y = c.length, w = n.length; ++i < y; ) {
          var S = t0(c[i], h[i]);
          if (S) {
            if (i >= w)
              return S;
            var D = n[i];
            return S * (D == "desc" ? -1 : 1);
          }
        }
        return e.index - t.index;
      }
      function n0(e, t, n, i) {
        for (var c = -1, h = e.length, y = n.length, w = -1, S = t.length, D = Ve(h - y, 0), W = N(S + D), H = !i; ++w < S; )
          W[w] = t[w];
        for (; ++c < y; )
          (H || c < h) && (W[n[c]] = e[c]);
        for (; D--; )
          W[w++] = e[c++];
        return W;
      }
      function r0(e, t, n, i) {
        for (var c = -1, h = e.length, y = -1, w = n.length, S = -1, D = t.length, W = Ve(h - w, 0), H = N(W + D), K = !i; ++c < W; )
          H[c] = e[c];
        for (var Z = c; ++S < D; )
          H[Z + S] = t[S];
        for (; ++y < w; )
          (K || c < h) && (H[Z + n[y]] = e[c++]);
        return H;
      }
      function st(e, t) {
        var n = -1, i = e.length;
        for (t || (t = N(i)); ++n < i; )
          t[n] = e[n];
        return t;
      }
      function Vt(e, t, n, i) {
        var c = !n;
        n || (n = {});
        for (var h = -1, y = t.length; ++h < y; ) {
          var w = t[h], S = i ? i(n[w], e[w], w, n, e) : r;
          S === r && (S = e[w]), c ? jt(n, w, S) : Fr(n, w, S);
        }
        return n;
      }
      function lf(e, t) {
        return Vt(e, Qo(e), t);
      }
      function cf(e, t) {
        return Vt(e, g0(e), t);
      }
      function Si(e, t) {
        return function(n, i) {
          var c = ue(n) ? hu : Fd, h = t ? t() : {};
          return c(n, e, re(i, 2), h);
        };
      }
      function ir(e) {
        return pe(function(t, n) {
          var i = -1, c = n.length, h = c > 1 ? n[c - 1] : r, y = c > 2 ? n[2] : r;
          for (h = e.length > 3 && typeof h == "function" ? (c--, h) : r, y && rt(n[0], n[1], y) && (h = c < 3 ? r : h, c = 1), t = Ie(t); ++i < c; ) {
            var w = n[i];
            w && e(t, w, i, h);
          }
          return t;
        });
      }
      function i0(e, t) {
        return function(n, i) {
          if (n == null)
            return n;
          if (!lt(n))
            return e(n, i);
          for (var c = n.length, h = t ? c : -1, y = Ie(n); (t ? h-- : ++h < c) && i(y[h], h, y) !== !1; )
            ;
          return n;
        };
      }
      function o0(e) {
        return function(t, n, i) {
          for (var c = -1, h = Ie(t), y = i(t), w = y.length; w--; ) {
            var S = y[e ? w : ++c];
            if (n(h[S], S, h) === !1)
              break;
          }
          return t;
        };
      }
      function uf(e, t, n) {
        var i = t & E, c = Lr(e);
        function h() {
          var y = this && this !== Ke && this instanceof h ? c : e;
          return y.apply(i ? n : this, arguments);
        }
        return h;
      }
      function a0(e) {
        return function(t) {
          t = Se(t);
          var n = Jn(t) ? Nt(t) : r, i = n ? n[0] : t.charAt(0), c = n ? yn(n, 1).join("") : t.slice(1);
          return i[e]() + c;
        };
      }
      function or(e) {
        return function(t) {
          return ho(il(rl(t).replace(Zc, "")), e, "");
        };
      }
      function Lr(e) {
        return function() {
          var t = arguments;
          switch (t.length) {
            case 0:
              return new e();
            case 1:
              return new e(t[0]);
            case 2:
              return new e(t[0], t[1]);
            case 3:
              return new e(t[0], t[1], t[2]);
            case 4:
              return new e(t[0], t[1], t[2], t[3]);
            case 5:
              return new e(t[0], t[1], t[2], t[3], t[4]);
            case 6:
              return new e(t[0], t[1], t[2], t[3], t[4], t[5]);
            case 7:
              return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
          }
          var n = rr(e.prototype), i = e.apply(n, t);
          return Oe(i) ? i : n;
        };
      }
      function df(e, t, n) {
        var i = Lr(e);
        function c() {
          for (var h = arguments.length, y = N(h), w = h, S = ar(c); w--; )
            y[w] = arguments[w];
          var D = h < 3 && y[0] !== S && y[h - 1] !== S ? [] : hn(y, S);
          if (h -= D.length, h < n)
            return d0(
              e,
              t,
              Ci,
              c.placeholder,
              r,
              y,
              D,
              r,
              r,
              n - h
            );
          var W = this && this !== Ke && this instanceof c ? i : e;
          return pt(W, this, y);
        }
        return c;
      }
      function s0(e) {
        return function(t, n, i) {
          var c = Ie(t);
          if (!lt(t)) {
            var h = re(n, 3);
            t = $e(t), n = function(w) {
              return h(c[w], w, c);
            };
          }
          var y = e(t, n, i);
          return y > -1 ? c[h ? t[y] : y] : r;
        };
      }
      function l0(e) {
        return en(function(t) {
          var n = t.length, i = n, c = St.prototype.thru;
          for (e && t.reverse(); i--; ) {
            var h = t[i];
            if (typeof h != "function")
              throw new At(m);
            if (c && !y && Fi(h) == "wrapper")
              var y = new St([], !0);
          }
          for (i = y ? i : n; ++i < n; ) {
            h = t[i];
            var w = Fi(h), S = w == "wrapper" ? qo(h) : r;
            S && Jo(S[0]) && S[1] == (B | R | U | M) && !S[4].length && S[9] == 1 ? y = y[Fi(S[0])].apply(y, S[3]) : y = h.length == 1 && Jo(h) ? y[w]() : y.thru(h);
          }
          return function() {
            var D = arguments, W = D[0];
            if (y && D.length == 1 && ue(W))
              return y.plant(W).value();
            for (var H = 0, K = n ? t[H].apply(this, D) : W; ++H < n; )
              K = t[H].call(this, K);
            return K;
          };
        });
      }
      function Ci(e, t, n, i, c, h, y, w, S, D) {
        var W = t & B, H = t & E, K = t & I, Z = t & (R | P), ie = t & V, fe = K ? r : Lr(e);
        function oe() {
          for (var xe = arguments.length, we = N(xe), yt = xe; yt--; )
            we[yt] = arguments[yt];
          if (Z)
            var it = ar(oe), vt = ku(we, it);
          if (i && (we = n0(we, i, c, Z)), h && (we = r0(we, h, y, Z)), xe -= vt, Z && xe < D) {
            var He = hn(we, it);
            return d0(
              e,
              t,
              Ci,
              oe.placeholder,
              n,
              we,
              He,
              w,
              S,
              D - xe
            );
          }
          var Lt = H ? n : this, on = K ? Lt[e] : e;
          return xe = we.length, w ? we = Bf(we, w) : ie && xe > 1 && we.reverse(), W && S < xe && (we.length = S), this && this !== Ke && this instanceof oe && (on = fe || Lr(on)), on.apply(Lt, we);
        }
        return oe;
      }
      function c0(e, t) {
        return function(n, i) {
          return Pd(n, e, t(i), {});
        };
      }
      function Ei(e, t) {
        return function(n, i) {
          var c;
          if (n === r && i === r)
            return t;
          if (n !== r && (c = n), i !== r) {
            if (c === r)
              return i;
            typeof n == "string" || typeof i == "string" ? (n = gt(n), i = gt(i)) : (n = Ks(n), i = Ks(i)), c = e(n, i);
          }
          return c;
        };
      }
      function Go(e) {
        return en(function(t) {
          return t = Ne(t, mt(re())), pe(function(n) {
            var i = this;
            return e(t, function(c) {
              return pt(c, i, n);
            });
          });
        });
      }
      function Ti(e, t) {
        t = t === r ? " " : gt(t);
        var n = t.length;
        if (n < 2)
          return n ? Oo(t, e) : t;
        var i = Oo(t, pi(e / jn(t)));
        return Jn(t) ? yn(Nt(i), 0, e).join("") : i.slice(0, e);
      }
      function ff(e, t, n, i) {
        var c = t & E, h = Lr(e);
        function y() {
          for (var w = -1, S = arguments.length, D = -1, W = i.length, H = N(W + S), K = this && this !== Ke && this instanceof y ? h : e; ++D < W; )
            H[D] = i[D];
          for (; S--; )
            H[D++] = arguments[++w];
          return pt(K, c ? n : this, H);
        }
        return y;
      }
      function u0(e) {
        return function(t, n, i) {
          return i && typeof i != "number" && rt(t, n, i) && (n = i = r), t = rn(t), n === r ? (n = t, t = 0) : n = rn(n), i = i === r ? t < n ? 1 : -1 : rn(i), Xd(t, n, i, e);
        };
      }
      function Ii(e) {
        return function(t, n) {
          return typeof t == "string" && typeof n == "string" || (t = It(t), n = It(n)), e(t, n);
        };
      }
      function d0(e, t, n, i, c, h, y, w, S, D) {
        var W = t & R, H = W ? y : r, K = W ? r : y, Z = W ? h : r, ie = W ? r : h;
        t |= W ? U : q, t &= ~(W ? q : U), t & z || (t &= ~(E | I));
        var fe = [
          e,
          t,
          c,
          Z,
          H,
          ie,
          K,
          w,
          S,
          D
        ], oe = n.apply(r, fe);
        return Jo(e) && _0(oe, fe), oe.placeholder = i, A0(oe, e, t);
      }
      function Vo(e) {
        var t = Ge[e];
        return function(n, i) {
          if (n = It(n), i = i == null ? 0 : Je(de(i), 292), i && As(n)) {
            var c = (Se(n) + "e").split("e"), h = t(c[0] + "e" + (+c[1] + i));
            return c = (Se(h) + "e").split("e"), +(c[0] + "e" + (+c[1] - i));
          }
          return t(n);
        };
      }
      var hf = tr && 1 / ii(new tr([, -0]))[1] == se ? function(e) {
        return new tr(e);
      } : fa;
      function f0(e) {
        return function(t) {
          var n = je(t);
          return n == ht ? bo(t) : n == tt ? Iu(t) : wu(t, e(t));
        };
      }
      function Zt(e, t, n, i, c, h, y, w) {
        var S = t & I;
        if (!S && typeof e != "function")
          throw new At(m);
        var D = i ? i.length : 0;
        if (D || (t &= ~(U | q), i = c = r), y = y === r ? y : Ve(de(y), 0), w = w === r ? w : de(w), D -= c ? c.length : 0, t & q) {
          var W = i, H = c;
          i = c = r;
        }
        var K = S ? r : qo(e), Z = [
          e,
          t,
          n,
          i,
          c,
          W,
          H,
          h,
          y,
          w
        ];
        if (K && Tf(Z, K), e = Z[0], t = Z[1], n = Z[2], i = Z[3], c = Z[4], w = Z[9] = Z[9] === r ? S ? 0 : e.length : Ve(Z[9] - D, 0), !w && t & (R | P) && (t &= ~(R | P)), !t || t == E)
          var ie = uf(e, t, n);
        else
          t == R || t == P ? ie = df(e, t, w) : (t == U || t == (E | U)) && !c.length ? ie = ff(e, t, n, i) : ie = Ci.apply(r, Z);
        var fe = K ? $s : _0;
        return A0(fe(ie, Z), e, t);
      }
      function h0(e, t, n, i) {
        return e === r || Mt(e, er[n]) && !Te.call(i, n) ? t : e;
      }
      function p0(e, t, n, i, c, h) {
        return Oe(e) && Oe(t) && (h.set(t, e), ki(e, t, r, p0, h), h.delete(t)), e;
      }
      function pf(e) {
        return Pr(e) ? r : e;
      }
      function m0(e, t, n, i, c, h) {
        var y = n & T, w = e.length, S = t.length;
        if (w != S && !(y && S > w))
          return !1;
        var D = h.get(e), W = h.get(t);
        if (D && W)
          return D == t && W == e;
        var H = -1, K = !0, Z = n & F ? new On() : r;
        for (h.set(e, t), h.set(t, e); ++H < w; ) {
          var ie = e[H], fe = t[H];
          if (i)
            var oe = y ? i(fe, ie, H, t, e, h) : i(ie, fe, H, e, t, h);
          if (oe !== r) {
            if (oe)
              continue;
            K = !1;
            break;
          }
          if (Z) {
            if (!po(t, function(xe, we) {
              if (!Ar(Z, we) && (ie === xe || c(ie, xe, n, i, h)))
                return Z.push(we);
            })) {
              K = !1;
              break;
            }
          } else if (!(ie === fe || c(ie, fe, n, i, h))) {
            K = !1;
            break;
          }
        }
        return h.delete(e), h.delete(t), K;
      }
      function mf(e, t, n, i, c, h, y) {
        switch (n) {
          case cn:
            if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
              return !1;
            e = e.buffer, t = t.buffer;
          case In:
            return !(e.byteLength != t.byteLength || !h(new ui(e), new ui(t)));
          case zt:
          case Kt:
          case Ht:
            return Mt(+e, +t);
          case qn:
            return e.name == t.name && e.message == t.message;
          case Ft:
          case En:
            return e == t + "";
          case ht:
            var w = bo;
          case tt:
            var S = i & T;
            if (w || (w = ii), e.size != t.size && !S)
              return !1;
            var D = y.get(e);
            if (D)
              return D == t;
            i |= F, y.set(e, t);
            var W = m0(w(e), w(t), i, c, h, y);
            return y.delete(e), W;
          case Tn:
            if (Ir)
              return Ir.call(e) == Ir.call(t);
        }
        return !1;
      }
      function gf(e, t, n, i, c, h) {
        var y = n & T, w = Yo(e), S = w.length, D = Yo(t), W = D.length;
        if (S != W && !y)
          return !1;
        for (var H = S; H--; ) {
          var K = w[H];
          if (!(y ? K in t : Te.call(t, K)))
            return !1;
        }
        var Z = h.get(e), ie = h.get(t);
        if (Z && ie)
          return Z == t && ie == e;
        var fe = !0;
        h.set(e, t), h.set(t, e);
        for (var oe = y; ++H < S; ) {
          K = w[H];
          var xe = e[K], we = t[K];
          if (i)
            var yt = y ? i(we, xe, K, t, e, h) : i(xe, we, K, e, t, h);
          if (!(yt === r ? xe === we || c(xe, we, n, i, h) : yt)) {
            fe = !1;
            break;
          }
          oe || (oe = K == "constructor");
        }
        if (fe && !oe) {
          var it = e.constructor, vt = t.constructor;
          it != vt && "constructor" in e && "constructor" in t && !(typeof it == "function" && it instanceof it && typeof vt == "function" && vt instanceof vt) && (fe = !1);
        }
        return h.delete(e), h.delete(t), fe;
      }
      function en(e) {
        return Zo(w0(e, r, F0), e + "");
      }
      function Yo(e) {
        return Ls(e, $e, Qo);
      }
      function $o(e) {
        return Ls(e, ct, g0);
      }
      var qo = gi ? function(e) {
        return gi.get(e);
      } : fa;
      function Fi(e) {
        for (var t = e.name + "", n = nr[t], i = Te.call(nr, t) ? n.length : 0; i--; ) {
          var c = n[i], h = c.func;
          if (h == null || h == e)
            return c.name;
        }
        return t;
      }
      function ar(e) {
        var t = Te.call(f, "placeholder") ? f : e;
        return t.placeholder;
      }
      function re() {
        var e = f.iteratee || ua;
        return e = e === ua ? Ps : e, arguments.length ? e(arguments[0], arguments[1]) : e;
      }
      function Bi(e, t) {
        var n = e.__data__;
        return Af(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
      }
      function Ko(e) {
        for (var t = $e(e), n = t.length; n--; ) {
          var i = t[n], c = e[i];
          t[n] = [i, c, v0(c)];
        }
        return t;
      }
      function Wn(e, t) {
        var n = Cu(e, t);
        return Ds(n) ? n : r;
      }
      function xf(e) {
        var t = Te.call(e, Mn), n = e[Mn];
        try {
          e[Mn] = r;
          var i = !0;
        } catch {
        }
        var c = li.call(e);
        return i && (t ? e[Mn] = n : delete e[Mn]), c;
      }
      var Qo = ko ? function(e) {
        return e == null ? [] : (e = Ie(e), dn(ko(e), function(t) {
          return ks.call(e, t);
        }));
      } : ha, g0 = ko ? function(e) {
        for (var t = []; e; )
          fn(t, Qo(e)), e = di(e);
        return t;
      } : ha, je = nt;
      (_o && je(new _o(new ArrayBuffer(1))) != cn || Cr && je(new Cr()) != ht || Ao && je(Ao.resolve()) != Cn || tr && je(new tr()) != tt || Er && je(new Er()) != Qt) && (je = function(e) {
        var t = nt(e), n = t == bt ? e.constructor : r, i = n ? zn(n) : "";
        if (i)
          switch (i) {
            case ju:
              return cn;
            case Zu:
              return ht;
            case ed:
              return Cn;
            case td:
              return tt;
            case nd:
              return Qt;
          }
        return t;
      });
      function yf(e, t, n) {
        for (var i = -1, c = n.length; ++i < c; ) {
          var h = n[i], y = h.size;
          switch (h.type) {
            case "drop":
              e += y;
              break;
            case "dropRight":
              t -= y;
              break;
            case "take":
              t = Je(t, e + y);
              break;
            case "takeRight":
              e = Ve(e, t - y);
              break;
          }
        }
        return { start: e, end: t };
      }
      function vf(e) {
        var t = e.match(Ee);
        return t ? t[1].split(ke) : [];
      }
      function x0(e, t, n) {
        t = xn(t, e);
        for (var i = -1, c = t.length, h = !1; ++i < c; ) {
          var y = Yt(t[i]);
          if (!(h = e != null && n(e, y)))
            break;
          e = e[y];
        }
        return h || ++i != c ? h : (c = e == null ? 0 : e.length, !!c && Pi(c) && tn(y, c) && (ue(e) || Hn(e)));
      }
      function bf(e) {
        var t = e.length, n = new e.constructor(t);
        return t && typeof e[0] == "string" && Te.call(e, "index") && (n.index = e.index, n.input = e.input), n;
      }
      function y0(e) {
        return typeof e.constructor == "function" && !Or(e) ? rr(di(e)) : {};
      }
      function wf(e, t, n) {
        var i = e.constructor;
        switch (t) {
          case In:
            return Uo(e);
          case zt:
          case Kt:
            return new i(+e);
          case cn:
            return rf(e, n);
          case vr:
          case br:
          case wr:
          case kr:
          case Fn:
          case Kn:
          case Ut:
          case Bn:
          case Nn:
            return e0(e, n);
          case ht:
            return new i();
          case Ht:
          case En:
            return new i(e);
          case Ft:
            return of(e);
          case tt:
            return new i();
          case Tn:
            return af(e);
        }
      }
      function kf(e, t) {
        var n = t.length;
        if (!n)
          return e;
        var i = n - 1;
        return t[i] = (n > 1 ? "& " : "") + t[i], t = t.join(n > 2 ? ", " : " "), e.replace(Ce, `{
/* [wrapped with ` + t + `] */
`);
      }
      function _f(e) {
        return ue(e) || Hn(e) || !!(_s && e && e[_s]);
      }
      function tn(e, t) {
        var n = typeof e;
        return t = t ?? _e, !!t && (n == "number" || n != "symbol" && Mc.test(e)) && e > -1 && e % 1 == 0 && e < t;
      }
      function rt(e, t, n) {
        if (!Oe(n))
          return !1;
        var i = typeof t;
        return (i == "number" ? lt(n) && tn(t, n.length) : i == "string" && t in n) ? Mt(n[t], e) : !1;
      }
      function Xo(e, t) {
        if (ue(e))
          return !1;
        var n = typeof e;
        return n == "number" || n == "symbol" || n == "boolean" || e == null || xt(e) ? !0 : no.test(e) || !to.test(e) || t != null && e in Ie(t);
      }
      function Af(e) {
        var t = typeof e;
        return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
      }
      function Jo(e) {
        var t = Fi(e), n = f[t];
        if (typeof n != "function" || !(t in be.prototype))
          return !1;
        if (e === n)
          return !0;
        var i = qo(n);
        return !!i && e === i[0];
      }
      function Sf(e) {
        return !!vs && vs in e;
      }
      var Cf = ai ? nn : pa;
      function Or(e) {
        var t = e && e.constructor, n = typeof t == "function" && t.prototype || er;
        return e === n;
      }
      function v0(e) {
        return e === e && !Oe(e);
      }
      function b0(e, t) {
        return function(n) {
          return n == null ? !1 : n[e] === t && (t !== r || e in Ie(n));
        };
      }
      function Ef(e) {
        var t = Oi(e, function(i) {
          return n.size === x && n.clear(), i;
        }), n = t.cache;
        return t;
      }
      function Tf(e, t) {
        var n = e[1], i = t[1], c = n | i, h = c < (E | I | B), y = i == B && n == R || i == B && n == M && e[7].length <= t[8] || i == (B | M) && t[7].length <= t[8] && n == R;
        if (!(h || y))
          return e;
        i & E && (e[2] = t[2], c |= n & E ? 0 : z);
        var w = t[3];
        if (w) {
          var S = e[3];
          e[3] = S ? n0(S, w, t[4]) : w, e[4] = S ? hn(e[3], k) : t[4];
        }
        return w = t[5], w && (S = e[5], e[5] = S ? r0(S, w, t[6]) : w, e[6] = S ? hn(e[5], k) : t[6]), w = t[7], w && (e[7] = w), i & B && (e[8] = e[8] == null ? t[8] : Je(e[8], t[8])), e[9] == null && (e[9] = t[9]), e[0] = t[0], e[1] = c, e;
      }
      function If(e) {
        var t = [];
        if (e != null)
          for (var n in Ie(e))
            t.push(n);
        return t;
      }
      function Ff(e) {
        return li.call(e);
      }
      function w0(e, t, n) {
        return t = Ve(t === r ? e.length - 1 : t, 0), function() {
          for (var i = arguments, c = -1, h = Ve(i.length - t, 0), y = N(h); ++c < h; )
            y[c] = i[t + c];
          c = -1;
          for (var w = N(t + 1); ++c < t; )
            w[c] = i[c];
          return w[t] = n(y), pt(e, this, w);
        };
      }
      function k0(e, t) {
        return t.length < 2 ? e : Pn(e, Et(t, 0, -1));
      }
      function Bf(e, t) {
        for (var n = e.length, i = Je(t.length, n), c = st(e); i--; ) {
          var h = t[i];
          e[i] = tn(h, n) ? c[h] : r;
        }
        return e;
      }
      function jo(e, t) {
        if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
          return e[t];
      }
      var _0 = S0($s), Dr = Yu || function(e, t) {
        return Ke.setTimeout(e, t);
      }, Zo = S0(Zd);
      function A0(e, t, n) {
        var i = t + "";
        return Zo(e, kf(i, Nf(vf(i), n)));
      }
      function S0(e) {
        var t = 0, n = 0;
        return function() {
          var i = Qu(), c = $ - (i - n);
          if (n = i, c > 0) {
            if (++t >= ne)
              return arguments[0];
          } else
            t = 0;
          return e.apply(r, arguments);
        };
      }
      function Ni(e, t) {
        var n = -1, i = e.length, c = i - 1;
        for (t = t === r ? i : t; ++n < t; ) {
          var h = Lo(n, c), y = e[h];
          e[h] = e[n], e[n] = y;
        }
        return e.length = t, e;
      }
      var C0 = Ef(function(e) {
        var t = [];
        return e.charCodeAt(0) === 46 && t.push(""), e.replace(ro, function(n, i, c, h) {
          t.push(c ? h.replace(Le, "$1") : i || n);
        }), t;
      });
      function Yt(e) {
        if (typeof e == "string" || xt(e))
          return e;
        var t = e + "";
        return t == "0" && 1 / e == -se ? "-0" : t;
      }
      function zn(e) {
        if (e != null) {
          try {
            return si.call(e);
          } catch {
          }
          try {
            return e + "";
          } catch {
          }
        }
        return "";
      }
      function Nf(e, t) {
        return _t(gr, function(n) {
          var i = "_." + n[0];
          t & n[1] && !ni(e, i) && e.push(i);
        }), e.sort();
      }
      function E0(e) {
        if (e instanceof be)
          return e.clone();
        var t = new St(e.__wrapped__, e.__chain__);
        return t.__actions__ = st(e.__actions__), t.__index__ = e.__index__, t.__values__ = e.__values__, t;
      }
      function Rf(e, t, n) {
        (n ? rt(e, t, n) : t === r) ? t = 1 : t = Ve(de(t), 0);
        var i = e == null ? 0 : e.length;
        if (!i || t < 1)
          return [];
        for (var c = 0, h = 0, y = N(pi(i / t)); c < i; )
          y[h++] = Et(e, c, c += t);
        return y;
      }
      function Mf(e) {
        for (var t = -1, n = e == null ? 0 : e.length, i = 0, c = []; ++t < n; ) {
          var h = e[t];
          h && (c[i++] = h);
        }
        return c;
      }
      function Lf() {
        var e = arguments.length;
        if (!e)
          return [];
        for (var t = N(e - 1), n = arguments[0], i = e; i--; )
          t[i - 1] = arguments[i];
        return fn(ue(n) ? st(n) : [n], Qe(t, 1));
      }
      var Of = pe(function(e, t) {
        return ze(e) ? Br(e, Qe(t, 1, ze, !0)) : [];
      }), Df = pe(function(e, t) {
        var n = Tt(t);
        return ze(n) && (n = r), ze(e) ? Br(e, Qe(t, 1, ze, !0), re(n, 2)) : [];
      }), Pf = pe(function(e, t) {
        var n = Tt(t);
        return ze(n) && (n = r), ze(e) ? Br(e, Qe(t, 1, ze, !0), r, n) : [];
      });
      function Wf(e, t, n) {
        var i = e == null ? 0 : e.length;
        return i ? (t = n || t === r ? 1 : de(t), Et(e, t < 0 ? 0 : t, i)) : [];
      }
      function zf(e, t, n) {
        var i = e == null ? 0 : e.length;
        return i ? (t = n || t === r ? 1 : de(t), t = i - t, Et(e, 0, t < 0 ? 0 : t)) : [];
      }
      function Hf(e, t) {
        return e && e.length ? Ai(e, re(t, 3), !0, !0) : [];
      }
      function Uf(e, t) {
        return e && e.length ? Ai(e, re(t, 3), !0) : [];
      }
      function Gf(e, t, n, i) {
        var c = e == null ? 0 : e.length;
        return c ? (n && typeof n != "number" && rt(e, t, n) && (n = 0, i = c), Md(e, t, n, i)) : [];
      }
      function T0(e, t, n) {
        var i = e == null ? 0 : e.length;
        if (!i)
          return -1;
        var c = n == null ? 0 : de(n);
        return c < 0 && (c = Ve(i + c, 0)), ri(e, re(t, 3), c);
      }
      function I0(e, t, n) {
        var i = e == null ? 0 : e.length;
        if (!i)
          return -1;
        var c = i - 1;
        return n !== r && (c = de(n), c = n < 0 ? Ve(i + c, 0) : Je(c, i - 1)), ri(e, re(t, 3), c, !0);
      }
      function F0(e) {
        var t = e == null ? 0 : e.length;
        return t ? Qe(e, 1) : [];
      }
      function Vf(e) {
        var t = e == null ? 0 : e.length;
        return t ? Qe(e, se) : [];
      }
      function Yf(e, t) {
        var n = e == null ? 0 : e.length;
        return n ? (t = t === r ? 1 : de(t), Qe(e, t)) : [];
      }
      function $f(e) {
        for (var t = -1, n = e == null ? 0 : e.length, i = {}; ++t < n; ) {
          var c = e[t];
          i[c[0]] = c[1];
        }
        return i;
      }
      function B0(e) {
        return e && e.length ? e[0] : r;
      }
      function qf(e, t, n) {
        var i = e == null ? 0 : e.length;
        if (!i)
          return -1;
        var c = n == null ? 0 : de(n);
        return c < 0 && (c = Ve(i + c, 0)), Xn(e, t, c);
      }
      function Kf(e) {
        var t = e == null ? 0 : e.length;
        return t ? Et(e, 0, -1) : [];
      }
      var Qf = pe(function(e) {
        var t = Ne(e, zo);
        return t.length && t[0] === e[0] ? Fo(t) : [];
      }), Xf = pe(function(e) {
        var t = Tt(e), n = Ne(e, zo);
        return t === Tt(n) ? t = r : n.pop(), n.length && n[0] === e[0] ? Fo(n, re(t, 2)) : [];
      }), Jf = pe(function(e) {
        var t = Tt(e), n = Ne(e, zo);
        return t = typeof t == "function" ? t : r, t && n.pop(), n.length && n[0] === e[0] ? Fo(n, r, t) : [];
      });
      function jf(e, t) {
        return e == null ? "" : qu.call(e, t);
      }
      function Tt(e) {
        var t = e == null ? 0 : e.length;
        return t ? e[t - 1] : r;
      }
      function Zf(e, t, n) {
        var i = e == null ? 0 : e.length;
        if (!i)
          return -1;
        var c = i;
        return n !== r && (c = de(n), c = c < 0 ? Ve(i + c, 0) : Je(c, i - 1)), t === t ? Bu(e, t, c) : ri(e, ds, c, !0);
      }
      function e1(e, t) {
        return e && e.length ? Us(e, de(t)) : r;
      }
      var t1 = pe(N0);
      function N0(e, t) {
        return e && e.length && t && t.length ? Mo(e, t) : e;
      }
      function n1(e, t, n) {
        return e && e.length && t && t.length ? Mo(e, t, re(n, 2)) : e;
      }
      function r1(e, t, n) {
        return e && e.length && t && t.length ? Mo(e, t, r, n) : e;
      }
      var i1 = en(function(e, t) {
        var n = e == null ? 0 : e.length, i = Co(e, t);
        return Ys(e, Ne(t, function(c) {
          return tn(c, n) ? +c : c;
        }).sort(t0)), i;
      });
      function o1(e, t) {
        var n = [];
        if (!(e && e.length))
          return n;
        var i = -1, c = [], h = e.length;
        for (t = re(t, 3); ++i < h; ) {
          var y = e[i];
          t(y, i, e) && (n.push(y), c.push(i));
        }
        return Ys(e, c), n;
      }
      function ea(e) {
        return e == null ? e : Ju.call(e);
      }
      function a1(e, t, n) {
        var i = e == null ? 0 : e.length;
        return i ? (n && typeof n != "number" && rt(e, t, n) ? (t = 0, n = i) : (t = t == null ? 0 : de(t), n = n === r ? i : de(n)), Et(e, t, n)) : [];
      }
      function s1(e, t) {
        return _i(e, t);
      }
      function l1(e, t, n) {
        return Do(e, t, re(n, 2));
      }
      function c1(e, t) {
        var n = e == null ? 0 : e.length;
        if (n) {
          var i = _i(e, t);
          if (i < n && Mt(e[i], t))
            return i;
        }
        return -1;
      }
      function u1(e, t) {
        return _i(e, t, !0);
      }
      function d1(e, t, n) {
        return Do(e, t, re(n, 2), !0);
      }
      function f1(e, t) {
        var n = e == null ? 0 : e.length;
        if (n) {
          var i = _i(e, t, !0) - 1;
          if (Mt(e[i], t))
            return i;
        }
        return -1;
      }
      function h1(e) {
        return e && e.length ? qs(e) : [];
      }
      function p1(e, t) {
        return e && e.length ? qs(e, re(t, 2)) : [];
      }
      function m1(e) {
        var t = e == null ? 0 : e.length;
        return t ? Et(e, 1, t) : [];
      }
      function g1(e, t, n) {
        return e && e.length ? (t = n || t === r ? 1 : de(t), Et(e, 0, t < 0 ? 0 : t)) : [];
      }
      function x1(e, t, n) {
        var i = e == null ? 0 : e.length;
        return i ? (t = n || t === r ? 1 : de(t), t = i - t, Et(e, t < 0 ? 0 : t, i)) : [];
      }
      function y1(e, t) {
        return e && e.length ? Ai(e, re(t, 3), !1, !0) : [];
      }
      function v1(e, t) {
        return e && e.length ? Ai(e, re(t, 3)) : [];
      }
      var b1 = pe(function(e) {
        return gn(Qe(e, 1, ze, !0));
      }), w1 = pe(function(e) {
        var t = Tt(e);
        return ze(t) && (t = r), gn(Qe(e, 1, ze, !0), re(t, 2));
      }), k1 = pe(function(e) {
        var t = Tt(e);
        return t = typeof t == "function" ? t : r, gn(Qe(e, 1, ze, !0), r, t);
      });
      function _1(e) {
        return e && e.length ? gn(e) : [];
      }
      function A1(e, t) {
        return e && e.length ? gn(e, re(t, 2)) : [];
      }
      function S1(e, t) {
        return t = typeof t == "function" ? t : r, e && e.length ? gn(e, r, t) : [];
      }
      function ta(e) {
        if (!(e && e.length))
          return [];
        var t = 0;
        return e = dn(e, function(n) {
          if (ze(n))
            return t = Ve(n.length, t), !0;
        }), yo(t, function(n) {
          return Ne(e, mo(n));
        });
      }
      function R0(e, t) {
        if (!(e && e.length))
          return [];
        var n = ta(e);
        return t == null ? n : Ne(n, function(i) {
          return pt(t, r, i);
        });
      }
      var C1 = pe(function(e, t) {
        return ze(e) ? Br(e, t) : [];
      }), E1 = pe(function(e) {
        return Wo(dn(e, ze));
      }), T1 = pe(function(e) {
        var t = Tt(e);
        return ze(t) && (t = r), Wo(dn(e, ze), re(t, 2));
      }), I1 = pe(function(e) {
        var t = Tt(e);
        return t = typeof t == "function" ? t : r, Wo(dn(e, ze), r, t);
      }), F1 = pe(ta);
      function B1(e, t) {
        return Js(e || [], t || [], Fr);
      }
      function N1(e, t) {
        return Js(e || [], t || [], Mr);
      }
      var R1 = pe(function(e) {
        var t = e.length, n = t > 1 ? e[t - 1] : r;
        return n = typeof n == "function" ? (e.pop(), n) : r, R0(e, n);
      });
      function M0(e) {
        var t = f(e);
        return t.__chain__ = !0, t;
      }
      function M1(e, t) {
        return t(e), e;
      }
      function Ri(e, t) {
        return t(e);
      }
      var L1 = en(function(e) {
        var t = e.length, n = t ? e[0] : 0, i = this.__wrapped__, c = function(h) {
          return Co(h, e);
        };
        return t > 1 || this.__actions__.length || !(i instanceof be) || !tn(n) ? this.thru(c) : (i = i.slice(n, +n + (t ? 1 : 0)), i.__actions__.push({
          func: Ri,
          args: [c],
          thisArg: r
        }), new St(i, this.__chain__).thru(function(h) {
          return t && !h.length && h.push(r), h;
        }));
      });
      function O1() {
        return M0(this);
      }
      function D1() {
        return new St(this.value(), this.__chain__);
      }
      function P1() {
        this.__values__ === r && (this.__values__ = K0(this.value()));
        var e = this.__index__ >= this.__values__.length, t = e ? r : this.__values__[this.__index__++];
        return { done: e, value: t };
      }
      function W1() {
        return this;
      }
      function z1(e) {
        for (var t, n = this; n instanceof yi; ) {
          var i = E0(n);
          i.__index__ = 0, i.__values__ = r, t ? c.__wrapped__ = i : t = i;
          var c = i;
          n = n.__wrapped__;
        }
        return c.__wrapped__ = e, t;
      }
      function H1() {
        var e = this.__wrapped__;
        if (e instanceof be) {
          var t = e;
          return this.__actions__.length && (t = new be(this)), t = t.reverse(), t.__actions__.push({
            func: Ri,
            args: [ea],
            thisArg: r
          }), new St(t, this.__chain__);
        }
        return this.thru(ea);
      }
      function U1() {
        return Xs(this.__wrapped__, this.__actions__);
      }
      var G1 = Si(function(e, t, n) {
        Te.call(e, n) ? ++e[n] : jt(e, n, 1);
      });
      function V1(e, t, n) {
        var i = ue(e) ? cs : Rd;
        return n && rt(e, t, n) && (t = r), i(e, re(t, 3));
      }
      function Y1(e, t) {
        var n = ue(e) ? dn : Rs;
        return n(e, re(t, 3));
      }
      var $1 = s0(T0), q1 = s0(I0);
      function K1(e, t) {
        return Qe(Mi(e, t), 1);
      }
      function Q1(e, t) {
        return Qe(Mi(e, t), se);
      }
      function X1(e, t, n) {
        return n = n === r ? 1 : de(n), Qe(Mi(e, t), n);
      }
      function L0(e, t) {
        var n = ue(e) ? _t : mn;
        return n(e, re(t, 3));
      }
      function O0(e, t) {
        var n = ue(e) ? pu : Ns;
        return n(e, re(t, 3));
      }
      var J1 = Si(function(e, t, n) {
        Te.call(e, n) ? e[n].push(t) : jt(e, n, [t]);
      });
      function j1(e, t, n, i) {
        e = lt(e) ? e : lr(e), n = n && !i ? de(n) : 0;
        var c = e.length;
        return n < 0 && (n = Ve(c + n, 0)), Wi(e) ? n <= c && e.indexOf(t, n) > -1 : !!c && Xn(e, t, n) > -1;
      }
      var Z1 = pe(function(e, t, n) {
        var i = -1, c = typeof t == "function", h = lt(e) ? N(e.length) : [];
        return mn(e, function(y) {
          h[++i] = c ? pt(t, y, n) : Nr(y, t, n);
        }), h;
      }), eh = Si(function(e, t, n) {
        jt(e, n, t);
      });
      function Mi(e, t) {
        var n = ue(e) ? Ne : Ws;
        return n(e, re(t, 3));
      }
      function th(e, t, n, i) {
        return e == null ? [] : (ue(t) || (t = t == null ? [] : [t]), n = i ? r : n, ue(n) || (n = n == null ? [] : [n]), Gs(e, t, n));
      }
      var nh = Si(function(e, t, n) {
        e[n ? 0 : 1].push(t);
      }, function() {
        return [[], []];
      });
      function rh(e, t, n) {
        var i = ue(e) ? ho : hs, c = arguments.length < 3;
        return i(e, re(t, 4), n, c, mn);
      }
      function ih(e, t, n) {
        var i = ue(e) ? mu : hs, c = arguments.length < 3;
        return i(e, re(t, 4), n, c, Ns);
      }
      function oh(e, t) {
        var n = ue(e) ? dn : Rs;
        return n(e, Di(re(t, 3)));
      }
      function ah(e) {
        var t = ue(e) ? Ts : Jd;
        return t(e);
      }
      function sh(e, t, n) {
        (n ? rt(e, t, n) : t === r) ? t = 1 : t = de(t);
        var i = ue(e) ? Td : jd;
        return i(e, t);
      }
      function lh(e) {
        var t = ue(e) ? Id : ef;
        return t(e);
      }
      function ch(e) {
        if (e == null)
          return 0;
        if (lt(e))
          return Wi(e) ? jn(e) : e.length;
        var t = je(e);
        return t == ht || t == tt ? e.size : No(e).length;
      }
      function uh(e, t, n) {
        var i = ue(e) ? po : tf;
        return n && rt(e, t, n) && (t = r), i(e, re(t, 3));
      }
      var dh = pe(function(e, t) {
        if (e == null)
          return [];
        var n = t.length;
        return n > 1 && rt(e, t[0], t[1]) ? t = [] : n > 2 && rt(t[0], t[1], t[2]) && (t = [t[0]]), Gs(e, Qe(t, 1), []);
      }), Li = Vu || function() {
        return Ke.Date.now();
      };
      function fh(e, t) {
        if (typeof t != "function")
          throw new At(m);
        return e = de(e), function() {
          if (--e < 1)
            return t.apply(this, arguments);
        };
      }
      function D0(e, t, n) {
        return t = n ? r : t, t = e && t == null ? e.length : t, Zt(e, B, r, r, r, r, t);
      }
      function P0(e, t) {
        var n;
        if (typeof t != "function")
          throw new At(m);
        return e = de(e), function() {
          return --e > 0 && (n = t.apply(this, arguments)), e <= 1 && (t = r), n;
        };
      }
      var na = pe(function(e, t, n) {
        var i = E;
        if (n.length) {
          var c = hn(n, ar(na));
          i |= U;
        }
        return Zt(e, i, t, n, c);
      }), W0 = pe(function(e, t, n) {
        var i = E | I;
        if (n.length) {
          var c = hn(n, ar(W0));
          i |= U;
        }
        return Zt(t, i, e, n, c);
      });
      function z0(e, t, n) {
        t = n ? r : t;
        var i = Zt(e, R, r, r, r, r, r, t);
        return i.placeholder = z0.placeholder, i;
      }
      function H0(e, t, n) {
        t = n ? r : t;
        var i = Zt(e, P, r, r, r, r, r, t);
        return i.placeholder = H0.placeholder, i;
      }
      function U0(e, t, n) {
        var i, c, h, y, w, S, D = 0, W = !1, H = !1, K = !0;
        if (typeof e != "function")
          throw new At(m);
        t = It(t) || 0, Oe(n) && (W = !!n.leading, H = "maxWait" in n, h = H ? Ve(It(n.maxWait) || 0, t) : h, K = "trailing" in n ? !!n.trailing : K);
        function Z(He) {
          var Lt = i, on = c;
          return i = c = r, D = He, y = e.apply(on, Lt), y;
        }
        function ie(He) {
          return D = He, w = Dr(xe, t), W ? Z(He) : y;
        }
        function fe(He) {
          var Lt = He - S, on = He - D, sl = t - Lt;
          return H ? Je(sl, h - on) : sl;
        }
        function oe(He) {
          var Lt = He - S, on = He - D;
          return S === r || Lt >= t || Lt < 0 || H && on >= h;
        }
        function xe() {
          var He = Li();
          if (oe(He))
            return we(He);
          w = Dr(xe, fe(He));
        }
        function we(He) {
          return w = r, K && i ? Z(He) : (i = c = r, y);
        }
        function yt() {
          w !== r && js(w), D = 0, i = S = c = w = r;
        }
        function it() {
          return w === r ? y : we(Li());
        }
        function vt() {
          var He = Li(), Lt = oe(He);
          if (i = arguments, c = this, S = He, Lt) {
            if (w === r)
              return ie(S);
            if (H)
              return js(w), w = Dr(xe, t), Z(S);
          }
          return w === r && (w = Dr(xe, t)), y;
        }
        return vt.cancel = yt, vt.flush = it, vt;
      }
      var hh = pe(function(e, t) {
        return Bs(e, 1, t);
      }), ph = pe(function(e, t, n) {
        return Bs(e, It(t) || 0, n);
      });
      function mh(e) {
        return Zt(e, V);
      }
      function Oi(e, t) {
        if (typeof e != "function" || t != null && typeof t != "function")
          throw new At(m);
        var n = function() {
          var i = arguments, c = t ? t.apply(this, i) : i[0], h = n.cache;
          if (h.has(c))
            return h.get(c);
          var y = e.apply(this, i);
          return n.cache = h.set(c, y) || h, y;
        };
        return n.cache = new (Oi.Cache || Jt)(), n;
      }
      Oi.Cache = Jt;
      function Di(e) {
        if (typeof e != "function")
          throw new At(m);
        return function() {
          var t = arguments;
          switch (t.length) {
            case 0:
              return !e.call(this);
            case 1:
              return !e.call(this, t[0]);
            case 2:
              return !e.call(this, t[0], t[1]);
            case 3:
              return !e.call(this, t[0], t[1], t[2]);
          }
          return !e.apply(this, t);
        };
      }
      function gh(e) {
        return P0(2, e);
      }
      var xh = nf(function(e, t) {
        t = t.length == 1 && ue(t[0]) ? Ne(t[0], mt(re())) : Ne(Qe(t, 1), mt(re()));
        var n = t.length;
        return pe(function(i) {
          for (var c = -1, h = Je(i.length, n); ++c < h; )
            i[c] = t[c].call(this, i[c]);
          return pt(e, this, i);
        });
      }), ra = pe(function(e, t) {
        var n = hn(t, ar(ra));
        return Zt(e, U, r, t, n);
      }), G0 = pe(function(e, t) {
        var n = hn(t, ar(G0));
        return Zt(e, q, r, t, n);
      }), yh = en(function(e, t) {
        return Zt(e, M, r, r, r, t);
      });
      function vh(e, t) {
        if (typeof e != "function")
          throw new At(m);
        return t = t === r ? t : de(t), pe(e, t);
      }
      function bh(e, t) {
        if (typeof e != "function")
          throw new At(m);
        return t = t == null ? 0 : Ve(de(t), 0), pe(function(n) {
          var i = n[t], c = yn(n, 0, t);
          return i && fn(c, i), pt(e, this, c);
        });
      }
      function wh(e, t, n) {
        var i = !0, c = !0;
        if (typeof e != "function")
          throw new At(m);
        return Oe(n) && (i = "leading" in n ? !!n.leading : i, c = "trailing" in n ? !!n.trailing : c), U0(e, t, {
          leading: i,
          maxWait: t,
          trailing: c
        });
      }
      function kh(e) {
        return D0(e, 1);
      }
      function _h(e, t) {
        return ra(Ho(t), e);
      }
      function Ah() {
        if (!arguments.length)
          return [];
        var e = arguments[0];
        return ue(e) ? e : [e];
      }
      function Sh(e) {
        return Ct(e, C);
      }
      function Ch(e, t) {
        return t = typeof t == "function" ? t : r, Ct(e, C, t);
      }
      function Eh(e) {
        return Ct(e, v | C);
      }
      function Th(e, t) {
        return t = typeof t == "function" ? t : r, Ct(e, v | C, t);
      }
      function Ih(e, t) {
        return t == null || Fs(e, t, $e(t));
      }
      function Mt(e, t) {
        return e === t || e !== e && t !== t;
      }
      var Fh = Ii(Io), Bh = Ii(function(e, t) {
        return e >= t;
      }), Hn = Os(function() {
        return arguments;
      }()) ? Os : function(e) {
        return We(e) && Te.call(e, "callee") && !ks.call(e, "callee");
      }, ue = N.isArray, Nh = rs ? mt(rs) : Wd;
      function lt(e) {
        return e != null && Pi(e.length) && !nn(e);
      }
      function ze(e) {
        return We(e) && lt(e);
      }
      function Rh(e) {
        return e === !0 || e === !1 || We(e) && nt(e) == zt;
      }
      var vn = $u || pa, Mh = is ? mt(is) : zd;
      function Lh(e) {
        return We(e) && e.nodeType === 1 && !Pr(e);
      }
      function Oh(e) {
        if (e == null)
          return !0;
        if (lt(e) && (ue(e) || typeof e == "string" || typeof e.splice == "function" || vn(e) || sr(e) || Hn(e)))
          return !e.length;
        var t = je(e);
        if (t == ht || t == tt)
          return !e.size;
        if (Or(e))
          return !No(e).length;
        for (var n in e)
          if (Te.call(e, n))
            return !1;
        return !0;
      }
      function Dh(e, t) {
        return Rr(e, t);
      }
      function Ph(e, t, n) {
        n = typeof n == "function" ? n : r;
        var i = n ? n(e, t) : r;
        return i === r ? Rr(e, t, r, n) : !!i;
      }
      function ia(e) {
        if (!We(e))
          return !1;
        var t = nt(e);
        return t == qn || t == $n || typeof e.message == "string" && typeof e.name == "string" && !Pr(e);
      }
      function Wh(e) {
        return typeof e == "number" && As(e);
      }
      function nn(e) {
        if (!Oe(e))
          return !1;
        var t = nt(e);
        return t == Sn || t == yr || t == xr || t == Xi;
      }
      function V0(e) {
        return typeof e == "number" && e == de(e);
      }
      function Pi(e) {
        return typeof e == "number" && e > -1 && e % 1 == 0 && e <= _e;
      }
      function Oe(e) {
        var t = typeof e;
        return e != null && (t == "object" || t == "function");
      }
      function We(e) {
        return e != null && typeof e == "object";
      }
      var Y0 = os ? mt(os) : Ud;
      function zh(e, t) {
        return e === t || Bo(e, t, Ko(t));
      }
      function Hh(e, t, n) {
        return n = typeof n == "function" ? n : r, Bo(e, t, Ko(t), n);
      }
      function Uh(e) {
        return $0(e) && e != +e;
      }
      function Gh(e) {
        if (Cf(e))
          throw new ce(d);
        return Ds(e);
      }
      function Vh(e) {
        return e === null;
      }
      function Yh(e) {
        return e == null;
      }
      function $0(e) {
        return typeof e == "number" || We(e) && nt(e) == Ht;
      }
      function Pr(e) {
        if (!We(e) || nt(e) != bt)
          return !1;
        var t = di(e);
        if (t === null)
          return !0;
        var n = Te.call(t, "constructor") && t.constructor;
        return typeof n == "function" && n instanceof n && si.call(n) == zu;
      }
      var oa = as ? mt(as) : Gd;
      function $h(e) {
        return V0(e) && e >= -_e && e <= _e;
      }
      var q0 = ss ? mt(ss) : Vd;
      function Wi(e) {
        return typeof e == "string" || !ue(e) && We(e) && nt(e) == En;
      }
      function xt(e) {
        return typeof e == "symbol" || We(e) && nt(e) == Tn;
      }
      var sr = ls ? mt(ls) : Yd;
      function qh(e) {
        return e === r;
      }
      function Kh(e) {
        return We(e) && je(e) == Qt;
      }
      function Qh(e) {
        return We(e) && nt(e) == Ji;
      }
      var Xh = Ii(Ro), Jh = Ii(function(e, t) {
        return e <= t;
      });
      function K0(e) {
        if (!e)
          return [];
        if (lt(e))
          return Wi(e) ? Nt(e) : st(e);
        if (Sr && e[Sr])
          return Tu(e[Sr]());
        var t = je(e), n = t == ht ? bo : t == tt ? ii : lr;
        return n(e);
      }
      function rn(e) {
        if (!e)
          return e === 0 ? e : 0;
        if (e = It(e), e === se || e === -se) {
          var t = e < 0 ? -1 : 1;
          return t * at;
        }
        return e === e ? e : 0;
      }
      function de(e) {
        var t = rn(e), n = t % 1;
        return t === t ? n ? t - n : t : 0;
      }
      function Q0(e) {
        return e ? Dn(de(e), 0, he) : 0;
      }
      function It(e) {
        if (typeof e == "number")
          return e;
        if (xt(e))
          return ft;
        if (Oe(e)) {
          var t = typeof e.valueOf == "function" ? e.valueOf() : e;
          e = Oe(t) ? t + "" : t;
        }
        if (typeof e != "string")
          return e === 0 ? e : +e;
        e = ps(e);
        var n = jr.test(e);
        return n || Rc.test(e) ? du(e.slice(2), n ? 2 : 8) : un.test(e) ? ft : +e;
      }
      function X0(e) {
        return Vt(e, ct(e));
      }
      function jh(e) {
        return e ? Dn(de(e), -_e, _e) : e === 0 ? e : 0;
      }
      function Se(e) {
        return e == null ? "" : gt(e);
      }
      var Zh = ir(function(e, t) {
        if (Or(t) || lt(t)) {
          Vt(t, $e(t), e);
          return;
        }
        for (var n in t)
          Te.call(t, n) && Fr(e, n, t[n]);
      }), J0 = ir(function(e, t) {
        Vt(t, ct(t), e);
      }), zi = ir(function(e, t, n, i) {
        Vt(t, ct(t), e, i);
      }), ep = ir(function(e, t, n, i) {
        Vt(t, $e(t), e, i);
      }), tp = en(Co);
      function np(e, t) {
        var n = rr(e);
        return t == null ? n : Is(n, t);
      }
      var rp = pe(function(e, t) {
        e = Ie(e);
        var n = -1, i = t.length, c = i > 2 ? t[2] : r;
        for (c && rt(t[0], t[1], c) && (i = 1); ++n < i; )
          for (var h = t[n], y = ct(h), w = -1, S = y.length; ++w < S; ) {
            var D = y[w], W = e[D];
            (W === r || Mt(W, er[D]) && !Te.call(e, D)) && (e[D] = h[D]);
          }
        return e;
      }), ip = pe(function(e) {
        return e.push(r, p0), pt(j0, r, e);
      });
      function op(e, t) {
        return us(e, re(t, 3), Gt);
      }
      function ap(e, t) {
        return us(e, re(t, 3), To);
      }
      function sp(e, t) {
        return e == null ? e : Eo(e, re(t, 3), ct);
      }
      function lp(e, t) {
        return e == null ? e : Ms(e, re(t, 3), ct);
      }
      function cp(e, t) {
        return e && Gt(e, re(t, 3));
      }
      function up(e, t) {
        return e && To(e, re(t, 3));
      }
      function dp(e) {
        return e == null ? [] : wi(e, $e(e));
      }
      function fp(e) {
        return e == null ? [] : wi(e, ct(e));
      }
      function aa(e, t, n) {
        var i = e == null ? r : Pn(e, t);
        return i === r ? n : i;
      }
      function hp(e, t) {
        return e != null && x0(e, t, Ld);
      }
      function sa(e, t) {
        return e != null && x0(e, t, Od);
      }
      var pp = c0(function(e, t, n) {
        t != null && typeof t.toString != "function" && (t = li.call(t)), e[t] = n;
      }, ca(ut)), mp = c0(function(e, t, n) {
        t != null && typeof t.toString != "function" && (t = li.call(t)), Te.call(e, t) ? e[t].push(n) : e[t] = [n];
      }, re), gp = pe(Nr);
      function $e(e) {
        return lt(e) ? Es(e) : No(e);
      }
      function ct(e) {
        return lt(e) ? Es(e, !0) : $d(e);
      }
      function xp(e, t) {
        var n = {};
        return t = re(t, 3), Gt(e, function(i, c, h) {
          jt(n, t(i, c, h), i);
        }), n;
      }
      function yp(e, t) {
        var n = {};
        return t = re(t, 3), Gt(e, function(i, c, h) {
          jt(n, c, t(i, c, h));
        }), n;
      }
      var vp = ir(function(e, t, n) {
        ki(e, t, n);
      }), j0 = ir(function(e, t, n, i) {
        ki(e, t, n, i);
      }), bp = en(function(e, t) {
        var n = {};
        if (e == null)
          return n;
        var i = !1;
        t = Ne(t, function(h) {
          return h = xn(h, e), i || (i = h.length > 1), h;
        }), Vt(e, $o(e), n), i && (n = Ct(n, v | A | C, pf));
        for (var c = t.length; c--; )
          Po(n, t[c]);
        return n;
      });
      function wp(e, t) {
        return Z0(e, Di(re(t)));
      }
      var kp = en(function(e, t) {
        return e == null ? {} : Kd(e, t);
      });
      function Z0(e, t) {
        if (e == null)
          return {};
        var n = Ne($o(e), function(i) {
          return [i];
        });
        return t = re(t), Vs(e, n, function(i, c) {
          return t(i, c[0]);
        });
      }
      function _p(e, t, n) {
        t = xn(t, e);
        var i = -1, c = t.length;
        for (c || (c = 1, e = r); ++i < c; ) {
          var h = e == null ? r : e[Yt(t[i])];
          h === r && (i = c, h = n), e = nn(h) ? h.call(e) : h;
        }
        return e;
      }
      function Ap(e, t, n) {
        return e == null ? e : Mr(e, t, n);
      }
      function Sp(e, t, n, i) {
        return i = typeof i == "function" ? i : r, e == null ? e : Mr(e, t, n, i);
      }
      var el = f0($e), tl = f0(ct);
      function Cp(e, t, n) {
        var i = ue(e), c = i || vn(e) || sr(e);
        if (t = re(t, 4), n == null) {
          var h = e && e.constructor;
          c ? n = i ? new h() : [] : Oe(e) ? n = nn(h) ? rr(di(e)) : {} : n = {};
        }
        return (c ? _t : Gt)(e, function(y, w, S) {
          return t(n, y, w, S);
        }), n;
      }
      function Ep(e, t) {
        return e == null ? !0 : Po(e, t);
      }
      function Tp(e, t, n) {
        return e == null ? e : Qs(e, t, Ho(n));
      }
      function Ip(e, t, n, i) {
        return i = typeof i == "function" ? i : r, e == null ? e : Qs(e, t, Ho(n), i);
      }
      function lr(e) {
        return e == null ? [] : vo(e, $e(e));
      }
      function Fp(e) {
        return e == null ? [] : vo(e, ct(e));
      }
      function Bp(e, t, n) {
        return n === r && (n = t, t = r), n !== r && (n = It(n), n = n === n ? n : 0), t !== r && (t = It(t), t = t === t ? t : 0), Dn(It(e), t, n);
      }
      function Np(e, t, n) {
        return t = rn(t), n === r ? (n = t, t = 0) : n = rn(n), e = It(e), Dd(e, t, n);
      }
      function Rp(e, t, n) {
        if (n && typeof n != "boolean" && rt(e, t, n) && (t = n = r), n === r && (typeof t == "boolean" ? (n = t, t = r) : typeof e == "boolean" && (n = e, e = r)), e === r && t === r ? (e = 0, t = 1) : (e = rn(e), t === r ? (t = e, e = 0) : t = rn(t)), e > t) {
          var i = e;
          e = t, t = i;
        }
        if (n || e % 1 || t % 1) {
          var c = Ss();
          return Je(e + c * (t - e + uu("1e-" + ((c + "").length - 1))), t);
        }
        return Lo(e, t);
      }
      var Mp = or(function(e, t, n) {
        return t = t.toLowerCase(), e + (n ? nl(t) : t);
      });
      function nl(e) {
        return la(Se(e).toLowerCase());
      }
      function rl(e) {
        return e = Se(e), e && e.replace(Lc, _u).replace(eu, "");
      }
      function Lp(e, t, n) {
        e = Se(e), t = gt(t);
        var i = e.length;
        n = n === r ? i : Dn(de(n), 0, i);
        var c = n;
        return n -= t.length, n >= 0 && e.slice(n, c) == t;
      }
      function Op(e) {
        return e = Se(e), e && Zi.test(e) ? e.replace(_r, Au) : e;
      }
      function Dp(e) {
        return e = Se(e), e && G.test(e) ? e.replace(b, "\\$&") : e;
      }
      var Pp = or(function(e, t, n) {
        return e + (n ? "-" : "") + t.toLowerCase();
      }), Wp = or(function(e, t, n) {
        return e + (n ? " " : "") + t.toLowerCase();
      }), zp = a0("toLowerCase");
      function Hp(e, t, n) {
        e = Se(e), t = de(t);
        var i = t ? jn(e) : 0;
        if (!t || i >= t)
          return e;
        var c = (t - i) / 2;
        return Ti(mi(c), n) + e + Ti(pi(c), n);
      }
      function Up(e, t, n) {
        e = Se(e), t = de(t);
        var i = t ? jn(e) : 0;
        return t && i < t ? e + Ti(t - i, n) : e;
      }
      function Gp(e, t, n) {
        e = Se(e), t = de(t);
        var i = t ? jn(e) : 0;
        return t && i < t ? Ti(t - i, n) + e : e;
      }
      function Vp(e, t, n) {
        return n || t == null ? t = 0 : t && (t = +t), Xu(Se(e).replace(Q, ""), t || 0);
      }
      function Yp(e, t, n) {
        return (n ? rt(e, t, n) : t === r) ? t = 1 : t = de(t), Oo(Se(e), t);
      }
      function $p() {
        var e = arguments, t = Se(e[0]);
        return e.length < 3 ? t : t.replace(e[1], e[2]);
      }
      var qp = or(function(e, t, n) {
        return e + (n ? "_" : "") + t.toLowerCase();
      });
      function Kp(e, t, n) {
        return n && typeof n != "number" && rt(e, t, n) && (t = n = r), n = n === r ? he : n >>> 0, n ? (e = Se(e), e && (typeof t == "string" || t != null && !oa(t)) && (t = gt(t), !t && Jn(e)) ? yn(Nt(e), 0, n) : e.split(t, n)) : [];
      }
      var Qp = or(function(e, t, n) {
        return e + (n ? " " : "") + la(t);
      });
      function Xp(e, t, n) {
        return e = Se(e), n = n == null ? 0 : Dn(de(n), 0, e.length), t = gt(t), e.slice(n, n + t.length) == t;
      }
      function Jp(e, t, n) {
        var i = f.templateSettings;
        n && rt(e, t, n) && (t = r), e = Se(e), t = zi({}, t, i, h0);
        var c = zi({}, t.imports, i.imports, h0), h = $e(c), y = vo(c, h), w, S, D = 0, W = t.interpolate || Zr, H = "__p += '", K = wo(
          (t.escape || Zr).source + "|" + W.source + "|" + (W === Jr ? Pe : Zr).source + "|" + (t.evaluate || Zr).source + "|$",
          "g"
        ), Z = "//# sourceURL=" + (Te.call(t, "sourceURL") ? (t.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++ou + "]") + `
`;
        e.replace(K, function(oe, xe, we, yt, it, vt) {
          return we || (we = yt), H += e.slice(D, vt).replace(Oc, Su), xe && (w = !0, H += `' +
__e(` + xe + `) +
'`), it && (S = !0, H += `';
` + it + `;
__p += '`), we && (H += `' +
((__t = (` + we + `)) == null ? '' : __t) +
'`), D = vt + oe.length, oe;
        }), H += `';
`;
        var ie = Te.call(t, "variable") && t.variable;
        if (!ie)
          H = `with (obj) {
` + H + `
}
`;
        else if (qe.test(ie))
          throw new ce(p);
        H = (S ? H.replace($r, "") : H).replace(ji, "$1").replace(qr, "$1;"), H = "function(" + (ie || "obj") + `) {
` + (ie ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (w ? ", __e = _.escape" : "") + (S ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + H + `return __p
}`;
        var fe = ol(function() {
          return Ae(h, Z + "return " + H).apply(r, y);
        });
        if (fe.source = H, ia(fe))
          throw fe;
        return fe;
      }
      function jp(e) {
        return Se(e).toLowerCase();
      }
      function Zp(e) {
        return Se(e).toUpperCase();
      }
      function em(e, t, n) {
        if (e = Se(e), e && (n || t === r))
          return ps(e);
        if (!e || !(t = gt(t)))
          return e;
        var i = Nt(e), c = Nt(t), h = ms(i, c), y = gs(i, c) + 1;
        return yn(i, h, y).join("");
      }
      function tm(e, t, n) {
        if (e = Se(e), e && (n || t === r))
          return e.slice(0, ys(e) + 1);
        if (!e || !(t = gt(t)))
          return e;
        var i = Nt(e), c = gs(i, Nt(t)) + 1;
        return yn(i, 0, c).join("");
      }
      function nm(e, t, n) {
        if (e = Se(e), e && (n || t === r))
          return e.replace(Q, "");
        if (!e || !(t = gt(t)))
          return e;
        var i = Nt(e), c = ms(i, Nt(t));
        return yn(i, c).join("");
      }
      function rm(e, t) {
        var n = X, i = te;
        if (Oe(t)) {
          var c = "separator" in t ? t.separator : c;
          n = "length" in t ? de(t.length) : n, i = "omission" in t ? gt(t.omission) : i;
        }
        e = Se(e);
        var h = e.length;
        if (Jn(e)) {
          var y = Nt(e);
          h = y.length;
        }
        if (n >= h)
          return e;
        var w = n - jn(i);
        if (w < 1)
          return i;
        var S = y ? yn(y, 0, w).join("") : e.slice(0, w);
        if (c === r)
          return S + i;
        if (y && (w += S.length - w), oa(c)) {
          if (e.slice(w).search(c)) {
            var D, W = S;
            for (c.global || (c = wo(c.source, Se(wt.exec(c)) + "g")), c.lastIndex = 0; D = c.exec(W); )
              var H = D.index;
            S = S.slice(0, H === r ? w : H);
          }
        } else if (e.indexOf(gt(c), w) != w) {
          var K = S.lastIndexOf(c);
          K > -1 && (S = S.slice(0, K));
        }
        return S + i;
      }
      function im(e) {
        return e = Se(e), e && Qr.test(e) ? e.replace(Kr, Nu) : e;
      }
      var om = or(function(e, t, n) {
        return e + (n ? " " : "") + t.toUpperCase();
      }), la = a0("toUpperCase");
      function il(e, t, n) {
        return e = Se(e), t = n ? r : t, t === r ? Eu(e) ? Lu(e) : yu(e) : e.match(t) || [];
      }
      var ol = pe(function(e, t) {
        try {
          return pt(e, r, t);
        } catch (n) {
          return ia(n) ? n : new ce(n);
        }
      }), am = en(function(e, t) {
        return _t(t, function(n) {
          n = Yt(n), jt(e, n, na(e[n], e));
        }), e;
      });
      function sm(e) {
        var t = e == null ? 0 : e.length, n = re();
        return e = t ? Ne(e, function(i) {
          if (typeof i[1] != "function")
            throw new At(m);
          return [n(i[0]), i[1]];
        }) : [], pe(function(i) {
          for (var c = -1; ++c < t; ) {
            var h = e[c];
            if (pt(h[0], this, i))
              return pt(h[1], this, i);
          }
        });
      }
      function lm(e) {
        return Nd(Ct(e, v));
      }
      function ca(e) {
        return function() {
          return e;
        };
      }
      function cm(e, t) {
        return e == null || e !== e ? t : e;
      }
      var um = l0(), dm = l0(!0);
      function ut(e) {
        return e;
      }
      function ua(e) {
        return Ps(typeof e == "function" ? e : Ct(e, v));
      }
      function fm(e) {
        return zs(Ct(e, v));
      }
      function hm(e, t) {
        return Hs(e, Ct(t, v));
      }
      var pm = pe(function(e, t) {
        return function(n) {
          return Nr(n, e, t);
        };
      }), mm = pe(function(e, t) {
        return function(n) {
          return Nr(e, n, t);
        };
      });
      function da(e, t, n) {
        var i = $e(t), c = wi(t, i);
        n == null && !(Oe(t) && (c.length || !i.length)) && (n = t, t = e, e = this, c = wi(t, $e(t)));
        var h = !(Oe(n) && "chain" in n) || !!n.chain, y = nn(e);
        return _t(c, function(w) {
          var S = t[w];
          e[w] = S, y && (e.prototype[w] = function() {
            var D = this.__chain__;
            if (h || D) {
              var W = e(this.__wrapped__), H = W.__actions__ = st(this.__actions__);
              return H.push({ func: S, args: arguments, thisArg: e }), W.__chain__ = D, W;
            }
            return S.apply(e, fn([this.value()], arguments));
          });
        }), e;
      }
      function gm() {
        return Ke._ === this && (Ke._ = Hu), this;
      }
      function fa() {
      }
      function xm(e) {
        return e = de(e), pe(function(t) {
          return Us(t, e);
        });
      }
      var ym = Go(Ne), vm = Go(cs), bm = Go(po);
      function al(e) {
        return Xo(e) ? mo(Yt(e)) : Qd(e);
      }
      function wm(e) {
        return function(t) {
          return e == null ? r : Pn(e, t);
        };
      }
      var km = u0(), _m = u0(!0);
      function ha() {
        return [];
      }
      function pa() {
        return !1;
      }
      function Am() {
        return {};
      }
      function Sm() {
        return "";
      }
      function Cm() {
        return !0;
      }
      function Em(e, t) {
        if (e = de(e), e < 1 || e > _e)
          return [];
        var n = he, i = Je(e, he);
        t = re(t), e -= he;
        for (var c = yo(i, t); ++n < e; )
          t(n);
        return c;
      }
      function Tm(e) {
        return ue(e) ? Ne(e, Yt) : xt(e) ? [e] : st(C0(Se(e)));
      }
      function Im(e) {
        var t = ++Wu;
        return Se(e) + t;
      }
      var Fm = Ei(function(e, t) {
        return e + t;
      }, 0), Bm = Vo("ceil"), Nm = Ei(function(e, t) {
        return e / t;
      }, 1), Rm = Vo("floor");
      function Mm(e) {
        return e && e.length ? bi(e, ut, Io) : r;
      }
      function Lm(e, t) {
        return e && e.length ? bi(e, re(t, 2), Io) : r;
      }
      function Om(e) {
        return fs(e, ut);
      }
      function Dm(e, t) {
        return fs(e, re(t, 2));
      }
      function Pm(e) {
        return e && e.length ? bi(e, ut, Ro) : r;
      }
      function Wm(e, t) {
        return e && e.length ? bi(e, re(t, 2), Ro) : r;
      }
      var zm = Ei(function(e, t) {
        return e * t;
      }, 1), Hm = Vo("round"), Um = Ei(function(e, t) {
        return e - t;
      }, 0);
      function Gm(e) {
        return e && e.length ? xo(e, ut) : 0;
      }
      function Vm(e, t) {
        return e && e.length ? xo(e, re(t, 2)) : 0;
      }
      return f.after = fh, f.ary = D0, f.assign = Zh, f.assignIn = J0, f.assignInWith = zi, f.assignWith = ep, f.at = tp, f.before = P0, f.bind = na, f.bindAll = am, f.bindKey = W0, f.castArray = Ah, f.chain = M0, f.chunk = Rf, f.compact = Mf, f.concat = Lf, f.cond = sm, f.conforms = lm, f.constant = ca, f.countBy = G1, f.create = np, f.curry = z0, f.curryRight = H0, f.debounce = U0, f.defaults = rp, f.defaultsDeep = ip, f.defer = hh, f.delay = ph, f.difference = Of, f.differenceBy = Df, f.differenceWith = Pf, f.drop = Wf, f.dropRight = zf, f.dropRightWhile = Hf, f.dropWhile = Uf, f.fill = Gf, f.filter = Y1, f.flatMap = K1, f.flatMapDeep = Q1, f.flatMapDepth = X1, f.flatten = F0, f.flattenDeep = Vf, f.flattenDepth = Yf, f.flip = mh, f.flow = um, f.flowRight = dm, f.fromPairs = $f, f.functions = dp, f.functionsIn = fp, f.groupBy = J1, f.initial = Kf, f.intersection = Qf, f.intersectionBy = Xf, f.intersectionWith = Jf, f.invert = pp, f.invertBy = mp, f.invokeMap = Z1, f.iteratee = ua, f.keyBy = eh, f.keys = $e, f.keysIn = ct, f.map = Mi, f.mapKeys = xp, f.mapValues = yp, f.matches = fm, f.matchesProperty = hm, f.memoize = Oi, f.merge = vp, f.mergeWith = j0, f.method = pm, f.methodOf = mm, f.mixin = da, f.negate = Di, f.nthArg = xm, f.omit = bp, f.omitBy = wp, f.once = gh, f.orderBy = th, f.over = ym, f.overArgs = xh, f.overEvery = vm, f.overSome = bm, f.partial = ra, f.partialRight = G0, f.partition = nh, f.pick = kp, f.pickBy = Z0, f.property = al, f.propertyOf = wm, f.pull = t1, f.pullAll = N0, f.pullAllBy = n1, f.pullAllWith = r1, f.pullAt = i1, f.range = km, f.rangeRight = _m, f.rearg = yh, f.reject = oh, f.remove = o1, f.rest = vh, f.reverse = ea, f.sampleSize = sh, f.set = Ap, f.setWith = Sp, f.shuffle = lh, f.slice = a1, f.sortBy = dh, f.sortedUniq = h1, f.sortedUniqBy = p1, f.split = Kp, f.spread = bh, f.tail = m1, f.take = g1, f.takeRight = x1, f.takeRightWhile = y1, f.takeWhile = v1, f.tap = M1, f.throttle = wh, f.thru = Ri, f.toArray = K0, f.toPairs = el, f.toPairsIn = tl, f.toPath = Tm, f.toPlainObject = X0, f.transform = Cp, f.unary = kh, f.union = b1, f.unionBy = w1, f.unionWith = k1, f.uniq = _1, f.uniqBy = A1, f.uniqWith = S1, f.unset = Ep, f.unzip = ta, f.unzipWith = R0, f.update = Tp, f.updateWith = Ip, f.values = lr, f.valuesIn = Fp, f.without = C1, f.words = il, f.wrap = _h, f.xor = E1, f.xorBy = T1, f.xorWith = I1, f.zip = F1, f.zipObject = B1, f.zipObjectDeep = N1, f.zipWith = R1, f.entries = el, f.entriesIn = tl, f.extend = J0, f.extendWith = zi, da(f, f), f.add = Fm, f.attempt = ol, f.camelCase = Mp, f.capitalize = nl, f.ceil = Bm, f.clamp = Bp, f.clone = Sh, f.cloneDeep = Eh, f.cloneDeepWith = Th, f.cloneWith = Ch, f.conformsTo = Ih, f.deburr = rl, f.defaultTo = cm, f.divide = Nm, f.endsWith = Lp, f.eq = Mt, f.escape = Op, f.escapeRegExp = Dp, f.every = V1, f.find = $1, f.findIndex = T0, f.findKey = op, f.findLast = q1, f.findLastIndex = I0, f.findLastKey = ap, f.floor = Rm, f.forEach = L0, f.forEachRight = O0, f.forIn = sp, f.forInRight = lp, f.forOwn = cp, f.forOwnRight = up, f.get = aa, f.gt = Fh, f.gte = Bh, f.has = hp, f.hasIn = sa, f.head = B0, f.identity = ut, f.includes = j1, f.indexOf = qf, f.inRange = Np, f.invoke = gp, f.isArguments = Hn, f.isArray = ue, f.isArrayBuffer = Nh, f.isArrayLike = lt, f.isArrayLikeObject = ze, f.isBoolean = Rh, f.isBuffer = vn, f.isDate = Mh, f.isElement = Lh, f.isEmpty = Oh, f.isEqual = Dh, f.isEqualWith = Ph, f.isError = ia, f.isFinite = Wh, f.isFunction = nn, f.isInteger = V0, f.isLength = Pi, f.isMap = Y0, f.isMatch = zh, f.isMatchWith = Hh, f.isNaN = Uh, f.isNative = Gh, f.isNil = Yh, f.isNull = Vh, f.isNumber = $0, f.isObject = Oe, f.isObjectLike = We, f.isPlainObject = Pr, f.isRegExp = oa, f.isSafeInteger = $h, f.isSet = q0, f.isString = Wi, f.isSymbol = xt, f.isTypedArray = sr, f.isUndefined = qh, f.isWeakMap = Kh, f.isWeakSet = Qh, f.join = jf, f.kebabCase = Pp, f.last = Tt, f.lastIndexOf = Zf, f.lowerCase = Wp, f.lowerFirst = zp, f.lt = Xh, f.lte = Jh, f.max = Mm, f.maxBy = Lm, f.mean = Om, f.meanBy = Dm, f.min = Pm, f.minBy = Wm, f.stubArray = ha, f.stubFalse = pa, f.stubObject = Am, f.stubString = Sm, f.stubTrue = Cm, f.multiply = zm, f.nth = e1, f.noConflict = gm, f.noop = fa, f.now = Li, f.pad = Hp, f.padEnd = Up, f.padStart = Gp, f.parseInt = Vp, f.random = Rp, f.reduce = rh, f.reduceRight = ih, f.repeat = Yp, f.replace = $p, f.result = _p, f.round = Hm, f.runInContext = _, f.sample = ah, f.size = ch, f.snakeCase = qp, f.some = uh, f.sortedIndex = s1, f.sortedIndexBy = l1, f.sortedIndexOf = c1, f.sortedLastIndex = u1, f.sortedLastIndexBy = d1, f.sortedLastIndexOf = f1, f.startCase = Qp, f.startsWith = Xp, f.subtract = Um, f.sum = Gm, f.sumBy = Vm, f.template = Jp, f.times = Em, f.toFinite = rn, f.toInteger = de, f.toLength = Q0, f.toLower = jp, f.toNumber = It, f.toSafeInteger = jh, f.toString = Se, f.toUpper = Zp, f.trim = em, f.trimEnd = tm, f.trimStart = nm, f.truncate = rm, f.unescape = im, f.uniqueId = Im, f.upperCase = om, f.upperFirst = la, f.each = L0, f.eachRight = O0, f.first = B0, da(f, function() {
        var e = {};
        return Gt(f, function(t, n) {
          Te.call(f.prototype, n) || (e[n] = t);
        }), e;
      }(), { chain: !1 }), f.VERSION = l, _t(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(e) {
        f[e].placeholder = f;
      }), _t(["drop", "take"], function(e, t) {
        be.prototype[e] = function(n) {
          n = n === r ? 1 : Ve(de(n), 0);
          var i = this.__filtered__ && !t ? new be(this) : this.clone();
          return i.__filtered__ ? i.__takeCount__ = Je(n, i.__takeCount__) : i.__views__.push({
            size: Je(n, he),
            type: e + (i.__dir__ < 0 ? "Right" : "")
          }), i;
        }, be.prototype[e + "Right"] = function(n) {
          return this.reverse()[e](n).reverse();
        };
      }), _t(["filter", "map", "takeWhile"], function(e, t) {
        var n = t + 1, i = n == j || n == ve;
        be.prototype[e] = function(c) {
          var h = this.clone();
          return h.__iteratees__.push({
            iteratee: re(c, 3),
            type: n
          }), h.__filtered__ = h.__filtered__ || i, h;
        };
      }), _t(["head", "last"], function(e, t) {
        var n = "take" + (t ? "Right" : "");
        be.prototype[e] = function() {
          return this[n](1).value()[0];
        };
      }), _t(["initial", "tail"], function(e, t) {
        var n = "drop" + (t ? "" : "Right");
        be.prototype[e] = function() {
          return this.__filtered__ ? new be(this) : this[n](1);
        };
      }), be.prototype.compact = function() {
        return this.filter(ut);
      }, be.prototype.find = function(e) {
        return this.filter(e).head();
      }, be.prototype.findLast = function(e) {
        return this.reverse().find(e);
      }, be.prototype.invokeMap = pe(function(e, t) {
        return typeof e == "function" ? new be(this) : this.map(function(n) {
          return Nr(n, e, t);
        });
      }), be.prototype.reject = function(e) {
        return this.filter(Di(re(e)));
      }, be.prototype.slice = function(e, t) {
        e = de(e);
        var n = this;
        return n.__filtered__ && (e > 0 || t < 0) ? new be(n) : (e < 0 ? n = n.takeRight(-e) : e && (n = n.drop(e)), t !== r && (t = de(t), n = t < 0 ? n.dropRight(-t) : n.take(t - e)), n);
      }, be.prototype.takeRightWhile = function(e) {
        return this.reverse().takeWhile(e).reverse();
      }, be.prototype.toArray = function() {
        return this.take(he);
      }, Gt(be.prototype, function(e, t) {
        var n = /^(?:filter|find|map|reject)|While$/.test(t), i = /^(?:head|last)$/.test(t), c = f[i ? "take" + (t == "last" ? "Right" : "") : t], h = i || /^find/.test(t);
        c && (f.prototype[t] = function() {
          var y = this.__wrapped__, w = i ? [1] : arguments, S = y instanceof be, D = w[0], W = S || ue(y), H = function(xe) {
            var we = c.apply(f, fn([xe], w));
            return i && K ? we[0] : we;
          };
          W && n && typeof D == "function" && D.length != 1 && (S = W = !1);
          var K = this.__chain__, Z = !!this.__actions__.length, ie = h && !K, fe = S && !Z;
          if (!h && W) {
            y = fe ? y : new be(this);
            var oe = e.apply(y, w);
            return oe.__actions__.push({ func: Ri, args: [H], thisArg: r }), new St(oe, K);
          }
          return ie && fe ? e.apply(this, w) : (oe = this.thru(H), ie ? i ? oe.value()[0] : oe.value() : oe);
        });
      }), _t(["pop", "push", "shift", "sort", "splice", "unshift"], function(e) {
        var t = oi[e], n = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru", i = /^(?:pop|shift)$/.test(e);
        f.prototype[e] = function() {
          var c = arguments;
          if (i && !this.__chain__) {
            var h = this.value();
            return t.apply(ue(h) ? h : [], c);
          }
          return this[n](function(y) {
            return t.apply(ue(y) ? y : [], c);
          });
        };
      }), Gt(be.prototype, function(e, t) {
        var n = f[t];
        if (n) {
          var i = n.name + "";
          Te.call(nr, i) || (nr[i] = []), nr[i].push({ name: t, func: n });
        }
      }), nr[Ci(r, I).name] = [{
        name: "wrapper",
        func: r
      }], be.prototype.clone = rd, be.prototype.reverse = id, be.prototype.value = od, f.prototype.at = L1, f.prototype.chain = O1, f.prototype.commit = D1, f.prototype.next = P1, f.prototype.plant = z1, f.prototype.reverse = H1, f.prototype.toJSON = f.prototype.valueOf = f.prototype.value = U1, f.prototype.first = f.prototype.head, Sr && (f.prototype[Sr] = W1), f;
    }, Zn = Ou();
    Rn ? ((Rn.exports = Zn)._ = Zn, co._ = Zn) : Ke._ = Zn;
  }).call(zr);
})(Ki, Ki.exports);
var m2 = Ki.exports;
const g2 = (a, o, r, l) => {
  const [u, d] = Y(0), [m, p] = Y({}), [g, x] = Y(a), [k, v] = Y({}), [A, C] = Y(!1), [T, F] = Y(!0), [E, I] = Y(o), [z, R] = Y([]), [P, U] = Y(!1), [q, B] = Y(!1), [M, V] = Y(0), [X, te] = Y(!1), [ne, $] = Y(0);
  return {
    activeStepIndex: u,
    formData: m,
    numberOfSteps: g,
    currentErrors: k,
    isStepForward: T,
    showWarningModalForDeletion: A,
    submitBttnTextContent: E,
    customErrors: z,
    isSubmitButtonDisabled: P,
    isStepProcessing: q,
    lastStepIndex: M,
    isStepAnimationFinished: X,
    keepValues: r,
    stepToIndex: ne,
    setStepToIndex: $,
    onFinishFunc: l,
    setIsStepAnimationFinished: te,
    setLastStepIndex: V,
    setIsStepProcessing: B,
    setIsSubmitButtonDisabled: U,
    addCustomError: (se, _e) => {
      R((at) => [...at, { name: se, errorMsg: _e }]);
    },
    removeCustomError: (se) => {
      R((_e) => _e.filter((at) => at.name !== se));
    },
    setSubmitBttnTextContent: I,
    setShowWarningModalForDeletion: C,
    setIsStepForward: F,
    setCurrentErrors: v,
    setNumberOfSteps: x,
    setActiveStepIndex: d,
    setFormData: p
  };
}, x2 = () => ({
  activeStepIndex: 0,
  formData: {},
  numberOfSteps: 1,
  currentErrors: {},
  isStepForward: !1,
  showWarningModalForDeletion: !1,
  submitBttnTextContent: "Befejezés",
  customErrors: [],
  isSubmitButtonDisabled: !1,
  isStepProcessing: !1,
  lastStepIndex: 0,
  isStepAnimationFinished: !1,
  keepValues: !0,
  stepToIndex: 0,
  setStepToIndex: () => {
  },
  onFinishFunc: () => {
  },
  setIsStepAnimationFinished: () => {
  },
  setLastStepIndex: () => {
  },
  setIsStepProcessing: () => {
  },
  setIsSubmitButtonDisabled: () => {
  },
  addCustomError: () => {
  },
  removeCustomError: () => {
  },
  setSubmitBttnTextContent: () => {
  },
  setShowWarningModalForDeletion: () => {
  },
  setIsStepForward: () => {
  },
  setCurrentErrors: () => {
  },
  setNumberOfSteps: () => {
  },
  setFormData: () => {
  },
  setActiveStepIndex: () => {
  }
}), Sc = m2.once(() => dt(x2())), An = () => Ot(Sc()), y2 = ({ children: a, step: o }) => {
  const { activeStepIndex: r, setIsStepAnimationFinished: l } = An(), [u, d] = Y(!1), m = {
    fade: {
      position: "absolute",
      opacity: 0,
      x: "-200%",
      scale: 0,
      transition: {
        opacity: {
          duration: 0.2
        },
        x: {
          duration: 0.1,
          delay: 0.5
        },
        scale: {
          duration: 0.5
        },
        duration: 0.5
      },
      transitionEnd: {
        display: "none"
      }
    },
    slideInitial: {
      opacity: 0,
      x: "200%",
      display: "none",
      transition: {
        duration: 0.2
      }
    },
    slide: {
      position: "relative",
      display: "grid",
      opacity: 1,
      scale: 1,
      left: "50%",
      x: "-50%",
      transition: {
        opacity: {
          duration: 0.1
        },
        position: {
          delay: 0.3
        },
        duration: 0.3
      }
    }
  };
  return /* @__PURE__ */ s(et, { children: /* @__PURE__ */ s(ye.div, {
    initial: "slideInitial",
    animate: r === o ? "slide" : "fade",
    variants: m,
    onAnimationStart: () => {
      l(!1), d(!0);
    },
    onAnimationComplete: () => {
      r === o ? (console.log("%c ANIMATION COMPLETE", "color: yellow"), l(!0), d(!0)) : setTimeout(() => {
        d(!1);
      }, 200);
    },
    className: "form-grid-container relative top-0 grid w-[95%] max-w-[var(--max-form-w)] gap-y-6 self-center",
    children: u ? a : null
  }) });
}, v2 = ({ children: a }) => {
  const { activeStepIndex: o, numberOfSteps: r, currentErrors: l, setCurrentErrors: u, setActiveStepIndex: d, setIsStepForward: m, showWarningModalForDeletion: p, setShowWarningModalForDeletion: g, setLastStepIndex: x, stepToIndex: k, setStepToIndex: v, keepValues: A } = An(), C = Re(null), [T, F] = Y(!1);
  ee(() => {
    u({});
    const R = new IntersectionObserver(([P]) => P.target.classList.toggle("ActiveStepperContainer", P.intersectionRatio < 1), {
      threshold: [1]
    });
    return C.current && R.observe(C.current), () => {
      R.disconnect();
    };
  }, [C]);
  const E = an((R) => new Promise((P) => {
    setTimeout(P, R);
  }), []), I = an(async (R) => {
    if (R <= o && R !== o) {
      m(!1);
      for (let P = o - R; P >= R; P--)
        await z(P), await E(300);
    } else
      R > o && F(!0);
  }, [o]), z = an(async (R) => {
    setTimeout(() => {
      x(R + 1), d(R);
    }, 20);
  }, []);
  return r > 1 ? /* @__PURE__ */ O(Ue, { children: [
    p && /* @__PURE__ */ s(Xl, {
      openModal: p ? "default" : void 0,
      setOpenModal: () => {
        document.body.style.overflow = "auto", g(!1);
      },
      onConfirm: () => {
        document.body.style.overflow = "auto", I(k);
      },
      header: "Űrlap Adatok Törlése",
      text: "Szeretne biztosan visszalépni, az aktuális űrlap adatai törlödni fognak!"
    }),
    /* @__PURE__ */ O("div", {
      ref: C,
      className: "StepperContainer -top-1 left-0 z-10 flex min-h-[62px] w-full justify-center",
      "data-testid": "stepper-container",
      children: [
        /* @__PURE__ */ s(dc, {
          selectorName: ".MultiStepForm-SubmitButton",
          whenTriggered: T,
          whenRerender: T,
          whenFinished: () => {
            F(!1);
          }
        }),
        /* @__PURE__ */ O("div", { className: "stepper-inner-grid w-full max-w-[var(--max-form-w)] px-1 md:px-3", children: [
          /* @__PURE__ */ s("div", { className: "empty-stepper-inner-grid-l" }),
          /* @__PURE__ */ s("div", { className: "self-center pl-2 pr-5 xl:pl-0 2xl:pr-3", children: /* @__PURE__ */ s(Pg, { activeStep: o, children: kn.toArray(a).map((R, P) => {
            const { title: U } = R.props, q = {};
            return o === P && Object.keys(l).length > 0 && (q.optional = /* @__PURE__ */ s(Hr, { variant: "caption", color: "error" }), q.error = !0), /* @__PURE__ */ s(Wg, {
              className: "cursor-pointer",
              onClick: () => {
                !A && P <= o && P !== o ? (v(P), g(!0)) : A && (v(P), I(P));
              },
              children: /* @__PURE__ */ s(zg, { ...q, children: U })
            }, U);
          }) }) }),
          /* @__PURE__ */ s("div", { className: "empty-stepper-inner-grid-r" })
        ] })
      ]
    })
  ] }) : /* @__PURE__ */ s(Ue, {});
}, b2 = "4.8.0", w2 = {
  g: "LottieFiles AE ",
  a: "",
  k: "",
  d: "",
  tc: ""
}, k2 = 30, _2 = 0, A2 = 31, S2 = 800, C2 = 200, E2 = "Loading Files", T2 = 0, I2 = [], F2 = [
  {
    ddd: 0,
    ind: 1,
    ty: 4,
    nm: "Search",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.97,
              y: 1
            },
            o: {
              x: 0.69,
              y: 0
            },
            t: 0,
            s: [
              351.535,
              97.918,
              0
            ],
            to: [
              6,
              -17,
              0
            ],
            ti: [
              11,
              14.25,
              0
            ]
          },
          {
            t: 30,
            s: [
              351.535,
              99.418,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          352.535,
          96.918,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    16.521,
                    -0.045
                  ],
                  [
                    -0.013,
                    -34.356
                  ],
                  [
                    -34.356,
                    0.012
                  ],
                  [
                    0.011,
                    34.356
                  ],
                  [
                    11.651,
                    11.659
                  ]
                ],
                o: [
                  [
                    -34.356,
                    0.012
                  ],
                  [
                    0.011,
                    34.356
                  ],
                  [
                    34.356,
                    -0.013
                  ],
                  [
                    -6e-3,
                    -16.483
                  ],
                  [
                    -11.651,
                    -11.715
                  ]
                ],
                v: [
                  [
                    -0.089,
                    -62.489
                  ],
                  [
                    -62.274,
                    -0.26
                  ],
                  [
                    -0.046,
                    61.927
                  ],
                  [
                    62.142,
                    -0.304
                  ],
                  [
                    43.936,
                    -44.254
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 1",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ind: 1,
            ty: "sh",
            ix: 2,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    9.639,
                    0.013
                  ],
                  [
                    -0.054,
                    41.136
                  ],
                  [
                    -41.136,
                    -0.054
                  ],
                  [
                    0.054,
                    -41.137
                  ],
                  [
                    28.059,
                    -11.391
                  ]
                ],
                o: [
                  [
                    -41.136,
                    -0.054
                  ],
                  [
                    0.054,
                    -41.137
                  ],
                  [
                    41.136,
                    0.055
                  ],
                  [
                    -0.039,
                    30.282
                  ],
                  [
                    -8.929,
                    3.626
                  ]
                ],
                v: [
                  [
                    -0.098,
                    74.485
                  ],
                  [
                    -74.484,
                    -0.097
                  ],
                  [
                    0.098,
                    -74.485
                  ],
                  [
                    74.484,
                    0.098
                  ],
                  [
                    28.019,
                    69.014
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 2",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.792156875134,
                0.807843148708,
                0.835294127464,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: !1
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                383.401,
                89.476
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "Transform"
          }
        ],
        nm: "Subtraction 48",
        np: 3,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: !1
      },
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    2.999,
                    -2.999
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    2.999,
                    2.999
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    2.999,
                    2.999
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -2.999,
                    2.999
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    -25.254,
                    -8.902
                  ],
                  [
                    -8.902,
                    -25.254
                  ],
                  [
                    -8.902,
                    -25.254
                  ],
                  [
                    23.005,
                    6.653
                  ],
                  [
                    23.005,
                    17.514
                  ],
                  [
                    17.514,
                    23.005
                  ],
                  [
                    6.653,
                    23.005
                  ],
                  [
                    -25.254,
                    -8.902
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 1",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.713725507259,
                0.733333349228,
                0.768627464771,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: !1
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                446.9,
                153.591
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "Transform"
          }
        ],
        nm: "Rectangle 4757",
        np: 2,
        cix: 2,
        bm: 0,
        ix: 2,
        mn: "ADBE Vector Group",
        hd: !1
      }
    ],
    ip: 0,
    op: 510,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 2,
    ty: 4,
    nm: "Files 5",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.24
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.172
              ]
            },
            t: 0,
            s: [
              0
            ]
          },
          {
            t: 30,
            s: [
              50
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.24,
              y: 1
            },
            o: {
              x: 0.167,
              y: 0.172
            },
            t: 0,
            s: [
              723.194,
              100.918,
              0
            ],
            to: [
              -25.25,
              -0.583,
              0
            ],
            ti: [
              25.25,
              0.583,
              0
            ]
          },
          {
            t: 30,
            s: [
              571.694,
              97.418,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          723.194,
          96.918,
          0
        ],
        ix: 1
      },
      s: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.24,
                0.24,
                0.24
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.167,
                0.167,
                0.167
              ],
              y: [
                0.172,
                0.172,
                11.207
              ]
            },
            t: 0,
            s: [
              100,
              100,
              100
            ]
          },
          {
            t: 30,
            s: [
              165,
              165,
              100
            ]
          }
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.019,
                    -0.326
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.326,
                    -0.019
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.019,
                    0.326
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.326,
                    0.019
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.326,
                    0.019
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.019,
                    0.326
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.326,
                    -0.019
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.019,
                    -0.326
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    -18.935,
                    -8.56
                  ],
                  [
                    -10.273,
                    -8.56
                  ],
                  [
                    -9.669,
                    -7.956
                  ],
                  [
                    -9.669,
                    -5.943
                  ],
                  [
                    -10.273,
                    -5.338
                  ],
                  [
                    -18.935,
                    -5.338
                  ],
                  [
                    -19.54,
                    -5.943
                  ],
                  [
                    -19.54,
                    -7.957
                  ],
                  [
                    -18.935,
                    -8.562
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 1",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ind: 1,
            ty: "sh",
            ix: 2,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.019,
                    -0.326
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.326,
                    -0.019
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.019,
                    0.326
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.326,
                    0.019
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.326,
                    0.019
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.019,
                    0.326
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.326,
                    -0.019
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.019,
                    -0.326
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    -18.935,
                    -0.906
                  ],
                  [
                    18.935,
                    -0.906
                  ],
                  [
                    19.54,
                    -0.301
                  ],
                  [
                    19.54,
                    1.713
                  ],
                  [
                    18.935,
                    2.318
                  ],
                  [
                    -18.935,
                    2.318
                  ],
                  [
                    -19.54,
                    1.713
                  ],
                  [
                    -19.54,
                    -0.302
                  ],
                  [
                    -18.935,
                    -0.907
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 2",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ind: 2,
            ty: "sh",
            ix: 3,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    -0.325,
                    0.019
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.019,
                    -0.326
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.326,
                    -0.019
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.019,
                    0.326
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.326,
                    0.019
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.019,
                    0.326
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.326,
                    -0.019
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.019,
                    -0.325
                  ]
                ],
                v: [
                  [
                    -18.935,
                    5.943
                  ],
                  [
                    18.935,
                    5.943
                  ],
                  [
                    19.54,
                    6.547
                  ],
                  [
                    19.54,
                    8.562
                  ],
                  [
                    18.935,
                    9.166
                  ],
                  [
                    -18.935,
                    9.166
                  ],
                  [
                    -19.54,
                    8.562
                  ],
                  [
                    -19.54,
                    6.546
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 3",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ind: 3,
            ty: "sh",
            ix: 4,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    -0.326,
                    0.019
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.019,
                    -0.326
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.326,
                    -0.019
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.019,
                    0.326
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.326,
                    0.019
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.019,
                    0.326
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.326,
                    -0.019
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.019,
                    -0.326
                  ]
                ],
                v: [
                  [
                    -18.935,
                    12.791
                  ],
                  [
                    -0.604,
                    12.791
                  ],
                  [
                    1e-3,
                    13.396
                  ],
                  [
                    1e-3,
                    15.41
                  ],
                  [
                    -0.604,
                    16.014
                  ],
                  [
                    -18.935,
                    16.014
                  ],
                  [
                    -19.54,
                    15.41
                  ],
                  [
                    -19.54,
                    13.396
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 4",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ind: 4,
            ty: "sh",
            ix: 5,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    -0.326,
                    0.019
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.019,
                    -0.326
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.326,
                    -0.019
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.019,
                    0.326
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.326,
                    0.019
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.019,
                    0.326
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.326,
                    -0.019
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.019,
                    -0.326
                  ]
                ],
                v: [
                  [
                    -18.935,
                    -16.014
                  ],
                  [
                    -6.446,
                    -16.014
                  ],
                  [
                    -5.842,
                    -15.41
                  ],
                  [
                    -5.842,
                    -13.396
                  ],
                  [
                    -6.446,
                    -12.791
                  ],
                  [
                    -18.935,
                    -12.791
                  ],
                  [
                    -19.54,
                    -13.396
                  ],
                  [
                    -19.54,
                    -15.41
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 5",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.698039233685,
                0.75686275959,
                0.819607853889,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: !1
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                723.194,
                96.817
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "Transform"
          }
        ],
        nm: "Path 2951",
        np: 6,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: !1
      },
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    -9.468,
                    -9.468
                  ],
                  [
                    9.468,
                    9.468
                  ],
                  [
                    -9.468,
                    9.468
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 1",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.698039233685,
                0.75686275959,
                0.819607853889,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: !1
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                738.705,
                74.961
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "Transform"
          }
        ],
        nm: "Path 2950",
        np: 2,
        cix: 2,
        bm: 0,
        ix: 2,
        mn: "ADBE Vector Group",
        hd: !1
      },
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    -0.025,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    2.872,
                    -0.021
                  ],
                  [
                    0.025,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.022,
                    2.872
                  ],
                  [
                    0,
                    0.026
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -2.872,
                    0.021
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.021,
                    2.872
                  ],
                  [
                    -0.025,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -2.872,
                    0.022
                  ],
                  [
                    0,
                    -0.026
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.021,
                    -2.872
                  ],
                  [
                    0.025,
                    0
                  ]
                ],
                v: [
                  [
                    -19.64,
                    -31.424
                  ],
                  [
                    5.942,
                    -31.424
                  ],
                  [
                    24.878,
                    -12.489
                  ],
                  [
                    24.878,
                    26.187
                  ],
                  [
                    19.715,
                    31.424
                  ],
                  [
                    19.64,
                    31.424
                  ],
                  [
                    -19.638,
                    31.424
                  ],
                  [
                    -24.878,
                    26.264
                  ],
                  [
                    -24.878,
                    26.187
                  ],
                  [
                    -24.878,
                    -26.187
                  ],
                  [
                    -19.715,
                    -31.424
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 1",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.850980401039,
                0.890196084976,
                0.921568632126,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: !1
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                723.094,
                96.918
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "Transform"
          }
        ],
        nm: "Path 2949",
        np: 2,
        cix: 2,
        bm: 0,
        ix: 3,
        mn: "ADBE Vector Group",
        hd: !1
      }
    ],
    ip: 0,
    op: 510,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 3,
    ty: 4,
    nm: "Files 4",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.24
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.172
              ]
            },
            t: 0,
            s: [
              50
            ]
          },
          {
            t: 30,
            s: [
              100
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.24,
              y: 1
            },
            o: {
              x: 0.167,
              y: 0.172
            },
            t: 0,
            s: [
              570.918,
              96.918,
              0
            ],
            to: [
              -30,
              0,
              0
            ],
            ti: [
              30,
              0,
              0
            ]
          },
          {
            t: 30,
            s: [
              390.918,
              96.918,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          570.918,
          96.918,
          0
        ],
        ix: 1
      },
      s: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.24,
                0.24,
                0.24
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.167,
                0.167,
                0.167
              ],
              y: [
                0.172,
                0.172,
                4.483
              ]
            },
            t: 0,
            s: [
              100,
              100,
              100
            ]
          },
          {
            t: 30,
            s: [
              126,
              126,
              100
            ]
          }
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.032,
                    -0.549
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.549,
                    -0.032
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.032,
                    0.549
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.549,
                    0.032
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.549,
                    0.032
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.032,
                    0.549
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.549,
                    -0.032
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.032,
                    -0.549
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    -31.928,
                    -14.435
                  ],
                  [
                    -17.322,
                    -14.435
                  ],
                  [
                    -16.303,
                    -13.415
                  ],
                  [
                    -16.303,
                    -10.021
                  ],
                  [
                    -17.322,
                    -9.001
                  ],
                  [
                    -31.928,
                    -9.001
                  ],
                  [
                    -32.948,
                    -10.021
                  ],
                  [
                    -32.948,
                    -13.417
                  ],
                  [
                    -31.928,
                    -14.436
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 1",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ind: 1,
            ty: "sh",
            ix: 2,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.032,
                    -0.549
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.549,
                    -0.032
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.032,
                    0.549
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.549,
                    0.032
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.549,
                    0.032
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.032,
                    0.549
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.549,
                    -0.032
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.032,
                    -0.549
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    -31.928,
                    -1.527
                  ],
                  [
                    31.928,
                    -1.527
                  ],
                  [
                    32.948,
                    -0.508
                  ],
                  [
                    32.948,
                    2.889
                  ],
                  [
                    31.928,
                    3.908
                  ],
                  [
                    -31.928,
                    3.908
                  ],
                  [
                    -32.948,
                    2.889
                  ],
                  [
                    -32.948,
                    -0.51
                  ],
                  [
                    -31.928,
                    -1.529
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 2",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ind: 2,
            ty: "sh",
            ix: 3,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    -0.549,
                    0.032
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.032,
                    -0.549
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.549,
                    -0.032
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.032,
                    0.549
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.549,
                    0.032
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.032,
                    0.549
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.549,
                    -0.032
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.033,
                    -0.548
                  ]
                ],
                v: [
                  [
                    -31.928,
                    10.021
                  ],
                  [
                    31.928,
                    10.021
                  ],
                  [
                    32.948,
                    11.04
                  ],
                  [
                    32.948,
                    14.436
                  ],
                  [
                    31.928,
                    15.456
                  ],
                  [
                    -31.928,
                    15.456
                  ],
                  [
                    -32.948,
                    14.436
                  ],
                  [
                    -32.948,
                    11.038
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 3",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ind: 3,
            ty: "sh",
            ix: 4,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    -0.549,
                    0.032
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.032,
                    -0.549
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.549,
                    -0.032
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.032,
                    0.549
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.549,
                    0.032
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.032,
                    0.549
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.549,
                    -0.032
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.032,
                    -0.549
                  ]
                ],
                v: [
                  [
                    -31.928,
                    21.568
                  ],
                  [
                    -1.018,
                    21.568
                  ],
                  [
                    1e-3,
                    22.588
                  ],
                  [
                    1e-3,
                    25.984
                  ],
                  [
                    -1.018,
                    27.004
                  ],
                  [
                    -31.928,
                    27.004
                  ],
                  [
                    -32.948,
                    25.984
                  ],
                  [
                    -32.948,
                    22.588
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 4",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ind: 4,
            ty: "sh",
            ix: 5,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    -0.549,
                    0.032
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.032,
                    -0.549
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.549,
                    -0.032
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.032,
                    0.549
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.549,
                    0.032
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.032,
                    0.549
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.549,
                    -0.032
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.032,
                    -0.549
                  ]
                ],
                v: [
                  [
                    -31.928,
                    -27.004
                  ],
                  [
                    -10.87,
                    -27.004
                  ],
                  [
                    -9.85,
                    -25.984
                  ],
                  [
                    -9.85,
                    -22.588
                  ],
                  [
                    -10.87,
                    -21.568
                  ],
                  [
                    -31.928,
                    -21.568
                  ],
                  [
                    -32.948,
                    -22.588
                  ],
                  [
                    -32.948,
                    -25.984
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 5",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.698039233685,
                0.75686275959,
                0.819607853889,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: !1
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                570.918,
                96.747
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "Transform"
          }
        ],
        nm: "Path 2951",
        np: 6,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: !1
      },
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    -15.965,
                    -15.965
                  ],
                  [
                    15.965,
                    15.965
                  ],
                  [
                    -15.965,
                    15.965
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 1",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.698039233685,
                0.75686275959,
                0.819607853889,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: !1
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                597.073,
                59.895
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "Transform"
          }
        ],
        nm: "Path 2950",
        np: 2,
        cix: 2,
        bm: 0,
        ix: 2,
        mn: "ADBE Vector Group",
        hd: !1
      },
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    -0.042,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    4.843,
                    -0.035
                  ],
                  [
                    0.042,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.037,
                    4.843
                  ],
                  [
                    0,
                    0.043
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -4.843,
                    0.035
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.035,
                    4.843
                  ],
                  [
                    -0.042,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -4.843,
                    0.037
                  ],
                  [
                    0,
                    -0.043
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.035,
                    -4.843
                  ],
                  [
                    0.042,
                    0
                  ]
                ],
                v: [
                  [
                    -33.117,
                    -52.988
                  ],
                  [
                    10.02,
                    -52.988
                  ],
                  [
                    41.949,
                    -21.059
                  ],
                  [
                    41.949,
                    44.156
                  ],
                  [
                    33.243,
                    52.988
                  ],
                  [
                    33.117,
                    52.988
                  ],
                  [
                    -33.113,
                    52.988
                  ],
                  [
                    -41.949,
                    44.286
                  ],
                  [
                    -41.949,
                    44.156
                  ],
                  [
                    -41.949,
                    -44.156
                  ],
                  [
                    -33.243,
                    -52.988
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 1",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.850980401039,
                0.890196084976,
                0.921568632126,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: !1
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                570.748,
                96.918
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "Transform"
          }
        ],
        nm: "Path 2949",
        np: 2,
        cix: 2,
        bm: 0,
        ix: 3,
        mn: "ADBE Vector Group",
        hd: !1
      }
    ],
    ip: 0,
    op: 510,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 4,
    ty: 4,
    nm: "Files 3",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.24
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.172
              ]
            },
            t: 0,
            s: [
              100
            ]
          },
          {
            t: 30,
            s: [
              50
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.24,
              y: 1
            },
            o: {
              x: 0.167,
              y: 0.172
            },
            t: 0,
            s: [
              390.535,
              96.918,
              0
            ],
            to: [
              -30,
              0,
              0
            ],
            ti: [
              30,
              0,
              0
            ]
          },
          {
            t: 30,
            s: [
              210.535,
              96.918,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          390.535,
          96.918,
          0
        ],
        ix: 1
      },
      s: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.24,
                0.24,
                0.24
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.167,
                0.167,
                0.167
              ],
              y: [
                0.172,
                0.172,
                -3.793
              ]
            },
            t: 0,
            s: [
              100,
              100,
              100
            ]
          },
          {
            t: 30,
            s: [
              78,
              78,
              100
            ]
          }
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.04,
                    -0.692
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.692,
                    -0.04
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.04,
                    0.692
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.692,
                    0.04
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.692,
                    0.04
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.04,
                    0.692
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.692,
                    -0.04
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.04,
                    -0.692
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    -40.242,
                    -18.193
                  ],
                  [
                    -21.833,
                    -18.193
                  ],
                  [
                    -20.548,
                    -16.908
                  ],
                  [
                    -20.548,
                    -12.63
                  ],
                  [
                    -21.833,
                    -11.345
                  ],
                  [
                    -40.242,
                    -11.345
                  ],
                  [
                    -41.526,
                    -12.63
                  ],
                  [
                    -41.526,
                    -16.911
                  ],
                  [
                    -40.242,
                    -18.195
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 1",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ind: 1,
            ty: "sh",
            ix: 2,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.04,
                    -0.692
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.692,
                    -0.04
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.04,
                    0.692
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.692,
                    0.04
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.692,
                    0.04
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.04,
                    0.692
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.692,
                    -0.04
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.04,
                    -0.692
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    -40.242,
                    -1.925
                  ],
                  [
                    40.242,
                    -1.925
                  ],
                  [
                    41.526,
                    -0.64
                  ],
                  [
                    41.526,
                    3.641
                  ],
                  [
                    40.242,
                    4.926
                  ],
                  [
                    -40.242,
                    4.926
                  ],
                  [
                    -41.526,
                    3.641
                  ],
                  [
                    -41.526,
                    -0.642
                  ],
                  [
                    -40.242,
                    -1.927
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 2",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ind: 2,
            ty: "sh",
            ix: 3,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    -0.691,
                    0.04
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.04,
                    -0.692
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.692,
                    -0.04
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.04,
                    0.692
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.692,
                    0.04
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.04,
                    0.692
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.692,
                    -0.04
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.041,
                    -0.691
                  ]
                ],
                v: [
                  [
                    -40.242,
                    12.63
                  ],
                  [
                    40.242,
                    12.63
                  ],
                  [
                    41.526,
                    13.914
                  ],
                  [
                    41.526,
                    18.195
                  ],
                  [
                    40.242,
                    19.48
                  ],
                  [
                    -40.242,
                    19.48
                  ],
                  [
                    -41.526,
                    18.195
                  ],
                  [
                    -41.526,
                    13.912
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 3",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ind: 3,
            ty: "sh",
            ix: 4,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    -0.692,
                    0.04
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.04,
                    -0.692
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.692,
                    -0.04
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.04,
                    0.692
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.692,
                    0.04
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.04,
                    0.692
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.692,
                    -0.04
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.04,
                    -0.692
                  ]
                ],
                v: [
                  [
                    -40.242,
                    27.184
                  ],
                  [
                    -1.284,
                    27.184
                  ],
                  [
                    1e-3,
                    28.469
                  ],
                  [
                    1e-3,
                    32.75
                  ],
                  [
                    -1.284,
                    34.035
                  ],
                  [
                    -40.242,
                    34.035
                  ],
                  [
                    -41.526,
                    32.75
                  ],
                  [
                    -41.526,
                    28.469
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 4",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ind: 4,
            ty: "sh",
            ix: 5,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    -0.692,
                    0.04
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.04,
                    -0.692
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.692,
                    -0.04
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.04,
                    0.692
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.692,
                    0.04
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.04,
                    0.692
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.692,
                    -0.04
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.04,
                    -0.692
                  ]
                ],
                v: [
                  [
                    -40.242,
                    -34.035
                  ],
                  [
                    -13.7,
                    -34.035
                  ],
                  [
                    -12.415,
                    -32.75
                  ],
                  [
                    -12.415,
                    -28.469
                  ],
                  [
                    -13.7,
                    -27.184
                  ],
                  [
                    -40.242,
                    -27.184
                  ],
                  [
                    -41.526,
                    -28.469
                  ],
                  [
                    -41.526,
                    -32.75
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 5",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.698039233685,
                0.75686275959,
                0.819607853889,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: !1
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                390.534,
                96.702
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "Transform"
          }
        ],
        nm: "Path 2951",
        np: 6,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: !1
      },
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    -20.121,
                    -20.121
                  ],
                  [
                    20.121,
                    20.121
                  ],
                  [
                    -20.121,
                    20.121
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 1",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.698039233685,
                0.75686275959,
                0.819607853889,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: !1
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                423.5,
                50.255
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "Transform"
          }
        ],
        nm: "Path 2950",
        np: 2,
        cix: 2,
        bm: 0,
        ix: 2,
        mn: "ADBE Vector Group",
        hd: !1
      },
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    -0.053,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    6.104,
                    -0.044
                  ],
                  [
                    0.053,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.047,
                    6.104
                  ],
                  [
                    0,
                    0.055
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -6.104,
                    0.044
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.044,
                    6.104
                  ],
                  [
                    -0.053,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -6.104,
                    0.047
                  ],
                  [
                    0,
                    -0.055
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.044,
                    -6.104
                  ],
                  [
                    0.053,
                    0
                  ]
                ],
                v: [
                  [
                    -41.74,
                    -66.785
                  ],
                  [
                    12.628,
                    -66.785
                  ],
                  [
                    52.871,
                    -26.542
                  ],
                  [
                    52.871,
                    55.653
                  ],
                  [
                    41.899,
                    66.785
                  ],
                  [
                    41.74,
                    66.785
                  ],
                  [
                    -41.735,
                    66.785
                  ],
                  [
                    -52.871,
                    55.817
                  ],
                  [
                    -52.871,
                    55.653
                  ],
                  [
                    -52.871,
                    -55.653
                  ],
                  [
                    -41.899,
                    -66.785
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 1",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.850980401039,
                0.890196084976,
                0.921568632126,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: !1
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                390.321,
                96.918
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "Transform"
          }
        ],
        nm: "Path 2949",
        np: 2,
        cix: 2,
        bm: 0,
        ix: 3,
        mn: "ADBE Vector Group",
        hd: !1
      }
    ],
    ip: 0,
    op: 510,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 5,
    ty: 4,
    nm: "Files 2",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.24
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.172
              ]
            },
            t: 0,
            s: [
              50
            ]
          },
          {
            t: 30,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.24,
              y: 1
            },
            o: {
              x: 0.167,
              y: 0.172
            },
            t: 0,
            s: [
              210.152,
              96.918,
              0
            ],
            to: [
              -22,
              0,
              0
            ],
            ti: [
              22,
              0,
              0
            ]
          },
          {
            t: 30,
            s: [
              78.151,
              96.918,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          210.152,
          96.918,
          0
        ],
        ix: 1
      },
      s: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.24,
                0.24,
                0.24
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.167,
                0.167,
                0.167
              ],
              y: [
                0.172,
                0.172,
                -6.897
              ]
            },
            t: 0,
            s: [
              100,
              100,
              100
            ]
          },
          {
            t: 30,
            s: [
              60,
              60,
              100
            ]
          }
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.032,
                    -0.549
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.549,
                    -0.032
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.032,
                    0.549
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.549,
                    0.032
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.549,
                    0.032
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.032,
                    0.549
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.549,
                    -0.032
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.032,
                    -0.549
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    -31.928,
                    -14.435
                  ],
                  [
                    -17.322,
                    -14.435
                  ],
                  [
                    -16.303,
                    -13.415
                  ],
                  [
                    -16.303,
                    -10.021
                  ],
                  [
                    -17.322,
                    -9.001
                  ],
                  [
                    -31.928,
                    -9.001
                  ],
                  [
                    -32.948,
                    -10.021
                  ],
                  [
                    -32.948,
                    -13.417
                  ],
                  [
                    -31.928,
                    -14.436
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 1",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ind: 1,
            ty: "sh",
            ix: 2,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.032,
                    -0.549
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.549,
                    -0.032
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.032,
                    0.549
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.549,
                    0.032
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.549,
                    0.032
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.032,
                    0.549
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.549,
                    -0.032
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.032,
                    -0.549
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    -31.928,
                    -1.527
                  ],
                  [
                    31.928,
                    -1.527
                  ],
                  [
                    32.948,
                    -0.508
                  ],
                  [
                    32.948,
                    2.889
                  ],
                  [
                    31.928,
                    3.908
                  ],
                  [
                    -31.928,
                    3.908
                  ],
                  [
                    -32.948,
                    2.889
                  ],
                  [
                    -32.948,
                    -0.51
                  ],
                  [
                    -31.928,
                    -1.529
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 2",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ind: 2,
            ty: "sh",
            ix: 3,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    -0.549,
                    0.032
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.032,
                    -0.549
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.549,
                    -0.032
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.032,
                    0.549
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.549,
                    0.032
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.032,
                    0.549
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.549,
                    -0.032
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.033,
                    -0.548
                  ]
                ],
                v: [
                  [
                    -31.928,
                    10.021
                  ],
                  [
                    31.928,
                    10.021
                  ],
                  [
                    32.948,
                    11.04
                  ],
                  [
                    32.948,
                    14.436
                  ],
                  [
                    31.928,
                    15.456
                  ],
                  [
                    -31.928,
                    15.456
                  ],
                  [
                    -32.948,
                    14.436
                  ],
                  [
                    -32.948,
                    11.038
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 3",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ind: 3,
            ty: "sh",
            ix: 4,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    -0.549,
                    0.032
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.032,
                    -0.549
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.549,
                    -0.032
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.032,
                    0.549
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.549,
                    0.032
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.032,
                    0.549
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.549,
                    -0.032
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.032,
                    -0.549
                  ]
                ],
                v: [
                  [
                    -31.928,
                    21.568
                  ],
                  [
                    -1.018,
                    21.568
                  ],
                  [
                    1e-3,
                    22.588
                  ],
                  [
                    1e-3,
                    25.984
                  ],
                  [
                    -1.018,
                    27.004
                  ],
                  [
                    -31.928,
                    27.004
                  ],
                  [
                    -32.948,
                    25.984
                  ],
                  [
                    -32.948,
                    22.588
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 4",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ind: 4,
            ty: "sh",
            ix: 5,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    -0.549,
                    0.032
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.032,
                    -0.549
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.549,
                    -0.032
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.032,
                    0.549
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.549,
                    0.032
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.032,
                    0.549
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.549,
                    -0.032
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.032,
                    -0.549
                  ]
                ],
                v: [
                  [
                    -31.928,
                    -27.004
                  ],
                  [
                    -10.87,
                    -27.004
                  ],
                  [
                    -9.85,
                    -25.984
                  ],
                  [
                    -9.85,
                    -22.588
                  ],
                  [
                    -10.87,
                    -21.568
                  ],
                  [
                    -31.928,
                    -21.568
                  ],
                  [
                    -32.948,
                    -22.588
                  ],
                  [
                    -32.948,
                    -25.984
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 5",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.698039233685,
                0.75686275959,
                0.819607853889,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: !1
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                210.151,
                96.747
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "Transform"
          }
        ],
        nm: "Path 2951",
        np: 6,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: !1
      },
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    -15.965,
                    -15.965
                  ],
                  [
                    15.965,
                    15.965
                  ],
                  [
                    -15.965,
                    15.965
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 1",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.698039233685,
                0.75686275959,
                0.819607853889,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: !1
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                236.306,
                59.895
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "Transform"
          }
        ],
        nm: "Path 2950",
        np: 2,
        cix: 2,
        bm: 0,
        ix: 2,
        mn: "ADBE Vector Group",
        hd: !1
      },
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    -0.042,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    4.843,
                    -0.035
                  ],
                  [
                    0.042,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.037,
                    4.843
                  ],
                  [
                    0,
                    0.043
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -4.843,
                    0.035
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.035,
                    4.843
                  ],
                  [
                    -0.042,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -4.843,
                    0.037
                  ],
                  [
                    0,
                    -0.043
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.035,
                    -4.843
                  ],
                  [
                    0.042,
                    0
                  ]
                ],
                v: [
                  [
                    -33.117,
                    -52.988
                  ],
                  [
                    10.02,
                    -52.988
                  ],
                  [
                    41.949,
                    -21.059
                  ],
                  [
                    41.949,
                    44.156
                  ],
                  [
                    33.243,
                    52.988
                  ],
                  [
                    33.117,
                    52.988
                  ],
                  [
                    -33.113,
                    52.988
                  ],
                  [
                    -41.949,
                    44.286
                  ],
                  [
                    -41.949,
                    44.156
                  ],
                  [
                    -41.949,
                    -44.156
                  ],
                  [
                    -33.243,
                    -52.988
                  ]
                ],
                c: !0
              },
              ix: 2
            },
            nm: "Path 1",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.850980401039,
                0.890196084976,
                0.921568632126,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: !1
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                209.981,
                96.918
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "Transform"
          }
        ],
        nm: "Path 2949",
        np: 2,
        cix: 2,
        bm: 0,
        ix: 3,
        mn: "ADBE Vector Group",
        hd: !1
      }
    ],
    ip: 0,
    op: 510,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 7,
    ty: 1,
    nm: "BG",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          400,
          100,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          400,
          100,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    sw: 800,
    sh: 200,
    sc: "#ffffff",
    ip: 0,
    op: 510,
    st: 0,
    bm: 0
  }
], B2 = [], N2 = {
  v: b2,
  meta: w2,
  fr: k2,
  ip: _2,
  op: A2,
  w: S2,
  h: C2,
  nm: E2,
  ddd: T2,
  assets: I2,
  layers: F2,
  markers: B2
}, R2 = {
  initial: {
    opacity: 0
  },
  animate: {
    opacity: 1,
    transition: {
      duration: 0.2
    }
  }
}, M2 = () => {
  function a() {
    document.body.style.overflow = "hidden";
  }
  function o() {
    document.body.style.overflow = "auto";
  }
  return ee(() => (a(), () => {
    o();
  }), []), /* @__PURE__ */ s(ye.div, {
    initial: "initial",
    animate: "animate",
    variants: R2,
    exit: { opacity: 0 },
    "data-testid": "form-loader",
    className: "fixed left-0 right-0 top-0 z-50 flex h-screen items-center justify-center overflow-y-auto overflow-x-hidden bg-gray-900 bg-opacity-50 dark:bg-opacity-80 md:inset-0 md:h-full",
    children: /* @__PURE__ */ O("div", { className: "StepLoader relative flex h-auto max-h-[300px] w-[95%] max-w-[300px] flex-col justify-center gap-5 self-center rounded-lg bg-white px-5 py-10 text-base font-normal text-gray-600 shadow dark:bg-gray-700", children: [
      /* @__PURE__ */ s(wa, { className: "w-[100%] max-w-[500px] self-center", animationData: N2 }),
      /* @__PURE__ */ s("span", { className: "self-center", children: "Adatok Feldolgozása" })
    ] })
  });
}, L2 = () => {
  const { isStepProcessing: a } = An();
  return /* @__PURE__ */ s(et, { initial: !1, children: a && /* @__PURE__ */ s(M2, {}) });
}, Lv = ({ children: a, title: o, showPageLoader: r = !1, isLoading: l = !1, onFinish: u, submitButtonTextContent: d = "Befejezés", keepInputValues: m = !1, styleSheet: p = {}, onClose: g }) => {
  const x = "multi-step-form", k = {
    ".DefaultBorder": {
      borderLeftColor: "rgb(249 250 251)"
    },
    ".ErrorBorder": {
      borderLeftColor: "rgb(240 82 82)"
    },
    ".SuccessBorder": {
      borderLeftColor: "rgb(49 196 141)"
    }
  }, v = Sc();
  return ee(() => {
    const A = _a(x);
    return Object.entries(k).forEach(([C, T]) => {
      Gn(A, C, T);
    }), Object.entries(p).forEach(([C, T]) => {
      Gn(A, C, T);
    }), () => {
      const C = document.getElementById(x);
      C && document.head.removeChild(C);
    };
  }, []), /* @__PURE__ */ O(La, { className: "p-0 sm:p-0 md:p-0 xl:p-0 2xl:p-0", children: [
    r && /* @__PURE__ */ s(p2, { isLoading: l }),
    /* @__PURE__ */ s(v.Provider, {
      value: g2(kn.toArray(a).length, d, m, u),
      children: /* @__PURE__ */ O("div", { className: "grid h-full gap-2", children: [
        /* @__PURE__ */ s("div", { className: "header-content flex h-auto w-full justify-center gap-6", children: /* @__PURE__ */ O("div", { className: "header-content-inner-grid grid w-full max-w-[var(--max-form-w)]", children: [
          /* @__PURE__ */ s("div", {}),
          /* @__PURE__ */ O(Ma, {
            noSidenav: !0,
            path: ["Minták", "Minta csoportok", "Minta csoport hozzáadása"],
            label: o,
            children: [
              /* @__PURE__ */ s("span", { className: "flex-grow-1 flex" }),
              /* @__PURE__ */ s(ye.button, {
                whileHover: {
                  scale: 0.9,
                  transition: {
                    duration: 0.1
                  }
                },
                whileTap: { scale: 0.8 },
                onClick: () => g(),
                className: "cursor-pointer",
                "aria-label": "form-close-bttn",
                type: "button",
                children: /* @__PURE__ */ s(vx, {})
              })
            ]
          }),
          /* @__PURE__ */ s("div", {})
        ] }) }),
        /* @__PURE__ */ s(v2, { children: a }),
        /* @__PURE__ */ s(L2, {}),
        /* @__PURE__ */ s("div", { className: "relative h-max w-full", children: /* @__PURE__ */ s(et, { initial: !1, children: kn.map(a, (A, C) => /* @__PURE__ */ s(y2, { step: C, children: Ll(A, {
          currentIndex: C
        }) })) }) })
      ] })
    })
  ] });
}, O2 = () => {
  const { submitForm: a, isSubmitting: o, isValidating: r } = Wl(), [l, u] = Y(!1), { numberOfSteps: d, activeStepIndex: m, setShowWarningModalForDeletion: p, submitBttnTextContent: g, isSubmitButtonDisabled: x, setStepToIndex: k, keepValues: v, setLastStepIndex: A, setIsStepForward: C, setActiveStepIndex: T } = An(), F = () => {
    A(m), C(!1), T((I) => I - 1);
  }, E = Ze(() => {
    u(r);
  }, 100);
  return ee(() => (E(), () => {
    E.cancel();
  }), [r]), /* @__PURE__ */ s(Ue, { children: /* @__PURE__ */ O("div", { className: "button-grid-container button-grid-center m-auto grid w-full max-w-[var(--max-form-w)] items-center px-2", children: [
    /* @__PURE__ */ s("div", { className: "button-content-blank-l" }),
    /* @__PURE__ */ s("div", { className: "flex", children: m !== 0 ? /* @__PURE__ */ s("button", {
      "data-testid": "multi-step-form-back-button",
      className: "MultiStepForm-BackButton capitalize",
      "aria-label": "multi-step-form-back-bttn",
      type: "button",
      onClick: () => {
        v ? F() : p(!0), k(m - 1);
      },
      children: "Vissza"
    }) : null }),
    /* @__PURE__ */ s("div", { className: "flex justify-end", children: /* @__PURE__ */ s($t, {
      "data-testid": "multi-step-form-submit-button",
      className: "MultiStepForm-SubmitButton",
      type: "submit",
      disabled: o || l || x,
      isProcessing: o || l,
      onClick: () => {
        a();
      },
      children: m < d - 1 ? "Következő" : g
    }) }),
    /* @__PURE__ */ s("div", { className: "button-content-blank-r" })
  ] }) });
};
class D2 {
  constructor(o) {
    Object.defineProperty(this, "props", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.props = o;
  }
}
const Ov = ({ title: a, formValues: o, validationSchema: r, children: l, onComplete: u, currentIndex: d, hideButtonContainer: m = !1 }) => {
  const p = Re(null), { setActiveStepIndex: g, formData: x, setFormData: k, numberOfSteps: v, activeStepIndex: A, setIsStepForward: C, customErrors: T, setIsStepProcessing: F, setLastStepIndex: E, lastStepIndex: I, isStepForward: z, keepValues: R, onFinishFunc: P } = An(), U = an((B) => Object.prototype.toString.call(B) === "[object Object]", []), q = an((B, M) => {
    if (!U(B) || !U(M))
      return {};
    const V = Object.keys(M).length;
    let X = 0;
    const te = {};
    return Object.keys(B).forEach((ne) => {
      Object.keys(M).forEach(($) => {
        ne === $ && (X++, te[ne] = B[ne]);
      });
    }), X == V ? te : {};
  }, []);
  return ee(() => {
    const B = p.current;
    B && B.validateForm();
  }, [T]), ee(() => {
    d === I && !z && !R && k({ ...x, ...o });
  }, [A]), /* @__PURE__ */ s(Ue, { children: /* @__PURE__ */ s(Ta, {
    innerRef: p,
    initialValues: (
      // Check if formData is present and get matched properties from it
      Object.keys(x).length > 0 && Object.keys(q(x, o)).length > 0 ? q(x, o) : new D2(o).props
    ),
    validationSchema: r,
    validateOnChange: !0,
    validateOnMount: !1,
    validateOnBlur: !0,
    validate: () => {
      const B = {};
      return T.forEach((M) => {
        B[M.name] = M.errorMsg;
      }), B;
    },
    onSubmit: (B, M) => {
      C(!0);
      const V = { ...x, ...B };
      k(V), F(!0), u && u(V, M), A === v - 1 && P && P(V, M), A !== v - 1 && setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 500), setTimeout(() => {
        E(A), g((X) => X < v - 1 ? X + 1 : X), M.setSubmitting(!1), F(!1);
      }, 800);
    },
    children: /* @__PURE__ */ s(Ue, { children: /* @__PURE__ */ O("section", {
      "data-title": a,
      id: `${a.replace(/\s/g, "-").toLowerCase()}-form-template`,
      className: "form-content grid gap-10 pb-7",
      children: [
        /* @__PURE__ */ s("div", { className: "FormTemplate grid gap-4", children: l }),
        m ? null : /* @__PURE__ */ s(O2, {})
      ]
    }) })
  }) });
}, P2 = ({ name: a, openedHintsArray: o, isToggleHints: r }) => {
  const [l, u] = Y(a), [d, m] = Y(o), [p, g] = Y(0), [x, k] = Y(r);
  return ee(() => {
    d.filter((v) => v === !0).length === 0 && (k(!0), m(new Array(d.length).fill(!0)));
  }, [d]), {
    formContainerID: l,
    openedHints: d,
    holderHeight: p,
    toggleHints: x,
    setToggleHints: k,
    setHolderHeight: g,
    setOpenedHints: m
  };
}, W2 = {
  formContainerID: "",
  openedHints: [],
  holderHeight: 0,
  toggleHints: !1,
  setToggleHints: () => {
  },
  setOpenedHints: () => {
  },
  setHolderHeight: () => {
  }
}, Cc = dt(W2), z2 = ({ children: a, name: o, openedHintsArray: r, isToggleHints: l }) => /* @__PURE__ */ s(Cc.Provider, {
  value: P2({
    name: o,
    openedHintsArray: r,
    isToggleHints: l
  }),
  children: a
}), mr = () => Ot(Cc), H2 = ({ title: a }) => {
  const { isFormElementLoading: o, hints: r } = Ur(), { toggleHints: l, setToggleHints: u, setOpenedHints: d } = mr();
  return /* @__PURE__ */ O("div", { className: "grid gap-3", children: [
    /* @__PURE__ */ O("div", { className: "flex justify-between", children: [
      o ? /* @__PURE__ */ O("div", { role: "status", className: "w-full animate-pulse self-center", children: [
        /* @__PURE__ */ s("div", { className: "h-[33px] w-[260px] rounded-lg bg-gray-200 dark:bg-gray-700" }),
        /* @__PURE__ */ s("span", { className: "sr-only", children: "Loading..." })
      ] }) : /* @__PURE__ */ s("h1", { className: "SingleFormElementHeaderText self-center text-2xl font-bold text-[#868686]", children: a }),
      r ? o ? /* @__PURE__ */ O("div", { role: "status", className: "animate-pulse", children: [
        /* @__PURE__ */ s("div", { className: "h-[46px] w-[46px] rounded-full bg-gray-200 dark:bg-gray-700" }),
        /* @__PURE__ */ s("span", { className: "sr-only", children: "Loading..." })
      ] }) : /* @__PURE__ */ s(ye.div, {
        onClick: () => {
          u(!l), d(new Array(r.length).fill(!0));
        },
        whileHover: {
          scale: 1.1
        },
        whileTap: { scale: 0.9 },
        whileFocus: { scale: 1.1 },
        transition: {
          type: "spring",
          stiffness: 400,
          damping: 17
        },
        "data-testid": "toggle-hints-button",
        className: "MultiStepForm-HintButton rounded-full p-2 text-2xl text-main md:text-3xl",
        children: l ? /* @__PURE__ */ s(zl, { "data-testid": "hide-hints-icon" }) : /* @__PURE__ */ s(Fa, { "data-testid": "show-hints-icon" })
      }) : null
    ] }),
    /* @__PURE__ */ s("hr", { className: "h-[2px] bg-[#F3EAEA]" })
  ] });
}, U2 = ({ index: a }) => {
  const { openedHints: o } = mr(), [r, l] = Y(o[a]), [u, d] = Y(a);
  return ee(() => {
    l(o[u]);
  }, [o]), { setShowBubble: l, showBubble: r, currentIndex: u };
}, G2 = {
  setShowBubble: () => {
  },
  showBubble: !0,
  currentIndex: 0
}, Ec = dt(G2), V2 = ({ children: a, index: o }) => /* @__PURE__ */ s(Ec.Provider, { value: U2({ index: o }), children: a }), Tc = () => Ot(Ec), Ic = ({ minWidth: a = 768 }) => {
  const [o, r] = Y(!1), [l, u] = Y(0);
  function d() {
    u(window.innerWidth), window.innerWidth > a ? r(!1) : r(!0);
  }
  return ee(() => (d(), window.addEventListener("resize", d), () => {
    window.removeEventListener("resize", d);
  }), []), { isSmallScreen: o, windowWidth: l };
}, Y2 = ({ children: a }) => {
  const { isFullScreen: o, name: r } = Ur(), { isStepAnimationFinished: l } = An(), { isSmallScreen: u } = Ic({ minWidth: 1024 }), [d, m] = me.useState(!1), p = Re(null), { setHolderHeight: g } = mr(), x = () => me.Children.map(a, (k, v) => {
    if (k)
      return /* @__PURE__ */ s(V2, { index: v, children: me.cloneElement(k, {}) });
  });
  return ee(() => {
    const k = document.getElementById(`${r}-form-element`);
    if (p.current && g(p.current.getBoundingClientRect().height), k && !o && !u) {
      const v = k.getBoundingClientRect();
      p.current && (p.current.style.height = `${v.height}px`);
    } else
      p.current && (p.current.style.height = "auto");
  }, [u, o, l]), /* @__PURE__ */ O(Ue, { children: [
    o ? null : /* @__PURE__ */ O(Ue, { children: [
      /* @__PURE__ */ s("div", { className: "fade-scrollbar-top" }),
      /* @__PURE__ */ s("div", { className: "fade-scrollbar-bottom" })
    ] }),
    /* @__PURE__ */ s("div", {
      ref: p,
      onMouseEnter: () => m(!0),
      onMouseLeave: () => m(!1),
      className: `${o || !u && `overflow-x-auto overflow-y-auto pb-2 pt-2 ${d ? "custom-scrollbar-light " : "custom-scrollbar-placeholder"} pr-1`} relative z-[100] flex flex-col max-lg:justify-start max-lg:gap-2 max-[520px]:gap-0 min-[520px]:flex-row lg:flex-col lg:gap-2 ${o ? "" : "lg:pl-4"}`,
      "data-testid": "hint-holder",
      children: x()
    })
  ] });
}, $2 = ({ children: a, pointerPosition: o, disablePointer: r, targetElementID: l, position: u = "bottom", changePositionOnSmallScreen: d = !1, transparentByDefault: m = !0, toggleHints: p }) => {
  const g = Re(null), x = Re(null), { formContainerID: k, openedHints: v } = mr(), { showBubble: A } = Tc(), { isFullScreen: C } = Ur(), { isStepAnimationFinished: T } = An(), { isSmallScreen: F, windowWidth: E } = Ic({ minWidth: 1024 });
  return ee(() => {
    if (l && (F || C)) {
      const I = document.getElementById(l), z = document.getElementById(k), R = I == null ? void 0 : I.getBoundingClientRect(), P = z == null ? void 0 : z.getBoundingClientRect(), U = () => {
        P && R && g.current && (console.log(g.current), console.log(g.current.offsetHeight), console.log(g.current.getBoundingClientRect().height), g.current.style.top = `-${P.height - ((I == null ? void 0 : I.offsetTop) ?? 0) + g.current.offsetHeight + 20}px`, g.current.style.left = `${((I == null ? void 0 : I.offsetLeft) ?? 0) + 6}px`, g.current.style.width = `${R.width}px`);
      }, q = () => {
        P && R && g.current && (g.current.style.top = `-${P.height - ((I == null ? void 0 : I.offsetTop) ?? 0) - ((I == null ? void 0 : I.getBoundingClientRect().height) ?? 0) + 5}px`, g.current.style.left = `${((I == null ? void 0 : I.offsetLeft) ?? 0) + 6}px`, g.current.style.width = `${R.width}px`);
      };
      g.current && R && P && x.current && (g.current.classList.remove("pr-4"), u === "bottom" ? F && d ? (U(), x.current.classList.add("top-pointer"), x.current.classList.remove(`${u}-pointer`)) : (q(), x.current.classList.add(`${u}-pointer`), x.current.classList.remove("top-pointer")) : u === "top" && (F && d ? (q(), x.current.classList.add("bottom-pointer"), x.current.classList.remove(`${u}-pointer`)) : (U(), x.current.classList.add(`${u}-pointer`), x.current.classList.remove("bottom-pointer"))), x.current.classList.remove("default-pointer"));
    } else
      x.current && (g.current.style.top = "unset", g.current.style.left = "unset", g.current.style.width = "auto", F || C ? (x.current.classList.remove("default-pointer"), x.current.classList.add("bottom-pointer")) : (x.current.classList.remove("bottom-pointer"), x.current.classList.add("default-pointer")));
  }, [
    l,
    k,
    g.current,
    x.current,
    F,
    E,
    T,
    v
  ]), /* @__PURE__ */ s(et, { initial: !1, children: !p && A ? /* @__PURE__ */ O(ye.div, {
    initial: { opacity: 0 },
    variants: l && (F || C) && m ? {
      show: {
        opacity: 0.7,
        transition: {
          duration: 0.2,
          delay: 0.5
        }
      }
    } : {
      show: {
        opacity: 1,
        transition: {
          duration: 0.2,
          delay: 0.5
        }
      }
    },
    whileHover: { opacity: 1, scale: 1.02 },
    exit: { opacity: 0 },
    ref: g,
    onMouseOver: () => g.current.style.zIndex = "100",
    onMouseLeave: () => g.current.style.zIndex = "99",
    className: `${l && (F || C) ? "absolute" : "relative"} ${C ? "mt-4 min-w-[165px] max-w-[480px]" : "max-lg:min-w-[165px] max-lg:max-w-[480px]"}  z-[99] w-full max-lg:mt-4`,
    "data-testid": "hint-bubble",
    children: [
      /* @__PURE__ */ s("div", {
        className: "MultiStepForm-HintBubble rounded-2xl border border-gray-200 bg-white p-3 shadow-lg lg:p-4",
        children: /* @__PURE__ */ s("div", { children: a })
      }),
      !r && /* @__PURE__ */ s("div", {
        className: "MultiStepForm-HintBubble-Pointer default-pointer absolute h-3 w-3 rotate-45 bg-white",
        ref: x,
        style: {
          top: `${o || null}px`
        },
        "data-testid": "hint-bubble-pointer"
      })
    ]
  }) : null });
}, q2 = ({ label: a, content: o }) => {
  const { currentIndex: r } = Tc(), { setOpenedHints: l } = mr();
  return /* @__PURE__ */ O("div", { className: "relative flex flex-col items-start", "data-testid": "hint-content", children: [
    /* @__PURE__ */ s(ye.div, {
      onClick: () => {
        l((u) => Object.assign([], { ...u, [r]: !1 }));
      },
      whileHover: {
        scale: 1.1
      },
      whileTap: { scale: 0.9 },
      whileFocus: { scale: 1.1 },
      transition: {
        type: "spring",
        stiffness: 400,
        damping: 17
      },
      "data-testid": "toggle-hint-bubble",
      className: "MultiStepForm-HintButton absolute right-0 top-0 rounded-full text-xl text-main lg:text-2xl",
      children: /* @__PURE__ */ s(Fa, {})
    }),
    /* @__PURE__ */ s("div", { className: "MultiStepForm-HintBubble-Title font-semibold", "data-testid": "hint-content-label", children: a }),
    /* @__PURE__ */ s("div", {
      className: "mt-1 w-full border-t-2 border-t-other-gray pb-1 lg:pb-3",
      "data-testid": "hint-content-divider"
    }),
    /* @__PURE__ */ s("div", {
      className: "MultiStepForm-HintBubble-Content pb-1 text-[13px] lg:pb-3 lg:text-[15px]",
      "data-testid": "hint-content-content",
      children: o
    })
  ] });
}, K2 = () => {
  const { hints: a } = Ur(), { toggleHints: o } = mr(), r = {
    initial: { opacity: 0, y: 10, height: 0 },
    show: {
      display: "block",
      y: 0,
      opacity: 1,
      height: "auto",
      transition: {
        // duration: 0.2,
        delay: 0.2,
        bounce: 0,
        duration: 0.4,
        delayChildren: 0.3,
        staggerChildren: 0.05
      }
    },
    hide: {
      opacity: 0,
      height: 0,
      y: 10,
      transition: {
        when: "afterChildren",
        staggerChildren: 0.2,
        delay: 0.4
      },
      transitionEnd: {}
    }
  };
  return /* @__PURE__ */ s(ye.div, {
    initial: "initial",
    animate: o ? "hide" : "show",
    exit: "hide",
    variants: r,
    className: "relative z-[100]",
    children: /* @__PURE__ */ s(Y2, { children: a == null ? void 0 : a.map((l, u) => {
      const { position: d, content: m, label: p, changePositionOnSmallScreen: g, children: x, targetElementID: k, transparentByDefault: v } = l;
      return /* @__PURE__ */ O($2, {
        position: d,
        changePositionOnSmallScreen: g,
        transparentByDefault: v,
        targetElementID: k,
        toggleHints: o,
        children: [
          /* @__PURE__ */ s(q2, { label: p, content: m }),
          x
        ]
      }, u);
    }) })
  });
}, Dv = ({ title: a = "", children: o, isFullScreen: r = !1, hints: l, showHintsByDefault: u = !1, className: d, turnOffBorderIndicator: m = !1 }) => {
  const { errors: p, touched: g, submitCount: x } = Wl(), { setCurrentErrors: k } = An(), [v, A] = Y([]), C = an((z) => {
    z && z.forEach((R) => {
      R.props.children && Array.isArray(kn.toArray(R.props.children)) && C(kn.toArray(R.props.children));
      const { name: P } = R.props;
      P && (Array.isArray(P) ? P.forEach((U) => {
        A((q) => [...q, U]);
      }) : v.includes(P) || A((U) => [...U, P]));
    });
  }, []), T = Ze(C, 10);
  ee(() => {
    const z = kn.toArray(o);
    return T(z), () => {
      T.cancel();
    };
  }, [o]), ee(() => {
    const z = "[data-error]", R = document.querySelector(z);
    k(R ? p : {});
  }, [p, g]);
  const F = an((z) => Object.prototype.toString.call(z) === "[object Object]", []), E = an((z, R) => {
    if (!F(z) || !Array.isArray(R))
      return {};
    const P = {};
    return Object.keys(z).forEach((U) => {
      R.forEach((q) => {
        U === q && (P[U] = z[U]);
      });
    }), P;
  }, []), I = an((z, R) => {
    if (!F(z) || !F(R))
      return !1;
    const P = {};
    return Object.keys(z).forEach((U) => {
      Object.keys(R).forEach((q) => {
        U === q && (P[U] = z[U]);
      });
    }), P;
  }, []);
  return /* @__PURE__ */ O(Ue, { children: [
    /* @__PURE__ */ s(dc, {
      whenRerender: x,
      selectorName: "[data-error]",
      focusOnParent: !0,
      whenTriggered: x !== 0
    }),
    /* @__PURE__ */ s(e3, {
      hintsParam: l,
      isFormFullScreen: r,
      formName: `${a.replace(/\s+/g, "-").toLowerCase()}`,
      children: /* @__PURE__ */ O("div", { className: `relative grid ${r ? "grid-cols-1" : "form-content-inner "}`, children: [
        /* @__PURE__ */ s("div", { className: "hidden lg:block" }),
        /* @__PURE__ */ O(z2, {
          isToggleHints: !u,
          openedHintsArray: new Array(l == null ? void 0 : l.length).fill(!0),
          name: `${a.replace(/\s+/g, "-").toLowerCase()}-form-element`,
          children: [
            /* @__PURE__ */ O("article", {
              "aria-label": `${a.replace(/\s+/g, "-").toLowerCase()}-form-element`,
              id: `${a.replace(/\s+/g, "-").toLowerCase()}-form-element`,
              className: sn(`delay-30 border-1 SingleFormElement relative grid gap-7 self-start overflow-x-auto overflow-y-hidden rounded-[18px] border-l-8 border-[#E5E7EB] bg-white px-5 pb-10 pt-3 shadow-lg transition-all ease-in-out md:px-7 md:pb-12 md:pt-5 lg:px-10 ${m ? "" : Object.keys(E(g, v)).length ? Object.keys(I(E(p, v), E(g, v))).length ? "ErrorBorder" : Object.keys(E(p, v)).length ? "DefaultBorder" : "SuccessBorder" : "DefaultBorder"}`, d),
              children: [
                a ? /* @__PURE__ */ s(H2, { title: a }) : null,
                /* @__PURE__ */ s(Ia, { className: "grid gap-3", children: o })
              ]
            }),
            /* @__PURE__ */ s(K2, {})
          ]
        })
      ] })
    })
  ] });
}, Pv = () => {
  const [a, o] = me.useState(!1);
  return {
    show: a,
    toggleShow: () => {
      o((l) => !l);
    }
  };
}, Fc = dt(void 0), Wv = ({ children: a, menuItems: o, menuProps: r }) => {
  const [l, u] = Y(null), [d, m] = Y(null), p = () => {
    u(null);
  }, g = (x, k) => {
    x.preventDefault(), u(l === null ? {
      mouseX: x.clientX + 2,
      mouseY: x.clientY - 6
    } : (
      // repeated contextmenu when it is already open closes it with Chrome 84 on Ubuntu
      // Other native context menus might behave different.
      // With this behavior we prevent contextmenu from the backdrop to re-locale existing context menus.
      null
    )), m(k);
  };
  return /* @__PURE__ */ O(Ue, { children: [
    /* @__PURE__ */ s(Yl, {
      "data-testid": "context-menu",
      open: l !== null,
      onClose: p,
      anchorReference: "anchorPosition",
      anchorPosition: l !== null ? { top: l.mouseY, left: l.mouseX } : void 0,
      MenuListProps: {
        dense: !0
      },
      sx: {
        "& .MuiMenu-paper": {
          borderRadius: "8px"
        }
      },
      disableAutoFocusItem: !0,
      variant: "menu",
      ...r,
      children: d && o ? o(d).map((x, k) => /* @__PURE__ */ O($i, {
        "data-testid": "context-menu-item",
        onClick: () => {
          p(), x.onClick();
        },
        ...x.menuItemProps,
        children: [
          x.icon && /* @__PURE__ */ s("div", { className: "mb-1 mr-2 h-5 w-5", children: x.icon }),
          /* @__PURE__ */ s(Hr, { variant: "inherit", paddingRight: 2, noWrap: !0, children: x.label })
        ]
      }, k)) : void 0
    }),
    /* @__PURE__ */ s(Fc.Provider, { value: { handleContextMenu: g, contextMenuData: d }, children: a })
  ] });
}, zv = () => Ot(Fc);
function Hv(a = "user.token", o = !0) {
  _n.interceptors.request.use(async (r) => {
    const l = await localStorage.getItem(a);
    return r.headers = r.headers ?? {}, r.withCredentials = o, l && (r.headers.Authorization = `Bearer ${JSON.parse(l).access}`), r;
  }, (r) => r);
}
function Uv(a, o = "user.token") {
  const r = _n.interceptors.response.use((l) => l, (l) => {
    var u;
    return ((u = l == null ? void 0 : l.response) == null ? void 0 : u.status) === 401 && !l.config.__isRetryRequest ? (_n.interceptors.response.eject(r), Q2(a).then((d) => (localStorage.setItem(o, JSON.stringify(d.data)), l.config.headers.Authorization = "Bearer " + d.data.access, l.config.__isRetryRequest = !0, _n.request(l.config))).catch((d) => Promise.reject(d))) : Promise.reject(l);
  });
}
function Q2(a) {
  return _n.post(`${a}`, null, { withCredentials: !0 });
}
function Gv({ children: a, muiTheme: o, joyTheme: r, flowbiteTheme: l }) {
  const u = Yg(o), d = bx(r);
  return /* @__PURE__ */ s($g, { theme: { [qg]: u }, children: /* @__PURE__ */ s(wx, { theme: { [kx]: d }, children: /* @__PURE__ */ s(jm, { theme: { theme: l }, children: a }) }) });
}
const X2 = Ba(({ className: a, ...o }) => /* @__PURE__ */ s(_x, { ...o, classes: { popper: a } }))(({ theme: a }) => ({
  [`& .${dl.tooltip}`]: {
    backgroundColor: a.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: a.shadows[1],
    fontSize: 11,
    borderRadius: "12px"
  },
  [`& .${dl.arrow}`]: {
    color: a.palette.common.white
  }
})), J2 = ({ direction: a, addButtonProps: o, ...r }) => {
  const l = Na();
  return a === "left" ? (
    /**
     * DIRECTION LEFT
     */
    /* @__PURE__ */ s(cl, {
      "data-testid": "custom-scroll-button-left",
      orientation: "horizontal",
      direction: "left",
      sx: {
        borderInline: "1px solid #eee"
      },
      ...r
    })
  ) : (
    /**
     * DIRECTION RIGHT
     * * Add button is rendered here
     */
    /* @__PURE__ */ O("div", { className: "h-[40px] flex items-center", children: [
      /* @__PURE__ */ s(X2, {
        title: !l && !o.isFull && o.addComponent,
        placement: "bottom-end",
        leaveDelay: 400,
        PopperProps: {
          keepMounted: !0
        },
        enterDelay: 250,
        enterNextDelay: 250,
        arrow: !0,
        children: /* @__PURE__ */ s("span", { children: /* @__PURE__ */ s(Vl, {
          "data-testid": "add-tab-button",
          disabled: o.isFull,
          color: "inherit",
          sx: {
            borderInline: "1px solid #eee",
            margin: 0,
            padding: 0,
            minWidth: "45px"
          },
          onClick: async () => {
            o.onAdd();
          },
          children: /* @__PURE__ */ s(rx, { className: "h-5 w-5 flex-shrink-0" })
        }) })
      }),
      /* @__PURE__ */ s(cl, {
        "data-testid": "custom-scroll-button-right",
        orientation: "horizontal",
        direction: "right",
        className: "h-[40px] bg-green-200",
        sx: {
          borderInline: "1px solid #eee",
          height: "40px"
        },
        ...r
      })
    ] })
  );
}, j2 = Ba(({ addButtonProps: a, ...o }) => /* @__PURE__ */ s(Hg, {
  variant: "scrollable",
  scrollButtons: !0,
  allowScrollButtonsMobile: !0,
  "aria-label": "scrollable force tabs example",
  TabIndicatorProps: {
    children: /* @__PURE__ */ s("span", { className: "MuiTabs-indicatorSpan" })
  },
  ScrollButtonComponent: (r) => /* @__PURE__ */ s(J2, {
    addButtonProps: a,
    ...r
  }),
  TabScrollButtonProps: {
    sx: {
      borderInline: "1px solid #eee"
    }
  },
  ...o
}))({
  "& .MuiTabs-indicator": {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent"
  },
  "& .MuiTabs-indicatorSpan": {
    maxWidth: 0,
    width: "100%",
    backgroundColor: "#000"
  },
  "& .MuiTabs-scrollButtons": {
    height: "40px"
  },
  "& .MuiTabs-scrollButtons.Mui-disabled": {
    opacity: 1,
    color: "rgba(0, 0, 0, 0.26)",
    height: "40px"
  },
  "& .MuiTabs-flexContainer": {
    height: "40px"
  },
  minHeight: "auto",
  height: "40px",
  "& button": {
    borderRight: "1px solid #eee",
    marginRight: 0,
    padding: 0,
    margin: 0,
    height: "40px"
  },
  "& button:hover": {
    backgroundColor: "rgba(243 244 246 / 50%)"
  },
  "& button.Mui-selected": {
    backgroundColor: "rgb(243 244 246)"
  }
}), Z2 = Ba(({ children: a, label: o, width: r, overrideLabel: l, onClose: u, index: d, closable: m, ...p }) => /* @__PURE__ */ s(Ug, {
  disableRipple: !0,
  label: (
    /**
     * if overrideLabel is set, render that instead of the default label
     */
    l || /**
     * * DEFAULT LABEL (TAB PANEL)
     */
    /* @__PURE__ */ s(Qi, {
      title: o.length > 4 ? o : void 0,
      placement: "bottom",
      enterDelay: 700,
      enterNextDelay: 500,
      arrow: !0,
      children: /* @__PURE__ */ O("div", {
        "data-testid": "tab-panel",
        className: `${r ?? "w-[200px] max-w-[200px]"} h-[40px] pr-1 pl-3 overflow-hidden flex items-center justify-between gap-0`,
        children: [
          /* @__PURE__ */ s("p", {
            "data-testid": "tab-label",
            className: "pt-1 min-w-0 w-full overflow-hidden text-ellipsis whitespace-nowrap text-left",
            children: o
          }),
          (m === void 0 || m === !0) && // eslint-disable-next-line jsx-a11y/no-static-element-interactions
          /* @__PURE__ */ s("div", {
            "data-testid": "close-tab-button",
            onClick: (g) => {
              g.stopPropagation(), u == null || u(d);
            },
            className: "p-1 rounded-small hover:bg-black hover:bg-opacity-5",
            children: /* @__PURE__ */ s(Kl, { className: "w-5 h-5 flex-shrink-0" })
          })
        ]
      })
    })
  ),
  ...p
}))(() => ({
  textTransform: "none",
  "&.Mui-selected": {
    color: "#000"
  },
  paddingInline: "0",
  minWidth: "auto",
  minHeight: "auto",
  "& button": {
    padding: 0
  }
})), ey = ({ value: a, onChange: o, tabsDivProps: r, children: l, addButtonProps: u }) => {
  const { className: d, ...m } = r ?? {};
  return /* @__PURE__ */ s("div", {
    className: sn("w-full bg-white border-b border-gray-300", d),
    ...m,
    children: /* @__PURE__ */ s(j2, {
      value: a,
      onChange: o,
      addButtonProps: u,
      children: l
    })
  });
}, va = Object.assign(ey, { Item: Z2 });
var Vi, ty = new Uint8Array(16);
function ny() {
  if (!Vi && (Vi = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !Vi))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Vi(ty);
}
const ry = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function iy(a) {
  return typeof a == "string" && ry.test(a);
}
var Xe = [];
for (var ba = 0; ba < 256; ++ba)
  Xe.push((ba + 256).toString(16).substr(1));
function oy(a) {
  var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = (Xe[a[o + 0]] + Xe[a[o + 1]] + Xe[a[o + 2]] + Xe[a[o + 3]] + "-" + Xe[a[o + 4]] + Xe[a[o + 5]] + "-" + Xe[a[o + 6]] + Xe[a[o + 7]] + "-" + Xe[a[o + 8]] + Xe[a[o + 9]] + "-" + Xe[a[o + 10]] + Xe[a[o + 11]] + Xe[a[o + 12]] + Xe[a[o + 13]] + Xe[a[o + 14]] + Xe[a[o + 15]]).toLowerCase();
  if (!iy(r))
    throw TypeError("Stringified UUID is invalid");
  return r;
}
function ay(a, o, r) {
  a = a || {};
  var l = a.random || (a.rng || ny)();
  if (l[6] = l[6] & 15 | 64, l[8] = l[8] & 63 | 128, o) {
    r = r || 0;
    for (var u = 0; u < 16; ++u)
      o[r + u] = l[u];
    return o;
  }
  return oy(l);
}
function Bc(a, o) {
  let r = 0;
  return a.forEach((l) => {
    const u = l.split(" ")[0], d = l.split(" ")[1];
    d && parseInt(d) > r && u === o && (r = parseInt(d));
  }), `${o} ${r + 1}`;
}
const Nc = Dl(({ children: a, inputProps: o, onComplete: r, tabLabels: l }, u) => /* @__PURE__ */ s(Ta, {
  innerRef: u,
  initialValues: {
    tabLabel: Bc(l, (o == null ? void 0 : o.placeholder) ?? "")
  },
  validationSchema: qi.object().shape({
    tabLabel: qi.string().required("Adjon meg egy nevet!").max(20, "Maximum 20 karakter!").test("tabLabel", "Nem tartalmazhat speciális karaktereket!", (d) => !d.match(/[^a-zA-Z0-9\sáÁéÉíÍóÓöÖőŐúÚüÜűŰ]/)).test("tabLabel", "Már létezik ilyen név!", (d) => !l.includes(d))
  }),
  onSubmit: (d, m) => {
    r(d.tabLabel), m.resetForm();
  },
  children: /* @__PURE__ */ O(Ia, { autoComplete: "off", children: [
    /* @__PURE__ */ s(tc, {
      name: "tabLabel",
      placeholder: (o == null ? void 0 : o.placeholder) ?? "...",
      label: (o == null ? void 0 : o.label) ?? "Új tab neve",
      inputProps: {
        sizing: "sm"
      },
      required: !0
    }),
    a
  ] })
})), sy = Dl(({ onComplete: a, buttonText: o, inputProps: r, tabLabels: l }, u) => /* @__PURE__ */ s("div", {
  className: "p-3 w-[200px] max-w-[200px]",
  "data-testid": "add-tab-component",
  children: /* @__PURE__ */ s(Nc, {
    ref: u,
    onComplete: a,
    tabLabels: l,
    inputProps: r,
    children: /* @__PURE__ */ s($t, {
      "data-testid": "add-tab-component-button",
      className: "mt-1 w-full",
      type: "submit",
      size: "xs",
      children: o ?? "Létrehozás"
    })
  })
})), ly = ({ show: a, toggleShow: o, onComplete: r, header: l, buttonText: u, inputProps: d, tabLabels: m }) => {
  const p = Re(null);
  return ee(() => {
    a && p.current && (p.current.resetForm(), p.current.setFieldValue("tabLabel", Bc(m, (d == null ? void 0 : d.placeholder) ?? "")));
  }, [m]), /* @__PURE__ */ O(Vn, { show: a, onClose: o, "data-testid": "add-tab-modal", children: [
    /* @__PURE__ */ s(Vn.Header, { children: l }),
    /* @__PURE__ */ s(Vn.Body, { children: /* @__PURE__ */ s(Nc, {
      ref: p,
      onComplete: (g) => {
        r(g), o();
      },
      tabLabels: m,
      inputProps: d,
      children: /* @__PURE__ */ O("div", { className: "mt-4 flex items-center gap-2", children: [
        /* @__PURE__ */ s($t, { type: "submit", size: "sm", children: u ?? "Létrehozás" }),
        /* @__PURE__ */ s($t, {
          size: "sm",
          color: "gray",
          onClick: o,
          children: "Vissza"
        })
      ] })
    }) })
  ] });
}, Vv = ({ defaultTabs: a, defaultTabData: o = {}, tabsEmptyMessage: r, RenderComponent: l, RenderCloseModalComponent: u, RenderEmptyComponent: d, addTabModalProps: m, contentDivProps: p, maxLength: g = 50, minLength: x = 0, isSticky: k, onTabsChange: v }) => {
  const [A, C] = me.useState(!1), [T, F] = me.useState(!1), [E, I] = me.useState(0), { current: z, setCurrent: R, tabs: P, tabActions: U } = cy({
    defaultTabs: a,
    onTabsChange: v
  }), { tabWidth: q } = dy({ length: P.length }), B = Na(), M = Re(null), V = (j, le) => {
    R(le);
  }, X = () => {
    C(!A);
  }, te = () => {
    F(!T);
  }, ne = (j) => {
    u ? (I(j), F(!0)) : U.removeTab(j);
  }, $ = (j) => {
    const le = {
      label: j,
      data: o
    };
    U.addTab(le);
  };
  return /* @__PURE__ */ O(Ue, { children: [
    /* @__PURE__ */ O("div", {
      "data-testid": "dynamic-tabs",
      ...p,
      className: sn("mb-6 w-full max-w-full relative", p == null ? void 0 : p.className),
      children: [
        /* @__PURE__ */ s(va, {
          tabsDivProps: {
            className: k ? "sticky top-0 z-10" : ""
          },
          addButtonProps: {
            onAdd: () => {
              var j;
              B && X(), (j = M.current) == null || j.submitForm();
            },
            isFull: P.length >= g,
            addComponent: /* @__PURE__ */ s(sy, {
              onComplete: $,
              tabLabels: P.map((j) => j.label),
              ref: M,
              ...m
            })
          },
          value: z,
          onChange: V,
          children: P.length > 0 ? (
            /**
             * Tabs
             */
            P.map((j, le) => {
              var ve;
              return /* @__PURE__ */ s(va.Item, {
                label: j.label,
                width: q,
                onClose: ne,
                index: le,
                closable: ((ve = j.options) == null ? void 0 : ve.closable) && P.length > x,
                children: j.data
              }, ay());
            })
          ) : (
            /**
             * Display this when there are no tabs
             */
            /* @__PURE__ */ s(va.Item, {
              label: "",
              overrideLabel: /* @__PURE__ */ s("div", { className: "bg-white text-gray-500 px-12 h-full flex items-center justify-center cursor-default", children: r }),
              width: q,
              onClose: ne,
              index: 0
            })
          )
        }),
        P[z] && /* @__PURE__ */ s(l, {
          tab: P[z],
          tabActions: U,
          index: z
        }),
        P.length === 0 && d && /* @__PURE__ */ s(d, {
          tabActions: U,
          index: z
        })
      ]
    }),
    /* @__PURE__ */ s(ly, {
      show: A && B,
      toggleShow: X,
      onComplete: $,
      tabLabels: P.map((j) => j.label),
      ...m
    }),
    u && P[E] && /* @__PURE__ */ s(u, {
      show: T,
      toggleShow: te,
      onComplete: () => {
        U.removeTab(E), F(!1);
      },
      tab: P[E],
      tabActions: U,
      index: E
    })
  ] });
}, cy = ({ defaultTabs: a = [], onTabsChange: o }) => {
  const [r, l] = Y(a), [u, d] = Y(Math.max(a.length - 1, 0)), [m, p] = Y(a.length <= 0);
  ee(() => {
    o == null || o(r, u);
  }, [r, u]);
  const g = (B) => {
    let { from: M, to: V } = B ?? {};
    return M = M !== void 0 && M >= 0 ? M : 0, V = V !== void 0 && V <= r.length - 1 ? V : r.length - 1, {
      from: M,
      to: V
    };
  }, x = (B) => {
    l((M) => {
      const V = B.label;
      if (M.some((ne) => ne.label === V))
        return M;
      const te = [...M];
      return te.push(B), q({
        action: "add",
        index: r.length - 1
      }), te;
    });
  }, k = (B, M) => {
    l((V) => {
      const X = M.label;
      if (V.some(($) => $.label === X))
        return V;
      const ne = [...V];
      return ne.splice(B, 0, M), q({
        action: "insert",
        index: B
      }), ne;
    });
  }, v = (B) => {
    l((M) => {
      B = B !== void 0 ? B : r.length - 1;
      const V = [...M];
      return V.splice(B, 1), q({
        action: "remove",
        index: B
      }), V;
    });
  }, A = (B) => {
    l((M) => {
      const V = M.findIndex((te) => te.label === B), X = [...M];
      return X.splice(V, 1), q({
        action: "remove",
        index: V
      }), X;
    });
  }, C = (B) => {
    l((M) => {
      const { from: V, to: X } = g(B), te = M.slice(0, V), ne = M.slice(X + 1), $ = [...te, ...ne];
      return q({
        action: "remove-range",
        range: {
          from: V,
          to: X
        }
      }), $;
    });
  }, T = (B, M) => {
    l((V) => {
      const X = [...V];
      return X[B] = M, X;
    });
  }, F = (B) => r.findIndex((M) => M.label === B), E = (B) => r.find((M) => M.label === B), I = (B) => r[B], z = (B) => {
    const { from: M, to: V } = g(B);
    return r.slice(M, V + 1).map((X) => X.label);
  }, R = (B) => {
    const { from: M, to: V } = g(B);
    return r.slice(M, V + 1).map((X) => X.data);
  }, P = (B) => {
    const { from: M, to: V } = g(B);
    return r.slice(M, V + 1);
  }, U = () => r.length;
  function q(B) {
    const { action: M } = B;
    if (M !== "remove-range" && M !== "none") {
      const { index: V } = B;
      switch (M) {
        case "add":
          d(V + 1);
          break;
        case "remove":
          V <= u && d((X) => X === 0 ? X : X - 1);
          break;
        case "insert":
          d(V);
          break;
      }
    } else if (M !== "none") {
      const { range: V } = B, { from: X, to: te } = V;
      X <= u && te >= u ? d(X === 0 ? 0 : X - 1) : te < u && d((ne) => X + (ne - (te + 1)));
    }
  }
  return ee(() => {
    u >= r.length && d(Math.max(r.length - 1, 0)), r.length <= 0 ? p(!0) : p(!1);
  }, [r]), {
    tabs: r,
    setTabs: l,
    current: u,
    setCurrent: d,
    isEmpty: m,
    tabActions: {
      setCurrent: d,
      setTabs: l,
      addTab: x,
      insertTab: k,
      removeTab: v,
      removeTabByLabel: A,
      removeTabsInRange: C,
      setTabAtIndex: T,
      getTabIndexByLabel: F,
      getTabByLabel: E,
      getTabAtIndex: I,
      getAllTabLabels: z,
      getAllTabData: R,
      getAllTabs: P,
      getTabsLength: U
    }
  };
}, uy = [
  {
    fromLength: 10,
    width: "w-[120px] h-[120px] max-sm:w-[100px] max-sm:max-w-[100px]"
  },
  {
    fromLength: 6,
    width: "w-[160px] h-[160px] max-sm:w-[110px] max-sm:max-w-[110px]"
  },
  {
    fromLength: 4,
    width: "w-[200px] h-[200px] max-sm:w-[120px] max-sm:max-w-[120px]"
  },
  {
    fromLength: 0,
    width: "w-[240px] h-[240px] max-sm:w-[140px] max-sm:max-w-[140px]"
  }
], dy = ({ length: a }) => {
  const [o, r] = me.useState("w-[200px] h-[200px]");
  return ee(() => {
    const l = uy.find((u) => a >= u.fromLength);
    l && r(l.width);
  }, [a]), {
    tabWidth: o
  };
}, fy = {
  defaultValue: 0,
  size: "md"
}, hy = {
  [`& .${sx.root}`]: {
    '&[aria-selected="true"]': {
      bgcolor: "background.surface",
      borderColor: "divider",
      "&::before": {
        content: '""',
        display: "block",
        position: "absolute",
        height: 2,
        bottom: -2,
        left: 0,
        right: 0,
        bgcolor: "background.surface"
      }
    }
  }
}, py = {
  variant: "soft"
}, my = {
  indicatorPlacement: "top"
}, Yv = ({ items: a, tabListProps: o, ...r }) => {
  const { sx: l, ...u } = o || {};
  return /* @__PURE__ */ O(lx, { ...fy, ...r, children: [
    /* @__PURE__ */ s(cx, {
      ...py,
      sx: {
        ...hy,
        ...l
      },
      ...u,
      children: a.map((d, m) => /* @__PURE__ */ O(ux, { ...my, ...d.tabProps, children: [
        d.icon && /* @__PURE__ */ s(dx, { children: /* @__PURE__ */ s(d.icon, { className: "mb-1 mr-2 h-5 w-5" }) }),
        d.label
      ] }, m))
    }),
    a.map((d, m) => /* @__PURE__ */ s(fx, { value: m, ...d.tabPanelProps, children: d.content }, m))
  ] });
};
export {
  oc as Background,
  $t as BasicButton,
  tc as BasicInputField,
  La as Body,
  l3 as Breadcrumbs,
  pv as ButtonWithConfirmModal,
  mv as ButtonWithInfoModal,
  gv as CheckboxForGroup,
  xv as CheckboxGroup,
  yv as CheckboxInputField,
  vv as ColorPickerInputField,
  Xl as ConfirmModal,
  Wv as ContextMenu,
  Fc as ContextMenuContext,
  bv as DatePickerInputField,
  fv as DraggableModal,
  hv as DraggableModalContainer,
  Vv as DynamicTabs,
  ic as FadePresence,
  wv as FileInputField,
  Ov as FormTemplate,
  kv as GenericSelectInput,
  Ma as Header,
  Yi as IconButton,
  Jl as InfoModal,
  ka as Logo,
  Mv as MicroPlate,
  Nv as MicroPlateContextProvider,
  Ql as Modal,
  _v as MuiSelectInput,
  Lv as MultiStepForm,
  yc as MyTableCompContext,
  mc as MyTableContext,
  xa as RadioButton,
  n3 as RadioButtonGroup,
  Fv as ReadOnlyTable,
  dc as ScrollTo,
  nc as SelectInputField,
  Tv as SidebarLayoutBasic,
  Iv as SidebarLayoutTable,
  Ev as SidenavContainer,
  Dv as SingleFormElement,
  Cv as SliderInput,
  Av as SwitchInputField,
  Bv as Table,
  C3 as TableComp,
  F3 as TableCompContext,
  E3 as TableContext,
  Yv as Tabs,
  Sv as TextAreaInputField,
  Gv as ThemeProvider,
  q3 as alphabet,
  v3 as convertReactCSSToPlainCSS,
  uc as getData,
  _a as getStyleSheet,
  Hv as jwtInterceptor,
  Uv as refreshInterceptor,
  Gn as updateRuleInStyleSheet,
  zv as useContextMenu,
  Nx as useDraggableModalContainer,
  Zl as useDraggableModalContext,
  dy as useDynamicTabWidth,
  cy as useDynamicTabs,
  ln as useMicroPlate,
  An as useMultiStepFormContext,
  Pv as useShow,
  Ur as useSingleFormElementContext,
  w3 as useTable,
  Gr as useTableProps,
  Rv as useWells,
  Ic as useWindowWidth
};
